/* @preserve
 *  espn-web-player-bundle v1.7.2
 *  2017-04-19T20:41:56.925Z
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.ESPNVideoPlayer = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* jshint esversion: 6, strict: false, curly: false, browserify: true */
var EventEmitter = require('events');
var BrightcovePlayer = require('./player/brightcove5/index');
var Html5Player = require('./player/native-player/index');
var ConfigLogger = require('./config-logger/index');
var Analytics = require('./analytics');
var Advertising = require('./advertising');

/*
  UA-sniffing code borrowed from VideoJS
  https://github.com/videojs/video.js/blob/3a859f97d0647fc3d1ef6b2f4b755c71da8bef63/src/js/utils/browser.js
*/
var USER_AGENT = window.navigator && window.navigator.userAgent || '';
var IS_EDGE = /Edge/i.test(USER_AGENT);
var IS_CHROME = !IS_EDGE && /Chrome/i.test(USER_AGENT);

var _bundle = void 0;
var _container = void 0;
var _element = void 0;
var _containerClone = void 0;

function flashMightBeBlocked(element) {
    if (!element) {
        return false;
    }

    if (IS_CHROME) {
        var width = element.getBoundingClientRect().width;
        var height = Math.max(element.getBoundingClientRect().height, width * (9 / 16));

        if (width < 400 || height < 300) {
            return true;
        }
    }

    return false;
}

/**
 * The ESPNVideoPlayer class.
 * @class
 */

var ESPNVideoPlayer = function (_EventEmitter) {
    _inherits(ESPNVideoPlayer, _EventEmitter);

    /**
     * Embed the video player
     * @param {String}          [playerTech] - either 'brightcove' or 'native'; defaults to 'brightcove'
     * @param {Object}          [techOptions]
     */

    function ESPNVideoPlayer() {
        var playerTech = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'brightcove';
        var techOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, ESPNVideoPlayer);

        var _this = _possibleConstructorReturn(this, (ESPNVideoPlayer.__proto__ || Object.getPrototypeOf(ESPNVideoPlayer)).call(this));

        switch (playerTech) {
            case 'native':
                _this.playerTech = Html5Player;
                break;
            default:
                _this.playerTech = BrightcovePlayer;
        }

        _this.options = techOptions;
        return _this;
    }

    _createClass(ESPNVideoPlayer, [{
        key: 'player',
        get: function get() {
            return _bundle && _bundle.player();
        }
    }, {
        key: 'bundle',
        get: function get() {
            return _bundle;
        }
    }, {
        key: 'analytics',
        get: function get() {
            return Analytics;
        }
    }, {
        key: 'advertising',
        get: function get() {
            return Advertising;
        }
    }]);

    return ESPNVideoPlayer;
}(EventEmitter);

/**
 * Embed the video player
 * @param {string}              guid - the cerebro guid
 * @param {(string|Element)}    el - the DOM element where the player will be embedded
 * @param {Object}              [options={}]
 * @param {function}            [callback]
 */


ESPNVideoPlayer.prototype.embed = function embed(guid, el, options) {
    var _this2 = this;

    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

    var element = el;
    if (Object.prototype.toString.call(el) === '[object String]') {
        element = document.getElementById(el);
    }
    _element = element;
    _container = element.parentNode;
    _containerClone = _container.cloneNode(true);

    var config = _extends({}, options);

    if (guid) {
        config.cerebroId = guid;
    }

    if (flashMightBeBlocked(element)) {
        if (!config.advertising) {
            config.advertising = {};
        }
        if (config.advertising.adTechOrder) {
            var indx = config.advertising.adTechOrder.indexOf('html5');
            if (indx !== 0) {
                // If 'html5' is not the first element, remove it.
                if (indx > 0) {
                    config.advertising.adTechOrder.splice(indx, 1);
                }

                config.advertising.adTechOrder.unshift('html5');
            }
        } else {
            _extends(config.advertising, { adTechOrder: ['html5', 'flash'] });
        }
    }

    _bundle = new this.playerTech(element, config);

    _bundle.player().ready(function () {
        callback(_this2);
    });

    return this;
};

/**
 * Pause the video player
 */
ESPNVideoPlayer.prototype.pause = function pause() {
    if (this.player) this.player.pause();

    return this;
};

ESPNVideoPlayer.prototype.ready = function ready() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    this.playerTech.loadTech(callback.bind(this), this.options);

    return this;
};

ESPNVideoPlayer.prototype.switchVideo = function (guid) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    if (!_bundle || !(guid || options.clipId)) {
        return;
    }

    var autoplay = typeof options.autoplay === 'boolean' ? options.autoplay : true;
    var source = options.clipSource || _bundle.clipSource;
    var clipId = options.clipId;
    // @TODO need to somehow stop currently playing ad??
    // I tried player().ads.skipLinearAdMode
    // https://github.com/videojs/videojs-contrib-ads#developing-an-integration...
    // for now if an ad is playing we'll just re-embed using the el the current video is using
    this.player.trigger('switch', { guid: guid, clipId: clipId, autoplay: autoplay, source: source });
    if (this.player && this.player.ads && this.player.ads.state === 'ad-playback') {
        this.unembed();
        var newPlaceholder = _containerClone ? _containerClone.children[0] : {};
        var newPlaceholderId = newPlaceholder.getAttribute ? newPlaceholder.getAttribute('id') : null;
        if (newPlaceholderId) {
            this.embed(guid, newPlaceholderId, options, callback);
        } else {
            callback(new Error('cloned placeholder missing ID'));
        }
    } else {
        if (guid) {
            options.cerebroId = guid;
        }
        _bundle.player().reset();
        _bundle.registerConfiguration(options);
        if (guid) {
            _bundle.loadShield(guid, autoplay);
        } else if (clipId) {
            _bundle.loadClip(clipId, autoplay, source);
        }
        callback(null, this);
    }
};

/**
 * Unembed the video player
 * @param {removeContainer}     [removeContainer=false]
 */
ESPNVideoPlayer.prototype.unembed = function unembed() {
    var removeContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    Analytics.reset();
    if (!_bundle) return;

    _bundle.dispose();
    _bundle = null;

    if (_container && _container.parentNode) {
        if (removeContainer) {
            _container.parentNode.removeChild(_container);
        } else {
            _container.parentNode.replaceChild(_containerClone, _container);
        }
    }
    return this;
};

/**
 * Remove the video player and it's container. This is an alias for espnVideoPlayer.unembed(true)
 */
ESPNVideoPlayer.prototype.remove = function remove() {
    this.unembed(true);
};

/**
 * Display an error message
 * @param {string|object}       error - an error code (`'AUTHZ_FAILURE'`, etc.) or a media error object (`{type: 'NOT_FOUND', message: 'This video is unavailable.'}`)
 * @param {(string|HTMLElement)}    [content] - optional, custom error message
 */
ESPNVideoPlayer.prototype.error = function error(err, content) {
    _bundle.error(err, content);
    return this;
};

/**
 * Module method to expose ConfigLogger
 */
ESPNVideoPlayer.ConfigLogger = ConfigLogger;

ESPNVideoPlayer.VERSION = '1.7.2';

module.exports = ESPNVideoPlayer;

},{"./advertising":5,"./analytics":7,"./config-logger/index":13,"./player/brightcove5/index":61,"./player/native-player/index":63,"events":25}],2:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    desktop: ['freewheel_admanager'],
    tablet: ['brightcove_once', 'freewheel_admanager'],
    mobile: ['brightcove_once', 'freewheel_admanager']
  };
}).call(undefined);

},{}],3:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  'use strict';

  var AdManager, AdProvider, Advertising, BrightcoveOnce, Fan, OnceUX, defaultProviderOrders, request;

  Advertising = require('../advertising');

  Fan = require('../fan');

  defaultProviderOrders = require('./config');

  request = require('superagent');

  AdProvider = function () {
    function AdProvider(player, data, providerOrders, callback) {
      var currentPlatform;
      this.player = player;
      this.data = data;
      this.sources = data.sources;
      this.onReady = callback;
      providerOrders = (typeof providerOrders === 'undefined' ? 'undefined' : _typeof(providerOrders)) === 'object' ? providerOrders : defaultProviderOrders;
      currentPlatform = data._shield && data._shield.device;
      switch (currentPlatform) {
        case 'MOBILE':
          this.chooseProvider(providerOrders.mobile);
          break;
        case 'TABLET':
          this.chooseProvider(providerOrders.tablet);
          break;
        case 'PC':
          this.chooseProvider(providerOrders.desktop);
          break;
        default:
          this.chooseProvider();
      }
      if (this.provider) {
        this.provider.setSource.call(this);
      } else {
        this.onReady(this);
      }
    }

    AdProvider.prototype.chooseProvider = function (providerOrder) {
      var i, len, provider;
      providerOrder = providerOrder || ['freewheel_admanager'];
      for (i = 0, len = providerOrder.length; i < len; i++) {
        provider = providerOrder[i];
        if (typeof this[provider] === 'function') {
          this.provider = this[provider]();
          if (this.provider) {
            break;
          }
        }
      }
    };

    AdProvider.prototype.data = void 0;

    AdProvider.prototype.player = void 0;

    AdProvider.prototype.provider = AdManager;

    AdProvider.prototype.sources = void 0;

    AdProvider.prototype.initAds = function (options) {
      return typeof this.provider.initAds === 'function' && this.provider.initAds.call(this, this.player, options);
    };

    AdProvider.prototype.brightcove_once = function () {
      if (this.data.onceHref) {
        return BrightcoveOnce;
      }
      return false;
    };

    AdProvider.prototype.freewheel_admanager = function () {
      if (this.player.FreeWheelPlugin) {
        return AdManager;
      }
      return false;
    };

    AdProvider.prototype.onceux = function () {
      if (this.player.onceux) {
        return OnceUX;
      }
      return false;
    };

    AdProvider.prototype.toString = function () {
      return this.provider.toString();
    };

    return AdProvider;
  }();

  AdManager = {
    toString: function toString() {
      return 'AdManager';
    },
    setSource: function setSource() {
      return this.onReady(this);
    },
    initAds: function initAds(player, opts) {
      var options, postroll, preroll, slots;
      if (!player.FreeWheelPlugin) {
        return;
      }
      preroll = opts.slots && opts.slots.preroll;
      postroll = opts.slots && opts.slots.postroll;
      slots = [];
      if (preroll) {
        slots.push({
          adUnit: 'preroll',
          timePosition: 0
        });
      }
      if (postroll) {
        slots.push({
          adUnit: 'postroll',
          timePosition: opts.duration
        });
      }
      if (preroll || postroll) {
        options = Advertising.adManager({
          networkId: opts.networkId,
          assetId: opts.id,
          assetDuration: opts.duration
        }, slots);

        /*
          On initial load, `player().FreeWheelPlugin` is a function, but after it
          has been called once, it becomes an object, so if we call `initAds`
          more than once, we need to check `FreeWheelPlugin`'s type.
         */
        opts.logger('FreeWheelPlugin', options);
        if (typeof player.FreeWheelPlugin === 'function') {
          player.FreeWheelPlugin(options);
        } else if (player.FreeWheelPlugin) {
          player.FreeWheelPlugin.settings = options;
          if (player.FreeWheelPlugin.tech === 'Html5' && player.FreeWheelPlugin.Html5) {
            player.FreeWheelPlugin.Html5._parameters.update(options.Html5);
          }
        }
      }
    }
  };

  BrightcoveOnce = {
    toString: function toString() {
      return 'BrightcoveOnce';
    },
    setSource: function setSource() {
      var _this = this;
      this.data.onceHref = this.data.onceHref.replace('now/od', 'now/ads/vmap/od');
      request.get(this.data.onceHref).query({
        UMADPARAM_fw_euid: Fan.SWID,
        output: '1'
      }).end(function (err, res) {
        var unicornOnce;
        if (res.body) {
          unicornOnce = res.body['vmap:VMAP'] && res.body['vmap:VMAP']['vmap:Extensions'] && res.body['vmap:VMAP']['vmap:Extensions']['uo:unicornOnce'];
          _this.sources = [{
            src: unicornOnce['@contenturi'],
            type: unicornOnce['@contenttype'].replace('audio', 'application')
          }];
        }
        _this.onReady(_this);
      });
    },
    /*
      We've already set `sources` to the ONCE URL, so nothing else to do.
     */
    initAds: null
  };

  OnceUX = {
    toString: function toString() {
      return 'OnceUX';
    },
    setSource: function setSource() {
      return this.onReady(this);
    },
    initAds: function initAds(player, opts) {
      var options;
      if (!player.onceux) {
        return;
      }
      if (typeof player.onceux === 'function') {
        options = Advertising.onceux(this.data.onceHref.replace('now/od', 'now/ads/vmap/od'));

        opts.logger('onceux', options);
        player.onceux(options);
      } else if (typeof player.onceux.src === 'function') {
        options = this.data.onceHref.replace('now/od', 'now/ads/vmap/od');

        opts.logger('onceux', { src: options });
        player.onceux.src(options);
      }
    }
  };

  module.exports = AdProvider;
}).call(undefined);

},{"../advertising":5,"../fan":17,"./config":2,"superagent":32}],4:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    host: 'http://bd0dc.v.fwmrm.net/ad/p/1',
    siteSectionId: 'espn:video',
    networkId: 87146,
    flash: {
      profile: '87146:espn_desktop_as3',
      serverUrl: 'http://bd0dc.v.fwmrm.net/ad/p/1',
      sdkurl: 'http://adm.fwmrm.net/p/espn_desktop_prod/AdManager.swf',
      swfurl: 'https://players.brightcove.net/videojs-freewheel/2/videojs.freewheel.swf'
    },
    html5: {
      profile: '87146:espn_desktop_js',
      serverUrl: 'http://1546a.v.fwmrm.net/ad/g/1',
      sdkurl: 'http://adm.fwmrm.net/p/espn_desktop_prod/AdManager.js'
    },
    adTechOrder: ['flash', 'html5'],
    debug: false,
    prerollTimeout: 3000,
    timeout: 5000,
    assetId: void 0,
    assetDuration: void 0,
    live: false,
    keyValues: [],

    beforeAdManager: function beforeAdManager(options) {
      return options;
    },

    /*
      These values should be uniquely generated when site section or asset ID
      change.
     */
    pageViewRandomNumber: 1,
    videoPlayRandomNumber: 1,

    /*
      Response type requested.
       From the docs, the possible values are:
         vast2, vast3, vmap1, smrx, ad (for display only)
     */
    responseType: 'vast2'
  };
}).call(undefined);

},{}],5:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Advertising, Fan, config, merge;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  merge = require('lodash.mergewith');

  Fan = require('../fan');

  config = require('./config');

  Advertising = {
    configure: function configure(obj) {
      if (obj) {
        merge(config, obj, mergeCustomizer);
      }
      return config;
    },
    adManager: function adManager(options) {
      var output;
      this.configure({ keyValues: [{ _fw_euid: Fan.SWID }] });
      if (options != null) {
        this.configure(options);
      }
      this.configure(config.beforeAdManager(config));
      output = {
        Flash: {
          networkId: "" + config.networkId,
          sdkurl: config.flash.sdkurl,
          serverUrl: config.flash.serverUrl,
          siteSectionCustomId: config.siteSectionId,
          swfurl: config.flash.swfurl,
          videoAssetCustomId: config.assetId,
          videoAssetDuration: config.assetDuration,
          profile: config.flash.profile,
          keyValues: config.keyValues
        },
        Html5: {
          networkId: "" + config.networkId,
          sdkurl: config.html5.sdkurl,
          serverUrl: config.html5.serverUrl,
          siteSectionCustomId: config.siteSectionId,
          videoAssetCustomId: config.assetId,
          videoAssetDuration: config.assetDuration,
          profile: config.html5.profile,
          keyValues: config.keyValues
        },
        adTechOrder: config.adTechOrder,
        debug: config.debug,
        prerollTimeout: config.prerollTimeout,
        timeout: config.timeout
      };

      if (config.startType) {
        output.Html5.autoPlayType = !!config.startType.match(/manual/i) ? 'VIDEO_ASSET_AUTO_PLAY_TYPE_ATTENDED' : 'VIDEO_ASSET_AUTO_PLAY_TYPE_UNATTENDED';
        output.Flash.autoPlay = true;
      } else {
        output.Html5.autoPlayType = 'VIDEO_ASSET_AUTO_PLAY_TYPE_NONE';
        output.Flash.autoPlay = false;
      }

      return output;
    },
    vast: function vast(options, slots) {
      var i, keys, len, params, slot, slotParams;
      if (options != null) {
        this.configure(options);
      }
      params = ["resp=" + config.responseType, "nw=" + config.networkId, "caid=" + config.assetId, config.assetDuration != null ? "vdur=" + config.assetDuration : void 0, "csid=" + config.siteSectionId, "prof=" + config.profile, config.live ? "mode=live" : void 0, "pvrn=" + config.pageViewRandomNumber, "vprn=" + config.videoPlayRandomNumber, config.responseType === 'vast2' ? "crtp=vast2s" : void 0];
      keys = [];
      slotParams = [];
      for (i = 0, len = slots.length; i < len; i++) {
        slot = slots[i];

        /*
          For our current purposes, a slot is always "temporal", so `ptgt=a`
          should be OK.
           `slot.adUnit` is set when calling `Advertising.vast()` and would be one
          of: `preroll`, `midroll`, or `postroll`
           If `adBreak` is included in the slot, it will be appended to `adUnit`
          to create a unique slot ID, i.e.: `midroll1`.
         */
        slotParams.push(["ptgt=a", "slau=" + slot.adUnit, "slid=" + slot.adUnit + (slot.adBreak != null ? slot.adBreak : void 0)].join('&'));
      }
      return config.host + "?" + params.join('&') + ";" + keys.join('&') + ";" + slotParams.join(';');
    },
    onceux: function onceux(metadataUri) {
      return {
        metadataUri: metadataUri,
        hideOverlay: config.hideOverlay
      };
    }
  };

  module.exports = Advertising;
}).call(undefined);

},{"../fan":17,"./config":4,"lodash.mergewith":28}],6:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    chartbeat: {
      uid: '22222',
      domain: 'espn.com',
      sections: null,
      authors: null
    },
    comscore: {
      clientId: '3000005',
      labels: {
        c3: '"*null"',
        c4: 'MediaInfo.site',
        c6: 'MediaInfo.comscoreC6',
        c8: 'MediaInfo.pageTitle',
        ns_st_pu: 'MediaInfo.publisher', // publisher brand name
        ns_st_pr: '"*null"', // program title
        ns_st_ep: 'MediaInfo.name', // episode title
        ns_st_sn: '"*null"', // episode season number
        ns_st_en: '"*null"', // episode number
        ns_st_st: '"*null"', // station title
        ns_st_ge: '"*null"', // content genre
        ns_st_ti: '"*null"', // TMS/Gracenote ID
        ns_st_ia: '"*null"', // ad load flag (Boolean, present means true) will be true for ESPN1 & ESPN2
        ns_st_ce: '"*null"', // complete episode flag
        ns_st_ddt: '"*null"', // digital airdate
        ns_st_tdt: '"*null"' // TV airdate
      }
    },
    conviva: {
      customerKey: 'eec329720efa1110d60c5a6d01a65baf032de653',
      playerName: 'Conviva Test Web Player',
      debug: false

      /*
        Plugin: Brightcove Perform Player (HTML5 1st/Flash Fallback) [c3.ESPN]
        Documentation:	Conviva Community: Integrate: Plugins: Brightcove Perform Player
        Production CUSTOMER_KEY:	766ee8daa5d5deaeeeab4481239072ea53f6f1cc
        Test CUSTOMER_KEY:	4ef48c3f3b0803661e860a61b35963306389af7e
         Plugin: Brightcove Perform Player (HTML5 1st/Flash Fallback) [c3.ESPN-com]
        Documentation:	Conviva Community: Integrate: Plugins: Brightcove Perform Player
        Production CUSTOMER_KEY:	fc8dbfdc5da519f576628f619306a357f31bd006
        Test CUSTOMER_KEY:	eec329720efa1110d60c5a6d01a65baf032de653
         Plugin: Brightcove Perform Player (HTML5 1st/Flash Fallback) [c3.ESPN-Intl]
        Documentation:	Conviva Community: Integrate: Plugins: Brightcove Perform Player
        Production CUSTOMER_KEY:	aff0675a75497f3e066783b2c5fd614c4e4d61cd
        Test CUSTOMER_KEY:	e685ed240475325e03bff60be2ad80b41322ac74
       */
    },
    adobeDCR: {
      VISITOR_API: {
        MARKETING_CLOUD_ORG_ID: "EE0201AC512D2BE80A490D4C@AdobeOrg",
        NAMESPACE: "espn",
        TRACKING_SERVER: "w88.espn.com"
      },
      APP_MEASUREMENT: {
        RSID: "wdgespredesign",
        TRACKING_SERVER: "w88.espn.com"
      },
      HEARTBEAT: {
        DISABLE: false, // disable if using milestone tracking
        TRACKING_SERVER: "espn.hb.omtrdc.net",
        PUBLISHER: "EE0201AC512D2BE80A490D4C@AdobeOrg",
        OVP: "Brightcove",
        SDK: "1.6.7",
        DEBUG_LOGGING: false // sitecatalyst-specific logging - set to false for production
      },
      QUALITY: {
        TIME_TO_START: 0
      },
      CUSTOM_EVENT: {
        disable: true, // disable if using heartbeat tracking
        bc_data_mapping: {
          name: "eVar106,prop2", // video name, accepts multiple eVars/props
          segment: "eVar203", // current milestone (e.g., '1:M:0-25')
          contentType: "eVar201", // content type (e.g., 'video' or 'ad')
          timePlayed: "event203", // amount of time played since last tracking event, tracked with milestone events
          view: "event201", // video start event
          segmentView: "event202", // general milestone tracking event, tracked with milestone events
          complete: "event207", // video complete event
          milestones: { // milestones in percent; milestones can be added/removed from list
            25: "event204", // 25%
            50: "event205", // 50%
            75: "event206" // 75%
          }
        },
        // keep to track volume change events
        bc_volumechange: {
          event: "event208", // event tracking number
          evar: "prop1" // the new volume chosen by the user (from 0-1.00), only one prop/eVar supported here
        },
        // keep to track when user has paused an ad
        bc_ad_pause: {
          event: "event209", // event tracking number
          evar: "eVar205" // time value of pausing an ad, only one prop/eVar supported here
        },
        // keep to track when user enters full screen mode
        bc_fullscreen_enter: {
          event: "event212" // event tracking number
        },
        // keep to track when user exits full screen mode
        bc_fullscreen_exit: {
          event: "event213" // event tracking number
        },
        // keep to track when user opens social share menu
        bc_social_opened: {
          event: "event214" // event tracking number
        },
        // keep to track when user closes social share menu
        bc_social_closed: {
          event: "event215" // event tracking number
        }
      },
      NIELSEN_DATA: {
        /** ESPN TO CONFIGURE NIELSEN APPLICATION DATA **/
        APP_INFO: {
          "clientId": "us-600140-test",
          "vcid": "b01",
          "apid": "T31187EE2-AC6E-46CB-BB54-D07591BED067",
          "appName": "BasicPlayerSample",
          "sfcode": "dcr",
          "nol_sdkDebug": "console",
          "nsdkv": "511"
        },
        CONFIG_KEY: '922e1d53d3e10abdde5cbea1b55459f5bacc65d4/55ba372b3336330017000bbf',
        CONTENT_METADATA: {
          "type": "content",
          "program": "",
          "segB": "",
          "segC": "Sport/Program Code",
          "isfullepisode": "",
          "adloadtype": 2,
          "airdate": "",
          "dataSrc": "CMS",
          "tv": false,
          "crossId2": "ESPN",
          "assetid": "",
          "category": ""
        },
        AD_METADATA: []
      },
      ESPN_CUSTOM_METADATA: {},
      MEDIAINFO: {}
    },
    nativeOmniture: {
      trackingServer: 'w88.espn.com',
      reportSuites: 'wdgespcom,wdgespge',
      secure: false,
      site: 'espn'
    }
  };
}).call(undefined);

},{}],7:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Analytics, config, merge;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  merge = require('lodash.mergewith');

  config = merge({}, require('./config'), mergeCustomizer);

  Analytics = {
    reset: function reset() {
      config = require('./config');
      return config;
    },
    configure: function configure(obj) {
      merge(config, obj, mergeCustomizer);
      return config;
    },
    chartbeat: function chartbeat(options) {
      if (options != null) {
        this.configure({
          chartbeat: options
        });
      }
      return config.chartbeat;
    },

    /*
      The comScore plugin for Brightcove pulls all of it's data from the
      `mediainfo` property. Configuration here consists of "mapping" labels to
      respective keys of the `mediainfo` object. Most of the mapping is done
      automatically, all we are doing here is manual overrides.
       The plugin requires those keys be prefixed with `MediaInfo`.
       If you need to provide a literal string, it needs to be double-quoted:
          c3: "\"*null\""
       Passing configurations at this level should be largely unneccessary.
     */
    comscore: function comscore(options) {
      var label, labelmap, ref, value;
      if (options != null) {
        if (options.c2) {
          options.clientId = options.c2;
        }
        config.comscore.clientId = options.c2 || options.clientId || config.comscore.clientId;
        if (options.labels) {
          merge(config.comscore.labels, options.labels);
        }
      }
      labelmap = [];
      ref = config.comscore.labels;
      for (label in ref) {
        value = ref[label];
        labelmap.push(label + "=" + value);
      }
      return {
        c2: config.comscore.clientId,
        labelmapping: labelmap.join(',')
      };
    },
    conviva: function conviva(options) {
      if (options != null) {
        this.configure({
          conviva: options
        });
      }
      return config.conviva;
    },
    adobeDCR: function adobeDCR(options) {
      if (options != null) {
        this.configure({
          adobeDCR: options
        });
      }
      return config.adobeDCR;
    },
    nativeOmniture: function nativeOmniture(options) {
      if (options != null) {
        this.configure({
          native: options
        });
      }
      return config.native;
    }
  };

  module.exports = Analytics;
}).call(undefined);

},{"./config":6,"lodash.mergewith":28}],8:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    VIDEO_BASE_URL: 'http://api-app.espn.com/v1/video',
    WATCH_BASE_URL: 'http://api-app.espn.com/v1/watch',
    VIDEOHUB_BASE_URL: 'http://www.espn.com/videohub'
  };
}).call(undefined);

},{}],9:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var API, CMS, Shield, config, merge, request;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  function listingsRequest(query, callback) {
    return request.get(config.WATCH_BASE_URL + '/listings').query({ tz: 'GMT' }).query(query).end(function (error, res) {
      var comscoreC6, data, listing, nielsenCrossId1;
      if (error) {
        console.error(error);
        return callback(error, null);
      }
      listing = res.body && res.body.listings && res.body.listings.shift();

      comscoreC6 = (listing.categories && listing.categories[0] && listing.categories[0].abbreviation) + (listing.subcategories && listing.subcategories[0] && listing.subcategories[0].abbreviation && listing.subcategories[0].abbreviation.replace(/-/g, ' '));

      if (listing.program) {
        nielsenCrossId1 = listing.program.categoryCode + listing.program.code + listing.showId;
      }

      if (listing) {
        data = {
          _listing: listing,
          airingId: listing.airingId,
          commercialReplacement: listing.commercialReplacement,
          comscoreC6: comscoreC6,
          description: listing.description,
          endTime: listing.endTime,
          eventId: listing.eventId,
          hasEspnId3Heartbeats: listing.broadcasts && listing.broadcasts[0].hasNielsenWatermarks || false,
          hasNielsenWatermarks: listing.broadcasts && listing.broadcasts[0].hasEspnId3Heartbeats || false,
          hasPassThroughAds: listing.hasPassThroughAds || false,
          id: listing.id,
          name: listing.name,
          nielsenCrossId1: nielsenCrossId1,
          originalAirDate: listing.originalAirDate,
          posterHref: listing.thumbnails && listing.thumbnails.large && listing.thumbnails.large.href,
          simulcastAiringId: listing.simulcastAiringId,
          sourceId: listing.broadcasts && listing.broadcasts[0].abbreviation,
          sourceType: listing.broadcasts[0].type,
          startTime: listing.startTime,
          status: listing.type,
          videoHref: listing.links && listing.links.source && listing.links.source.hls && listing.links.source.hls.default && listing.links.source.hls.default.href,
          webHref: listing.links && listing.links.web && listing.links.web.href
        };

        return callback(null, data);
      }
      return callback('NOT_FOUND', null);
    });
  }

  request = require('superagent');

  Shield = require('../shield');

  CMS = require('../cms');

  config = require('./config');

  merge = require('lodash.mergewith');

  API = function () {
    function API(options) {
      merge(config, options, mergeCustomizer);
      this.cms = new CMS(options && options.cms || config.cms);

      if (config.getRelated && typeof config.getRelated === 'function') {
        this.getRelated = config.getRelated.bind(this);
        this.request = request;
      }
    }

    API.prototype.getClip = function (id, callback) {
      var cms, url;
      cms = this.cms;
      url = config.VIDEO_BASE_URL + '/clips/' + id;

      return request.get(url).query(cms.apiParams).end(function (error, res) {
        var _video, clip, comscoreC6, errorResponse, i, len, sources, video, videos, showcode;
        if (error) {
          console.error(error);
          if (res.body && res.body.message) {
            errorResponse = {
              code: res.body.code || error.status,
              message: res.body.message
            };
          } else {
            errorResponse = error;
          }
          return callback(errorResponse, null);
        }
        if (cms.key) {
          videos = res.body && res.body.videos;
          for (i = 0, len = videos.length; i < len; i++) {
            _video = videos[i];
            if (_video.source === cms.key) {
              video = _video;
              break;
            }
          }
        } else {
          video = res.body && res.body.videos && res.body.videos.shift();
        }
        if (!video) {
          error = 'Clip ' + cms.apiMediaId(id) + ' not found.';
          console.error(error);
          return callback(error, null);
        }
        sources = [];
        if (video.links && video.links.source && video.links.source.HLS && video.links.source.HLS.href) {
          sources.push({
            src: video.links.source.HLS.href,
            type: 'application/x-mpegURL'
          });
        }
        if (video.links && video.links.source && video.links.source.mezzanine && video.links.source.mezzanine.href) {
          sources.push({
            src: video.links.source.mezzanine.href,
            type: 'video/mp4'
          });
        }
        showcode = video.ad && video.ad.bundle ? video.ad.bundle : "Not Applicable";

        if (video.tracking) {
          comscoreC6 = '' + (video.tracking.leagueName && video.tracking.leagueName.toLowerCase() !== 'no league') ? video.tracking.leagueName : video.tracking.sportName;
        }

        clip = {
          _clips: video,
          advertisingId: cms.adAssetId(video.id),
          assetName: video.tracking && video.tracking.trackingName,
          caption: video.caption,
          cerebroId: video.cerebroId,
          comscoreC6: comscoreC6,
          createDate: new Date(video.lastModified).toISOString(),
          duration: video.duration,
          headline: video.headline,
          id: video.id,
          keywords: video.keywords,
          mediaId: cms.apiMediaId(video.id),
          originalPublishDate: video.originalPublishDate,
          posterHref: video.posterImages.full.href,
          publishDate: new Date(video.originalPublishDate).toISOString(),
          showcode: showcode,
          sources: sources,
          sport: video.tracking && video.tracking.sportName,
          syndicatable: video.syndicatable,
          webHref: video.links.web.href
        };
        return callback(null, clip);
      });
    };

    API.prototype.getClipThroughShield = function (id, callback) {
      var shield;
      shield = new Shield();

      if (/\:/.test(id)) {
        id = id.split(':')[1];
      }
      if (/^[\d]*$/.test(id)) {
        return this.getClip(id, function (clipApiError, clipApiResponse) {
          if (clipApiError) {
            console.error(clipApiError);
            return callback(clipApiError, null);
          }
          if (typeof clipApiResponse.cerebroId === 'undefined' && config.BypassShieldDeviceAndGeoRestrictions === true) {
            console.warn('Bypassing Shield device and geo restrictions is STRONGLY discouraged!');
            return callback(clipApiError, clipApiResponse);
          }
          return shield.getClip(clipApiResponse.cerebroId, callback, clipApiResponse);
        });
      } else {
        return shield.getClip(id, callback);
      }
    };

    API.prototype.getChannel = function (channel, callback) {
      return listingsRequest({ networks: channel, types: 'live' }, callback);
    };

    API.prototype.getListing = function (id, callback) {
      return listingsRequest({ id: id }, callback);
    };

    API.prototype.getRelated = function (id, options, callback) {
      var clips, url, queryParams;
      url = config.getRelatedBaseURL || config.VIDEOHUB_BASE_URL + '/player/getRelatedFeed';
      queryParams = {
        mediaId: this.cms.apiMediaId(id)
      };

      if (options.country) {
        queryParams.country = options.country.substr(options.country.indexOf('_') + 1);
      }

      clips = [];
      return request.get(url).query(queryParams).accept('xml').end(function (error, res) {
        var i, item, asseturl, items, len;
        if (error) {
          console.error(error);
          return callback(error, null);
        }
        items = res.xhr.responseXML.getElementsByTagName('item');
        for (i = 0, len = items.length; i < len; i++) {
          item = items[i];
          // fallback to ':' so array references below won't be undefined
          asseturl = item.querySelector('asseturl').textContent || ':';

          clips.push({
            caption: item.querySelector('caption').textContent,
            duration: item.getAttribute('duration'),
            headline: item.querySelector('headline').textContent,
            id: asseturl.split(':')[1],
            poster: item.querySelector('thumbnailurl').textContent,
            source: asseturl.split(':')[0],
            web: item.querySelector('hostedAtURL').textContent,
            mediaId: asseturl
          });
        }
        return callback(null, clips);
      });
    };

    API.prototype.getProvidersByClient = function (client, callback) {
      var url;
      url = config.WATCH_BASE_URL + '/clients/' + client + '/providers';
      return request.get(url).end(function (error, res) {
        var providers;
        if (error) {
          console.error(error);
          return callback(error, null);
        }
        providers = res.body && res.body.clients && res.body.clients.length > 0 && res.body.clients[0].providers || [];
        return callback(null, providers);
      });
    };

    return API;
  }();

  API.configure = function (options) {
    merge(config, options, mergeCustomizer);
    return config;
  };

  module.exports = API;
}).call(undefined);

},{"../cms":12,"../shield":66,"./config":8,"lodash.mergewith":28,"superagent":32}],10:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Authorizer, Fan, config, merge, request, session;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  Fan = require('../fan');

  request = require('superagent');

  config = {
    v: '2.0.0',
    partner: 'watchespn',
    platform: 'web'
  };

  merge = require('lodash.mergewith');

  Authorizer = function () {
    function Authorizer(player, options) {
      this.player = player;
      merge(config, options, mergeCustomizer);
    }

    Authorizer.prototype.startSession = function (listing) {
      this.stopSession();
      request.get(listing.videoHref).query({
        v: config.v,
        partner: config.partner,
        platform: config.platform,
        token: config.token,
        tokenType: config.tokenType,
        resource: config.resource,
        SWID: Fan.SWID
      }).withCredentials().end(function (error, res) {
        if (error) {
          console.error(error, res && res.body);
          return this.onStatusChange(res && res.body || error, null);
        }
        if (res.type === 'application/json' && res.body) {
          session = res.body.session;
          config.token = session.token;
          config.tokenType = 'GATEKEEPER';
          listing._session = session;
          listing.videoHref = session.playbackUrls && session.playbackUrls["default"];
          listing.simulcastAiringId = session.event.simulcastAiringId;
          listing.passThroughBeaconURL = session.passThroughBeaconURL;
          this.maintainSession();
        } else {
          this.player.error({ type: 'AUTH_FAIL', headline: 'Authorization failed' });
        }
        this.onStatusChange(null, listing);
      }.bind(this));
    };

    Authorizer.prototype.stopSession = function () {
      clearTimeout(this.maintainTimeout);
      clearTimeout(this.programTimeout);
      session = null;
    };

    Authorizer.prototype.maintainSession = function () {
      var delay, queryData;
      delay = session.ttl - 60000;
      queryData = {
        v: config.v,
        partner: config.partner,
        platform: config.platform,
        token: config.token
      };
      clearTimeout(this.maintainTimeout);
      this.maintainTimeout = setTimeout(function () {
        request.get(session.maintainUrl).query(queryData).withCredentials().end(function (error, res) {
          if (error) {
            return console.error(error);
          }
          if (res.type === 'application/json' && res.body) {
            session = res.body.session;
            config.token = session.token;
          }
          this.maintainSession();
        }.bind(this));
      }.bind(this), delay);
    };

    Authorizer.prototype.dispose = function () {
      this.stopSession();
    };

    Authorizer.prototype.onStatusChange = function () {};

    Authorizer.prototype.startShieldSession = function (listing) {
      this.stopSession();
      request.get(listing.videoHref).withCredentials().end(function (error, res) {
        if (error) {
          console.error(error, res.body);
          return this.onStatusChange(res.body, null);
        }
        if (res.type === 'application/json' && res.body) {
          listing.videoHref = res.body.stream;

          ['hasEspnId3Heartbeats', 'hasNielsenWatermarks', 'hasPassThroughAds', 'passThroughBeaconURL', 'seekInSeconds'].forEach(function (prop) {
            if (typeof res.body[prop] !== 'undefined') {
              listing[prop] = res.body[prop];
            }
          });
        } else {
          this.player.error({ type: 'AUTH_FAIL', headline: 'Authorization failed' });
        }
        this.onStatusChange(null, listing);
      }.bind(this));
    };

    return Authorizer;
  }();

  Authorizer.configure = function (options) {
    merge(config, options, mergeCustomizer);
    return config;
  };

  module.exports = Authorizer;
}).call(undefined);

},{"../fan":17,"lodash.mergewith":28,"superagent":32}],11:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    cric: {
      adAssetIdPrefix: '',
      adNetworkId: '87146',
      apiIdPrefix: 'cric:',
      apiParams: {},
      key: 'cric',
      syndicationKey: 'cricinfo'
    },
    deportes: {
      adAssetIdPrefix: '',
      adNetworkId: '135087',
      apiIdPrefix: 'deportes:',
      apiParams: {
        lang: 'es'
      },
      key: 'deportes',
      syndicationKey: 'deportes'
    },
    espn: {
      adAssetIdPrefix: '',
      adNetworkId: '87146',
      apiIdPrefix: 'espn:',
      apiParams: {},
      key: 'espn',
      syndicationKey: 'domestic'
    },
    intl: {
      adAssetIdPrefix: 'intl:',
      adNetworkId: '87146',
      apiIdPrefix: 'intl:',
      apiParams: {
        sport: 'soccer',
        region: 'GB'
      },
      key: 'intl',
      syndicationKey: 'soccerfc'
    }
  };
}).call(undefined);

},{}],12:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var CMS, config, merge;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  merge = require('lodash.mergewith');

  config = require('./config');

  CMS = function () {
    function CMS(cms) {
      return merge(this, config[cms], mergeCustomizer);
    }

    CMS.prototype.adAssetId = function (id) {
      return (this.adAssetIdPrefix || "") + id;
    };

    CMS.prototype.apiMediaId = function (id) {
      if (this.apiIdPrefix && typeof id === 'string' && id.match(this.apiIdPrefix)) {
        return id;
      }
      return (this.apiIdPrefix || "") + id;
    };

    return CMS;
  }();

  module.exports = CMS;
}).call(undefined);

},{"./config":11,"lodash.mergewith":28}],13:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var ConfigLogger, stack;

  stack = {};

  ConfigLogger = function ConfigLogger(sourceId, plugin, configs) {
    var entry;

    switch (arguments.length) {
      case 0:
        return stack;
      case 1:
        return stack[sourceId];
      case 2:
        return stack[sourceId].filter(function (item) {
          return item[plugin];
        });
      default:
        stack[sourceId] = stack[sourceId] || [];
        entry = {};
        entry[plugin] = configs;

        stack[sourceId].push(entry);
        return stack;
    }
  };

  module.exports = ConfigLogger;
}).call(undefined);

},{}],14:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// jshint ignore: start
(function () {
  var loadConviva = typeof ConvivaPrivateLoader === 'undefined';

  function convivaBrowserSupportsVideoElement() {
    try {
      return !!document.createElement('video').canPlayType;
    } catch (e) {
      return false;
    }
  }
  function convivaBrowserSupportsLocalStorage() {
    try {
      return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
      return false;
    }
  }

  var convivaSupportedBrowser = convivaBrowserSupportsVideoElement() && convivaBrowserSupportsLocalStorage();

  loadConviva = loadConviva && convivaSupportedBrowser;
  if (loadConviva) {
    var ConvivaPrivateLoader = typeof ConvivaPrivateLoader !== 'undefined' ? ConvivaPrivateLoader : function () {};
    (function () {

      function registerName(cls, clsname) {
        if (typeof ConvivaPrivateModule != "undefined") {
          ConvivaPrivateModule[clsname] = cls;
        } else if (typeof ConvivaPrivateTestingModule != "undefined") {
          ConvivaPrivateTestingModule[clsname] = cls;
        } else {

          ConvivaPrivateLoader[clsname] = cls;
        }
      }
      registerName(registerName, "registerName");

      function __id(x) {
        return x;
      }
      registerName(__id, "__id");

      function getConvivaType(className) {
        if (typeof ConvivaPrivateModule != "undefined" && ConvivaPrivateModule.hasOwnProperty(className)) {
          return ConvivaPrivateModule[className];
        } else if (typeof ConvivaPrivateTestingModule != "undefined" && ConvivaPrivateTestingModule.hasOwnProperty(className)) {
          return ConvivaPrivateTestingModule[className];
        } else if (ConvivaPrivateLoader.hasOwnProperty(className)) {
          return ConvivaPrivateLoader[className];
        } else {
          return null;
        }
      }
      registerName(getConvivaType, "getConvivaType");

      function importConvivaPrivateProgram(fromWhere, fromWhereName) {
        var res = "";
        var p;
        for (p in fromWhere) {
          if (fromWhere.hasOwnProperty(p)) {
            res += "var " + p + "=" + __id(fromWhereName) + "." + p + ";";
          }
        }
        return res;
      }
      registerName(importConvivaPrivateProgram, "importConvivaPrivateProgram");

      function STAT_INIT() {
        return "STAT_INIT";
      }
      registerName(STAT_INIT, "STAT_INIT");

      function statInit(cls, clsname) {
        cls.call(STAT_INIT);
        registerName(cls, clsname);
      }
      registerName(statInit, "statInit");

      function defPubMeth(obj, name, m) {
        if (obj != STAT_INIT) {
          if (obj[name] == undefined) {
            obj[name] = m;
          } else {

            obj["super_" + name] = m;
          }
        }
      }
      registerName(defPubMeth, "defPubMeth");

      function defPrivMeth(obj, name, m) {
        if (obj != STAT_INIT) obj[name] = m;
      }
      registerName(defPrivMeth, "defPrivMeth");

      function defStatMeth(obj, cls, name, m) {
        if (obj == STAT_INIT) cls[name] = m;
      }
      registerName(defStatMeth, "defStatMeth");

      function defGet(obj, name, m) {
        if (obj != STAT_INIT) {
          if (typeof Object.defineProperty != 'undefined') {
            Object.defineProperty(obj, name, {
              configurable: true,
              enumerable: true,
              get: m
            });
          } else {
            obj.__defineGetter__(name, m);
          }
        }
      }
      registerName(defGet, "defGet");

      function defSet(obj, name, m) {
        if (obj != STAT_INIT) {
          if (typeof Object.defineProperty != 'undefined') {
            Object.defineProperty(obj, name, {
              configurable: true,
              set: m
            });
          } else {
            obj.__defineSetter__(name, m);
          }
        }
      }
      registerName(defSet, "defSet");

      function defStatGet(obj, cls, name, m) {
        if (obj == STAT_INIT) defGet(cls, name, m);
      }
      registerName(defStatGet, "defStatGet");

      function defStatSet(obj, cls, name, m) {
        if (obj == STAT_INIT) defSet(cls, name, m);
      }
      registerName(defStatSet, "defStatSet");

      function slIsArray(inObj) {

        if (inObj.constructor == Array) {
          return true;
        } else if (typeof inObj.length == 'undefined') {
          return false;
        } else {
          return true;
        }
      }
      registerName(slIsArray, "slIsArray");

      function slForEachPropValue(a, f) {
        var ist = slIsArray(a);
        if (slIsArray(a)) {
          for (var i = 0; i < a.length; i++) {
            f(a[i]);
          }
        } else {
          for (var p in a) {
            if (a.hasOwnProperty(p)) f(a[p]);
          }
        }
      }
      registerName(slForEachPropValue, "slForEachPropValue");

      function slForEachProp(a, f) {
        if (slIsArray(a)) {
          for (var i = 0; i < a.length; i++) {
            f(i);
          }
        } else {
          for (var p in a) {
            if (a.hasOwnProperty(p)) f(p);
          }
        }
      }
      registerName(slForEachProp, "slForEachProp");

      function declTestClass(obj, name, cls, meta) {
        if (obj == STAT_INIT) jstest.DeclareTestClass(name, cls, meta);
      }
      registerName(declTestClass, "declTestClass");

      function declTestMethod(obj, clsname, mname, mcode, meta) {
        if (obj == STAT_INIT) {
          jstest.DeclareTestMethod(clsname, mname, meta);
        } else {
          jstest.SetTestMethodClosure(clsname, mname, mcode);
        }
      }
      registerName(declTestMethod, "declTestMethod");

      function sluint() {
        sluint.two32 = 0x100000000;

        sluint.Cast = function (v) {
          var vi = parseInt(v);
          if (vi > sluint.MaxValue) {
            vi = vi % sluint.two32;
          } else if (vi < 0) {
            vi = -vi % sluint.two32;
            vi = sluint.two32 - vi;
          }
          return vi;
        };

        sluint.uintRegex = new RegExp("^[0-9]+$");
        sluint.Parse = function (v) {
          Lang.parseChecker(v, sluint.uintRegex);
          return sluint.Cast(v);
        };

        sluint.MaxValue = sluint.two32 - 1;
        sluint.MinValue = 0;
      }
      statInit(sluint, "sluint");

      function slint() {
        slint.Cast = function (v) {

          var vu = sluint.Cast(v);
          if (vu > slint.MaxValue) {
            vu = vu - sluint.two32;
          }
          return vu;
        };

        slint.intRegex = new RegExp("^[+-]?[0-9]+$");
        slint.Parse = function (v) {
          Lang.parseChecker(v, slint.intRegex);
          return slint.Cast(v);
        };

        slint.MaxValue = 0x7FFFFFFF;
        slint.MinValue = -0x80000000;
      }
      statInit(slint, "slint");

      function Int64() {
        var _s = this;

        if (_s == STAT_INIT) Int64.TWO_TO_32 = 4294967296.0;

        function __constr() {
          _s._l = 0;
          _s._h = 0;
        };

        defStatMeth(_s, Int64, "fromUnsignedInt", __fromUnsignedInt);
        function __fromUnsignedInt(i) {
          var res = new Int64();
          res._h = 0;
          res._l = i;
          return res;
        };

        defStatMeth(_s, Int64, "fromInt", __fromInt);
        function __fromInt(i) {
          var res = new Int64();
          if (i >= 0) {
            res._h = 0;
            res._l = sluint.Cast(i);
          } else {
            res._h = -1;
            res._l = sluint.Cast(i);
          }
          return res;
        };

        defStatMeth(_s, Int64, "fromNumber", __fromNumber);
        function __fromNumber(n) {
          var l1 = n % Int64.TWO_TO_32;

          if (l1 < 0) {
            l1 = Number(sluint.MaxValue) + 1.0 + l1;
          }
          var res = new Int64();
          res._l = sluint.Cast(l1 + 0.5);
          res._h = slint.Cast((n - l1) / Int64.TWO_TO_32);

          return res;
        };

        defGet(_s, "asNumber", __asNumber);
        function __asNumber() {
          return Number(_s._h) * Int64.TWO_TO_32 + Number(_s._l);
        };

        if (_s != STAT_INIT) {
          this.toString = function () {
            return _s.asNumber.toString();
          };
        }

        if (_s != STAT_INIT) __constr.apply(this, arguments);
      };
      statInit(Int64, "Int64");

      function UInt64() {

        var _s = this;

        function __constr() {

          Int64.call(_s);
          _s._l = 0;
          _s._h = 0;
        }

        defStatMeth(_s, UInt64, "fromUnsignedInt", __fromUnsignedInt);
        function __fromUnsignedInt(i) {
          var res = new UInt64();
          res._h = 0;
          res._l = i;
          return res;
        };

        defStatMeth(_s, UInt64, "fromNumber", __fromNumber);
        function __fromNumber(n) {
          var res = new UInt64();
          res._h = Math.floor(n / Int64.TWO_TO_32);
          res._l = n % Int64.TWO_TO_32;
          return res;
        };

        if (_s != STAT_INIT) __constr.apply(arguments);
      };
      statInit(UInt64, "UInt64");

      function CandidateStream() {
        var _s = this;

        function _constr(id, bitrate, resource) {
          _s.id = id;
          _s.bitrate = bitrate;
          _s.resource = resource;
        }

        defPubMeth(_s, "Cleanup", __Cleanup);defPubMeth(_s, "Cleanup", __Cleanup);
        function __Cleanup() {
          _s.id = null;
          _s.bitrate = 0;
          _s.resource = null;
        }

        if (_s != STAT_INIT) _s.__auto_id = undefined;
        defGet(_s, "id", __get_id);defGet(_s, "id", __get_id);
        function __get_id() {
          return _s.__auto_id;
        }
        defSet(_s, "id", __set_id);defSet(_s, "id", __set_id);
        function __set_id(value) {
          _s.__auto_id = value;
        }

        if (_s != STAT_INIT) _s.__auto_bitrate = undefined;
        defGet(_s, "bitrate", __get_bitrate);defGet(_s, "bitrate", __get_bitrate);
        function __get_bitrate() {
          return _s.__auto_bitrate;
        }
        defSet(_s, "bitrate", __set_bitrate);defSet(_s, "bitrate", __set_bitrate);
        function __set_bitrate(value) {
          _s.__auto_bitrate = value;
        }

        if (_s != STAT_INIT) _s.__auto_resource = undefined;
        defGet(_s, "resource", __get_resource);defGet(_s, "resource", __get_resource);
        function __get_resource() {
          return _s.__auto_resource;
        }
        defSet(_s, "resource", __set_resource);defSet(_s, "resource", __set_resource);
        function __set_resource(value) {
          _s.__auto_resource = value;
        }

        defPubMeth(_s, "CheckValidity", __CheckValidity);defPubMeth(_s, "CheckValidity", __CheckValidity);
        function __CheckValidity() {

          if (_s.id != null && !(typeof _s.id === "string")) {
            return "CandidateStream.id is not a string";
          } else if (_s.bitrate != null && !(typeof _s.bitrate === "number")) {
            return "CandidateStream.bitrate is not an int";
          } else if (_s.resource != null && !(typeof _s.resource === "string")) {
            return "CandidateStream.resource is not a string";
          }
          return null;
        }

        defStatMeth(_s, CandidateStream, "ConstructClone", __ConstructClone);defStatMeth(_s, CandidateStream, "ConstructClone", __ConstructClone);
        function __ConstructClone(fromObj) {
          if (fromObj == null) return null;
          var res = new CandidateStream("", -1, null);
          res.id = NativeLang.GetStringField("id", fromObj);
          res.bitrate = slint.Cast(NativeLang.GetField("bitrate", fromObj));
          res.resource = NativeLang.GetStringField("resource", fromObj);
          return res;
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(CandidateStream, "CandidateStream");

      function ConvivaContentInfo() {
        var _s = this;

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_AKAMAI = "AKAMAI";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_AMAZON = "AMAZON";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_ATT = "ATT";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_BITGRAVITY = "BITGRAVITY";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_BT = "BT";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_CDNETWORKS = "CDNETWORKS";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_CHINACACHE = "CHINACACHE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_EDGECAST = "EDGECAST";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_HIGHWINDS = "HIGHWINDS";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_INTERNAP = "INTERNAP";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_LEVEL3 = "LEVEL3";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_LIMELIGHT = "LIMELIGHT";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_OCTOSHAPE = "OCTOSHAPE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_SWARMCAST = "SWARMCAST";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_VELOCIX = "VELOCIX";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_TELEFONICA = "TELEFONICA";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_MICROSOFT = "MICROSOFT";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_CDNVIDEO = "CDNVIDEO";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_QBRICK = "QBRICK";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_NGENIX = "NGENIX";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_IPONLY = "IPONLY";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_TALKTALK = "TALKTALK";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_INHOUSE = "INHOUSE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_COMCAST = "COMCAST";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_NICE = "NICE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_TELENOR = "TELENOR";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_FASTLY = "FASTLY";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_TELIA = "TELIA";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_CHINANETCENTER = "CHINANETCENTER";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_MIRRORIMAGE = "MIRRORIMAGE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_SONIC = "SONIC";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_ATLAS = "ATLAS";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_OOYALA = "OOYALA";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_TATA = "TATA";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_GOOGLE = "GOOGLE";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_INSTARTLOGIC = "INSTARTLOGIC";

        if (_s == STAT_INIT) ConvivaContentInfo.CDN_NAME_OTHER = "OTHER";

        if (_s == STAT_INIT) ConvivaContentInfo.FRAMEWORK_NAME_BRIGHTCOVE = "Brightcove";

        if (_s == STAT_INIT) ConvivaContentInfo.FRAMEWORK_NAME_KALTURA = "Kaltura";

        if (_s == STAT_INIT) ConvivaContentInfo.FRAMEWORK_NAME_OOYALA = "Ooyala";

        if (_s == STAT_INIT) ConvivaContentInfo.FRAMEWORK_NAME_OSMF = "OSMF";

        if (_s == STAT_INIT) ConvivaContentInfo.FRAMEWORK_NAME_THE_PLATFORM = "thePlatform";

        if (_s == STAT_INIT) ConvivaContentInfo.DEVICE_TYPE_CONSOLE = "Console";

        if (_s == STAT_INIT) ConvivaContentInfo.DEVICE_TYPE_MOBILE = "Mobile";

        if (_s == STAT_INIT) ConvivaContentInfo.DEVICE_TYPE_PC = "PC";

        if (_s == STAT_INIT) ConvivaContentInfo.DEVICE_TYPE_SET_TOP_BOX = "Settop";

        if (_s == STAT_INIT) ConvivaContentInfo.PLUGIN_NAME_KALTURA = "ConvivaKalturaPlugin";

        if (_s == STAT_INIT) ConvivaContentInfo.NO_RESOURCE = "no_resource";

        if (_s != STAT_INIT) _s.assetName = undefined;

        if (_s != STAT_INIT) _s._tags = null;

        defGet(_s, "tags", __get_tags);defGet(_s, "tags", __get_tags);
        function __get_tags() {
          return Lang.StringDictionaryToRepr(_s._tags);
        }
        defSet(_s, "tags", __set_tags);defSet(_s, "tags", __set_tags);
        function __set_tags(value) {
          _s._tags = Lang.DictionaryFromRepr(value);
        }

        if (_s != STAT_INIT) _s.defaultReportingBitrateKbps = -1;

        if (_s != STAT_INIT) _s.defaultReportingCdnName = ConvivaContentInfo.CDN_NAME_OTHER;

        if (_s != STAT_INIT) _s.defaultReportingResource = null;

        if (_s != STAT_INIT) _s.frameworkName = null;

        if (_s != STAT_INIT) _s.frameworkVersion = null;

        if (_s != STAT_INIT) _s.pluginName = null;

        if (_s != STAT_INIT) _s.pluginVersion = null;

        if (_s != STAT_INIT) _s.viewerId = null;

        if (_s != STAT_INIT) _s.deviceId = null;

        if (_s != STAT_INIT) _s.deviceType = null;

        if (_s != STAT_INIT) _s.playerName = null;

        if (_s != STAT_INIT) _s.streamUrl = null;

        if (_s != STAT_INIT) _s._isLive = false;

        defGet(_s, "isLive", __get_isLive);defGet(_s, "isLive", __get_isLive);
        function __get_isLive() {
          return _s._isLive;
        }
        defSet(_s, "isLive", __set_isLive);defSet(_s, "isLive", __set_isLive);
        function __set_isLive(value) {
          if (value === "true") {
            value = true;
          }
          if (value === "false") {
            value = false;
          }
          if (value !== true && value !== false) {
            var utils = Utils.getInstance();
            utils.err("Invalid value for ConvivaContentInfo.isLive, expected boolean. Defaulting to false.");
            value = false;
          }
          _s._isLive = value;
        }

        function _constr(assetName, tags) {
          _s.assetName = assetName;
          _s.tags = tags;
          if (_s._tags == null) {
            _s._tags = new DictionaryCS();
          }
        }

        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_AKAMAI", ConvivaContentInfo.CDN_NAME_AKAMAI);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_AMAZON", ConvivaContentInfo.CDN_NAME_AMAZON);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_ATLAS", ConvivaContentInfo.CDN_NAME_ATLAS);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_ATT", ConvivaContentInfo.CDN_NAME_ATT);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_BITGRAVITY", ConvivaContentInfo.CDN_NAME_BITGRAVITY);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_BT", ConvivaContentInfo.CDN_NAME_BT);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_CDNETWORKS", ConvivaContentInfo.CDN_NAME_CDNETWORKS);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_CDNVIDEO", ConvivaContentInfo.CDN_NAME_CDNVIDEO);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_CHINACACHE", ConvivaContentInfo.CDN_NAME_CHINACACHE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_CHINANETCENTER", ConvivaContentInfo.CDN_NAME_CHINANETCENTER);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_COMCAST", ConvivaContentInfo.CDN_NAME_COMCAST);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_EDGECAST", ConvivaContentInfo.CDN_NAME_EDGECAST);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_FASTLY", ConvivaContentInfo.CDN_NAME_FASTLY);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_GOOGLE", ConvivaContentInfo.CDN_NAME_GOOGLE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_HIGHWINDS", ConvivaContentInfo.CDN_NAME_HIGHWINDS);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_INHOUSE", ConvivaContentInfo.CDN_NAME_INHOUSE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_INSTARTLOGIC", ConvivaContentInfo.CDN_NAME_INSTARTLOGIC);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_INTERNAP", ConvivaContentInfo.CDN_NAME_INTERNAP);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_IPONLY", ConvivaContentInfo.CDN_NAME_IPONLY);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_LEVEL3", ConvivaContentInfo.CDN_NAME_LEVEL3);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_LIMELIGHT", ConvivaContentInfo.CDN_NAME_LIMELIGHT);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_MICROSOFT", ConvivaContentInfo.CDN_NAME_MICROSOFT);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_MIRRORIMAGE", ConvivaContentInfo.CDN_NAME_MIRRORIMAGE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_NGENIX", ConvivaContentInfo.CDN_NAME_NGENIX);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_NICE", ConvivaContentInfo.CDN_NAME_NICE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_OCTOSHAPE", ConvivaContentInfo.CDN_NAME_OCTOSHAPE);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_OOYALA", ConvivaContentInfo.CDN_NAME_OOYALA);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_OTHER", ConvivaContentInfo.CDN_NAME_OTHER);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_QBRICK", ConvivaContentInfo.CDN_NAME_QBRICK);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_SONIC", ConvivaContentInfo.CDN_NAME_SONIC);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_SWARMCAST", ConvivaContentInfo.CDN_NAME_SWARMCAST);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_TALKTALK", ConvivaContentInfo.CDN_NAME_TALKTALK);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_TATA", ConvivaContentInfo.CDN_NAME_TATA);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_TELEFONICA", ConvivaContentInfo.CDN_NAME_TELEFONICA);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_TELENOR", ConvivaContentInfo.CDN_NAME_TELENOR);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_TELIA", ConvivaContentInfo.CDN_NAME_TELIA);
        defStatMeth(_s, ConvivaContentInfo, "CDN_NAME_VELOCIX", ConvivaContentInfo.CDN_NAME_VELOCIX);
        defStatMeth(_s, ConvivaContentInfo, "DEVICE_TYPE_CONSOLE", ConvivaContentInfo.DEVICE_TYPE_CONSOLE);
        defStatMeth(_s, ConvivaContentInfo, "DEVICE_TYPE_MOBILE", ConvivaContentInfo.DEVICE_TYPE_MOBILE);
        defStatMeth(_s, ConvivaContentInfo, "DEVICE_TYPE_PC", ConvivaContentInfo.DEVICE_TYPE_PC);
        defStatMeth(_s, ConvivaContentInfo, "DEVICE_TYPE_SET_TOP_BOX", ConvivaContentInfo.DEVICE_TYPE_SET_TOP_BOX);
        defStatMeth(_s, ConvivaContentInfo, "FRAMEWORK_NAME_BRIGHTCOVE", ConvivaContentInfo.FRAMEWORK_NAME_BRIGHTCOVE);
        defStatMeth(_s, ConvivaContentInfo, "FRAMEWORK_NAME_KALTURA", ConvivaContentInfo.FRAMEWORK_NAME_KALTURA);
        defStatMeth(_s, ConvivaContentInfo, "FRAMEWORK_NAME_OOYALA", ConvivaContentInfo.FRAMEWORK_NAME_OOYALA);
        defStatMeth(_s, ConvivaContentInfo, "FRAMEWORK_NAME_OSMF", ConvivaContentInfo.FRAMEWORK_NAME_OSMF);
        defStatMeth(_s, ConvivaContentInfo, "FRAMEWORK_NAME_THE_PLATFORM", ConvivaContentInfo.FRAMEWORK_NAME_THE_PLATFORM);
        defStatMeth(_s, ConvivaContentInfo, "NO_RESOURCE", ConvivaContentInfo.NO_RESOURCE);
        defStatMeth(_s, ConvivaContentInfo, "PLUGIN_NAME_KALTURA", ConvivaContentInfo.PLUGIN_NAME_KALTURA);
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(ConvivaContentInfo, "ConvivaContentInfo");

      function ConvivaStreamerProxy() {
        var _s = this;

        if (_s != STAT_INIT) _s._notifiers = new ListCS();

        if (_s != STAT_INIT) _s._stream = new StreamInfo(-1, ConvivaContentInfo.CDN_NAME_OTHER, ConvivaContentInfo.NO_RESOURCE, -1, -1, -1);
        if (_s != STAT_INIT) _s._playingState = ConvivaStreamerProxy.UNKNOWN;

        if (_s != STAT_INIT) _s._lastMetadata = null;

        if (_s != STAT_INIT) _s._lastError = null;

        if (_s != STAT_INIT) _s._pendingErrors = new ListCS();

        if (_s != STAT_INIT) _s._displayWidth = -1;

        if (_s != STAT_INIT) _s._displayHeight = -1;

        if (_s != STAT_INIT) _s._availableStreams = null;

        if (_s != STAT_INIT) _s._currentLoadingStatus = null;

        if (_s != STAT_INIT) _s.isProxyInitialized = undefined;

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_PLAYINGSTATECHANGE = "PlayingStateChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_STREAMINFOCHANGE = "StreamInfoChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_AVAILABLESTREAMINFOCHANGE = "AvailableStreamInfoChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_PROXYINITIALIZED = "ProxyInitialized";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_METADATACHANGE = "MetadataChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_LOADINGSTATUSCHANGE = "LoadingStatusChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_DOWNLOADSTATECHANGE = "DownloadStateChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_DISPLAYSIZECHANGE = "DisplaySizeChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_ERRORCHANGE = "ErrorChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_LOG = "Log";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_RESOURCE_ERROR = "ResourceError";

        if (_s == STAT_INIT) ConvivaStreamerProxy.REASON_PRESENTATION_CHANGE = "PresentationChange";

        if (_s == STAT_INIT) ConvivaStreamerProxy.STOPPED = "STOPPED";

        if (_s == STAT_INIT) ConvivaStreamerProxy.PLAYING = "PLAYING";

        if (_s == STAT_INIT) ConvivaStreamerProxy.BUFFERING = "BUFFERING";

        if (_s == STAT_INIT) ConvivaStreamerProxy.PAUSED = "PAUSED";

        if (_s == STAT_INIT) ConvivaStreamerProxy.NOT_MONITORED = "NOT_MONITORED";

        if (_s == STAT_INIT) ConvivaStreamerProxy.ERROR = "ERROR";

        if (_s == STAT_INIT) ConvivaStreamerProxy.UNKNOWN = "UNKNOWN";

        if (_s == STAT_INIT) ConvivaStreamerProxy.DOWNLOADSTATE_ACTIVE = 1;

        if (_s == STAT_INIT) ConvivaStreamerProxy.DOWNLOADSTATE_INACTIVE = 0;

        if (_s == STAT_INIT) ConvivaStreamerProxy.METADATA_DURATION = "duration";

        if (_s == STAT_INIT) ConvivaStreamerProxy.METADATA_ENCODED_FRAMERATE = "framerate";

        if (_s == STAT_INIT) ConvivaStreamerProxy.BOOLEAN_TRUE = 1;
        if (_s == STAT_INIT) ConvivaStreamerProxy.BOOLEAN_FALSE = -1;
        if (_s == STAT_INIT) ConvivaStreamerProxy.BOOLEAN_UNAVAILABLE = 0;

        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_VIDEO = 1;
        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_QUALITY_METRICS = 2;
        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_BITRATE_METRICS = 4;

        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_BITRATE_SWITCHING = 8;
        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_CDN_SWITCHING = 16;

        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_BITRATE_EXTERNAL = 16;

        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_SOURCE_HTTP = 32;
        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_SOURCE_CHUNKED = 64;
        if (_s == STAT_INIT) ConvivaStreamerProxy.CAPABILITY_SOURCE_STREAMING = 128;

        function _constr() {}

        defPubMeth(_s, "Cleanup", __Cleanup);defPubMeth(_s, "Cleanup", __Cleanup);
        function __Cleanup() {
          if (_s._notifiers != null) {
            _s._notifiers.Clear();
          }
        }

        defPubMeth(_s, "GetCapabilities", __GetCapabilities);defPubMeth(_s, "GetCapabilities", __GetCapabilities);
        function __GetCapabilities() {
          return 0;
        }

        defPubMeth(_s, "GetPlayheadTimeMs", __GetPlayheadTimeMs);defPubMeth(_s, "GetPlayheadTimeMs", __GetPlayheadTimeMs);
        function __GetPlayheadTimeMs() {
          return -1;
        }

        defPubMeth(_s, "GetIsPHTAccurate", __GetIsPHTAccurate);defPubMeth(_s, "GetIsPHTAccurate", __GetIsPHTAccurate);
        function __GetIsPHTAccurate() {
          return true;
        }

        defPubMeth(_s, "GetBufferLengthMs", __GetBufferLengthMs);defPubMeth(_s, "GetBufferLengthMs", __GetBufferLengthMs);
        function __GetBufferLengthMs() {
          return -1;
        }

        defPubMeth(_s, "GetVideoBufferLengthMs", __GetVideoBufferLengthMs);defPubMeth(_s, "GetVideoBufferLengthMs", __GetVideoBufferLengthMs);
        function __GetVideoBufferLengthMs() {
          return -1;
        }

        defPubMeth(_s, "GetAudioBufferLengthMs", __GetAudioBufferLengthMs);defPubMeth(_s, "GetAudioBufferLengthMs", __GetAudioBufferLengthMs);
        function __GetAudioBufferLengthMs() {
          return -1;
        }

        defPubMeth(_s, "GetStartingBufferLengthMs", __GetStartingBufferLengthMs);defPubMeth(_s, "GetStartingBufferLengthMs", __GetStartingBufferLengthMs);
        function __GetStartingBufferLengthMs() {
          return -1;
        }

        defPubMeth(_s, "SetStartingBufferLengthMs", __SetStartingBufferLengthMs);defPubMeth(_s, "SetStartingBufferLengthMs", __SetStartingBufferLengthMs);
        function __SetStartingBufferLengthMs(ms) {}

        defPubMeth(_s, "GetIsStartingBufferFull", __GetIsStartingBufferFull);defPubMeth(_s, "GetIsStartingBufferFull", __GetIsStartingBufferFull);
        function __GetIsStartingBufferFull() {
          return false;
        }

        defPubMeth(_s, "GetRenderedFrameRate", __GetRenderedFrameRate);defPubMeth(_s, "GetRenderedFrameRate", __GetRenderedFrameRate);
        function __GetRenderedFrameRate() {
          return -1.0;
        }

        defPubMeth(_s, "GetSourceFrameRate", __GetSourceFrameRate);defPubMeth(_s, "GetSourceFrameRate", __GetSourceFrameRate);
        function __GetSourceFrameRate() {
          return -1.0;
        }

        defPubMeth(_s, "GetDroppedFrames", __GetDroppedFrames);defPubMeth(_s, "GetDroppedFrames", __GetDroppedFrames);
        function __GetDroppedFrames() {
          return -1;
        }

        defPubMeth(_s, "GetCpuPercent", __GetCpuPercent);defPubMeth(_s, "GetCpuPercent", __GetCpuPercent);
        function __GetCpuPercent() {
          return -1.0;
        }

        defPubMeth(_s, "GetMemoryAvailable", __GetMemoryAvailable);defPubMeth(_s, "GetMemoryAvailable", __GetMemoryAvailable);
        function __GetMemoryAvailable() {
          return -1.0;
        }

        defPubMeth(_s, "GetCapacityKbps", __GetCapacityKbps);defPubMeth(_s, "GetCapacityKbps", __GetCapacityKbps);
        function __GetCapacityKbps(resource) {
          return -1;
        }

        defPubMeth(_s, "GetServerAddress", __GetServerAddress);defPubMeth(_s, "GetServerAddress", __GetServerAddress);
        function __GetServerAddress() {
          return null;
        }

        defPubMeth(_s, "GetIsLive", __GetIsLive);defPubMeth(_s, "GetIsLive", __GetIsLive);
        function __GetIsLive() {
          return ConvivaStreamerProxy.BOOLEAN_UNAVAILABLE;
        }

        defPubMeth(_s, "GetStreamerVersion", __GetStreamerVersion);defPubMeth(_s, "GetStreamerVersion", __GetStreamerVersion);
        function __GetStreamerVersion() {
          return -1;
        }

        defPubMeth(_s, "FetchCandidateStreams", __FetchCandidateStreams);defPubMeth(_s, "FetchCandidateStreams", __FetchCandidateStreams);
        function __FetchCandidateStreams(resource) {}

        defPubMeth(_s, "Play", __Play);defPubMeth(_s, "Play", __Play);
        function __Play(destination) {}

        defPubMeth(_s, "GetApiVersion", __GetApiVersion);defPubMeth(_s, "GetApiVersion", __GetApiVersion);
        function __GetApiVersion() {
          return ConvivaStreamerProxy.API_VERSION;
        }
        if (_s == STAT_INIT) ConvivaStreamerProxy.API_VERSION = 1;

        defPubMeth(_s, "SetMonitoringNotifier", __SetMonitoringNotifier);defPubMeth(_s, "SetMonitoringNotifier", __SetMonitoringNotifier);
        function __SetMonitoringNotifier(notifier) {

          if (notifier == null) return;

          var previousNotifiers = _s._notifiers;

          var newNotifiers = new ListCS();
          newNotifiers.Add(notifier);
          _s._notifiers = newNotifiers;

          if (_s._notifiers != null) {

            if (_s.isProxyInitialized) {
              notifier(ConvivaStreamerProxy.REASON_PROXYINITIALIZED, null);
            }

            _s.SetDownloadStateChange(StreamInfo.VIDEO, ConvivaStreamerProxy.DOWNLOADSTATE_ACTIVE);
            _s.SetDownloadStateChange(StreamInfo.AUDIO, ConvivaStreamerProxy.DOWNLOADSTATE_ACTIVE);

            var newInfo = _s._stream;
            _s._stream = new StreamInfo(-1, ConvivaContentInfo.CDN_NAME_OTHER, ConvivaContentInfo.NO_RESOURCE, -1, -1, -1);
            _s.SetStream(newInfo);

            var newState = _s._playingState;
            _s._playingState = ConvivaStreamerProxy.UNKNOWN;
            _s.SetPlayingState(newState);

            var newMetadata = _s._lastMetadata;
            _s._lastMetadata = null;
            _s.SetMetadata(newMetadata);

            var _for_array_1 = _s._pendingErrors.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var strErr = _for_array_1[_for_idx_2];

              _s.SetError(strErr);
            }

            var newStreams = _s._availableStreams;
            _s._availableStreams = null;
            _s.SetAvailableStreams(newStreams);

            var newChunkDownloadStatus = _s._currentLoadingStatus;
            _s._currentLoadingStatus = null;
            _s.SetLoadingStatus(newChunkDownloadStatus);

            var newDiplayWidth = _s._displayWidth;
            var newDisplayHeight = _s._displayWidth;
            _s._displayWidth = -1;
            _s._displayHeight = -1;
            _s.SetDisplaySize(newDiplayWidth, newDisplayHeight);
          }

          previousNotifiers.Add(notifier);
          _s._notifiers = previousNotifiers;
        }

        defPubMeth(_s, "GetLoadingStatus", __GetLoadingStatus);defPubMeth(_s, "GetLoadingStatus", __GetLoadingStatus);
        function __GetLoadingStatus() {
          return _s._currentLoadingStatus;
        }

        defPubMeth(_s, "GetPlayingState", __GetPlayingState);defPubMeth(_s, "GetPlayingState", __GetPlayingState);
        function __GetPlayingState() {
          return _s._playingState;
        }

        defPubMeth(_s, "GetBitrateKbps", __GetBitrateKbps);defPubMeth(_s, "GetBitrateKbps", __GetBitrateKbps);
        function __GetBitrateKbps() {
          return _s._stream.bitrateKbps;
        }

        defPubMeth(_s, "GetCdnName", __GetCdnName);defPubMeth(_s, "GetCdnName", __GetCdnName);
        function __GetCdnName() {
          return _s._stream.cdnName;
        }

        defPubMeth(_s, "GetResource", __GetResource);defPubMeth(_s, "GetResource", __GetResource);
        function __GetResource() {
          return _s._stream.resource;
        }

        defPubMeth(_s, "GetStream", __GetStream);defPubMeth(_s, "GetStream", __GetStream);
        function __GetStream() {
          return _s._stream;
        }

        defPubMeth(_s, "GetStreams", __GetStreams);defPubMeth(_s, "GetStreams", __GetStreams);
        function __GetStreams() {
          return null;
        }

        defPubMeth(_s, "GetLastError", __GetLastError);defPubMeth(_s, "GetLastError", __GetLastError);
        function __GetLastError() {
          return _s._lastError;
        }

        defPubMeth(_s, "GetLastMetadata", __GetLastMetadata);defPubMeth(_s, "GetLastMetadata", __GetLastMetadata);
        function __GetLastMetadata() {
          return _s._lastMetadata;
        }

        defPubMeth(_s, "GetDisplayWidth", __GetDisplayWidth);defPubMeth(_s, "GetDisplayWidth", __GetDisplayWidth);
        function __GetDisplayWidth() {
          return _s._displayWidth;
        }

        defPubMeth(_s, "GetDisplayHeight", __GetDisplayHeight);defPubMeth(_s, "GetDisplayHeight", __GetDisplayHeight);
        function __GetDisplayHeight() {
          return _s._displayHeight;
        }

        defPubMeth(_s, "GetStreamerType", __GetStreamerType);defPubMeth(_s, "GetStreamerType", __GetStreamerType);
        function __GetStreamerType() {
          return null;
        }

        defPubMeth(_s, "GetLoadedBytes", __GetLoadedBytes);defPubMeth(_s, "GetLoadedBytes", __GetLoadedBytes);
        function __GetLoadedBytes() {
          return -1;
        }

        defPubMeth(_s, "SetDownloadStateChange", __SetDownloadStateChange);defPubMeth(_s, "SetDownloadStateChange", __SetDownloadStateChange);
        function __SetDownloadStateChange(type, state) {
          var downloadStateChange = new ListCS();
          downloadStateChange.Add(type);
          downloadStateChange.Add(state);
          var _for_array_1 = _s._notifiers.Values;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var notifier = _for_array_1[_for_idx_2];

            _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_DOWNLOADSTATECHANGE, downloadStateChange);
          }
        }

        defPubMeth(_s, "SetStream", __SetStream);defPubMeth(_s, "SetStream", __SetStream);
        function __SetStream(updatedStream) {

          if (updatedStream.bitrateKbps <= -2) updatedStream.bitrateKbps = _s._stream.bitrateKbps;
          if (updatedStream.cdnName == null) updatedStream.cdnName = _s._stream.cdnName;
          if (updatedStream.resource == null) updatedStream.resource = _s._stream.resource;
          if (!_s._stream.equals(updatedStream)) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_STREAMINFOCHANGE, updatedStream);
            }
          }
          _s._stream = updatedStream;
        }

        defPubMeth(_s, "SetError", __SetError);defPubMeth(_s, "SetError", __SetError);
        function __SetError(error) {

          _s._lastError = error;

          if (_s._notifiers != null && _s._notifiers.Count > 0) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_ERRORCHANGE, error);
            }
          } else {
            _s._pendingErrors.Add(error);
          }
        }

        defPubMeth(_s, "SetMetadata", __SetMetadata);defPubMeth(_s, "SetMetadata", __SetMetadata);
        function __SetMetadata(metadata) {

          _s._lastMetadata = metadata;

          if (metadata != null) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_METADATACHANGE, metadata);
            }
          }
        }

        defPubMeth(_s, "Log", __Log);defPubMeth(_s, "Log", __Log);
        function __Log(message) {
          var _for_array_1 = _s._notifiers.Values;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var notifier = _for_array_1[_for_idx_2];

            _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_LOG, message);
          }
        }

        defPubMeth(_s, "LogError", __LogError);defPubMeth(_s, "LogError", __LogError);
        function __LogError(message) {
          var _for_array_1 = _s._notifiers.Values;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var notifier = _for_array_1[_for_idx_2];

            _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_LOG, "ERROR:" + message);
          }
        }

        defPubMeth(_s, "GetTotalLoadedBytes", __GetTotalLoadedBytes);defPubMeth(_s, "GetTotalLoadedBytes", __GetTotalLoadedBytes);
        function __GetTotalLoadedBytes() {
          return null;
        }

        defPubMeth(_s, "SetLoadingStatus", __SetLoadingStatus);defPubMeth(_s, "SetLoadingStatus", __SetLoadingStatus);
        function __SetLoadingStatus(loadingStatus) {
          _s._currentLoadingStatus = loadingStatus;
          if (loadingStatus != null) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_LOADINGSTATUSCHANGE, loadingStatus);
            }
          }
        }

        defPubMeth(_s, "SetPlayingState", __SetPlayingState);defPubMeth(_s, "SetPlayingState", __SetPlayingState);
        function __SetPlayingState(newState) {

          if (newState != _s._playingState) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_PLAYINGSTATECHANGE, newState);
            }
          }
          _s._playingState = newState;
        }

        defPubMeth(_s, "SetBitrateKbps", __SetBitrateKbps);defPubMeth(_s, "SetBitrateKbps", __SetBitrateKbps);
        function __SetBitrateKbps(updatedBitrateKbps) {
          var updatedStream = new StreamInfo(updatedBitrateKbps, null, null, -1, -1, -1);
          _s.SetStream(updatedStream);
        }

        defPubMeth(_s, "SetCdnName", __SetCdnName);defPubMeth(_s, "SetCdnName", __SetCdnName);
        function __SetCdnName(updatedCdnName) {
          var updatedStream = new StreamInfo(-2, updatedCdnName, null, -1, -1, -1);
          _s.SetStream(updatedStream);
        }

        defPubMeth(_s, "SetResource", __SetResource);defPubMeth(_s, "SetResource", __SetResource);
        function __SetResource(updatedResource) {
          var updatedStream = new StreamInfo(-2, null, updatedResource, -1, -1, -1);
          _s.SetStream(updatedStream);
        }

        defPubMeth(_s, "SetDisplaySize", __SetDisplaySize);defPubMeth(_s, "SetDisplaySize", __SetDisplaySize);
        function __SetDisplaySize(displayWidth, displayHeight) {

          if (displayWidth != -1 && displayHeight != -1) {

            _s._displayWidth = displayWidth;
            _s._displayHeight = displayHeight;

            var displaySize = new ListCS();
            displaySize.Add(displayWidth);
            displaySize.Add(displayHeight);
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_DISPLAYSIZECHANGE, displaySize);
            }
          }
        }

        defPubMeth(_s, "SetAvailableStreams", __SetAvailableStreams);defPubMeth(_s, "SetAvailableStreams", __SetAvailableStreams);
        function __SetAvailableStreams(streams) {
          _s._availableStreams = streams;
          if (streams != null) {
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_AVAILABLESTREAMINFOCHANGE, streams);
            }
          }
        }

        defPubMeth(_s, "SetProxyInitialized", __SetProxyInitialized);defPubMeth(_s, "SetProxyInitialized", __SetProxyInitialized);
        function __SetProxyInitialized() {
          if (!_s.isProxyInitialized) {
            _s.isProxyInitialized = true;
            var _for_array_1 = _s._notifiers.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var notifier = _for_array_1[_for_idx_2];

              _s.notifyListeners(notifier, ConvivaStreamerProxy.REASON_PROXYINITIALIZED, null);
            }
          }
        }

        defPrivMeth(_s, "notifyListeners", __notifyListeners);
        function __notifyListeners(notifier, reason, arg) {
          try {
            notifier(reason, arg);
          } catch (e) {
            notifier(ConvivaStreamerProxy.REASON_LOG, "ConvivaStreamerProxy : uncaught exception " + e);
          }
        }

        defStatMeth(_s, ConvivaStreamerProxy, "API_VERSION", ConvivaStreamerProxy.API_VERSION);
        defStatMeth(_s, ConvivaStreamerProxy, "BOOLEAN_FALSE", ConvivaStreamerProxy.BOOLEAN_FALSE);
        defStatMeth(_s, ConvivaStreamerProxy, "BOOLEAN_TRUE", ConvivaStreamerProxy.BOOLEAN_TRUE);
        defStatMeth(_s, ConvivaStreamerProxy, "BOOLEAN_UNAVAILABLE", ConvivaStreamerProxy.BOOLEAN_UNAVAILABLE);
        defStatMeth(_s, ConvivaStreamerProxy, "BUFFERING", ConvivaStreamerProxy.BUFFERING);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_BITRATE_EXTERNAL", ConvivaStreamerProxy.CAPABILITY_BITRATE_EXTERNAL);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_BITRATE_METRICS", ConvivaStreamerProxy.CAPABILITY_BITRATE_METRICS);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_BITRATE_SWITCHING", ConvivaStreamerProxy.CAPABILITY_BITRATE_SWITCHING);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_CDN_SWITCHING", ConvivaStreamerProxy.CAPABILITY_CDN_SWITCHING);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_QUALITY_METRICS", ConvivaStreamerProxy.CAPABILITY_QUALITY_METRICS);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_SOURCE_CHUNKED", ConvivaStreamerProxy.CAPABILITY_SOURCE_CHUNKED);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_SOURCE_HTTP", ConvivaStreamerProxy.CAPABILITY_SOURCE_HTTP);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_SOURCE_STREAMING", ConvivaStreamerProxy.CAPABILITY_SOURCE_STREAMING);
        defStatMeth(_s, ConvivaStreamerProxy, "CAPABILITY_VIDEO", ConvivaStreamerProxy.CAPABILITY_VIDEO);
        defStatMeth(_s, ConvivaStreamerProxy, "DOWNLOADSTATE_ACTIVE", ConvivaStreamerProxy.DOWNLOADSTATE_ACTIVE);
        defStatMeth(_s, ConvivaStreamerProxy, "DOWNLOADSTATE_INACTIVE", ConvivaStreamerProxy.DOWNLOADSTATE_INACTIVE);
        defStatMeth(_s, ConvivaStreamerProxy, "ERROR", ConvivaStreamerProxy.ERROR);
        defStatMeth(_s, ConvivaStreamerProxy, "METADATA_DURATION", ConvivaStreamerProxy.METADATA_DURATION);
        defStatMeth(_s, ConvivaStreamerProxy, "METADATA_ENCODED_FRAMERATE", ConvivaStreamerProxy.METADATA_ENCODED_FRAMERATE);
        defStatMeth(_s, ConvivaStreamerProxy, "NOT_MONITORED", ConvivaStreamerProxy.NOT_MONITORED);
        defStatMeth(_s, ConvivaStreamerProxy, "PAUSED", ConvivaStreamerProxy.PAUSED);
        defStatMeth(_s, ConvivaStreamerProxy, "PLAYING", ConvivaStreamerProxy.PLAYING);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_AVAILABLESTREAMINFOCHANGE", ConvivaStreamerProxy.REASON_AVAILABLESTREAMINFOCHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_DISPLAYSIZECHANGE", ConvivaStreamerProxy.REASON_DISPLAYSIZECHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_DOWNLOADSTATECHANGE", ConvivaStreamerProxy.REASON_DOWNLOADSTATECHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_ERRORCHANGE", ConvivaStreamerProxy.REASON_ERRORCHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_LOADINGSTATUSCHANGE", ConvivaStreamerProxy.REASON_LOADINGSTATUSCHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_LOG", ConvivaStreamerProxy.REASON_LOG);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_METADATACHANGE", ConvivaStreamerProxy.REASON_METADATACHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_PLAYINGSTATECHANGE", ConvivaStreamerProxy.REASON_PLAYINGSTATECHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_PRESENTATION_CHANGE", ConvivaStreamerProxy.REASON_PRESENTATION_CHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_PROXYINITIALIZED", ConvivaStreamerProxy.REASON_PROXYINITIALIZED);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_RESOURCE_ERROR", ConvivaStreamerProxy.REASON_RESOURCE_ERROR);
        defStatMeth(_s, ConvivaStreamerProxy, "REASON_STREAMINFOCHANGE", ConvivaStreamerProxy.REASON_STREAMINFOCHANGE);
        defStatMeth(_s, ConvivaStreamerProxy, "STOPPED", ConvivaStreamerProxy.STOPPED);
        defStatMeth(_s, ConvivaStreamerProxy, "UNKNOWN", ConvivaStreamerProxy.UNKNOWN);
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(ConvivaStreamerProxy, "ConvivaStreamerProxy");

      function LivePass() {
        var _s = this;

        if (_s == STAT_INIT) LivePass.READY = "READY";

        if (_s == STAT_INIT) LivePass.STREAM_SELECTION_SUCC = 0;

        if (_s == STAT_INIT) LivePass.STREAM_SELECTION_FAILURE = 1;

        if (_s == STAT_INIT) LivePass.STREAM_SELECTION_TIMEOUT = 2;

        if (_s == STAT_INIT) LivePass.OPTION_EXTERNAL_BITRATE_REPORTING = "externalBitrateReporting";

        if (_s == STAT_INIT) LivePass.readyState = false;

        if (_s == STAT_INIT) LivePass._settings = null;

        if (_s == STAT_INIT) LivePass._utils = null;

        if (_s == STAT_INIT) LivePass._sessionFactory = null;

        if (_s == STAT_INIT) LivePass._toggleTracesUsed = false;

        if (_s == STAT_INIT) LivePass._toggleTracesValue = false;

        if (_s == STAT_INIT) LivePass._globalSessionId = -1;

        defStatMeth(_s, LivePass, "init", __init);
        function __init(customerKey) {
          if (LivePass.readyState) {
            LivePass._utils.log("LivePass.init(): already initialized.");
            return;
          }
          if (LivePass._utils == null) {

            LivePass._utils = Utils.CreateUtils(null);
          }
          if (customerKey == null || customerKey.length == 0) {
            LivePass._utils.err("LivePass.init(): invalid customerKey: " + customerKey);
            return;
          }
          LivePass._utils.runProtectedSync(function () {
            LivePass._settings = LivePass._utils.getSettings();

            if (LivePass._toggleTracesUsed) {
              LivePass._settings.enableLogging = LivePass._toggleTracesValue;
            }

            LivePass._settings.clientInstanceId = LivePass._utils.randUInt();

            LivePass._settings.customerKey = customerKey;
            LivePass._utils.log("LivePass.init(): url=" + LivePass._settings.gatewayUrl + " customerKey=" + LivePass._settings.customerKey);
            LivePass._utils.startFetchClientId();
            PlayerStates.init();
            LivePass._sessionFactory = new SessionFactory();
            LivePass.readyState = true;
            LivePass._utils.log("LivePass.init(): done.");
          }, "LivePass.init");
        }

        defStatMeth(_s, LivePass, "initWithSettings", __initWithSettings);
        function __initWithSettings(customerKey, settings) {

          if (LivePass.readyState) {
            LivePass._utils.log("LivePass.initWithSettings(): already initialized.");
            return;
          }
          LivePass._utils = Utils.CreateUtils(settings);
          LivePass.init(customerKey);
        }

        defStatMeth(_s, LivePass, "cleanup", __cleanup);
        function __cleanup() {
          if (LivePass._utils != null) {
            LivePass._utils.runProtected(function () {
              LivePass._utils.log("LivePass.cleanup()");
              if (LivePass._sessionFactory != null) {
                LivePass._sessionFactory.cleanup();
              }
              LivePass._sessionFactory = null;
              LivePass._globalSessionId = -1;
              if (LivePass._utils != null) {
                LivePass._utils.cleanup();
              }
              LivePass._utils = null;
              LivePass._settings = null;
            }, "LivePass.cleanup");
          }
          LivePass.readyState = false;
        }

        defStatMeth(_s, LivePass, "createSession", __createSession);
        function __createSession(streamer, contentInfo, options) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.createSession before LivePass.init");
            return -1;
          }
          return LivePass.createSessionWithGlobal(streamer, contentInfo, options, false);
        }

        defStatMeth(_s, LivePass, "createSessionWithGlobal", __createSessionWithGlobal);
        function __createSessionWithGlobal(streamer, contentInfo, options, global) {

          var sid = LivePass._sessionFactory.newSessionId();
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.makeSession(streamer, contentInfo, options, sid, global);
          }, "LivePass.createSession");
          return sid;
        }

        defStatMeth(_s, LivePass, "reportError", __reportError);
        function __reportError(sessionId, errorMsg) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.reportError before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {

              session.reportError(StreamerError.makeUnscopedError(errorMsg, StreamerError.SEVERITY_FATAL));
            }
          }, "LivePass.reportError");
        }

        defStatMeth(_s, LivePass, "setBitrate", __setBitrate);
        function __setBitrate(sessionId, bitrateKbps) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.setBitrate before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.setBitrate(bitrateKbps);
            }
          }, "LivePass.setBitrate");
        }

        defStatMeth(_s, LivePass, "setCurrentStreamMetadata", __setCurrentStreamMetadata);
        function __setCurrentStreamMetadata(sessionId, metadata) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.setCurrentStreamMetadata before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.setCurrentStreamMetadata(metadata);
            }
          }, "LivePass.setCurrentStreamMetadata");
        }

        defStatMeth(_s, LivePass, "setCdnNameOrResource", __setCdnNameOrResource);
        function __setCdnNameOrResource(sessionId, resource) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.setCdnNameOrResource before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.setCdnNameOrResource(resource);
            }
          }, "LivePass.setCdnNameOrResource");
        }

        defStatMeth(_s, LivePass, "detachStreamer", __detachStreamer);
        function __detachStreamer(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.detachStreamer before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.detachStreamer();
            }
          }, "LivePass.detachStreamer");
        }

        defStatMeth(_s, LivePass, "attachStreamer", __attachStreamer);
        function __attachStreamer(sessionId, streamer) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.attachStreamer before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.attachStreamer(streamer);
            }
          }, "LivePass.attachStreamer");
        }

        defStatMeth(_s, LivePass, "sendSessionEvent", __sendSessionEvent);
        function __sendSessionEvent(sessionId, eventName, eventAttributes) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.sendSessionEvent before LivePass.init");
            return;
          }
          var eventAttrDictCS = null;
          eventAttrDictCS = Lang.DictionaryFromRepr(eventAttributes);
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.sendCustomEvent(eventName, eventAttrDictCS);
            }
          }, "LivePass.sendSessionEvent");
        }

        defStatMeth(_s, LivePass, "sendEvent", __sendEvent);
        function __sendEvent(eventName, eventAttributes) {

          if (!LivePass.readyState) {
            LivePass.ping("LivePass.sendEvent before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {

            if (LivePass._globalSessionId < 0) {
              var cci = new ConvivaContentInfo("", new DictionaryCS());
              LivePass._globalSessionId = LivePass.createSessionWithGlobal(null, cci, null, true);
            }
            LivePass.sendSessionEvent(LivePass._globalSessionId, eventName, eventAttributes);
          }, "LivePass.sendEvent");
        }

        defStatMeth(_s, LivePass, "cleanupSession", __cleanupSession);
        function __cleanupSession(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.cleanupSession before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            LivePass._sessionFactory.cleanupSession(sessionId);
          }, "Livepass.cleanupSession");
        }

        defStatMeth(_s, LivePass, "pauseJoinTime", __pauseJoinTime);
        function __pauseJoinTime(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.pauseJoinTime before LivePass.init");
            return;
          }
          LivePass.adStart(sessionId);
        }

        defStatMeth(_s, LivePass, "resumeJoinTime", __resumeJoinTime);
        function __resumeJoinTime(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.resumeJoinTime before LivePass.init");
            return;
          }
          LivePass.adEnd(sessionId);
        }

        defStatMeth(_s, LivePass, "adStart", __adStart);
        function __adStart(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.adStart before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.adStart();
            }
          }, "LivePass.adStart");
        }

        defStatMeth(_s, LivePass, "adEnd", __adEnd);
        function __adEnd(sessionId) {
          if (!LivePass.readyState) {
            LivePass.ping("LivePass.adEnd before LivePass.init");
            return;
          }
          LivePass._utils.runProtected(function () {
            var session = LivePass._sessionFactory.getSession(sessionId);
            if (session != null) {
              session.adEnd();
            }
          }, "LivePass.adEnd");
        }

        defStatMeth(_s, LivePass, "toggleTraces", __toggleTraces);
        function __toggleTraces(b) {

          LivePass._toggleTracesUsed = true;
          if (LivePass._settings != null) {
            LivePass._settings.enableLogging = b;
          } else {
            LivePass._toggleTracesValue = b;
          }
        }

        defStatMeth(_s, LivePass, "ping", __ping);
        function __ping(msg) {
          if (LivePass._utils != null) {
            LivePass._utils.ping(msg);
          }
        }
      }
      statInit(LivePass, "LivePass");

      function PlayerStates() {
        var _s = this;

        if (_s == STAT_INIT) PlayerStates.stateToInt = null;

        if (_s == STAT_INIT) PlayerStates.intToState = null;

        if (_s == STAT_INIT) PlayerStates.UNINITIALIZED = "UNINITIALIZED";
        if (_s == STAT_INIT) PlayerStates.eUninitialized = 0;

        if (_s == STAT_INIT) PlayerStates.PLAYING = "PLAYING";
        if (_s == STAT_INIT) PlayerStates.ePlaying = 3;
        if (_s == STAT_INIT) PlayerStates.STOPPED = "STOPPED";
        if (_s == STAT_INIT) PlayerStates.eStopped = 1;
        if (_s == STAT_INIT) PlayerStates.PAUSED = "PAUSED";
        if (_s == STAT_INIT) PlayerStates.ePaused = 12;
        if (_s == STAT_INIT) PlayerStates.BUFFERING = "BUFFERING";
        if (_s == STAT_INIT) PlayerStates.eBuffering = 6;
        if (_s == STAT_INIT) PlayerStates.NOT_MONITORED = "NOT_MONITORED";
        if (_s == STAT_INIT) PlayerStates.eNotMonitored = 98;
        if (_s == STAT_INIT) PlayerStates.UNKNOWN = "UNKNOWN";
        if (_s == STAT_INIT) PlayerStates.eUnknown = 100;

        defStatMeth(_s, PlayerStates, "init", __init);
        function __init() {
          PlayerStates.stateToInt = new DictionaryCS();
          PlayerStates.intToState = new DictionaryCS();
          PlayerStates.stateToInt.SetValue(PlayerStates.UNINITIALIZED, PlayerStates.eUninitialized);PlayerStates.intToState.SetValue(PlayerStates.eUninitialized, PlayerStates.UNINITIALIZED);
          PlayerStates.stateToInt.SetValue(PlayerStates.PLAYING, PlayerStates.ePlaying);PlayerStates.intToState.SetValue(PlayerStates.ePlaying, PlayerStates.PLAYING);
          PlayerStates.stateToInt.SetValue(PlayerStates.STOPPED, PlayerStates.eStopped);PlayerStates.intToState.SetValue(PlayerStates.eStopped, PlayerStates.STOPPED);
          PlayerStates.stateToInt.SetValue(PlayerStates.PAUSED, PlayerStates.ePaused);PlayerStates.intToState.SetValue(PlayerStates.ePaused, PlayerStates.PAUSED);
          PlayerStates.stateToInt.SetValue(PlayerStates.BUFFERING, PlayerStates.eBuffering);PlayerStates.intToState.SetValue(PlayerStates.eBuffering, PlayerStates.BUFFERING);
          PlayerStates.stateToInt.SetValue(PlayerStates.NOT_MONITORED, PlayerStates.eNotMonitored);PlayerStates.intToState.SetValue(PlayerStates.eNotMonitored, PlayerStates.NOT_MONITORED);
          PlayerStates.stateToInt.SetValue(PlayerStates.UNKNOWN, PlayerStates.eUnknown);PlayerStates.intToState.SetValue(PlayerStates.eUnknown, PlayerStates.UNKNOWN);
        }

        defStatMeth(_s, PlayerStates, "stringToInt", __stringToInt);
        function __stringToInt(stateStr) {
          if (PlayerStates.stateToInt == null) {
            PlayerStates.init();
          }
          if (PlayerStates.stateToInt.ContainsKey(stateStr)) {
            return PlayerStates.stateToInt.GetValue(stateStr);
          } else {
            return PlayerStates.eUnknown;
          }
        }

        defStatMeth(_s, PlayerStates, "intToString", __intToString);
        function __intToString(stateInt) {
          if (PlayerStates.intToState == null) {
            PlayerStates.init();
          }
          if (PlayerStates.intToState.ContainsKey(stateInt)) {
            return PlayerStates.intToState.GetValue(stateInt);
          } else {
            return PlayerStates.UNKNOWN;
          }
        }

        defStatMeth(_s, PlayerStates, "cleanup", __cleanup);
        function __cleanup() {
          PlayerStates.stateToInt = null;
        }
      }
      statInit(PlayerStates, "PlayerStates");

      function StreamInfo() {
        var _s = this;

        if (_s == STAT_INIT) StreamInfo.UNKNOWN = -1;

        if (_s == STAT_INIT) StreamInfo.AUDIO = 0;

        if (_s == STAT_INIT) StreamInfo.VIDEO = 1;

        if (_s == STAT_INIT) StreamInfo.TEXT = 2;

        if (_s == STAT_INIT) StreamInfo.RESOURCE = 3;

        if (_s == STAT_INIT) StreamInfo.UNKNOWN_RESOURCE = "";

        if (_s == STAT_INIT) StreamInfo.MAX_BITRATE = 2147483647;

        if (_s != STAT_INIT) _s.__auto_type = undefined;
        defGet(_s, "type", __get_type);defGet(_s, "type", __get_type);
        function __get_type() {
          return _s.__auto_type;
        }
        defSet(_s, "type", __set_type);defSet(_s, "type", __set_type);
        function __set_type(value) {
          _s.__auto_type = value;
        }

        if (_s != STAT_INIT) _s.__auto_sourceHeightPixels = undefined;
        defGet(_s, "sourceHeightPixels", __get_sourceHeightPixels);defGet(_s, "sourceHeightPixels", __get_sourceHeightPixels);
        function __get_sourceHeightPixels() {
          return _s.__auto_sourceHeightPixels;
        }
        defSet(_s, "sourceHeightPixels", __set_sourceHeightPixels);defSet(_s, "sourceHeightPixels", __set_sourceHeightPixels);
        function __set_sourceHeightPixels(value) {
          _s.__auto_sourceHeightPixels = value;
        }

        if (_s != STAT_INIT) _s.__auto_sourceWidthPixels = undefined;
        defGet(_s, "sourceWidthPixels", __get_sourceWidthPixels);defGet(_s, "sourceWidthPixels", __get_sourceWidthPixels);
        function __get_sourceWidthPixels() {
          return _s.__auto_sourceWidthPixels;
        }
        defSet(_s, "sourceWidthPixels", __set_sourceWidthPixels);defSet(_s, "sourceWidthPixels", __set_sourceWidthPixels);
        function __set_sourceWidthPixels(value) {
          _s.__auto_sourceWidthPixels = value;
        }

        if (_s != STAT_INIT) _s.__auto_bitrateKbps = undefined;
        defGet(_s, "bitrateKbps", __get_bitrateKbps);defGet(_s, "bitrateKbps", __get_bitrateKbps);
        function __get_bitrateKbps() {
          return _s.__auto_bitrateKbps;
        }
        defSet(_s, "bitrateKbps", __set_bitrateKbps);defSet(_s, "bitrateKbps", __set_bitrateKbps);
        function __set_bitrateKbps(value) {
          _s.__auto_bitrateKbps = value;
        }

        if (_s != STAT_INIT) _s.__auto_resource = undefined;
        defGet(_s, "resource", __get_resource);defGet(_s, "resource", __get_resource);
        function __get_resource() {
          return _s.__auto_resource;
        }
        defSet(_s, "resource", __set_resource);defSet(_s, "resource", __set_resource);
        function __set_resource(value) {
          _s.__auto_resource = value;
        }

        if (_s != STAT_INIT) _s.__auto_cdnName = undefined;
        defGet(_s, "cdnName", __get_cdnName);defGet(_s, "cdnName", __get_cdnName);
        function __get_cdnName() {
          return _s.__auto_cdnName;
        }
        defSet(_s, "cdnName", __set_cdnName);defSet(_s, "cdnName", __set_cdnName);
        function __set_cdnName(value) {
          _s.__auto_cdnName = value;
        }

        function _constr(_bitrateKbps, _cdnName, _resource, type, widthPixels, heightPixels) {
          _s.bitrateKbps = _bitrateKbps;
          _s.cdnName = _cdnName;
          _s.resource = _resource;
          _s.type = type;
          _s.sourceHeightPixels = heightPixels;
          _s.sourceWidthPixels = widthPixels;
        }

        defPubMeth(_s, "GetBitrateKbps", __GetBitrateKbps);defPubMeth(_s, "GetBitrateKbps", __GetBitrateKbps);
        function __GetBitrateKbps() {
          return _s.bitrateKbps;
        }

        defPubMeth(_s, "GetCdnName", __GetCdnName);defPubMeth(_s, "GetCdnName", __GetCdnName);
        function __GetCdnName() {
          return _s.cdnName;
        }

        defPubMeth(_s, "GetResource", __GetResource);defPubMeth(_s, "GetResource", __GetResource);
        function __GetResource() {
          return _s.resource;
        }

        defPubMeth(_s, "equals", __equals);defPubMeth(_s, "equals", __equals);
        function __equals(other) {
          if (other == null) return false;

          return _s.cdnName == other.cdnName && _s.resource == other.resource && _s.bitrateKbps == other.bitrateKbps && _s.type == other.type && _s.sourceHeightPixels == other.sourceHeightPixels && _s.sourceWidthPixels == other.sourceWidthPixels;
        }

        defStatMeth(_s, StreamInfo, "ConstructClone", __ConstructClone);defStatMeth(_s, StreamInfo, "ConstructClone", __ConstructClone);
        function __ConstructClone(fromObj) {
          if (fromObj == null) return null;
          var res = new StreamInfo(-1, ConvivaContentInfo.CDN_NAME_OTHER, null, -1, -1, -1);
          res.type = slint.Cast(NativeLang.GetField("type", fromObj));
          res.bitrateKbps = slint.Cast(NativeLang.GetField("bitrateKbps", fromObj));
          res.resource = NativeLang.GetStringField("resource", fromObj);
          res.cdnName = NativeLang.GetStringField("cdnName", fromObj);
          res.sourceHeightPixels = slint.Cast(NativeLang.GetField("sourceHeightPixels", fromObj));
          res.sourceWidthPixels = slint.Cast(NativeLang.GetField("sourceWidthPixels", fromObj));
          return res;
        }

        defPubMeth(_s, "ToStr", __ToStr);defPubMeth(_s, "ToStr", __ToStr);
        function __ToStr() {
          var typeString = null;

          switch (_s.type) {
            case StreamInfo.UNKNOWN:
              typeString = "UNKNOWN";
              break;
            case StreamInfo.VIDEO:
              typeString = "VIDEO";
              break;
            case StreamInfo.AUDIO:
              typeString = "AUDIO";
              break;
            case StreamInfo.TEXT:
              typeString = "TEXT";
              break;
            case StreamInfo.RESOURCE:
              typeString = "RESOURCE";
              break;
            default:
              throw new Error("Unknown stream type " + _s.type);
          }

          return "type=" + typeString + ", bitrateKbps=" + _s.bitrateKbps + ", resource=" + (_s.resource != null ? _s.resource : "null") + ", cdnName=" + (_s.cdnName != null ? _s.cdnName : "null") + ", sourceHeightPixels=" + _s.sourceHeightPixels + ", sourceWidthPixels=" + _s.sourceWidthPixels;
        }
        defStatMeth(_s, StreamInfo, "AUDIO", StreamInfo.AUDIO);
        defStatMeth(_s, StreamInfo, "MAX_BITRATE", StreamInfo.MAX_BITRATE);
        defStatMeth(_s, StreamInfo, "RESOURCE", StreamInfo.RESOURCE);
        defStatMeth(_s, StreamInfo, "TEXT", StreamInfo.TEXT);
        defStatMeth(_s, StreamInfo, "UNKNOWN", StreamInfo.UNKNOWN);
        defStatMeth(_s, StreamInfo, "UNKNOWN_RESOURCE", StreamInfo.UNKNOWN_RESOURCE);
        defStatMeth(_s, StreamInfo, "VIDEO", StreamInfo.VIDEO);
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(StreamInfo, "StreamInfo");

      function StreamSwitch() {
        var _s = this;

        if (_s == STAT_INIT) StreamSwitch._nextId = 0;

        if (_s == STAT_INIT) StreamSwitch.PENDING = "PENDING";

        if (_s == STAT_INIT) StreamSwitch.IN_PROGRESS = "IN_PROGRESS";

        if (_s == STAT_INIT) StreamSwitch.SUCCEEDED = "SUCCEEDED";

        if (_s == STAT_INIT) StreamSwitch.FAILED = "FAILED";

        if (_s == STAT_INIT) StreamSwitch.INTERRUPTED = "INTERRUPTED";

        defStatMeth(_s, StreamSwitch, "MakeSwitch", __MakeSwitch);defStatMeth(_s, StreamSwitch, "MakeSwitch", __MakeSwitch);
        function __MakeSwitch(source, target, status) {
          return new StreamSwitch(StreamSwitch.GetNextId(false), source, target, -1, null, status);
        }

        defStatMeth(_s, StreamSwitch, "MakeSwitchToStream", __MakeSwitchToStream);defStatMeth(_s, StreamSwitch, "MakeSwitchToStream", __MakeSwitchToStream);
        function __MakeSwitchToStream(target, status) {
          return new StreamSwitch(StreamSwitch.GetNextId(false), null, target, -1, null, status);
        }

        defPubMeth(_s, "Cleanup", __Cleanup);defPubMeth(_s, "Cleanup", __Cleanup);
        function __Cleanup() {}

        if (_s != STAT_INIT) _s.__auto_id = undefined;
        defGet(_s, "id", __get_id);defGet(_s, "id", __get_id);
        function __get_id() {
          return _s.__auto_id;
        }
        defSet(_s, "id", __set_id);defSet(_s, "id", __set_id);
        function __set_id(value) {
          _s.__auto_id = value;
        }

        if (_s != STAT_INIT) _s.__auto_timeoutMs = undefined;
        defGet(_s, "timeoutMs", __get_timeoutMs);defGet(_s, "timeoutMs", __get_timeoutMs);
        function __get_timeoutMs() {
          return _s.__auto_timeoutMs;
        }
        defSet(_s, "timeoutMs", __set_timeoutMs);defSet(_s, "timeoutMs", __set_timeoutMs);
        function __set_timeoutMs(value) {
          _s.__auto_timeoutMs = value;
        }

        if (_s != STAT_INIT) _s.__auto_sourceStream = undefined;
        defGet(_s, "sourceStream", __get_sourceStream);defGet(_s, "sourceStream", __get_sourceStream);
        function __get_sourceStream() {
          return _s.__auto_sourceStream;
        }
        defSet(_s, "sourceStream", __set_sourceStream);defSet(_s, "sourceStream", __set_sourceStream);
        function __set_sourceStream(value) {
          _s.__auto_sourceStream = value;
        }

        if (_s != STAT_INIT) _s.__auto_targetStream = undefined;
        defGet(_s, "targetStream", __get_targetStream);defGet(_s, "targetStream", __get_targetStream);
        function __get_targetStream() {
          return _s.__auto_targetStream;
        }
        defSet(_s, "targetStream", __set_targetStream);defSet(_s, "targetStream", __set_targetStream);
        function __set_targetStream(value) {
          _s.__auto_targetStream = value;
        }

        if (_s != STAT_INIT) _s.__auto_mode = undefined;
        defGet(_s, "mode", __get_mode);defGet(_s, "mode", __get_mode);
        function __get_mode() {
          return _s.__auto_mode;
        }
        defSet(_s, "mode", __set_mode);defSet(_s, "mode", __set_mode);
        function __set_mode(value) {
          _s.__auto_mode = value;
        }

        if (_s != STAT_INIT) _s.__auto_status = undefined;
        defGet(_s, "status", __get_status);defGet(_s, "status", __get_status);
        function __get_status() {
          return _s.__auto_status;
        }
        defSet(_s, "status", __set_status);defSet(_s, "status", __set_status);
        function __set_status(value) {
          _s.__auto_status = value;
        }

        function _constr(id, sourceStream, targetStream, timeoutMs, mode, status) {
          _s.id = id;
          _s.sourceStream = sourceStream;
          _s.targetStream = targetStream;
          _s.timeoutMs = timeoutMs;
          _s.mode = mode;
          _s.status = status;
        }

        defPubMeth(_s, "CheckValidity", __CheckValidity);defPubMeth(_s, "CheckValidity", __CheckValidity);
        function __CheckValidity() {
          if (_s.id == null) {
            return "StreamSwitch.id is null (and must be non-null)";
          }

          if (_s.id != null && !(typeof _s.id === "string")) {
            return "StreamSwitch.id is not a string";
          } else if (_s.timeoutMs != null && !(typeof _s.timeoutMs === "number")) {
            return "StreamSwitch.timeoutMs is not an int";
          } else if (_s.mode != null && !(typeof _s.mode === "string")) {
            return "StreamSwitch.mode is not a string";
          } else if (_s.status != null && !(typeof _s.status === "string")) {
            return "StreamSwitch.status is not a string";
          } else if (_s.sourceStream != null && !(_s.sourceStream instanceof CandidateStream)) {
            return "StreamSwitch.sourceStream is not a CandidateStream";
          } else if (_s.targetStream != null && !(_s.targetStream instanceof CandidateStream)) {
            return "StreamSwitch.targetStream is not a CandidateStream";
          }
          var sourceStreamError = _s.sourceStream != null ? _s.sourceStream.CheckValidity() : null;
          if (sourceStreamError != null) {
            return sourceStreamError;
          }
          var targetStreamError = _s.targetStream != null ? _s.targetStream.CheckValidity() : null;
          if (targetStreamError != null) {
            return targetStreamError;
          }
          return null;
        }

        defStatMeth(_s, StreamSwitch, "ConstructClone", __ConstructClone);defStatMeth(_s, StreamSwitch, "ConstructClone", __ConstructClone);
        function __ConstructClone(fromObj) {
          var res = new StreamSwitch(null, null, null, -1, "", "");
          res.id = NativeLang.GetStringField("id", fromObj);
          res.sourceStream = CandidateStream.ConstructClone(NativeLang.GetField("sourceStream", fromObj));
          res.targetStream = CandidateStream.ConstructClone(NativeLang.GetField("targetStream", fromObj));
          res.timeoutMs = slint.Cast(NativeLang.GetField("timeoutMs", fromObj));
          res.mode = NativeLang.GetStringField("mode", fromObj);
          res.status = NativeLang.GetStringField("status", fromObj);
          return res;
        }

        defStatMeth(_s, StreamSwitch, "StaticInit", __StaticInit);defStatMeth(_s, StreamSwitch, "StaticInit", __StaticInit);
        function __StaticInit() {
          StreamSwitch._nextId = 0;
        }

        defStatMeth(_s, StreamSwitch, "StaticCleanup", __StaticCleanup);defStatMeth(_s, StreamSwitch, "StaticCleanup", __StaticCleanup);
        function __StaticCleanup() {
          StreamSwitch._nextId = 0;
        }

        defStatMeth(_s, StreamSwitch, "GetNextId", __GetNextId);defStatMeth(_s, StreamSwitch, "GetNextId", __GetNextId);
        function __GetNextId(useInternalNamespace) {
          var id = StreamSwitch._nextId;
          StreamSwitch._nextId += 1;
          if (useInternalNamespace) {
            return "c3." + Lang.ToString(id);
          } else {
            return Lang.ToString(id);
          }
        }
        defStatMeth(_s, StreamSwitch, "FAILED", StreamSwitch.FAILED);
        defStatMeth(_s, StreamSwitch, "INTERRUPTED", StreamSwitch.INTERRUPTED);
        defStatMeth(_s, StreamSwitch, "IN_PROGRESS", StreamSwitch.IN_PROGRESS);
        defStatMeth(_s, StreamSwitch, "PENDING", StreamSwitch.PENDING);
        defStatMeth(_s, StreamSwitch, "SUCCEEDED", StreamSwitch.SUCCEEDED);
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(StreamSwitch, "StreamSwitch");

      function StreamerError() {
        var _s = this;

        if (_s == STAT_INIT) StreamerError.ERROR_SCOPE_UNKNOWN = 0;

        if (_s == STAT_INIT) StreamerError.ERROR_SCOPE_STREAM_SEGMENT = 1;

        if (_s == STAT_INIT) StreamerError.ERROR_SCOPE_STREAM = 2;

        if (_s == STAT_INIT) StreamerError.ERROR_SCOPE_RESOURCE = 3;

        if (_s == STAT_INIT) StreamerError.SEVERITY_WARNING = 0;

        if (_s == STAT_INIT) StreamerError.SEVERITY_FATAL = 1;

        if (_s != STAT_INIT) _s.__auto_errorCode = undefined;
        defGet(_s, "errorCode", __get_errorCode);defGet(_s, "errorCode", __get_errorCode);
        function __get_errorCode() {
          return _s.__auto_errorCode;
        }
        defSet(_s, "errorCode", __set_errorCode);defSet(_s, "errorCode", __set_errorCode);
        function __set_errorCode(value) {
          _s.__auto_errorCode = value;
        }

        if (_s != STAT_INIT) _s.__auto_severity = undefined;
        defGet(_s, "severity", __get_severity);defGet(_s, "severity", __get_severity);
        function __get_severity() {
          return _s.__auto_severity;
        }
        defSet(_s, "severity", __set_severity);defSet(_s, "severity", __set_severity);
        function __set_severity(value) {
          _s.__auto_severity = value;
        }

        if (_s != STAT_INIT) _s.__auto_stream = undefined;
        defGet(_s, "stream", __get_stream);defGet(_s, "stream", __get_stream);
        function __get_stream() {
          return _s.__auto_stream;
        }
        defSet(_s, "stream", __set_stream);defSet(_s, "stream", __set_stream);
        function __set_stream(value) {
          _s.__auto_stream = value;
        }

        if (_s != STAT_INIT) _s.__auto_index = undefined;
        defGet(_s, "index", __get_index);defGet(_s, "index", __get_index);
        function __get_index() {
          return _s.__auto_index;
        }
        defSet(_s, "index", __set_index);defSet(_s, "index", __set_index);
        function __set_index(value) {
          _s.__auto_index = value;
        }

        if (_s != STAT_INIT) _s.__auto_scope = undefined;
        defGet(_s, "scope", __get_scope);defGet(_s, "scope", __get_scope);
        function __get_scope() {
          return _s.__auto_scope;
        }
        defSet(_s, "scope", __set_scope);defSet(_s, "scope", __set_scope);
        function __set_scope(value) {
          _s.__auto_scope = value;
        }

        defStatMeth(_s, StreamerError, "makeUnscopedError", __makeUnscopedError);defStatMeth(_s, StreamerError, "makeUnscopedError", __makeUnscopedError);
        function __makeUnscopedError(errorCode, severity) {
          return new StreamerError(errorCode, null, -1, severity, StreamerError.ERROR_SCOPE_UNKNOWN);
        }

        defStatMeth(_s, StreamerError, "makeStreamError", __makeStreamError);defStatMeth(_s, StreamerError, "makeStreamError", __makeStreamError);
        function __makeStreamError(errCode, severity, stream) {
          return new StreamerError(errCode, stream, -1, severity, StreamerError.ERROR_SCOPE_STREAM);
        }

        defStatMeth(_s, StreamerError, "makeResourceError", __makeResourceError);defStatMeth(_s, StreamerError, "makeResourceError", __makeResourceError);
        function __makeResourceError(errCode, severity, stream) {
          return new StreamerError(errCode, stream, -1, severity, StreamerError.ERROR_SCOPE_RESOURCE);
        }

        defStatMeth(_s, StreamerError, "makeStreamSegmentError", __makeStreamSegmentError);defStatMeth(_s, StreamerError, "makeStreamSegmentError", __makeStreamSegmentError);
        function __makeStreamSegmentError(errCode, severity, stream, idx) {
          return new StreamerError(errCode, stream, idx, severity, StreamerError.ERROR_SCOPE_STREAM_SEGMENT);
        }

        function _constr(_errorCode, _stream, _index, _severity, _scope) {
          _s.errorCode = _errorCode;

          _s.stream = _stream;
          _s.index = _index;
          _s.severity = _severity;
          _s.scope = _scope;
        }

        defStatMeth(_s, StreamerError, "ConstructClone", __ConstructClone);defStatMeth(_s, StreamerError, "ConstructClone", __ConstructClone);
        function __ConstructClone(fromObj) {
          if (fromObj == null) return null;
          var res = new StreamerError("", null, 0, 0, 0);
          res.errorCode = NativeLang.GetStringField("errorCode", fromObj);
          res.severity = slint.Cast(NativeLang.GetField("severity", fromObj));
          res.stream = StreamInfo.ConstructClone(NativeLang.GetField("stream", fromObj));
          res.scope = slint.Cast(NativeLang.GetField("scope", fromObj));
          res.index = slint.Cast(NativeLang.GetField("index", fromObj));
          return res;
        }

        defPubMeth(_s, "ToStr", __ToStr);defPubMeth(_s, "ToStr", __ToStr);
        function __ToStr() {
          return "errorCode=" + (_s.errorCode != null ? _s.errorCode : "null") + ", index=" + _s.index + ", severity=" + _s.severity + ", scope=" + _s.scope + ", stream=(" + _s.stream.ToStr() + ")";
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(StreamerError, "StreamerError");

      function Monitor() {
        var _s = this;

        if (_s != STAT_INIT) _s._sessionId = 0;

        if (_s != STAT_INIT) _s._externalBitrateReporting = false;

        if (_s != STAT_INIT) _s._streamer = null;

        if (_s != STAT_INIT) _s._streamerObject = null;

        if (_s != STAT_INIT) _s._eventQueue = null;
        if (_s != STAT_INIT) _s._contentInfo = null;
        if (_s != STAT_INIT) _s._nextHeartbeat = null;
        if (_s != STAT_INIT) _s._utils = null;

        if (_s != STAT_INIT) _s._playingState = ConvivaStreamerProxy.UNKNOWN;
        if (_s != STAT_INIT) _s._streamInfo = null;
        if (_s != STAT_INIT) _s._sessionFlags = 1;

        if (_s != STAT_INIT) _s._startTimeMs = 0;
        if (_s != STAT_INIT) _s._lastStateUpdateTimeMs = 0;

        if (_s != STAT_INIT) _s._pauseJoinTimeStartTimeMs = 0;
        if (_s != STAT_INIT) _s._pauseJointTimeTotalMs = 0;

        if (_s != STAT_INIT) _s._cumulativeTimePerState = null;

        if (_s != STAT_INIT) _s._joinTimeMs = -1;
        if (_s != STAT_INIT) _s._bufferingEventCount = 0;

        if (_s != STAT_INIT) _s._nominalPlayingBitsTotal = 0;

        if (_s != STAT_INIT) _s._encodedFps = -1;
        if (_s != STAT_INIT) _s._contentLengthSec = -1;

        if (_s != STAT_INIT) _s._playingFpsObservationCount = 0;

        if (_s != STAT_INIT) _s._playingFpsTotal = 0;

        function _constr(streamer, eventQueue, contentInfo, options, sessionId) {

          _s._eventQueue = eventQueue;
          _s._utils = Utils.getInstance();
          _s._contentInfo = contentInfo;
          _s._sessionId = sessionId;
          _s._nextHeartbeat = new DictionaryCS();
          _s._streamerObject = streamer;

          _s._startTimeMs = 0;
          _s._lastStateUpdateTimeMs = 0;

          _s._pauseJoinTimeStartTimeMs = 0;
          _s._pauseJointTimeTotalMs = 0;

          _s._cumulativeTimePerState = new DictionaryCS();
          var _for_array_1 = PlayerStates.stateToInt.KeyValuePairs;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var statePair = _for_array_1[_for_idx_2];

            _s._cumulativeTimePerState.SetValue(statePair.Value, 0);
          }

          _s._joinTimeMs = -1;
          _s._bufferingEventCount = 0;

          _s._nominalPlayingBitsTotal = 0;

          _s._encodedFps = -1;
          _s._contentLengthSec = -1;
          _s._playingFpsObservationCount = 0;
          _s._playingFpsTotal = 0;

          if (options != null) {
            var optionsDict = Lang.DictionaryFromRepr(options);
            if (optionsDict.ContainsKey(LivePass.OPTION_EXTERNAL_BITRATE_REPORTING)) {
              _s._externalBitrateReporting = optionsDict.GetValue(LivePass.OPTION_EXTERNAL_BITRATE_REPORTING);
            }
          }
        }

        defPubMeth(_s, "start", __start);
        function __start(nowMs) {
          _s._startTimeMs = nowMs;
          _s._lastStateUpdateTimeMs = nowMs;
          _s.buildInitialStreamInfo();

          _s.attachStreamer(_s._streamerObject);
          _s._streamerObject = null;
        }

        defPubMeth(_s, "attachStreamer", __attachStreamer);
        function __attachStreamer(streamerObject) {
          _s._utils.logSession("Monitor.attachStreamer()", _s._sessionId);
          if (_s._streamer != null) {
            _s._utils.logSession("Monitor.attachStreamer(): detach current streamer first", _s._sessionId);
            return;
          }
          if (streamerObject == null) {
            _s._utils.logSession("Monitor.attachStreamer(): received a null streamer", _s._sessionId);
            _s.SetPlayingState(ConvivaStreamerProxy.NOT_MONITORED);
            return;
          }

          _s._streamer = Monitor.wrapInConvivaStreamerProxy(streamerObject, _s._sessionId);

          _s._sessionFlags = _s._streamer.GetCapabilities();
          if (_s._externalBitrateReporting) {
            _s._sessionFlags |= ConvivaStreamerProxy.CAPABILITY_BITRATE_EXTERNAL;
          }

          _s.SetPlayingState(ConvivaStreamerProxy.UNKNOWN);

          _s._streamer.SetMonitoringNotifier(_s.notificationFromStreamerProxy);

          _s._lastStateUpdateTimeMs = _s._utils.epochTimeMs();
        }

        defPubMeth(_s, "detachStreamer", __detachStreamer);
        function __detachStreamer() {
          _s._utils.logSession("Monitor.detachStreamer()", _s._sessionId);
          _s.updateMetrics();
          if (_s._streamer != null) {
            _s._streamer.Cleanup();
            _s.SetPlayingState(ConvivaStreamerProxy.NOT_MONITORED);
            _s._streamer = null;
          }
        }

        defPubMeth(_s, "pauseJoinTime", __pauseJoinTime);
        function __pauseJoinTime() {
          _s._utils.logSession("Monitor.pauseJoinTime()", _s._sessionId);
          if (_s._pauseJoinTimeStartTimeMs == 0) {
            _s._pauseJoinTimeStartTimeMs = _s._utils.epochTimeMs();

            var newState = new DictionaryCS();
            var oldState = new DictionaryCS();
            newState.SetValue("pj", true);
            oldState.SetValue("pj", false);
            _s.declareStateChange(newState, oldState);
          }
        }

        defPubMeth(_s, "resumeJoinTime", __resumeJoinTime);
        function __resumeJoinTime(addEvent) {
          _s._utils.logSession("Monitor.resumeJoinTime()", _s._sessionId);
          if (_s._pauseJoinTimeStartTimeMs > 0) {
            _s._pauseJointTimeTotalMs += _s._utils.epochTimeMs() - _s._pauseJoinTimeStartTimeMs;
            if (addEvent) {
              var newState = new DictionaryCS();
              var oldState = new DictionaryCS();
              newState.SetValue("pj", false);
              oldState.SetValue("pj", true);
              _s.declareStateChange(newState, oldState);
            }
          }
          _s._pauseJoinTimeStartTimeMs = 0;
        }

        defGet(_s, "streamer", __get_streamer);
        function __get_streamer() {
          return _s._streamer;
        }

        defPrivMeth(_s, "buildInitialStreamInfo", __buildInitialStreamInfo);
        function __buildInitialStreamInfo() {
          var initialBitrateKbps = -1;
          var initialResource = null;
          var initialCdnName = ConvivaContentInfo.CDN_NAME_OTHER;

          if (_s._contentInfo != null) {
            initialCdnName = _s._contentInfo.defaultReportingCdnName;

            if (_s._contentInfo.defaultReportingResource == null || _s._contentInfo.defaultReportingResource == ConvivaContentInfo.NO_RESOURCE) {
              initialResource = initialCdnName;
            } else {
              initialResource = _s._contentInfo.defaultReportingResource;
            }
            initialBitrateKbps = _s._contentInfo.defaultReportingBitrateKbps;
          }

          _s._streamInfo = new StreamInfo(initialBitrateKbps, initialCdnName, initialResource, -1, -1, -1);
        }

        defPrivMeth(_s, "notificationFromStreamerProxy", __notificationFromStreamerProxy);
        function __notificationFromStreamerProxy(notificationName, arg) {
          _s._utils.runProtected(function () {
            switch (notificationName) {
              case "PlayingStateChange":
                var newState = arg;
                _s.OnPlayingStateChange(newState);
                break;
              case "StreamInfoChange":
                var newInfo = arg;
                _s.SetStream(newInfo);
                break;
              case "ErrorChange":
                var newError = arg;
                _s.OnError(newError);
                break;
              case "MetadataChange":
                _s.OnMetadata(arg);
                break;
              case "Log":
                var logMsg = arg;
                _s._utils.logSession(logMsg, _s._sessionId);
                break;
            }
          }, "notificationFromStreamerProxy");
        }

        defPrivMeth(_s, "OnPlayingStateChange", __OnPlayingStateChange);
        function __OnPlayingStateChange(newPlayingState) {
          _s.updateStateCumulativeTime();
          if (_s._playingState == newPlayingState) {
            return;
          }

          var hasJoined = _s._joinTimeMs >= 0;
          var newState = new DictionaryCS();
          var oldState = new DictionaryCS();
          newState.SetValue("ps", PlayerStates.stringToInt(newPlayingState));
          oldState.SetValue("ps", PlayerStates.stringToInt(_s._playingState));

          if (!hasJoined && newPlayingState == ConvivaStreamerProxy.PLAYING) {

            _s._cumulativeTimePerState.SetValue(PlayerStates.eBuffering, 0);

            if (_s._pauseJoinTimeStartTimeMs > 0) {
              _s.resumeJoinTime(false);
              newState.SetValue("pj", false);
              oldState.SetValue("pj", true);
            }

            _s._joinTimeMs = slint.Cast(_s._utils.epochTimeMs() - _s._startTimeMs - _s._pauseJointTimeTotalMs);

            if (_s._joinTimeMs < 0) {
              _s._joinTimeMs = 0;
            }
          }
          if (hasJoined && newPlayingState == ConvivaStreamerProxy.BUFFERING) {
            _s._bufferingEventCount++;
          }
          _s._utils.logSession("Monitor: change playing state to " + newPlayingState, _s._sessionId);
          _s._playingState = newPlayingState;
          _s.declareStateChange(newState, oldState);
        }

        defPrivMeth(_s, "SetPlayingState", __SetPlayingState);
        function __SetPlayingState(newState) {
          if (_s._playingState == newState) {
            return;
          }
          _s.OnPlayingStateChange(newState);
        }

        defPubMeth(_s, "SetStream", __SetStream);
        function __SetStream(targetStream) {
          if (targetStream == null) {
            return;
          }

          if (_s._streamer != null) {
            if (targetStream.bitrateKbps == _s._streamer.GetBitrateKbps()) {

              targetStream.bitrateKbps = -2;
            }
            if (targetStream.cdnName == _s._streamer.GetCdnName()) {

              targetStream.cdnName = null;
            }
            if (targetStream.resource == _s._streamer.GetResource()) {

              targetStream.resource = null;
            }
          }

          if (targetStream.resource == null && targetStream.cdnName != null && _s._streamInfo.cdnName == _s._streamInfo.resource) {
            targetStream.resource = targetStream.cdnName;
          }
          if (!_s._externalBitrateReporting && targetStream.bitrateKbps <= -2) targetStream.bitrateKbps = _s._streamInfo.bitrateKbps;
          if (targetStream.cdnName == null) targetStream.cdnName = _s._streamInfo.cdnName;
          if (targetStream.resource == null || targetStream.resource == ConvivaContentInfo.NO_RESOURCE) targetStream.resource = _s._streamInfo.resource;
          if (!_s._streamInfo.equals(targetStream)) {
            _s.updateStateCumulativeTime();
            _s.enqueueStreamChangeEvent(_s._streamInfo, targetStream);
            _s._streamInfo = targetStream;
          }
        }

        defPubMeth(_s, "setBitrate", __setBitrate);
        function __setBitrate(newBitrateKbps) {
          if (_s._externalBitrateReporting) {
            var newStream = StreamInfo.ConstructClone(_s._streamInfo);
            newStream.bitrateKbps = newBitrateKbps;
            _s.SetStream(newStream);
          } else {
            _s._utils.logSession("setBitrate() call ignored, enable external bitrate reporting first.", _s._sessionId);
          }
        }

        defPubMeth(_s, "OnError", __OnError);
        function __OnError(e) {

          _s.declareError(e.errorCode, e.severity == StreamerError.SEVERITY_FATAL);
        }

        defPrivMeth(_s, "OnMetadata", __OnMetadata);
        function __OnMetadata(metadata) {

          var metadataDict = Lang.DictionaryFromRepr(metadata);
          if (metadataDict.ContainsKey(ConvivaStreamerProxy.METADATA_ENCODED_FRAMERATE)) {
            _s._encodedFps = slint.Cast(_s._utils.parseNumber(metadataDict.GetValue(ConvivaStreamerProxy.METADATA_ENCODED_FRAMERATE), -1));
            _s._utils.logSession("Monitor: received " + ConvivaStreamerProxy.METADATA_ENCODED_FRAMERATE + " metadata: " + _s._encodedFps, _s._sessionId);
          }
          if (metadataDict.ContainsKey(ConvivaStreamerProxy.METADATA_DURATION)) {
            _s._contentLengthSec = slint.Cast(_s._utils.parseNumber(metadataDict.GetValue(ConvivaStreamerProxy.METADATA_DURATION), -1));
            _s._utils.logSession("Monitor: received " + ConvivaStreamerProxy.METADATA_DURATION + " metadata: " + _s._contentLengthSec, _s._sessionId);
          }
        }

        defPubMeth(_s, "updateHeartbeat", __updateHeartbeat);
        function __updateHeartbeat(heartbeat) {
          _s.updateMetrics();

          var playingTime = _s._cumulativeTimePerState.GetValue(PlayerStates.ePlaying);
          var hasJoined = _s._joinTimeMs >= 0;
          var bufferingTime = 0;
          if (hasJoined) {
            bufferingTime = _s._cumulativeTimePerState.GetValue(PlayerStates.eBuffering);
          }

          var averageBitrateKbps = -1;
          if (hasJoined) {
            averageBitrateKbps = slint.Cast((_s._nominalPlayingBitsTotal + 0.0) / playingTime);
          }
          var averageFps = -1;
          if (_s._playingFpsObservationCount > 0) {
            averageFps = slint.Cast((_s._playingFpsTotal + 0.0) / _s._playingFpsObservationCount);
          }
          NativeLang.setDictValue(heartbeat, "ps", PlayerStates.stringToInt(_s._playingState));
          NativeLang.setDictValue(heartbeat, "pj", _s._pauseJoinTimeStartTimeMs > 0 ? true : false);
          NativeLang.setDictValue(heartbeat, "sf", _s._sessionFlags);
          NativeLang.setDictValue(heartbeat, "tpt", playingTime);
          NativeLang.setDictValue(heartbeat, "tbt", bufferingTime);
          NativeLang.setDictValue(heartbeat, "tpst", _s._cumulativeTimePerState.GetValue(PlayerStates.ePaused));
          NativeLang.setDictValue(heartbeat, "tst", _s._cumulativeTimePerState.GetValue(PlayerStates.eStopped));
          NativeLang.setDictValue(heartbeat, "jt", _s._joinTimeMs);
          NativeLang.setDictValue(heartbeat, "tbe", _s._bufferingEventCount);
          if (_s._contentLengthSec > 0) {
            NativeLang.setDictValue(heartbeat, "cl", _s._contentLengthSec);
          }
          if (_s._streamInfo.GetBitrateKbps() > 0) {
            NativeLang.setDictValue(heartbeat, "cbr", _s._streamInfo.GetBitrateKbps());
            NativeLang.setDictValue(heartbeat, "br", _s._streamInfo.GetBitrateKbps());
          }
          if (averageBitrateKbps > 0) {
            NativeLang.setDictValue(heartbeat, "abr", averageBitrateKbps);
          }
          NativeLang.setDictValue(heartbeat, "rs", _s._streamInfo.GetResource());
          NativeLang.setDictValue(heartbeat, "cdn", _s._streamInfo.GetCdnName());

          if (_s._encodedFps >= 0) {
            NativeLang.setDictValue(heartbeat, "efps", _s._encodedFps);
          }
          if (averageFps >= 0) {
            NativeLang.setDictValue(heartbeat, "afps", averageFps);
          }
        }

        defPubMeth(_s, "cleanup", __cleanup);
        function __cleanup() {
          if (_s._streamer != null) {
            _s._streamer.Cleanup();
          }
          _s._streamer = null;
          _s._streamerObject = null;
          _s._eventQueue = null;
          _s._contentInfo = null;
          _s._nextHeartbeat = null;
          _s._streamInfo = null;
          _s._cumulativeTimePerState = null;
          _s._utils = null;
        }

        defPrivMeth(_s, "updateMetrics", __updateMetrics);
        function __updateMetrics() {
          if (_s._streamer == null) return;
          if (_s._playingState == ConvivaStreamerProxy.PLAYING) {
            var fps = _s._streamer.GetRenderedFrameRate();
            if (fps >= 0) {
              _s._playingFpsTotal += fps;
              _s._playingFpsObservationCount++;
            }
          }
          _s.updateStateCumulativeTime();
        }

        defPrivMeth(_s, "enqueueEvent", __enqueueEvent);
        function __enqueueEvent(type, eventData) {
          _s._eventQueue.enqueueEvent(type, eventData, slint.Cast(_s._utils.epochTimeMs() - _s._startTimeMs));
        }

        defPrivMeth(_s, "enqueueStreamChangeEvent", __enqueueStreamChangeEvent);
        function __enqueueStreamChangeEvent(oldStream, newStream) {
          var newState = new DictionaryCS();
          var oldState = new DictionaryCS();
          if (oldStream.GetBitrateKbps() != newStream.GetBitrateKbps() && newStream.GetBitrateKbps() > 0) {
            oldState.SetValue("br", oldStream.GetBitrateKbps());
            newState.SetValue("br", newStream.GetBitrateKbps());
            _s._utils.logSession("Monitor: change bitrate from " + oldState.GetValue("br") + " to " + newState.GetValue("br"), _s._sessionId);
          }
          if (oldStream.GetCdnName() != newStream.GetCdnName()) {
            oldState.SetValue("cdn", oldStream.GetCdnName());
            newState.SetValue("cdn", newStream.GetCdnName());
            _s._utils.logSession("Monitor: change cdnName from " + oldState.GetValue("cdn") + " to " + newState.GetValue("cdn"), _s._sessionId);
          }
          if (oldStream.GetResource() != newStream.GetResource()) {
            oldState.SetValue("rs", oldStream.GetResource());
            newState.SetValue("rs", newStream.GetResource());
            _s._utils.logSession("Monitor: change resource from " + oldState.GetValue("rs") + " to " + newState.GetValue("rs"), _s._sessionId);
          }
          _s.declareStateChange(newState, oldState);
        }

        defPrivMeth(_s, "updateStateCumulativeTime", __updateStateCumulativeTime);
        function __updateStateCumulativeTime() {
          var now = _s._utils.epochTimeMs();
          var playingStateInt = PlayerStates.stringToInt(_s._playingState);
          if (_s._playingState != ConvivaStreamerProxy.UNKNOWN) {
            var delta = slint.Cast(now - _s._lastStateUpdateTimeMs);
            _s._cumulativeTimePerState.SetValue(playingStateInt, _s._cumulativeTimePerState.GetValue(playingStateInt) + delta);

            var bitrateKbps = _s._streamInfo.GetBitrateKbps();
            if (_s._playingState == ConvivaStreamerProxy.PLAYING && bitrateKbps != -1) {
              _s._nominalPlayingBitsTotal += delta * bitrateKbps;
            }
          }
          _s._lastStateUpdateTimeMs = now;
        }

        defPrivMeth(_s, "declareError", __declareError);
        function __declareError(errorMsg, isFatal) {
          if (_s._joinTimeMs < 0 && isFatal) {

            _s._joinTimeMs = -2;
          }
          var data = new DictionaryCS();
          data.SetValue("ft", isFatal);
          data.SetValue("err", errorMsg);
          _s.enqueueEvent("CwsErrorEvent", data);
        }

        defPrivMeth(_s, "declareStateChange", __declareStateChange);
        function __declareStateChange(newState, oldState) {

          var newStateNative = Lang.StringDictionaryToRepr(newState);
          var oldStateNative = Lang.StringDictionaryToRepr(oldState);
          var data = new DictionaryCS();
          data.SetValue("new", newStateNative);
          if (oldState != null) {
            data.SetValue("old", oldStateNative);
          }
          _s.enqueueEvent("CwsStateChangeEvent", data);
        }

        defStatMeth(_s, Monitor, "wrapInConvivaStreamerProxy", __wrapInConvivaStreamerProxy);
        function __wrapInConvivaStreamerProxy(streamer, sessionId) {

          var realSamsungStreamerProxy = null;
          try {
            if (streamer.getAttribute && streamer.getAttribute("classid").indexOf("clsid:SAMSUNG-INFOLINK") >= 0) {
              realSamsungStreamerProxy = new SamsungStreamerProxy(streamer);
              realSamsungStreamerProxy.startMonitoring();
            }
          } catch (e) {}
          if (realSamsungStreamerProxy) {
            return realSamsungStreamerProxy;
          } else if (streamer.hasOwnProperty('getStreamerType') && streamer.getStreamerType() == 'Samsung') {
            return SamsungStreamerProxy.createSamsungStreamerProxy(streamer);
          } else if (streamer.setQosData !== undefined && streamer.licenseResponse !== undefined) {
            return new PlayStationTouchFactorStreamerProxy();
          } else if (streamer.codecs !== undefined && streamer.maxBufferLength !== undefined) {
            return new PlayStationLibjscriptStreamerProxy();
          } else if (streamer.textTrackDisplay !== undefined && streamer.mediaLoader !== undefined) {
            return new ConvivaVideojsStreamerProxy(streamer);
          } else if (streamer.networkState !== undefined && streamer.readyState !== undefined) {
            return new Html5ConvivaStreamerProxy(streamer);
          } else if (streamer.currentPTS !== undefined && streamer.availableAudioStreams !== undefined) {
            return new PlayStationTrilithiumStreamerProxy(streamer);
          } else if (streamer.mediaElementAdapter !== undefined) {
            return new Xbox1ConvivaStreamerProxy(streamer);
          } else if (streamer.MbId !== undefined && streamer.blockedParams !== undefined) {
            return new ConvivaOoyalaStreamerProxy(streamer);
          } else if (streamer.mb !== undefined && streamer.mb.MbId !== undefined && streamer.mb.blockedParams !== undefined) {
            return new ConvivaOoyalaStreamerProxy(streamer.mb);
          } else {
            return streamer;
          }
        }
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Monitor, "Monitor");

      function EventQueue() {
        var _s = this;

        if (_s != STAT_INIT) _s._events = null;
        if (_s != STAT_INIT) _s._nextSeqNumber = 0;

        function _constr() {
          _s._events = NativeLang.makeList();
        }

        defPubMeth(_s, "enqueueEvent", __enqueueEvent);
        function __enqueueEvent(type, data, timeSinceSessionStart) {
          data.SetValue("t", type);
          data.SetValue("st", timeSinceSessionStart);
          data.SetValue("seq", _s._nextSeqNumber);
          _s._nextSeqNumber++;
          NativeLang.addListValue(_s._events, Lang.StringDictionaryToRepr(data));
        }

        defPubMeth(_s, "flushEvents", __flushEvents);
        function __flushEvents() {
          var currentEvents = _s._events;
          _s._events = NativeLang.makeList();
          return currentEvents;
        }
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(EventQueue, "EventQueue");

      function Session() {
        var _s = this;

        if (_s != STAT_INIT) _s._contentInfo = null;

        if (_s != STAT_INIT) _s._nativeReprTags = null;
        if (_s != STAT_INIT) _s._utils = null;
        if (_s != STAT_INIT) _s._settings = null;

        if (_s != STAT_INIT) _s._monitor = null;

        if (_s != STAT_INIT) _s._eventQueue = null;

        if (_s != STAT_INIT) _s._clientIdWaiter = null;
        if (_s != STAT_INIT) _s._heartbeatTimer = null;
        if (_s != STAT_INIT) _s._encodeHeartbeatTimer = null;

        if (_s == STAT_INIT) Session._sendLogs = false;

        if (_s != STAT_INIT) _s._sessionId = 0;

        if (_s != STAT_INIT) _s._startTimeMs = 0;
        if (_s != STAT_INIT) _s._heartbeatSequenceNumber = 0;

        function _constr(streamer, contentInfo, options, global) {
          _s._contentInfo = contentInfo;
          _s._utils = Utils.getInstance();
          _s._settings = _s._utils.getSettings();
          _s._sessionId = _s._utils.randInt();

          var langTags = Lang.DictionaryFromRepr(_s._contentInfo.tags);
          var keysToCorrect = new ListCS();
          var _for_array_1 = langTags.Keys;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var tkey = _for_array_1[_for_idx_2];

            if (langTags.GetValue(tkey) == null) {
              keysToCorrect.Add(tkey);
            }
          }
          var _for_array_3 = keysToCorrect.Values;
          for (var _for_idx_4 = 0; _for_idx_4 < _for_array_3.length; _for_idx_4++) {
            var tkey1 = _for_array_3[_for_idx_4];

            _s.log("WARNING: correcting null value for tag " + tkey1);
            NativeLang.setDictValue(_s._contentInfo.tags, tkey1, "null");
          }
          _s._nativeReprTags = Lang.StringDictionaryToRepr(_s._contentInfo.tags);

          _s._eventQueue = new EventQueue();

          if (!global) {
            _s._monitor = new Monitor(streamer, _s._eventQueue, _s._contentInfo, options, _s._sessionId);
          }
        }

        defPubMeth(_s, "start", __start);
        function __start() {
          if (_s._monitor != null) {
            _s.log("Session.start(): assetName=" + _s._contentInfo.assetName);
          }
          _s._startTimeMs = _s._utils.epochTimeMs();
          if (_s._monitor != null) {
            _s._monitor.start(_s._startTimeMs);
          }
          _s._heartbeatSequenceNumber = 0;

          if (_s._utils.clientIdLoadingDone == null) {

            _s.sendHeartbeat();
          } else {

            _s._clientIdWaiter = _s.onClientIdLoaded;
            _s._utils.clientIdLoadingDone.AddHandler(_s._clientIdWaiter);
          }
          _s._heartbeatTimer = null;
          _s.resetHeartbeatTimer();
        }

        defPubMeth(_s, "cleanup", __cleanup);
        function __cleanup() {
          _s.log("Session.cleanup()" + _s.sessionTypeTag());
          if (_s._heartbeatTimer != null) {
            _s._heartbeatTimer.cleanup();
          }
          _s._heartbeatTimer = null;
          _s._utils.logSession("Schedule the last hb before session cleanup" + _s.sessionTypeTag(), _s._sessionId);

          if (_s._monitor != null) {
            _s.enqueueSessionEndEvent();
          }

          var urgentHb = _s.makeHeartbeat();
          if (urgentHb != null) {
            _s.encodeAndPostHeartbeat(urgentHb, function () {

              _s.cleanupAll();
            });
          } else {

            _s.cleanupAll();
          }
        }

        defPrivMeth(_s, "enqueueSessionEndEvent", __enqueueSessionEndEvent);
        function __enqueueSessionEndEvent() {
          var eventData = new DictionaryCS();
          _s._eventQueue.enqueueEvent("CwsSessionEndEvent", eventData, slint.Cast(_s._utils.epochTimeMs() - _s._startTimeMs));
        }

        defPubMeth(_s, "pauseJoinTime", __pauseJoinTime);
        function __pauseJoinTime() {
          if (_s._monitor != null) {
            _s._monitor.pauseJoinTime();
          }
        }

        defPubMeth(_s, "resumeJoinTime", __resumeJoinTime);
        function __resumeJoinTime() {
          if (_s._monitor != null) {
            _s._monitor.resumeJoinTime(true);
          }
        }

        defPubMeth(_s, "adStart", __adStart);
        function __adStart() {

          _s.pauseJoinTime();
        }

        defPubMeth(_s, "adEnd", __adEnd);
        function __adEnd() {

          _s.resumeJoinTime();
        }

        defPubMeth(_s, "detachStreamer", __detachStreamer);
        function __detachStreamer() {
          _s._monitor.detachStreamer();
        }

        defPubMeth(_s, "attachStreamer", __attachStreamer);
        function __attachStreamer(streamer) {
          _s._monitor.attachStreamer(streamer);
        }

        defPrivMeth(_s, "resetHeartbeatTimer", __resetHeartbeatTimer);
        function __resetHeartbeatTimer() {
          if (_s._heartbeatTimer != null) {
            _s._heartbeatTimer.cleanup();
          }
          _s._heartbeatTimer = _s._utils.createTimer(_s.sendHeartbeat, _s._settings.heartbeatIntervalMs, "sendHeartbeat");
        }

        defPrivMeth(_s, "cleanupAll", __cleanupAll);
        function __cleanupAll() {
          if (_s._clientIdWaiter != null) {
            _s._utils.clientIdLoadingDone.DeleteHandler(_s._clientIdWaiter);
            _s._clientIdWaiter = null;
          }
          if (_s._monitor != null) {
            _s._monitor.cleanup();
            _s._monitor = null;
          }
          if (_s._encodeHeartbeatTimer != null) {
            _s._encodeHeartbeatTimer.cleanup();
            _s._encodeHeartbeatTimer = null;
          }
          if (_s._eventQueue != null) {
            _s._eventQueue.flushEvents();
            _s._eventQueue = null;
          }
          _s._contentInfo = null;
          _s._nativeReprTags = null;
          _s._settings = null;
          _s._utils = null;
        }

        defPrivMeth(_s, "log", __log);
        function __log(message) {
          _s._utils.logSession(message, _s._sessionId);
        }

        defPubMeth(_s, "reportError", __reportError);
        function __reportError(err) {
          _s.log("Session.reportError()");
          if (_s._monitor != null) {

            _s._monitor.OnError(err);
          }
        }

        defPubMeth(_s, "setBitrate", __setBitrate);
        function __setBitrate(bitrateKbps) {
          _s.log("Session.setBitrate(): bitrateKbps=" + bitrateKbps);
          if (_s._monitor != null) {
            _s._monitor.setBitrate(bitrateKbps);
          }
        }

        defPubMeth(_s, "setCurrentStreamMetadata", __setCurrentStreamMetadata);
        function __setCurrentStreamMetadata(metadata) {
          _s.log("Session.setCurrentStreamMetadata()");
          if (_s._monitor != null && _s._monitor.streamer != null) {

            _s._monitor.streamer.SetMetadata(metadata);
          }
        }

        defPubMeth(_s, "setCdnNameOrResource", __setCdnNameOrResource);
        function __setCdnNameOrResource(resource) {
          _s.log("Session.setCdnNameOrResource()");
          if (_s._monitor != null) {
            var newStream = new StreamInfo(-2, resource, resource, -1, -1, -1);
            _s._monitor.SetStream(newStream);
          }
        }

        defPubMeth(_s, "sendCustomEvent", __sendCustomEvent);
        function __sendCustomEvent(name, eventAttrs) {
          _s.log("Session.sendEvent(): eventName=" + name + _s.sessionTypeTag());
          var eventData = new DictionaryCS();
          eventData.SetValue("name", name);

          var eventAttrsNative = Lang.StringDictionaryToRepr(eventAttrs);

          eventData.SetValue("attr", eventAttrsNative);
          _s._eventQueue.enqueueEvent("CwsCustomEvent", eventData, slint.Cast(_s._utils.epochTimeMs() - _s._startTimeMs));
        }

        defPrivMeth(_s, "sendHeartbeat", __sendHeartbeat);
        function __sendHeartbeat() {
          var heartbeat = null;
          if (_s._encodeHeartbeatTimer != null) {
            _s._encodeHeartbeatTimer.cleanup();
          }
          _s._encodeHeartbeatTimer = _s._utils.scheduleAction(function () {
            heartbeat = _s.makeHeartbeat();
            if (heartbeat != null) {
              _s._encodeHeartbeatTimer = _s._utils.scheduleAction(function () {
                _s.encodeAndPostHeartbeat(heartbeat, null);
                _s._encodeHeartbeatTimer = null;
              }, 1, "encodeAndSendHeartbeat");
            }
          }, 1, "makeHeartbeat");
        }

        defPrivMeth(_s, "makeHeartbeat", __makeHeartbeat);
        function __makeHeartbeat() {
          var heartbeat = {};
          NativeLang.setDictValue(heartbeat, "t", "CwsSessionHb");
          NativeLang.setDictValue(heartbeat, "cid", _s._settings.customerKey);
          NativeLang.setDictValue(heartbeat, "clid", _s._utils.clientId);
          NativeLang.setDictValue(heartbeat, "sid", _s._sessionId);
          NativeLang.setDictValue(heartbeat, "seq", _s._heartbeatSequenceNumber);
          NativeLang.setDictValue(heartbeat, "pver", _s._settings.protocolVersion);
          NativeLang.setDictValue(heartbeat, "clv", _s._settings.clientVersion);
          NativeLang.setDictValue(heartbeat, "iid", _s._settings.clientInstanceId);
          var platformMetadata = Lang.StringDictionaryToRepr(_s._settings.platformApi.getPlatformMetadata());
          if (platformMetadata != null) {
            NativeLang.setDictValue(heartbeat, "pm", platformMetadata);
          }
          if (_s._utils.device != null) {
            NativeLang.setDictValue(heartbeat, "dv", _s._utils.device);
          }
          if (_s._utils.deviceVersion != null) {
            NativeLang.setDictValue(heartbeat, "dvv", _s._utils.deviceVersion);
          }
          if (_s._utils.deviceType != null) {
            NativeLang.setDictValue(heartbeat, "dvt", _s._utils.deviceType);
          } else if (_s._contentInfo.deviceType != null) {
            NativeLang.setDictValue(heartbeat, "dvt", _s._contentInfo.deviceType);
          }
          if (_s._utils.os != null) {
            NativeLang.setDictValue(heartbeat, "os", _s._utils.os);
          }
          if (_s._utils.osVersion != null) {
            NativeLang.setDictValue(heartbeat, "osv", _s._utils.osVersion);
          }
          if (_s._utils.platform != null) {
            NativeLang.setDictValue(heartbeat, "pt", _s._utils.platform);
          }
          if (_s._contentInfo.viewerId != null) {
            NativeLang.setDictValue(heartbeat, "vid", _s._contentInfo.viewerId);
          }
          if (_s._contentInfo.streamUrl != null) {
            NativeLang.setDictValue(heartbeat, "url", _s._contentInfo.streamUrl);
          }
          if (_s._contentInfo.playerName != null) {
            NativeLang.setDictValue(heartbeat, "pn", _s._contentInfo.playerName);
          }
          NativeLang.setDictValue(heartbeat, "tags", _s._nativeReprTags);

          if (_s._monitor != null) {
            NativeLang.setDictValue(heartbeat, "an", _s._contentInfo.assetName);
            NativeLang.setDictValue(heartbeat, "lv", _s._contentInfo.isLive);
            _s._monitor.updateHeartbeat(heartbeat);
          } else {

            NativeLang.setDictValue(heartbeat, "sf", 0);
          }
          var currentEvents = _s._eventQueue.flushEvents();
          NativeLang.setDictValue(heartbeat, "evs", currentEvents);

          if (_s._monitor == null && NativeLang.listCount(currentEvents) == 0) {
            return null;
          }

          if (Session._sendLogs) {
            NativeLang.setDictValue(heartbeat, "lg", Lang.ListToRepr(_s._utils.getLogs(_s._sessionId)));
          }

          var currentTime = _s._utils.epochTimeMs();
          NativeLang.setDictValue(heartbeat, "st", slint.Cast(currentTime - _s._startTimeMs));
          NativeLang.setDictValue(heartbeat, "cts", currentTime / 1000.0);
          _s._heartbeatSequenceNumber++;
          return heartbeat;
        }

        defPrivMeth(_s, "sessionTypeTag", __sessionTypeTag);
        function __sessionTypeTag() {
          if (_s._monitor == null) return " (global session)";
          return "";
        }

        defPrivMeth(_s, "encodeAndPostHeartbeat", __encodeAndPostHeartbeat);
        function __encodeAndPostHeartbeat(heartbeat, afterPostCbk) {
          var jsonHeartbeat = _s._utils.jsonEncode(heartbeat);
          var url = _s._settings.gatewayUrl + _s._settings.gatewayPath;
          var contentType = "application/json";
          _s.log("Send HB[" + (_s._heartbeatSequenceNumber - 1) + "]" + _s.sessionTypeTag());
          _s._utils.httpRequest(true, url, jsonHeartbeat, contentType, _s.onHeartbeatResponse);
          if (afterPostCbk != null) {
            afterPostCbk();
          }
        }

        defPrivMeth(_s, "onHeartbeatResponse", __onHeartbeatResponse);
        function __onHeartbeatResponse(isSuccess, jsonResponse) {
          if (_s._utils != null) {
            _s._utils.runProtected(function () {
              if (isSuccess) {
                var decodedResponse = _s._utils.jsonDecode(jsonResponse);
                if (decodedResponse != null) {
                  if (decodedResponse.ContainsKey("clid")) {
                    _s._utils.setClientIdFromServer(Lang.ToString(decodedResponse.GetValue("clid")), false);
                  }
                  var newSendLogs = decodedResponse.ContainsKey("slg") && Boolean(decodedResponse.GetValue("slg"));
                  if (newSendLogs != Session._sendLogs) {
                    _s.log("Turning " + (newSendLogs ? "on" : "off") + " sending of logs");
                    Session._sendLogs = newSendLogs;
                  }
                  if (decodedResponse.ContainsKey("hbi")) {
                    var heartbeatIntervalSec = slint.Cast(decodedResponse.GetValue("hbi"));
                    if (1000 * heartbeatIntervalSec != _s._settings.heartbeatIntervalMs) {
                      _s.log("Received hbInterval from server " + heartbeatIntervalSec);
                      _s._settings.heartbeatIntervalMs = 1000 * heartbeatIntervalSec;
                      if (_s._heartbeatTimer != null) {
                        _s.resetHeartbeatTimer();
                      }
                    }
                  }
                  if (decodedResponse.ContainsKey("gw")) {
                    var gatewayUrl = decodedResponse.GetValue("gw");
                    if (gatewayUrl != _s._settings.gatewayUrl) {
                      _s.log("Received gatewayUrl from server " + gatewayUrl);
                      _s._settings.gatewayUrl = gatewayUrl;
                    }
                  }
                } else {
                  _s.log("Decoded heartbeat response is null.");
                }
              } else {
                _s.log("Received no response (or a bad response) to heartbeat POST request.");
              }
            }, "onHeartbeatResponse");
          }
        }

        defPrivMeth(_s, "onClientIdLoaded", __onClientIdLoaded);
        function __onClientIdLoaded() {

          _s._utils.clientIdLoadingDone.DeleteHandler(_s._clientIdWaiter);
          _s._clientIdWaiter = null;
          _s.sendHeartbeat();
        }

        defPubMeth(_s, "initialResourceBitrateSelection", __initialResourceBitrateSelection);
        function __initialResourceBitrateSelection() {
          var proxy = _s._monitor.streamer;
          throw new Error("Not implemented");
        }

        defPubMeth(_s, "midStreamResourceBitrateSelection", __midStreamResourceBitrateSelection);
        function __midStreamResourceBitrateSelection(switchTriggers) {

          throw new Error("Not implemented");
        }
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Session, "Session");

      function SessionFactory() {
        var _s = this;
        if (_s != STAT_INIT) _s.lastSessionId = 0;

        if (_s != STAT_INIT) _s._utils = null;
        if (_s != STAT_INIT) _s._settings = null;
        if (_s != STAT_INIT) _s._nextSessionId = 0;
        if (_s != STAT_INIT) _s._sessionsById = null;

        function _constr() {
          _s._utils = Utils.getInstance();
          _s._settings = _s._utils.getSettings();
          _s._nextSessionId = 0;
          _s._sessionsById = new DictionaryCS();
          _s.lastSessionId = 0;
        }

        defPubMeth(_s, "cleanup", __cleanup);
        function __cleanup() {
          _s._utils = null;
          _s._settings = null;
          if (_s._sessionsById != null) {
            var _for_array_1 = _s._sessionsById.KeyValuePairs;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var sessionPair = _for_array_1[_for_idx_2];

              var sess = sessionPair.Value;
              sess.cleanup();
            }
          }
          _s._sessionsById = null;
          _s._nextSessionId = 0;
        }

        defPubMeth(_s, "newSessionId", __newSessionId);
        function __newSessionId() {
          var sessionId = _s._nextSessionId;
          _s._nextSessionId++;
          return sessionId;
        }

        defPubMeth(_s, "makeSession", __makeSession);
        function __makeSession(streamer, contentInfo, options, sessionId, global) {
          var session = new Session(streamer, contentInfo, options, global);
          _s.addSession(sessionId, session);
          _s.lastSessionId = sessionId;
          session.start();
          return session;
        }

        defPubMeth(_s, "getSession", __getSession);
        function __getSession(sessionId) {
          if (_s._sessionsById.ContainsKey(sessionId)) {
            return _s._sessionsById.GetValue(sessionId);
          }
          if (sessionId == -1) {
            _s._utils.err("LivePass: invalid sessionId. LivePass not properly initialized yet?");
          } else {
            _s._utils.err("LivePass: invalid sessionId. Did you cleanup that session previously?");
          }
          return null;
        }

        defPubMeth(_s, "addSession", __addSession);
        function __addSession(sessionId, session) {
          _s._sessionsById.SetValue(sessionId, session);
        }

        defPubMeth(_s, "removeSession", __removeSession);
        function __removeSession(sessionId) {
          _s._sessionsById.Remove(sessionId);
        }

        defPubMeth(_s, "cleanupSession", __cleanupSession);
        function __cleanupSession(sessionId) {
          var session = _s.getSession(sessionId);
          if (session != null) {
            _s.removeSession(sessionId);
            session.cleanup();
          }
        }
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(SessionFactory, "SessionFactory");

      function ArrayCS() {
        var _s = this;

        if (_s != STAT_INIT) _s.arr = undefined;
        function _constr(size) {
          if (size == undefined) size = 0;
          _s.arr = new Array(size);
        }

        defStatMeth(_s, ArrayCS, "Create", __Create);
        function __Create() {
          var res = new ArrayCS();
          var l = [];

          for (var i = 0; i < arguments.length; i++) {
            l.push(arguments[i]);
          }
          res.arr = l;
          return res;
        }

        defStatMeth(_s, ArrayCS, "FromRepr", __FromRepr);
        function __FromRepr(a) {
          if (a == null) return null;
          var res = new ArrayCS();
          res.arr = a;
          return res;
        }

        defPubMeth(_s, "ToRepr", __ToRepr);
        function __ToRepr() {
          return _s.arr;
        }

        defGet(_s, "Length", __Length);
        function __Length() {
          return _s.arr.length;
        }

        defPubMeth(_s, "GetValue", __GetValue);
        function __GetValue(idx) {
          if (idx >= _s.arr.length) {
            throw new Error("Index out of bounds: " + idx + " (length " + _s.arr.length + ")");
          } else if (idx < 0) {
            throw new Error("Index out of bounds: " + idx);
          }
          return _s.arr[idx];
        }

        defPubMeth(_s, "SetValue", __SetValue);
        function __SetValue(idx, v) {
          if (idx >= _s.arr.length) {
            throw new Error("Index out of bounds: " + idx + " (length " + _s.arr.length + ")");
          } else if (idx < 0) {
            throw new Error("Index out of bounds: " + idx);
          }
          _s.arr[idx] = v;
        }

        defGet(_s, "Values", __Values);
        function __Values() {
          return _s.arr;
        }

        if (_s != STAT_INIT) _constr.apply(this, arguments);
      }
      statInit(ArrayCS, "ArrayCS");

      function Cleanable() {
        var _s = this;

        if (_s != STAT_INIT) _s._cleanupAction = null;

        if (_s == STAT_INIT) Cleanable._nextCleanupId = 0;
        if (_s != STAT_INIT) _s._id = 0;
        if (_s != STAT_INIT) _s._cleanupCollection = null;

        function _constr(cleanupCollection) {
          _s._cleanupCollection = cleanupCollection;
          _s._id = Cleanable._nextCleanupId;
          Cleanable._nextCleanupId++;
          _s._cleanupCollection.SetValue(_s._id, _s);
        }

        defPubMeth(_s, "setCleanupAction", __setCleanupAction);
        function __setCleanupAction(cleanupAction) {
          _s._cleanupAction = cleanupAction;
        }

        defPubMeth(_s, "cleanup", __cleanup);
        function __cleanup() {
          if (_s._cleanupAction != null) {
            _s._cleanupAction();
          }
          _s._cleanupCollection.Remove(_s._id);
        }

        defStatMeth(_s, Cleanable, "cleanupCollection", __cleanupCollection);
        function __cleanupCollection(collection) {

          Utils.getInstance().log("cleanupCollection");
          var toClean = new ListCS();
          var _for_array_1 = collection.Values;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var o = _for_array_1[_for_idx_2];

            toClean.Add(o);
          }
          var _for_array_3 = toClean.Values;
          for (var _for_idx_4 = 0; _for_idx_4 < _for_array_3.length; _for_idx_4++) {
            var o = _for_array_3[_for_idx_4];

            o.cleanup();
          }
          collection.Clear();
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Cleanable, "Cleanable");

      function DictionaryCS() {
        var _s = this;

        if (_s != STAT_INIT) _s.obj = undefined;
        function _constr(size) {
          _s.obj = {};
        }

        defStatMeth(_s, DictionaryCS, "FromRepr", __FromRepr);
        function __FromRepr(o) {
          if (o == null) return null;
          if (o instanceof DictionaryCS) {
            return o;
          }
          if (o.hasOwnProperty("ToObject")) {
            o = o.ToObject();
          }
          var res = new DictionaryCS();

          slForEachProp(o, function (k) {
            res.obj[k] = o[k];
          });
          return res;
        }

        defPubMeth(_s, "ToObject", __ToObject);
        function __ToObject() {
          return _s.obj;
        }

        defStatMeth(_s, DictionaryCS, "Create", __Create);
        function __Create() {
          var res = new DictionaryCS();
          for (var i = 0; i + 1 < arguments.length; i += 2) {
            res.obj[arguments[i]] = arguments[i + 1];
          }
          return res;
        };

        defPubMeth(_s, "CopyToObject", __CopyToObject);
        function __CopyToObject(obj) {
          slForEachProp(_s.obj, function (k) {
            obj[k] = _s.obj[k];
          });
        }

        defPubMeth(_s, "GetValue", __GetValue);
        function __GetValue(key) {
          return _s.obj[key];
        }

        defPubMeth(_s, "SetValue", __SetValue);
        function __SetValue(key, v) {
          _s.obj[key] = v;
        }

        defPubMeth(_s, "Clear", __Clear);
        function __Clear() {
          slForEachProp(_s.obj, function (p) {
            delete _s.obj[p];
          });
        }

        defPubMeth(_s, "ContainsKey", __ContainsKey);
        function __ContainsKey(key) {
          return _s.obj[key] !== undefined;
        }

        defPubMeth(_s, "Contains", __Contains);
        function __Contains(key) {
          return ContainsKey(key);
        }

        defGet(_s, "Keys", __Keys);
        function __Keys() {
          var res = new Array();
          slForEachProp(_s.obj, function (p) {
            res.push(p);
          });
          return res;
        }

        defGet(_s, "Values", __Values);
        function __Values() {
          var res = new Array();
          slForEachProp(_s.obj, function (p) {
            res.push(_s.obj[p]);
          });
          return res;
        }

        defGet(_s, "KeyValuePairs", __KeyValuePairs);
        function __KeyValuePairs() {
          var res = new Array();
          slForEachProp(_s.obj, function (p) {
            res.push(new KeyValuePairCS(p, _s.obj[p]));
          });
          return res;
        }

        defGet(_s, "Count", __Count);
        function __Count() {
          var res = 0;
          slForEachProp(_s.obj, function (p) {
            res++;
          });
          return res;
        }

        defPubMeth(_s, "Add", __SetValue);

        defPubMeth(_s, "Remove", __Remove);
        function __Remove(key) {
          if (_s.ContainsKey(key)) {
            delete _s.obj[key];
            return true;
          } else return false;
        }

        if (_s != STAT_INIT) _constr.apply(this, arguments);
      }
      statInit(DictionaryCS, "DictionaryCS");

      function Eventer() {
        var _s = this;
        if (_s != STAT_INIT) _s._handlers = undefined;

        function _constr() {
          _s._handlers = new ListCS();
        }

        defPubMeth(_s, "Cleanup", __Cleanup);
        function __Cleanup() {
          _s._handlers = new ListCS();
        }

        defPubMeth(_s, "AddHandler", __AddHandler);
        function __AddHandler(handler) {
          _s._handlers.Add(handler);
        }

        defPubMeth(_s, "DeleteHandler", __DeleteHandler);
        function __DeleteHandler(handler) {
          _s._handlers.Remove(handler);
        }

        defPubMeth(_s, "DispatchEvent", __DispatchEvent);
        function __DispatchEvent() {
          var _for_array_1 = _s._handlers.Values;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var h = _for_array_1[_for_idx_2];

            h();
          }
        }
        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Eventer, "Eventer");

      function KeyValuePairCS() {
        var _s = this;

        if (_s != STAT_INIT) _s.key = undefined;
        if (_s != STAT_INIT) _s.val = undefined;
        function _constr(key, val) {
          _s.key = key;
          _s.val = val;
        }

        defGet(_s, "Key", __Key);
        function __Key() {
          return _s.key;
        }

        defGet(_s, "Value", __Value);
        function __Value() {
          return _s.val;
        }
        if (_s != STAT_INIT) _constr.apply(this, arguments);
      }
      statInit(KeyValuePairCS, "KeyValuePairCS");

      function Lang() {
        Lang.StringIndexOf = function (s1, s2) {
          return s1.indexOf(s2);
        };

        Lang.StringStartsWith = function (s1, s2) {
          return 0 == s1.indexOf(s2);
        };

        Lang.StringContains = function (s1, s2) {
          return 0 <= s1.indexOf(s2);
        };

        Lang.StringGetChar = function (s, where) {
          if (where < 0 || where >= s.length) {
            throw new Error("ArgumentOutOfRange");
          }
          return s[where];
        };

        Lang.StringSubstring = function (str, startIndex, count) {
          if (startIndex < 0 || startIndex >= str.length || count != undefined && (count < 0 || startIndex + count > str.length)) {
            throw new Error("ArgumentOutOfRange");
          }
          if (count == undefined) {
            return str.substr(startIndex);
          } else {
            return str.substr(startIndex, count);
          }
        };

        Lang.StringSplit = function (s1, sep) {
          var res = s1.split(sep);
          return ArrayCS.FromRepr(res);
        };

        Lang.StringEnumerator = function (s) {
          return s.split("");
        };

        Lang.StringCompareTo = function (str1, str2) {
          if (str1 == null) {
            if (str2 == null) return 0;
            return -1;
          }
          if (str2 == null) return 1;

          if (str1 < str2) return -1;
          if (str1 == str2) return 0;
          return 1;
        };

        Lang.StringTrim = function (s) {
          return s.replace(/^\s*/, "").replace(/\s*$/, "");
        };

        Lang.StringReplace = function (str1, strsearch, strreplace) {
          if (strsearch == null || strsearch == "" || strreplace == null) {
            throw new Error("InvalidArgument");
          }

          var searchIdx = str1.indexOf(strsearch);
          if (searchIdx >= 0) {
            var searchLen = strsearch.length;

            return str1.substr(0, searchIdx) + strreplace + Lang.StringReplace(str1.substr(searchIdx + searchLen), strsearch, strreplace);
          } else {
            return str1;
          }
        };

        Lang.StringLastIndexOf = function (str1, strsearch) {
          if (strsearch == null || strsearch == "") {
            throw new Error("InvalidArgument");
          }
          return str1.lastIndexOf(strsearch);
        };

        Lang.ListFromRepr = function (a) {
          return ListCS.FromRepr(a);
        };

        Lang.ArrayFromRepr = function (repr) {
          return ArrayCS.FromRepr(repr);
        };

        Lang.ArrayToRepr = function (a) {
          if (a == null) return null;
          return a.ToRepr();
        };

        Lang.ListFromRepr = function (repr) {
          return ListCS.FromRepr(repr);
        };

        Lang.ListToRepr = function (l) {
          if (l == null) return null;
          return l.ToRepr();
        };

        Lang.DictionaryFromRepr = function (repr) {
          var tmp = DictionaryCS.FromRepr(repr);

          return tmp;
        };

        Lang.StringDictionaryToRepr = function (dict) {
          if (dict == null) return null;
          if (dict.hasOwnProperty("ToObject")) {
            return dict.ToObject();
          } else {
            return dict;
          }
        };

        Lang.DictionaryCopyToObject = function (dict, obj) {
          if (dict == null) return;
          dict.CopyToObject(obj);
        };

        Lang.StringFromRepr = function (s) {
          return s;
        };

        Lang.StringToXml = function (str) {
          try {
            if (window.DOMParser) {
              var xmlobject = new DOMParser().parseFromString(str, "text/xml");
              return xmlobject.documentElement;
            } else {

              var xmlobject = new ActiveXObject("Microsoft.XMLDOM");
              xmlobject.async = "false";
              xmlobject.loadXML(str);
              return xmlobject.documentElement;
            }
          } catch (e) {
            return null;
          }
        };

        Lang.XmlToString = function (oXML) {
          try {
            if (window.XMLSerializer) {
              return new XMLSerializer().serializeToString(oXML);
            } else {
              return oXML.xml;
            }
          } catch (e) {
            return null;
          }
        };

        Lang.ToString = function (o) {
          if (o == null) return null;

          if (typeof o.ToString == "function") {
            return o.ToString();
          } else {
            return o.toString();
          }
        };

        Lang.StringToLower = function (s) {
          return s.toLowerCase();
        };

        Lang.StringToInt = function (s) {
          return parseInt(s);
        };

        Lang.AsDouble = function (v) {
          if (v instanceof Int64) {
            return v.asNumber;
          } else if (v instanceof UInt64) {
            return v.asNumber;
          } else {
            return Number(v);
          }
        };

        Lang.doubleRegex = new RegExp("^([+-]?[0-9]*\\.?[0-9]+)((e|E)[+-]?[0-9]+)?$");
        Lang.parseDouble = function (v) {

          Lang.parseChecker(v, Lang.doubleRegex, "double");
          return parseFloat(v);
        };

        Lang.parseChecker = function (s, pattern, what) {
          if (!pattern.test(s)) {
            throw new Error("Invalid string for " + what + ": " + s);
          }
        };
      }
      statInit(Lang, "Lang");

      function ListCS() {
        var _s = this;

        if (_s != STAT_INIT) _s.arr = undefined;
        function _constr() {

          if (arguments.length > 1) {
            Ping.Send("Error: Instantiate ListCS with too many arguments");
          } else if (arguments.length == 0) {
            ArrayCS.call(_s, 0);
          } else if (arguments[0] instanceof Number) {
            ArrayCS.call(_s, arguments[0]);
          } else if (arguments[0] instanceof Array) {
            ArrayCS.call(_s, arguments[0].length);
            _s.arr = arguments[0];
          } else if (arguments[0] instanceof ArrayCS) {
            ArrayCS.call(_s, arguments[0].length);
            _s.arr = arguments[0].arr;
          } else {
            Ping.Send("Error: Instantiate ListCS with inappropriate arguments");
          }
        }

        defStatMeth(_s, ListCS, "Create", __Create);
        function __Create(a) {
          var res = new ListCS();
          for (var i = 0; i < arguments.length; i++) {
            res.arr.push(arguments[i]);
          }
          return res;
        }

        defStatMeth(_s, ListCS, "FromRepr", __FromRepr);
        function __FromRepr(a) {
          if (a == null) {
            return a;
          }
          if (a instanceof ListCS) {
            return a;
          }
          var res = new ListCS();
          res.arr = a;
          return res;
        }

        defPubMeth(_s, "ToRepr", __ToRepr);
        function __ToRepr() {
          return _s.arr;
        }

        defGet(_s, "Count", __Count);
        function __Count() {
          return _s.arr.length;
        }

        defGet(_s, "Values", __Values);
        function __Values() {
          return _s.arr;
        }

        defPubMeth(_s, "Add", __Add);
        function __Add(e) {
          _s.arr.push(e);
        }

        defPubMeth(_s, "Clear", __Clear);
        function __Clear(e) {
          _s.arr.length = 0;
        }

        defPubMeth(_s, "IndexOf", __IndexOf);
        function __IndexOf(e) {
          var startIndex = arguments[1];
          if (startIndex == null) {
            startIndex = 0;
          } else if (startIndex < 0 || startIndex >= _s.arr.length) {
            throw new Error("Starting index out of bound");
          }

          for (var i = startIndex; i < _s.arr.length; i++) {
            if (_s.arr[i] == e) return i;
          }
          return -1;
        }

        defPubMeth(_s, "Contains", __Contains);
        function __Contains(e) {
          return _s.IndexOf(e) >= 0;
        }

        defPubMeth(_s, "Insert", __Insert);
        function __Insert(idx, e) {
          _s.arr.splice(idx, 0, e);
        }

        defPubMeth(_s, "Remove", __Remove);
        function __Remove(e) {
          var idx = _s.IndexOf(e);
          if (idx < 0) return false;
          _s.RemoveAt(idx);
          return true;
        }

        defPubMeth(_s, "RemoveRange", __RemoveRange);
        function __RemoveRange(where, count) {
          _s.arr.splice(where, count);
        }

        defPubMeth(_s, "RemoveAt", __RemoveAt);
        function __RemoveAt(where) {
          _s.arr.splice(where, 1);
        }

        defPubMeth(_s, "GetRange", __GetRange);
        function __GetRange(startidx, len) {
          var res = new ListCS();
          res.arr = _s.arr.slice(startidx, startidx + len);
          return res;
        }

        defPubMeth(_s, "Sort", __Sort);
        function __Sort() {
          _s.arr.sort.apply(_s.arr, arguments);
        }

        defPubMeth(_s, "ToArray", __ToArray);
        function __ToArray() {
          return ArrayCS.FromRepr(_s.arr.slice());
        }

        if (_s != STAT_INIT) _constr.apply(this, arguments);
      }
      statInit(ListCS, "ListCS");

      function NativeLang() {
        var _s = this;

        defStatMeth(_s, NativeLang, "setDictValue", __setDictValue);
        function __setDictValue(dict, key, value) {
          dict[key] = value;
        }

        defStatMeth(_s, NativeLang, "makeList", __makeList);
        function __makeList() {
          return [];
        }

        defStatMeth(_s, NativeLang, "listCount", __listCount);
        function __listCount(lst) {
          return lst.length;
        }

        defStatMeth(_s, NativeLang, "addListValue", __addListValue);
        function __addListValue(list, value) {
          list.push(value);
        }

        defStatMeth(_s, NativeLang, "removeListValueAt", __removeListValueAt);
        function __removeListValueAt(list, idx) {
          list.splice(idx, 1);
        }

        defStatMeth(_s, NativeLang, "GetField", __GetField);
        function __GetField(propName, obj) {
          return obj[propName];
        }

        defStatMeth(_s, NativeLang, "GetStringField", __GetStringField);
        function __GetStringField(propName, obj) {
          var o = NativeLang.GetField(propName, obj);
          if (o) {
            return o.toString();
          }
          return null;
        }
      }
      statInit(NativeLang, "NativeLang");

      function Settings() {
        var _s = this;

        if (_s != STAT_INIT) _s.heartbeatIntervalMs = 20000;

        if (_s != STAT_INIT) _s.customerKey = null;

        if (_s != STAT_INIT) _s.gatewayUrl = "https://cws.conviva.com";
        if (_s != STAT_INIT) _s.gatewayPath = "/0/wsg";

        if (_s != STAT_INIT) _s.protocolVersion = "1.7";

        if (_s != STAT_INIT) _s.clientVersion = "2.111.0.30375";

        if (_s != STAT_INIT) _s.clientInstanceId = 0;

        if (_s != STAT_INIT) _s.loadDataTimeoutMs = 10000;

        if (_s != STAT_INIT) _s.enableLogging = false;

        if (_s != STAT_INIT) _s.platformApi = null;

        if (_s != STAT_INIT) _s.allowUncaughtExceptions = false;

        if (_s != STAT_INIT) _s.pingComponentName = "jscws";
        if (_s != STAT_INIT) _s.pingUrl = "https://pings.conviva.com/ping.ping";

        defPubMeth(_s, "changeSettings", __changeSettings);
        function __changeSettings(settings) {
          if (settings == null) return;
          var sobj = Lang.DictionaryFromRepr(settings);
          var _for_array_1 = sobj.Keys;
          for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
            var key = _for_array_1[_for_idx_2];

            var v = sobj.GetValue(key);
            switch (key) {
              case "platformApi":
                _s.platformApi = v;
                break;
              case "gatewayUrl":
                _s.gatewayUrl = sobj.GetValue(key);
                break;
              case "heartbeatIntervalMs":
                _s.heartbeatIntervalMs = slint.Cast(sobj.GetValue(key));
                break;
              case "enableLogging":
                _s.enableLogging = Boolean(sobj.GetValue(key));
                break;
              case "allowUncaughtExceptions":
                _s.allowUncaughtExceptions = Boolean(sobj.GetValue(key));
                break;
              default:
                throw new Error("Unsupported settings: " + key);
            }
          }
        }
      }
      statInit(Settings, "Settings");

      function Utils() {
        var _s = this;

        if (_s == STAT_INIT) Utils._instance = null;
        if (_s != STAT_INIT) _s._referenceCount = 0;

        if (_s != STAT_INIT) _s._settings = null;

        if (_s == STAT_INIT) Utils.DEFAULT_CLIENT_ID = "0";

        if (_s != STAT_INIT) _s._loadClientIdTimeout = null;
        if (_s != STAT_INIT) _s.clientId = Utils.DEFAULT_CLIENT_ID;
        if (_s != STAT_INIT) _s.clientIdLoadingDone = null;

        if (_s != STAT_INIT) _s._pingUrl = null;
        if (_s != STAT_INIT) _s._cachedPingUrl = false;
        if (_s != STAT_INIT) _s._isSendingPing = false;

        if (_s != STAT_INIT) _s.protocolVersion = null;

        if (_s != STAT_INIT) _s.device = null;
        if (_s != STAT_INIT) _s.os = null;
        if (_s != STAT_INIT) _s.osVersion = null;
        if (_s != STAT_INIT) _s.deviceVersion = null;
        if (_s != STAT_INIT) _s.deviceType = null;
        if (_s != STAT_INIT) _s.platform = null;

        if (_s != STAT_INIT) _s._cleanables = null;

        if (_s == STAT_INIT) Utils.MAX_SIZE_LOGBUFFER = 32;
        if (_s == STAT_INIT) Utils.logBuffer = new ListCS();

        function _constr(settings) {
          _s._settings = settings;
          _s._referenceCount = 1;
          _s._pingUrl = null;
          _s._isSendingPing = false;
          _s.protocolVersion = _s._settings.protocolVersion;

          _s._cleanables = new DictionaryCS();

          if (_s._settings.platformApi == null) {
            if (typeof PlayStationWebmafApi !== "undefined") {
              _s._settings.platformApi = new PlayStationWebmafApi();
            } else if (typeof PlayStationTouchFactorApi !== "undefined") {
              _s._settings.platformApi = new PlayStationTouchFactorApi();
            } else if (typeof PlayStationLibjscriptApi !== "undefined") {
              _s._settings.platformApi = new PlayStationLibjscriptApi();
            } else if (typeof ConvivaVideojsPlatformApi != "undefined") {
              _s._settings.platformApi = new ConvivaVideojsPlatformApi();
            } else if (typeof Html5PlatformApi !== "undefined") {
              _s._settings.platformApi = new Html5PlatformApi();
            } else if (typeof PlayStationTrilithiumApi !== "undefined") {
              _s._settings.platformApi = new PlayStationTrilithiumApi();
            } else if (typeof Xbox1PlatformApi !== "undefined") {
              _s._settings.platformApi = new Xbox1PlatformApi();
            }
          }
          if (_s._settings.platformApi == null) {
            throw new Error("PlatformApi is null");
          }

          _s.device = _s._settings.platformApi.getDevice();
          _s.deviceVersion = _s._settings.platformApi.getDeviceVersion();
          _s.deviceType = _s._settings.platformApi.getDeviceType();
          _s.os = _s._settings.platformApi.getOS();
          _s.osVersion = _s._settings.platformApi.getOSVersion();

          _s.platform = "Js";
        }

        defStatMeth(_s, Utils, "CreateUtils", __CreateUtils);
        function __CreateUtils(settings) {
          if (Utils._instance == null) {
            var s = new Settings();
            s.changeSettings(settings);
            Utils._instance = new Utils(s);
            Utils._instance._start();
          } else {
            Utils._instance.getSettings().changeSettings(settings);
            Utils._instance._referenceCount++;
          }
          return Utils._instance;
        }

        defStatMeth(_s, Utils, "getInstance", __getInstance);
        function __getInstance() {
          if (Utils._instance == null) {
            throw new Error("CreateUtils module has not been called");
          }
          return Utils._instance;
        }

        defPubMeth(_s, "getPlatformApi", __getPlatformApi);
        function __getPlatformApi() {
          return _s._settings.platformApi;
        }

        defPubMeth(_s, "getSettings", __getSettings);
        function __getSettings() {
          return _s._settings;
        }

        defPrivMeth(_s, "_start", ___start);
        function ___start() {}

        defPubMeth(_s, "cleanup", __cleanup);
        function __cleanup() {
          _s._referenceCount--;
          if (_s._referenceCount > 0) {
            return;
          }
          if (_s.clientIdLoadingDone != null) {
            _s.clientIdLoadingDone.Cleanup();
            _s.clientIdLoadingDone = null;
          }
          if (_s._cleanables != null) {
            Cleanable.cleanupCollection(_s._cleanables);
            _s._cleanables = null;
          }
          if (_s._settings != null && _s._settings.platformApi != null) {
            _s._settings.platformApi.cleanup();
          }
          _s._settings = null;
          Utils._instance = null;
        }

        defPubMeth(_s, "logNoBuffer", __logNoBuffer);
        function __logNoBuffer(msg) {
          var timeMsec = _s.epochTimeMs();
          var theTime = undefined;
          theTime = (timeMsec / 1000.0).toFixed(3).toString();

          msg = "[" + theTime + "] " + msg;

          var isError = Lang.StringContains(msg, "ERROR:");

          if (_s._settings.enableLogging) {
            if (isError) {
              _s._settings.platformApi.consoleErr(msg);
            } else {
              _s._settings.platformApi.consoleLog(msg);
            }
          }
          return msg;
        }

        defPubMeth(_s, "log", __log);
        function __log(msg) {
          msg = _s.logNoBuffer(msg);

          if (Utils.logBuffer.Count >= Utils.MAX_SIZE_LOGBUFFER) {
            Utils.logBuffer.RemoveAt(0);
          }
          Utils.logBuffer.Add(msg);
        }

        defPubMeth(_s, "logSession", __logSession);
        function __logSession(msg, sessionId) {
          _s.log("sid=" + sessionId + " " + msg);
        }

        defPubMeth(_s, "err", __err);
        function __err(message) {
          _s.log("ERROR: " + message);
        }

        defPubMeth(_s, "getLogs", __getLogs);
        function __getLogs(sessionId) {

          var res = Utils.logBuffer;
          Utils.logBuffer = new ListCS();
          return res;
        }

        defPubMeth(_s, "assert", __assert);
        function __assert(condition, msg) {
          if (!condition) {
            throw new Error("Assertion failure: " + msg);
          }
        }

        defPubMeth(_s, "runProtected", __runProtected);
        function __runProtected(func, message) {
          _s.runProtectedSync(func, message);
        }

        defPubMeth(_s, "runProtectedSync", __runProtectedSync);
        function __runProtectedSync(func, message) {
          var allowUncaughtExceptions = _s._settings.allowUncaughtExceptions;

          if (allowUncaughtExceptions) {
            func();
          } else {
            try {
              func();
            } catch (e) {
              _s.onUncaughtException(message, e);
            }
          }
        }

        defPrivMeth(_s, "onUncaughtException", __onUncaughtException);
        function __onUncaughtException(msg, e) {
          try {
            _s.ping("Uncaught exception: " + msg + ": " + Lang.ToString(e));
          } catch (eping) {
            _s.err("Caught exception while sending ping: " + Lang.ToString(eping));
          }
        }

        defPubMeth(_s, "ping", __ping);
        function __ping(msg) {
          if (_s._isSendingPing) {
            return;
          }
          _s._isSendingPing = true;
          _s.initPing();
          var pingUrl = _s._pingUrl + "&d=" + _s.urlEncodeString(Lang.ToString(msg));
          _s.err("Ping: " + pingUrl);
          _s.httpRequest(false, pingUrl, null, null, null);
          _s._isSendingPing = false;
        }

        defPrivMeth(_s, "initPing", __initPing);
        function __initPing() {

          if (!_s._cachedPingUrl) {

            var componentName = "jscws";

            var metadataSchema = null;

            try {
              var platformMetadata = Lang.DictionaryFromRepr(_s._settings.platformApi.getPlatformMetadata());
              if (platformMetadata != null && platformMetadata.ContainsKey("sch")) {
                metadataSchema = platformMetadata.GetValue("sch");
              }
            } catch (e) {}

            _s._pingUrl = _s._settings.pingUrl + "?" + "comp=" + componentName + "&clv=" + _s._settings.clientVersion + "&cid=" + _s._settings.customerKey + "&uuid=" + _s.clientId;

            if (metadataSchema != null) {
              _s._pingUrl += "&sch=" + metadataSchema;
            }

            if (_s.clientId != Utils.DEFAULT_CLIENT_ID && metadataSchema != null) {
              _s._cachedPingUrl = true;
            }
          }
        }

        defPrivMeth(_s, "urlEncodeString", __urlEncodeString);
        function __urlEncodeString(rawString) {
          return escape(rawString);
        }

        defPubMeth(_s, "epochTimeMs", __epochTimeMs);
        function __epochTimeMs() {
          return _s._settings.platformApi.epochTimeMs();
        }

        defPubMeth(_s, "createTimer", __createTimer);
        function __createTimer(timerAction, intervalMs, actionName) {
          var cleanable = new Cleanable(_s._cleanables);
          var wrappedAction = null;
          wrappedAction = function wrappedAction() {
            _s.runProtected(timerAction, actionName);
          };
          cleanable.setCleanupAction(_s._settings.platformApi.createTimer(wrappedAction, intervalMs, actionName));
          return cleanable;
        }

        defPubMeth(_s, "scheduleAction", __scheduleAction);
        function __scheduleAction(action, delayMs, actionName) {
          var cleanable = new Cleanable(_s._cleanables);
          var actionHappened = false;
          var wrappedAction = null;
          wrappedAction = function wrappedAction() {
            if (cleanable != null) {
              cleanable.cleanup();
            }
            action();
            actionHappened = true;
          };
          cleanable.setCleanupAction(_s._settings.platformApi.createTimer(wrappedAction, delayMs, actionName));

          if (actionHappened) {
            cleanable.cleanup();
          }
          return cleanable;
        }

        defPubMeth(_s, "parseInt", __parseInt);
        function __parseInt(decimalInt, defaultResult) {
          var result = defaultResult;
          try {
            result = slint.Parse(decimalInt);
          } catch (e) {}
          return result;
        }

        defPubMeth(_s, "parseNumber", __parseNumber);
        function __parseNumber(numberStr, defaultResult) {
          var result = defaultResult;
          try {
            result = Lang.parseDouble(numberStr);
          } catch (e) {}
          return result;
        }

        defPubMeth(_s, "startFetchClientId", __startFetchClientId);
        function __startFetchClientId() {

          _s.clientId = Utils.DEFAULT_CLIENT_ID;
          _s.clientIdLoadingDone = new Eventer();

          _s._loadClientIdTimeout = _s.scheduleAction(function () {
            _s.log("Timeout in reading clientId. Using " + Utils.DEFAULT_CLIENT_ID + ".");
            _s.ping("Timeout in reading clientId. IGNORE waited " + _s._settings.loadDataTimeoutMs + "ms.");
            if (_s.clientIdLoadingDone != null) {
              _s.clientIdLoadingDone.DispatchEvent();
            }
            _s._loadClientIdTimeout = null;
          }, _s._settings.loadDataTimeoutMs, "utils.readClientId timeout callback");

          var onLoad = undefined;
          onLoad = function onLoad(fSuccess, loadedData) {
            _s.runProtected(function () {
              if (_s._loadClientIdTimeout != null) {
                _s._loadClientIdTimeout.cleanup();
                _s._loadClientIdTimeout = null;
              }
              var result = null;
              if (fSuccess) {
                try {
                  result = _s.jsonDecode(loadedData);
                } catch (e) {
                  result = null;
                }
              }
              var loadedClientId = null;
              if (fSuccess && result != null && result.ContainsKey("clId")) {
                loadedClientId = result.GetValue("clId");
              }
              if (loadedClientId != null && loadedClientId != Utils.DEFAULT_CLIENT_ID && loadedClientId != "null") {
                _s.clientId = loadedClientId;
                _s.log("Setting the client id to " + loadedClientId + " (from local storage)");
              } else {
                _s.log("Failed to load the client id from local storage");
              }
              if (_s.clientIdLoadingDone != null) {
                _s.clientIdLoadingDone.DispatchEvent();
                _s.clientIdLoadingDone = null;
              }
            }, "utils.fetchClientId onLoad");
          };
          _s._settings.platformApi.loadLocalData(onLoad);
        }

        defPubMeth(_s, "setClientIdFromServer", __setClientIdFromServer);
        function __setClientIdFromServer(newClientId, fromStorage) {

          if (_s._loadClientIdTimeout != null) {
            _s._loadClientIdTimeout.cleanup();
            _s._loadClientIdTimeout = null;
          }
          _s.clientIdLoadingDone = null;
          if (_s.clientId != newClientId) {
            _s.clientId = newClientId;
            _s.log("Setting the client id to " + newClientId + " (from server)");
            _s.writeClientId();
          }
        }

        defPrivMeth(_s, "writeClientId", __writeClientId);
        function __writeClientId() {
          var dataToSave = new DictionaryCS();
          dataToSave.SetValue("clId", _s.clientId);
          var onSaved = undefined;
          onSaved = function onSaved(fSuccess) {
            _s.runProtected(function () {
              if (!fSuccess) {
                _s.err("An error occurred while saving the clientId.");
              }
            }, "utils.writeClientId onSaved");
          };
          var dataObject = Lang.StringDictionaryToRepr(dataToSave);
          var dataStr = _s.jsonEncode(dataObject);
          _s._settings.platformApi.saveLocalData(dataStr, onSaved);
        }

        defPubMeth(_s, "randInt", __randInt);
        function __randInt() {

          return Math.floor(Math.random() * 4294967295) - 2147483648;
        }

        defPubMeth(_s, "randUInt", __randUInt);
        function __randUInt() {

          var uInt = _s.randInt();
          uInt = Math.abs(uInt);
          if (uInt < 0) uInt = 0;
          return uInt;
        }

        defPubMeth(_s, "httpRequest", __httpRequest);
        function __httpRequest(isPOST, url, data, contentType, callback) {
          var cleanable = new Cleanable(_s._cleanables);
          cleanable.setCleanupAction(_s._settings.platformApi.httpRequest(isPOST, url, data, contentType, function (isSuccess, response) {

            cleanable.cleanup();
            if (callback != null) {
              callback(isSuccess, response);
            }
          }));
          return cleanable;
        }

        defPubMeth(_s, "jsonEncode", __jsonEncode);
        function __jsonEncode(obj) {
          var res = null;
          _s.runProtectedSync(function () {
            res = _s._settings.platformApi.jsonEncode(obj);
          }, "utils.jsonEncode");
          return res;
        }

        defPubMeth(_s, "jsonDecode", __jsonDecode);
        function __jsonDecode(json) {
          var res = null;
          _s.runProtectedSync(function () {
            var decodedJson = _s._settings.platformApi.jsonDecode(json);
            res = Lang.DictionaryFromRepr(decodedJson);
          }, "utils.jsonDecode");
          return res;
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Utils, "Utils");

      function DataLoader() {
        var _s = this;

        if (_s == STAT_INIT) {
          DataLoader.frameId = 'conviva_iframe';
          DataLoader.frameUrl = '/cws_iframe.html';
          DataLoader.TESTAPI_forTouchstone = true;

          DataLoader.referenceCount = 0;

          DataLoader.nextConvivaRequestId = 0;
          DataLoader.callbacks = {};
          DataLoader.communicationFramesIds = {};

          if (typeof window !== 'undefined') {
            if (window.addEventListener) {
              window.addEventListener('message', handleResp, false);
            } else if (window.attachEvent) {
              window.attachEvent('onmessage', handleResp);
            }
          }
        }

        function _constr() {
          DataLoader.referenceCount++;
        }

        this.cleanup = function () {
          DataLoader.referenceCount--;
          if (DataLoader.referenceCount == 0) {

            DataLoader.nextConvivaRequestId = 0;
            DataLoader.callbacks = {};
            slForEachPropValue(DataLoader.communicationFramesIds, function (communicationFrameId) {
              _s.removeIFrame(communicationFrameId);
            });
            DataLoader.communicationFramesIds = {};
          }
        };

        this.findFrameById = function (remoteFrameId) {
          return remoteFrameId ? document.getElementById(remoteFrameId) : null;
        };

        this.findFrameForDomain = function (forDomain) {

          var remoteFrameId = DataLoader.communicationFramesIds[forDomain];
          return _s.findFrameById(remoteFrameId);
        };

        this.makeRequest = function (isPOST, url, data, contentType, callback) {

          var m = url.match(/^(https?:\/\/[^\/]*)(\/.*)$/);
          if (!m) {
            Utils.getInstance().log("ERROR: UrlLoader: cannot parse url: " + url);
            return null;
          }
          var forDomain = m[1];

          var remoteFrame = _s.findFrameForDomain(forDomain);
          if (remoteFrame && remoteFrame.loaded) {

            var convivaRequestId = DataLoader.nextConvivaRequestId++;
            var method = isPOST ? "POST" : "GET";
            var evt = { 'url': url,
              'method': method,
              'data': data,
              'contentType': contentType,
              'requestId': convivaRequestId,
              'convivaRequestId': convivaRequestId };

            DataLoader.callbacks[convivaRequestId] = [forDomain, callback];

            remoteFrame.contentWindow.postMessage(evt, DataLoader.TESTAPI_forTouchstone ? "*" : forDomain);
          } else if (remoteFrame && !remoteFrame.loaded) {

            setTimeout(function () {
              _s.makeRequest(isPOST, url, data, contentType, callback);
            }, 500);
          } else {

            _s.insertIFrame(forDomain, function () {
              var remoteFrame = _s.findFrameForDomain(forDomain);
              if (remoteFrame) {
                remoteFrame.loaded = true;
                _s.makeRequest(isPOST, url, data, contentType, callback);
              }
            });
          }
          return null;
        };

        this.insertIFrame = function (forDomain, callback) {

          var remoteFrame = document.createElement("iframe");
          remoteFrame.id = "_conviva_iframe_" + forDomain + "_" + DataLoader.frameId;

          remoteFrame.style.height = "0px";
          remoteFrame.style.width = "0px";
          remoteFrame.style.top = "-50px";
          remoteFrame.style.left = "-50px";
          remoteFrame.style.borderWidth = "0px";
          remoteFrame.height = 0;
          remoteFrame.width = 0;
          remoteFrame.src = forDomain + DataLoader.frameUrl;
          remoteFrame.onload = callback;
          DataLoader.communicationFramesIds[forDomain] = remoteFrame.id;
          var body = document.body || document.getElementsByTagName('body')[0];
          if (body) {
            body.appendChild(remoteFrame);
          }
        };

        this.removeIFrame = function (communicationFrameId) {
          var remoteFrame = _s.findFrameById(communicationFrameId);
          if (remoteFrame != null) {
            var body = document.body || document.getElementsByTagName('body')[0];
            body.removeChild(remoteFrame);
          }
        };

        function handleResp(e) {

          try {
            var d = e.data;

            if ((typeof d === 'undefined' ? 'undefined' : _typeof(d)) !== 'object') return;
            if (typeof d.convivaRequestId === 'undefined') {

              if (typeof d.requestId !== 'undefined') {
                d.convivaRequestId = d.requestId;
              } else {
                return;
              }
            }

            var domain_callback = DataLoader.callbacks[d.convivaRequestId];
            if (!domain_callback) {
              Utils.getInstance().log('Received response for unknown request');
              return;
            }
            if (!DataLoader.TESTAPI_forTouchstone && e.origin != domain_callback[0]) {
              Utils.getInstance().log('ERROR: Bad origin:' + e.origin);
              return;
            }

            delete DataLoader.callbacks[d.convivaRequestId];
            var bytes = d.bytes;
            if (!d.post_err || d.post_err != 'ok') {
              Utils.getInstance().log('ERROR: Error posting to ' + e.origin + ' (' + bytes + ')');
              domain_callback[1](false, d.post_err);
            } else {
              domain_callback[1](true, bytes);
            }
          } catch (e) {}
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(DataLoader, "DataLoader");

      function Infer() {
        var _s = this;

        if (_s == STAT_INIT) Infer.MOVING_STATE = "MOVING";
        if (_s == STAT_INIT) Infer.NOT_MOVING_STATE = "NOT_MOVING";

        if (_s != STAT_INIT) _s.movingMinimumSamples = 3;
        if (_s != STAT_INIT) _s.notMovingMinimumSamples = 3;

        if (_s != STAT_INIT) _s.movingExpectedSpeed = 1;
        if (_s != STAT_INIT) _s.notMovingExpectedSpeed = 0;
        if (_s != STAT_INIT) _s.movingSpeedTolerance = 0.25;

        if (_s != STAT_INIT) _s.resetAfter = false;

        if (_s != STAT_INIT) _s._lastPlayHeadTimeSpeeds = undefined;
        if (_s != STAT_INIT) _s._lastPlayHeadTime = 0;
        if (_s != STAT_INIT) _s._lastPollTime = 0;

        function _constr() {
          _s.Reset();
        }

        defPubMeth(_s, "Update", __Update);
        function __Update(phtNow) {
          var now = Utils.getInstance().epochTimeMs();
          if (_s._lastPollTime > 0 && now > _s._lastPollTime) {
            _s._lastPlayHeadTimeSpeeds.Insert(0, Lang.AsDouble(phtNow - _s._lastPlayHeadTime) / (now - _s._lastPollTime));
          }
          _s._lastPollTime = now;
          _s._lastPlayHeadTime = Lang.AsDouble(phtNow);
          if (_s._lastPlayHeadTimeSpeeds.Count > Math.max(_s.movingMinimumSamples, _s.notMovingMinimumSamples)) {
            _s._lastPlayHeadTimeSpeeds.RemoveAt(_s._lastPlayHeadTimeSpeeds.Count - 1);
          }
          return _s.InferState();
        }

        defPrivMeth(_s, "InferState", __InferState);
        function __InferState() {
          var inferredState = null;
          var numPhSpeedSamples = _s._lastPlayHeadTimeSpeeds.Count;
          if (numPhSpeedSamples >= Math.min(_s.movingMinimumSamples, _s.notMovingMinimumSamples)) {
            var avgSpeed = 0.0;
            var _for_array_1 = _s._lastPlayHeadTimeSpeeds.Values;
            for (var _for_idx_2 = 0; _for_idx_2 < _for_array_1.length; _for_idx_2++) {
              var phSpeed = _for_array_1[_for_idx_2];

              avgSpeed += phSpeed;
            }
            avgSpeed /= numPhSpeedSamples;

            if (numPhSpeedSamples >= _s.movingMinimumSamples && Math.abs(avgSpeed - _s.movingExpectedSpeed) < _s.movingSpeedTolerance) {
              inferredState = Infer.MOVING_STATE;
            }
            if (numPhSpeedSamples >= _s.notMovingMinimumSamples && avgSpeed == _s.notMovingExpectedSpeed) {
              inferredState = Infer.NOT_MOVING_STATE;
            }
          }
          if (_s.resetAfter && inferredState != null) {
            _s.Reset();
          }
          return inferredState;
        }

        defPubMeth(_s, "Reset", __Reset);
        function __Reset() {
          _s._lastPlayHeadTimeSpeeds = new ListCS();
          _s._lastPlayHeadTime = -1;
          _s._lastPollTime = 0;
        }

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Infer, "Infer");

      function ConvivaVideojsStreamerProxy() {
        var _s = this;

        if (_s != STAT_INIT) {
          _s._capabilities = ConvivaStreamerProxy.CAPABILITY_VIDEO + ConvivaStreamerProxy.CAPABILITY_QUALITY_METRICS + ConvivaStreamerProxy.CAPABILITY_BITRATE_METRICS;
          _s._duration = -1;
        }

        function _constr(vjsPlayer) {

          ConvivaStreamerProxy.call(_s);
          _s.Log('ConvivaVideojsStreamerProxy._constr()');

          _s._vjsPlayer = vjsPlayer;

          _s._infer = new Conviva.Infer();

          _s._setAllEventListeners();
          _s._startPolling();
          _s.firstPlay = true;
          _s.tech = null;
          var requestTech = new Object();
          requestTech.IWillNotUseThisInPlugins = true;
          _s.requestTech = requestTech;
          if ((_s.tech = _s._vjsPlayer.tech(_s.requestTech)) !== null) {
            console.log('Found TECH...');
          } else {
            console.log('DID NOT FIND TECH !!');
          }
          if (_s.tech.hls) {
            var bandW = Math.round(_s.tech.hls.bandwidth / 1024);
            var updatedStream = new StreamInfo(bandW, null, null, -1, -1, -1);
            _s.SetStream(updatedStream);
            console.log('Ctor : BANDWIDTH: ' + bandW);
          } else {
            console.log('Ctor : Player is not ready! ');
          }
        }

        defPubMeth(_s, "Cleanup", __Cleanup);
        function __Cleanup() {

          _s.Log('ConvivaVideojsStreamerProxy.Cleanup()');
          _s.Log('ConvivaVideojsStreamer: leave the inference in...');

          _s.Log('ConvivaVideojsStreamer: leave the event listeners and player in...');

          _s._duration = -1;

          _s.super_Cleanup();
        }

        defPubMeth(_s, "GetCapabilities", __GetCapabilities);
        function __GetCapabilities() {

          return _s._capabilities;
        }

        this.GetDuration = function () {
          return _s._duration;
        };

        this.GetBufferLengthMs = function () {
          return _s._bufferLengthMs;
        };

        this.GetEncodedFrameRate = function () {
          return _s._encodedFrameRate;
        };

        this.GetPlayheadTimeMs = function () {
          return _s._playheadTimeMs;
        };

        this.SetDuration = function (duration) {
          if (isFinite(duration) && duration > 0) {
            var durationSec = duration;

            if (_s.GetDuration() != durationSec) {
              _s._duration = durationSec;
              var meta = {};
              meta[ConvivaStreamerProxy.METADATA_DURATION] = _s._duration;
              _s.SetMetadata(meta);
            }
          }
        };

        this.SetPlayheadTimeMs = function (pht) {
          if (isFinite(pht) && pht > 0) {
            var phtMs = pht * 1000;
            if (_s.GetPlayheadTimeMs() != phtMs) {
              _s._playheadTimeMs = phtMs;
            }
            _s.InferState();
          }
        };

        this.SetPlayerState = function (convivaState) {
          if (_s.GetPlayingState() !== convivaState) {
            _s.SetPlayingState(convivaState);
            _s._infer.Reset();
          }
        };

        this.InferState = function () {
          if (_s._infer) {
            var newState = _s._infer.Update(_s.GetPlayheadTimeMs());
            if (newState) {
              if (newState === Conviva.Infer.MOVING_STATE && _s.GetPlayingState() !== Conviva.ConvivaStreamerProxy.PLAYING) {
                _s.Log('ConvivaVideojsStreamerProxy.InferState(): PLAYING');
                _s.SetPlayerState(Conviva.ConvivaStreamerProxy.PLAYING);
              }
              if (newState === Conviva.Infer.NOT_MOVING_STATE && _s.GetPlayingState() === Conviva.ConvivaStreamerProxy.PLAYING) {
                _s.Log('ConvivaVideojsStreamerProxy.InferState(): BUFFERING');
                _s.SetPlayerState(Conviva.ConvivaStreamerProxy.BUFFERING);
              }
            }
          }
        };

        this._startPolling = function () {
          _s._polling = true;
          _s._cancelTimer = Utils.getInstance()._settings.platformApi.createTimer(_s._poll, 100, 'ConvivaVideojsStreamerProxy._poll');
        };

        this._poll = function () {
          Utils.getInstance().runProtected(function () {

            if (!_s._polling || !_s._vjsPlayer) {
              _s.SetPlayheadTimeMs(0);
              return;
            }
            _s.SetPlayheadTimeMs(_s._vjsPlayer.currentTime());
          }, 'ConvivaVideojsStreamerProxy._poll');
        };

        this._stopPolling = function () {
          if (!_s._polling && typeof _s._cancelTimer === 'function') {
            _s._cancelTimer();
          }
          _s._polling = false;
        };

        this._declareError = function (errMsg) {
          _s.Log('ConvivaVideojsStreamerProxy._declareError: ' + errMsg);
          _s.SetError(StreamerError.makeUnscopedError(errMsg, StreamerError.SEVERITY_FATAL));
        };

        this._setAllEventListeners = function () {
          _s.Log('ConvivaVideojsStreamerProxy._setAllEventListeners()');

          if (_s._vjsPlayer) {
            _s._vjsPlayer.on('ended', _s.onEnded);
            _s._vjsPlayer.on('loadedmetadata', _s.onLoadedMetadata);
            _s._vjsPlayer.on('loadstart', _s.onLoadstart);
            _s._vjsPlayer.on('pause', _s.onPause);
            _s._vjsPlayer.on('durationchange', _s.onDurationchange);
            _s._vjsPlayer.on('emptied', _s.onEmptied);

            _s._vjsPlayer.on('stalled', _s.onStalled);
            _s._vjsPlayer.on('waiting', _s.onWaiting);
            _s._vjsPlayer.on('play', _s.onPlay);

            _s._vjsPlayer.on('error', _s.onError);
            _s._vjsPlayer.on('mediachange', _s.onMediaChange);
            _s._vjsPlayer.on('progress', _s.onProgress);
          }
        };

        this._removeAllEventListeners = function () {
          _s.Log('ConvivaVideojsStreamerProxy._removeAllEventListeners()');

          if (_s._vjsPlayer) {
            _s._vjsPlayer.off('ended', _s.onEnded);
            _s._vjsPlayer.off('loadedmetadata', _s.onLoadedMetadata);
            _s._vjsPlayer.off('loadstart', _s.onLoadstart);
            _s._vjsPlayer.off('pause', _s.onPause);
            _s._vjsPlayer.off('durationchange', _s.onDurationchange);
            _s._vjsPlayer.off('emptied', _s.onEmptied);
            _s._vjsPlayer.off('stalled', _s.onStalled);
            _s._vjsPlayer.off('waiting', _s.onWaiting);
            _s._vjsPlayer.off('play', _s.onPlay);

            _s._vjsPlayer.off('error', _s.onError);
            _s._vjsPlayer.off('mediachange', _s.onMediaChange);
          }
        };

        this.onPause = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onPause');
            _s.SetPlayerState(Conviva.ConvivaStreamerProxy.PAUSED);
          }, 'ConvivaVideojsStreamerProxy.onPause');
        };

        this.onLoadedMetadata = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onLoadedMetadata');
            if (!_s._vjsPlayer.duration()) {
              return;
            }
            if (_s._vjsPlayer) {
              _s.SetDuration(_s._vjsPlayer.duration());
            }
          }, 'ConvivaVideojsStreamerProxy.onLoadedMetadata');
        };

        this.onEnded = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onEnded');
            if (_s._vjsPlayer) _s.SetPlayerState(Conviva.ConvivaStreamerProxy.STOPPED);
          }, 'ConvivaVideojsStreamerProxy.onEnded');
        };

        this.onDurationchange = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onDurationchange');
            if (_s._vjsPlayer) {
              _s.SetDuration(_s._vjsPlayer.duration());
            }
          }, 'ConvivaVideojsStreamerProxy.onDurationchange');
        };

        this.onLoadstart = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onLoadstart');
            _s.SetPlayerState(Conviva.ConvivaStreamerProxy.STOPPED);
          }, 'ConvivaVideojsStreamerProxy.onLoadstart');
        };

        this.onPlay = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onPlay');
            if (_s.firstPlay) {
              _s.Log('ConvivaVideojsStreamerProxy.onPlay :First Play IGNORED!!');
              _s.firstPlay = false;
              return;
            }
            _s.SetPlayerState(Conviva.ConvivaStreamerProxy.PLAYING);
          }, 'ConvivaVideojsStreamerProxy.onPlay');
        };

        this.onStalled = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onStalled NO STATE CHANGE');
          }, 'ConvivaVideojsStreamerProxy.onStalled');
        };

        this.onEmptied = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onEmptied');
            _s.Log('ConvivaVideojsStreamerProxy.onEmptied');
            _s.SetPlayerState(Conviva.ConvivaStreamerProxy.STOPPED);
          }, 'ConvivaVideojsStreamerProxy.onEmptied');
        };

        this.onWaiting = function (event, p1, p2) {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onWaiting');
            _s.Log('ConvivaVideojsStreamerProxy.onWaiting');
            _s.SetPlayerState(Conviva.ConvivaStreamerProxy.BUFFERING);
          }, 'ConvivaVideojsStreamerProxy.onWaiting');
        };

        this.onError = function () {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onError');
            if (_s._vjsPlayer) {
              var errorEvent = _s._vjsPlayer.error();
              var reportedError = _s._convertError(errorEvent ? errorEvent.code : 99);
              _s.Log("MediaError: " + errorEvent.message);
              _s._declareError(reportedError);
            }
          }, 'ConvivaVideojsStreamerProxy.onError');
        };

        this.onProgress = function () {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onProgress');
            if (_s._vjsPlayer && typeof _s._vjsPlayer.tech(_s.requestTech).hls !== "undefined") {
              var updatedStream = new StreamInfo(Math.round(_s._vjsPlayer.tech(_s.requestTech).hls.playlists.media().attributes.BANDWIDTH / 1024), null, null, -1, -1, -1);
              _s.SetStream(updatedStream);
            }
          }, 'ConvivaVideojsStreamerProxy.onProgress');
        };

        this.onMediaChange = function () {
          Utils.getInstance().runProtected(function () {
            _s.Log('ConvivaVideojsStreamerProxy.onMediaChange');
            if (_s._vjsPlayer && typeof _s._vjsPlayer.tech(_s.requestTech).hls !== "undefined") {
              var updatedStream = new StreamInfo(Math.round(_s._vjsPlayer.tech(_s.requestTech).hls.playlists.media().attributes.BANDWIDTH / 1024), null, null, -1, -1, -1);
              _s.SetStream(updatedStream);
            }
          }, 'ConvivaVideojsStreamerProxy.onMediaChange');
        };

        this._convertError = function (code) {
          var errStr;
          switch (code) {
            case 0:
              errStr = 'MEDIA_ERR_CUSTOM';break;
            case 1:
              errStr = 'MEDIA_ERR_ABORTED';break;
            case 2:
              errStr = 'MEDIA_ERR_NETWORK';break;
            case 3:
              errStr = 'MEDIA_ERR_DECODE';break;
            case 4:
              errStr = 'MEDIA_ERR_SRC_NOT_SUPPORTED';break;
            default:
              errStr = 'MEDIA_ERR_UNKNOWN';
          }

          _s.Log("MediaError: code " + code + " " + errStr);
          return errStr;
        };

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }

      statInit(ConvivaVideojsStreamerProxy, "ConvivaVideojsStreamerProxy");

      function Html5PlatformApi() {
        var _s = this;
        var _persistentData = null;
        var _convivaKey = "convivaPersistent";

        function _constr() {
          _s._dataLoader = new DataLoader();

          _s.platform = navigator && navigator.platform && (navigator.platform.toString ? navigator.platform.toString() : null);
        }

        this.cleanup = function () {
          if (_s._dataLoader != null) {
            _s._dataLoader.cleanup();
            _s._dataLoader = null;
          }
        };

        this.saveLocalData = function (data, callback) {
          try {
            localStorage.setItem(_convivaKey, data);
          } catch (e) {
            callback(false);
            return;
          }
          callback(true);
        };

        this.loadLocalData = function (callback) {
          try {
            var data = localStorage.getItem(_convivaKey);
            callback(true, data);
          } catch (e) {
            callback(false, "");
          }
        };

        this.deleteLocalData = function () {
          try {
            var data = localStorage.clear();
          } catch (e) {}
        };

        this.httpRequest = function (isPOST, url, data, contentType, callback) {
          if (typeof data !== "string") {
            data = _s.jsonEncode(data, null);
          }
          return _s._dataLoader.makeRequest(isPOST, url, data, contentType, callback);
        };

        this.epochTimeMs = function () {
          var d = new Date();
          return d.getTime();
        };

        this.createTimer = function (timerAction, intervalMs, actionName) {

          var timerId = setInterval(timerAction, intervalMs);
          return function () {
            if (timerId != -1) {
              clearInterval(timerId);
              timerId = -1;
            }
          };
        };

        this.jsonEncode = function (obj) {
          var jsonString = null;
          jsonString = JSON.stringify(obj);
          return jsonString;
        };

        this.jsonDecode = function (json) {
          var parsedJson = null;
          parsedJson = JSON.parse(json);
          return parsedJson;
        };

        this.consoleLog = function (message) {
          if (typeof console != 'undefined' && console.log) {
            console.log(message);
          }
        };

        this.consoleErr = function (errMsg) {
          if (typeof console != 'undefined' && console.error) {
            console.error(errMsg);
          }
        };

        this.getDevice = function () {
          return 'browser';
        };

        this.getDeviceVersion = function () {
          return null;
        };

        this.getDeviceType = function () {
          return "PC";
        };

        this.getOS = function () {
          return _s._getPlatformName();
        };

        this.getOSVersion = function () {
          return null;
        };

        defPubMeth(_s, "getPlatformMetadata", __getPlatformMetadata);
        function __getPlatformMetadata() {
          var res = { "sch": "html5.1" };
          res['np'] = navigator && navigator.platform && (navigator.platform.toString ? navigator.platform.toString() : null);
          res['nua'] = navigator && navigator.userAgent && (navigator.userAgent.toString ? navigator.userAgent.toString() : null);
          return res;
        }

        this._getPlatformName = function () {
          if (_s.platform == null) {
            return null;
          }
          var stringContains = function stringContains(haystack, needle) {
            return haystack.indexOf(needle) >= 0;
          };
          if (stringContains(_s.platform, "iPad") || stringContains(_s.platform, "iPhone") || stringContains(_s.platform, "iPod")) {
            return "IOS";
          } else if (stringContains(_s.platform, "Mac")) {
            return "MAC";
          } else if (stringContains(_s.platform, "Win")) {
            return "WIN";
          } else if (stringContains(_s.platform, "Linux") || stringContains(_s.platform, "SunOS") || stringContains(_s.platform, "HP-UX") || stringContains(_s.platform, "BSD")) {
            return "UNIX";
          } else if (stringContains(_s.platform, "PLAYSTATION 3")) {
            return "PS3";
          } else if (stringContains(_s.platform, "XBOX")) {
            return "XBOX";
          } else {
            return null;
          }
        };

        if (_s != STAT_INIT) _constr.apply(_s, arguments);
      }
      statInit(Html5PlatformApi, "Html5PlatformApi");

      function ConvivaVideojsPlatformApi() {
        var _s = this;

        function _constr() {
          Html5PlatformApi.call(_s);
        }

        this.getPlatformMetadata = function () {
          var res = _s.super_getPlatformMetadata();
          res['sch'] = 'bc.perform.dt.1';
          res['fwv'] = bc.VERSION || '1.0';
          return res;
        };

        _constr.apply(_s, arguments);
      }
      statInit(ConvivaVideojsPlatformApi, "ConvivaVideojsPlatformApi");
    })();
    var Conviva = typeof Conviva !== 'undefined' ? Conviva : function () {};
    Conviva.LivePass = ConvivaPrivateLoader.LivePass;Conviva.ConvivaContentInfo = ConvivaPrivateLoader.ConvivaContentInfo;Conviva.StreamerError = ConvivaPrivateLoader.StreamerError;Conviva.ConvivaStreamerProxy = ConvivaPrivateLoader.ConvivaStreamerProxy;Conviva.Settings = ConvivaPrivateLoader.Settings;Conviva.StreamInfo = ConvivaPrivateLoader.StreamInfo;Conviva.Utils = ConvivaPrivateLoader.Utils;Conviva.ConvivaVideojsStreamerProxy = ConvivaPrivateLoader.ConvivaVideojsStreamerProxy;Conviva.ConvivaVideojsPlatformApi = ConvivaPrivateLoader.ConvivaVideojsPlatformApi;Conviva.Infer = ConvivaPrivateLoader.Infer;
  }

  module.exports = Conviva;
}).call(undefined);

},{}],15:[function(require,module,exports){
/* globals videojs */
'use strict';

var Conviva, Fan, first, merge, plugin;

function mergeCustomizer(objValue, srcValue) {
  if (srcValue === null) {
    return objValue;
  }
}

Conviva = require('./ConvivaLivePass_BcPerform');
Fan = require('../fan');

merge = require('lodash.mergewith');

first = true;

function init() {
  videojs.plugin('conviva', plugin);
}

module.exports = {
  init: init
};

plugin = function plugin(options) {

  if (options.debug) console.debug('CONVIVA: plugin');
  var assetName, cci, cleanup, mediainfo, onAdsAdEnded, onAdsAdStarted, _onDispose, onEnded, onError, onLoadStart, onContentPlayback, onRestart, player, sessionId, setMetadata, streamProxy, tags;

  player = this;

  if (options.debug) {
    Conviva.LivePass.initWithSettings(options.customerKey, {
      gatewayUrl: 'https://espn-com-test.testonly.conviva.com'
    });

    // Enable debugging output
    Conviva.LivePass.toggleTraces(true);
  } else {
    Conviva.LivePass.init(options.customerKey);
  }

  streamProxy = new Conviva.ConvivaVideojsStreamerProxy(player);

  setMetadata = function setMetadata() {
    mediainfo = player.mediainfo || {};

    tags = {
      site: location.hostname,
      userId: Fan.SWID,
      bundleVersion: '1.7.2',
      hidden: document.hidden + ''
      // eventName: '', // Live only?
      // eventType: '', // Live only?
      // league: '', // Live only?
      // partner: '', // Live only?
    };
    if (mediainfo.airingId) {
      tags.airingId = mediainfo.airingId;
    }
    if (mediainfo.sourceType) {
      tags.broadcastType = mediainfo.sourceType;
    }
    if (mediainfo.eventId) {
      tags.eventId = mediainfo.eventId + '';
    }
    if (mediainfo.sourceId) {
      tags.network = mediainfo.sourceId;
    }
    if (mediainfo.status) {
      tags.assetType = mediainfo.status;
    }
    if (mediainfo.affiliate) {
      tags.affiliate = mediainfo.affiliate;
    }

    if (options.tags) {
      merge(tags, options.tags, mergeCustomizer);
    }

    if (tags.broadcastType && tags.broadcastType === "linear" && tags.network) {
      assetName = tags.network;
    } else {
      assetName = mediainfo.name + (mediainfo.id ? " - " + mediainfo.id : "");
    }
    if (options.debug) console.debug('CONVIVA: assetName: ' + assetName);
    cci = new Conviva.ConvivaContentInfo(assetName, tags);

    cci.defaultReportingCdnName = Conviva.ConvivaContentInfo.CDN_NAME_OTHER;

    cci.isLive = mediainfo.live;
    cci.streamUrl = player.currentSrc();
    cci.playerName = options.playerName;
    cci.viewerId = Fan.SWID;
  };

  onLoadStart = function onLoadStart() {
    if (options.debug) {
      console.debug('CONVIVA: loadstart');
      console.debug('CONVIVA: loadstart: adstate:' + player.ads.state);
    }
    if (player.ads && (player.ads.state === 'ad-playback' || player.ads.state === 'content-resuming')) {
      // html5 ad related loadStarts, do not attempt cleanup
    } else if (sessionId != null) {
      console.warn('CONVIVA: session exists onLoadStart, cleaning up');
      cleanup();
    }
    if (sessionId == null) {
      setMetadata();
      if (player.ads && player.ads.state) {
        if (options.debug) console.debug('CONVIVA: loadstart:ads:createSession');
        sessionId = Conviva.LivePass.createSession(null, cci);
      } else {
        if (options.debug) console.debug('CONVIVA: loadstart:noads:createSession');
        sessionId = Conviva.LivePass.createSession(streamProxy, cci);
      }
    }
  };

  onAdsAdStarted = function onAdsAdStarted() {
    if (options.debug) console.debug('CONVIVA: ads-ad-started:detachStreamer');
    Conviva.LivePass.detachStreamer(sessionId, streamProxy);
    Conviva.LivePass.adStart(sessionId);
  };

  onAdsAdEnded = function onAdsAdEnded() {
    if (options.debug) console.debug('CONVIVA: ads-ad-ended');
    Conviva.LivePass.adEnd(sessionId);
    if (options.debug) console.debug('CONVIVA: ads-ad-ended:attachStreamer');
    Conviva.LivePass.attachStreamer(sessionId, streamProxy);
  };

  onContentPlayback = function onContentPlayback() {
    if (sessionId != null) {
      if (options.debug) console.debug('CONVIVA: contentplayback:attachStreamer');
      Conviva.LivePass.attachStreamer(sessionId, streamProxy);
    }
  };

  onRestart = function onRestart() {
    if (player.currentTime() === 0) {
      if (options.debug) console.debug('CONVIVA: restart');
      if (sessionId == null) {
        setMetadata();
        if (options.debug) console.debug('CONVIVA: restart:createSession:streamer');
        sessionId = Conviva.LivePass.createSession(streamProxy, cci);
      } else {
        if (options.debug) console.debug('CONVIVA: restart:attachStreamer');
        Conviva.LivePass.attachStreamer(sessionId, streamProxy);
      }
    }
  };

  onEnded = function onEnded() {
    if (options.debug) console.debug('CONVIVA: ended');
    if (player.ads && player.ads.state === 'ad-playback') {
      // html5 ad end, do nothing
    } else {
      cleanup();
      player.one('seeking', onRestart);
    }
  };

  cleanup = function cleanup() {
    if (sessionId != null) {
      if (player.ads && player.ads.state === 'ad-playback') {
        Conviva.LivePass.adEnd(sessionId);
      }
      if (options.debug) console.debug('CONVIVA: endeded:detachStreamer');
      Conviva.LivePass.detachStreamer(sessionId, streamProxy);
      if (options.debug) console.debug('CONVIVA: endeded:cleanupSession');
      Conviva.LivePass.cleanupSession(sessionId);
      sessionId = null;
    }
  };

  onError = function onError() {
    var error = player.error();
    if (!error) {
      error.code = "unknown";
      error.message = "unknown";
    }

    // don't create a session for a -2 error
    if (sessionId == null && error.code !== -2) {
      setMetadata();
      if (options.debug) console.debug('CONVIVA: error:createSession:streamer');
      sessionId = Conviva.LivePass.createSession(streamProxy, cci);
    }

    var errMsg = 'code:' + error.code + ' ' + (error.type && error.type !== error.code ? error.type : error.headline || error.message);

    console.debug('CONVIVA: ERROR ' + errMsg);
    // if (options.debug) console.debug('CONVIVA: ERROR ' + errMsg);

    if (sessionId) {
      // report the error for diagnostics
      Conviva.LivePass.reportError(sessionId, errMsg);

      // Send extra data to player insights
      var eventName = "error:" + error.code;
      var eventAttributes = {};
      eventAttributes.currentTime = player.currentTime() + '';
      var i;
      var bufferedRanges = [];
      for (i = 0; i < player.buffered().length; i++) {
        bufferedRanges.push(player.buffered().start(i) + '-' + player.buffered().end(i));
      }
      eventAttributes.buffered = bufferedRanges.join(', ');
      var seekableRanges = [];
      for (i = 0; i < player.seekable().length; i++) {
        seekableRanges.push(player.seekable().start(i) + '-' + player.seekable().end(i));
      }
      eventAttributes.seekable = seekableRanges.join(', ');
      eventAttributes.hidden = document.hidden + '';

      if (options.debug) console.debug('CONVIVA: Event: ' + eventName, eventAttributes);
      Conviva.LivePass.sendEvent(eventName, eventAttributes);
    }
    cleanup();
  };

  _onDispose = function onDispose() {
    if (sessionId != null) {
      Conviva.LivePass.cleanupSession(sessionId);
    }
    player.off('ads-ad-started', onAdsAdStarted);
    player.off('ads-ad-ended', onAdsAdEnded);
    player.off('contentplayback', onContentPlayback);
    player.off('dispose', _onDispose);
    player.off('ended', onEnded);
    player.off('error', onError);
    player.off('loadstart', onLoadStart);
    player.off('seeking', onRestart);
    first = true;
  };

  if (first) {
    first = false;
    if (options.debug) console.debug('CONVIVA: ON');
    player.on('ads-ad-started', onAdsAdStarted);
    player.on('ads-ad-ended', onAdsAdEnded);
    player.on('contentplayback', onContentPlayback);
    player.on('dispose', _onDispose);
    player.on('ended', onEnded);
    player.on('error', onError);
    player.on('loadstart', onLoadStart);
    //        player.on('play', function() {console.debug('CONVIVA: play')});
  }
  /*
  `play` is fired regardless of the presence of ads, but
  `contentplayback` is only fired when ads have been requested, so in
  that case we need to NOT attach a listener to `play`.
  */
  //      if (!player.ads.state) {
  //        player.on('play', onPlayback);
  //      }
};

},{"../fan":17,"./ConvivaLivePass_BcPerform":14,"lodash.mergewith":28}],16:[function(require,module,exports){
'use strict';

/*
 * This module acts as an adapter between the bundle and the various player
 * tech Adobe/Nielsen/Omniture plugins.
 *
 * The goal is to present a common analytics plugin interface to the bundle.
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var merge = require('lodash.mergewith');

var tz = require("timezone");

var heartbeatThreshold = 20000; // 20 seconds

function mergeCustomizer(objValue, srcValue) {
  if (srcValue === null) {
    return objValue;
  }
}

function playheadOffset(player, plugin) {
  if (!player.mediainfo) {
    return;
  }

  if (typeof plugin.setPlayheadOffset === 'function' && player.mediainfo.live && player.mediainfo.startTime) {
    var _playheadOffset = Math.round((Date.now() - player.mediainfo.startTime) / 1000);

    player.on('omnitureReady', function () {
      plugin.setPlayheadOffset(_playheadOffset);
    });
  }
}

function configure(player, config) {
  var contentMetadata = {};

  var localConfig = {
    NIELSEN_DATA: {
      CONTENT_METADATA: {}
    },
    ESPN_CUSTOM_METADATA: {
      "Showcode": player.mediainfo.showcode
    }
  };

  // https://espnjira.disney.com/browse/VPLAYREPLACE-769
  // Airdate, formatted as `yyyyMMddHH:mm:ss`
  if (player.mediainfo.originalPublishDate || player.mediainfo.originalAirDate) {
    localConfig.NIELSEN_DATA.CONTENT_METADATA.airdate = tz(player.mediainfo.originalPublishDate || player.mediainfo.originalAirDate, '%Y%m%d%k%M%S', require("timezone/America/New_York"), 'America/New_York');
  }

  if (player.mediainfo.live) {
    localConfig.MEDIAINFO = { live: true };
  }

  if (player.mediainfo.hasNielsenWatermarks) {
    contentMetadata = {
      adloadtype: 1,
      dataSrc: 'ID3',
      tv: true
    };
  }

  // https://espnjira.disney.com/browse/VPLAYREPLACE-769
  // Shared inventory
  if (player.mediainfo.commercialReplacement === 'SHARED INV') {
    contentMetadata.adloadtype = 1;
  }

  // https://espnjira.disney.com/browse/VPLAYREPLACE-769
  // Cross Reference ID 1
  if (player.mediainfo.nielsenCrossId1) {
    contentMetadata.crossId1 = player.mediainfo.nielsenCrossId1;
  }

  merge(localConfig.NIELSEN_DATA.CONTENT_METADATA, contentMetadata, mergeCustomizer);

  merge(config, localConfig, mergeCustomizer);

  return config;
}

function setEventListeners(player, plugin) {
  var adBreakStarted = void 0,
      heartbeatTimeout = void 0;
  var canTrackAdStartComplete = typeof plugin.trackAdStart === 'function' && typeof plugin.trackAdComplete === 'function';

  function startHeartbeatTimer() {
    // console.debug('starting ad timer', player.currentTime());

    heartbeatTimeout = setTimeout(trackAdStart, heartbeatThreshold);
  }

  function resetHeartbeatTimer() {
    // console.debug('resetting ad timer', player.currentTime());

    clearTimeout(heartbeatTimeout);

    // An ad break was started at least 20 seconds ago.
    if (adBreakStarted && adBreakStarted + heartbeatThreshold < Date.now()) {
      trackAdComplete();
    }

    startHeartbeatTimer();
  }

  function trackAdComplete() {
    // console.debug('sending trackAdComplete', player.currentTime());

    if (adBreakStarted) {
      plugin.trackAdComplete();
    }
    adBreakStarted = false;
  }

  function trackAdStart(adID) {
    // console.debug('sending trackAdStart', player.currentTime());

    clearTimeout(heartbeatTimeout);

    plugin.trackAdStart(adID);
    adBreakStarted = Date.now();
  }

  function onPause() {
    // console.debug('stopping ad timer');

    clearTimeout(heartbeatTimeout);

    player.one('play', function () {
      startHeartbeatTimer();
    });
  }

  function onCueChange(event, cue) {
    var payload, shouldResetAdTimer, shouldSendID3, shouldTrackAdTransitions;

    // console.info(cue);
    try {
      payload = JSON.parse(cue.text);
    } catch (e) {
      payload = cue.text;
    }

    shouldSendID3 = typeof plugin.sendID3 === 'function' && cue.owner && cue.owner.match(/^www\.nielsen\.com/i) !== null && player.mediainfo.hasNielsenWatermarks;
    shouldTrackAdTransitions = canTrackAdStartComplete && cue.owner === 'com.espn.authnet.transition';
    shouldResetAdTimer = canTrackAdStartComplete && player.mediainfo.hasEspnId3Heartbeats && cue.owner === 'com.espn.authnet.heartbeat' && payload[0].type === 'PROGRAM' && !(payload[1] && payload[1].type === 'COMMERCIAL');

    if (shouldSendID3) {
      // console.debug(cue.owner);

      plugin.sendID3(cue.owner);
    }

    if (shouldTrackAdTransitions) {
      // console.debug('transitioning from ' + payload.from.type + ' to ' + payload.to.type);

      if (payload.from.type === 'PROGRAM' && payload.to.type === 'COMMERCIAL') {
        trackAdStart(payload.to.id);
      } else if (payload.from.type === 'COMMERCIAL' && payload.to.type === 'COMMERCIAL') {
        trackAdComplete();
        trackAdStart(payload.to.id);
      } else if (payload[1] && payload[1].type === 'COMMERCIAL') {
        trackAdStart(payload[1].id);
      } else if (payload.from.type === 'COMMERCIAL' && payload.to.type === 'PROGRAM') {
        trackAdComplete();
      }
    }

    if (shouldResetAdTimer) {
      resetHeartbeatTimer();
    }
  }

  player.on('pause', onPause);

  player.on('espn.id3cuechange', onCueChange);

  player.one('dispose', function () {
    player.off('pause', onPause);
    player.off('espn.id3cuechange', onCueChange);
    clearTimeout(heartbeatTimeout);
  });
}

var ESPNAdobeNielsenAdapter = function () {
  function ESPNAdobeNielsenAdapter(player, config) {
    _classCallCheck(this, ESPNAdobeNielsenAdapter);

    this.player = player;

    config = configure(this.player, config);

    if (typeof this.player.BCGSAdobeDCRPlugin === 'function') {
      // Brightcove's plugin
      this.plugin = this.player.BCGSAdobeDCRPlugin({ options: config });
    } else if (this.player.heartbeats) {
      // TVSDK ""plugin""
      this.plugin = this.player.heartbeats(config);
    } else {
      throw new Error('No Adobe/Nielsen plugin found');
    }

    playheadOffset(this.player, this.plugin);
    setEventListeners(this.player, this.plugin);
  }

  _createClass(ESPNAdobeNielsenAdapter, [{
    key: 'loadNewOptions',
    value: function loadNewOptions(options) {
      // console.debug('loading new options');
      if (typeof this.plugin === 'function') {
        this.plugin({ options: options });
      } else if (typeof this.plugin.loadNewOptions === 'function') {
        this.plugin.loadNewOptions(options);
      }
    }
  }, {
    key: 'completeLiveProgram',
    value: function completeLiveProgram() {
      if (typeof this.plugin.completeLiveProgram === 'function') {
        this.plugin.completeLiveProgram();
      }
    }
  }]);

  return ESPNAdobeNielsenAdapter;
}();

module.exports = ESPNAdobeNielsenAdapter;

},{"lodash.mergewith":28,"timezone":40,"timezone/America/New_York":39}],17:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Cookie, FanApi, SWID;

  Cookie = require('cookie-cutter');
  FanApi = new (require('watch-fanapi'))();

  function getAutoStart(callback) {
    SWID = Cookie.get('SWID');
    var autoPlay, vas;
    autoPlay = true;
    vas = Cookie.get('VAS');
    if (vas) {
      autoPlay = parseInt(vas, 10) === 1;
    }
    if (typeof SWID === 'string' && SWID.indexOf('{') === 0) {
      FanApi.getAutoStartForFanId(SWID, function (autoStart) {
        autoPlay = autoStart === true || autoStart === false ? autoStart : autoPlay;
        if (callback) {
          callback(autoPlay);
        }
      });
    } else {
      if (callback) {
        callback(autoPlay);
      }
    }
  }

  function setAutoStart(value) {
    SWID = Cookie.get('SWID');
    if (value === true || value === false) {
      Cookie.set('VAS', value ? 1 : 2); // support affinity sites
      if (SWID) {
        FanApi.updateAutoStartForFanId(SWID, value);
      }
    }
  }

  exports.getAutoStart = getAutoStart;
  exports.setAutoStart = setAutoStart;
  Object.defineProperty(exports, 'SWID', {
    get: function get() {
      return Cookie.get('SWID');
    }
  });
}).call(undefined);

},{"cookie-cutter":24,"watch-fanapi":43}],18:[function(require,module,exports){
module.exports={
  "Could not download the video": "An error occurred during video playback, possibly due to network connectivity or being in a backgrounded browser tab. Please try again.",
  "EMBARGOED": "Video is not yet available.",
  "EXPIRED": "Video has expired.",
  "EXPIRED_CONTENT": "Video has expired.",
  "Fullscreen": "Full Screen",
  "GEOLOCATION_NOT_ALLOWED": "Video is not available in your country.",
  "NOT_FOUND": "This video is unavailable.",
  "Non-Fullscreen": "Exit Full Screen",
  "STREAM_LIMITED": "The maximum number of concurrent streams has been reached on your account. If you have any questions or need assistance please visit es.pn/watchfaq or call 888-549-ESPN.",
  "STREAM_LIMIT_ERROR": "The maximum number of concurrent streams has been reached on your account. If you have any questions or need assistance please visit es.pn/watchfaq or call 888-549-ESPN."
}

},{}],19:[function(require,module,exports){
module.exports={  
  "A network error caused the video download to fail part-way.": "Un error de red ha interrumpido la descarga del vídeo.",
  "Autoplay": "Reproducción automática",
  "Caption Settings": "Opciones de subtítulos",
  "Captions": "Subtítulos especiales",
  "Chapters": "Capítulos",
  "Check out this video on ESPN": "No te pierdas este video de ESPN",
  "Closed Caption": "Subtítulos",
  "Closed Captions": "Subtítulos",
  "Copied": "Copiado",
  "Copy": "Copiar",
  "Copy Embed Link": "Obtener código",
  "Copy Link": "Obtener URL",
  "Could not download the video": "No se ha podido descargar el vídeo.",
  "Current Time": "Tiempo reproducido",
  "Duration Time": "Duración total",
  "Email Video": "Enviar por Email",
  "Email": "Enviar por correo",
  "Embed Code": "Insertar código",
  "EMBARGOED": "El vídeo no está disponible todavía.",
  "Error Code": "Código De Error",
  "EXPIRED": "El video ha expirado.",
  "EXPIRED_CONTENT": "El video ha expirado.",
  "From": "De",
  "Fullscreen": "Maximizar video",
  "GEOLOCATION_NOT_ALLOWED": "El vídeo no está disponible en tu país.",
  "LIVE": "DIRECTO",
  "Loaded": "Cargado",
  "Message": "Mensaje",
  "Menu": "Menú",
  "Mute": "Silenciador",
  "No compatible source was found for this video.": "No se ha encontrado ninguna fuente compatible con este vídeo.",
  "No video has been loaded": "No hay ningún vídeo cargado.",
  "Non-Fullscreen": "Tamaño original",
  "NOT_FOUND": "Este vídeo no está disponible.",
  "OK": "aprobar",
  "Pause": "Pausa",
  "Play": "Reproducir",
  "Playback Rate": "Velocidad de reproducción",
  "Progress": "Progreso",
  "Remaining Time": "Tiempo restante",
  "Replay": "Reproducir de nuevo",
  "Send": "Enviar",
  "Settings": "Configuración",
  "Share": "Compartir",
  "Start at": "Iniciar en",
  "Stop": "Detener",
  "STREAM_LIMITED": "The maximum number of concurrent streams has been reached on your account.",
  "STREAM_LIMIT_ERROR": "The maximum number of concurrent streams has been reached on your account.",
  "Stream Type": "Tipo de secuencia",
  "Subtitles": "Subtítulos",
  "Technical details": "Detalles técnicos",
  "The video connection was lost, please confirm you are connected to the internet": "Se ha perdido la conexión al vídeo. Compruebe si su equipo está conectado a internet.",
  "The video could not be loaded, either because the server or network failed or because the format is not supported.": "No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.",
  "The video download was cancelled": "Ha interrumpido la reproducción del vídeo.",
  "The video is bad or in a format that cannot be played on your browser": "El vídeo está dañado o tiene un formato no reproducible en su navegador.",
  "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.",
  "The video you're trying to watch is encrypted and we don't know how to decrypt it": "The video you're trying to watch is encrypted and we don't know how to decrypt it",
  "This video is either unavailable or not supported in this browser": "Este vídeo no está disponible o es incompatible con este navegador.",
  "This video is unavailable": "Este vídeo no está disponible.",
  "To": "A",
  "Unmute": "Eliminar silenciador",
  "Unmuted": "Eliminar silenciador",
  "Up Next": "A continuación",
  "You aborted the video playback": "Ha interrumpido la reproducción del vídeo.",
  "captions off": "Subtítulos especiales desactivados",
  "subtitles off": "Subtítulos desactivados"
}

},{}],20:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var I18n, LANG, TRANSLATIONS;

  TRANSLATIONS = {};
  LANG = 'en';

  I18n = function I18n(key) {
    return TRANSLATIONS[LANG][key] || TRANSLATIONS.en[key] || key;
  };

  /*
    Adds key/value pairs in the form of:
    {
      "Yes": "はい"
      "No": "いいえ"
    }
   */
  I18n.add = function (lang, data) {
    var k, v;
    if (!TRANSLATIONS[lang]) {
      TRANSLATIONS[lang] = {};
    }
    for (k in data) {
      v = data[k];
      TRANSLATIONS[lang][k] = v;
    }
  };

  /*
    Destroy translation data
   */
  I18n.reset = function () {
    TRANSLATIONS = {};
    LANG = 'en';
  };

  I18n.setLang = function (lang) {
    if (TRANSLATIONS[lang]) {
      LANG = lang;
    }
  };

  I18n.translations = function () {
    return TRANSLATIONS;
  };

  I18n.add('en', require('./en.json'));
  I18n.add('es', require('./es.json'));
  I18n.add('pt', require('./pt.json'));

  module.exports = I18n;
}).call(undefined);

},{"./en.json":18,"./es.json":19,"./pt.json":21}],21:[function(require,module,exports){
module.exports={
  "A network error caused the media download to fail part-way.": "Um erro na rede fez o vídeo parar parcialmente.",
  "An unanticipated problem was encountered, check back soon and try again": "Aconteceu um erro inesperado, tente novamente mais tarde",
  "Captions": "Anotações",
  "captions off": "Sem Anotações",
  "Chapters": "Capítulos",
  "Check out this video on ESPN": "Confira esse vídeo no WatchESPN",
  "Could not download the video": "Não foi possível realizar o download do vídeo",
  "Current Time": "Tempo",
  "Duration Time": "Duração",
  "Error Code": "Código do Erro",
  "Fullscreen": "Tela Cheia",
  "LIVE": "AO VIVO",
  "Loaded": "Carregado",
  "Mute": "Mudo",
  "No compatible source was found for this media.": "Não foi encontrada fonte de vídeo compatível.",
  "No video has been loaded": "Nenhum vídeo foi carregado",
  "Non-Fullscreen": "Tela Normal",
  "Pause": "Pausar",
  "Play": "Tocar",
  "Playback Rate": "Velocidade",
  "Progress": "Progresso",
  "Remaining Time": "Tempo Restante",
  "Stream Type": "Tipo de Stream",
  "Subtitles": "Legendas",
  "subtitles off": "Sem Legendas",
  "Technical details": "Detalhes técnicos",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "O vídeo não pode ser carregado, ou porque houve um problema com sua rede ou pelo formato do vídeo não ser suportado.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "A execução foi interrompida por um problema com o vídeo ou por seu navegador não dar suporte ao seu formato.",
  "The video connection was lost, please confirm you are connected to the internet": "A conexão com o vídeo foi perdida. Por favor, confirme que está conectado a internet",
  "The video download was cancelled": "O download do vídeo foi cancelado",
  "The video is bad or in a format that cannot be played on your browser": "O vídeo está em um formato que o seu browser não suporta",
  "The video you are trying to watch is encrypted and we do not know how to decrypt it": "O vídeo que você está tentando assistir é criptografado e nós não sabemos como decodificá-lo",
  "This video is either unavailable or not supported in this browser": "O vídeo não está disponível ou não é suportado pelo seu browser",
  "Unmute": "Habilitar Som",
  "You aborted the media playback": "Você parou a execução do vídeo."
}
},{}],22:[function(require,module,exports){
(function (process,global){
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2015 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.4.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype.invokeFirst = function (fn, receiver, arg) {
    this._normalQueue.unshift(fn, receiver, arg);
    this._queueTick();
};

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (!true) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (!true) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0) {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};

Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

return PassThroughHandlerContext;
};

},{"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (!true) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (!true) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    this._init$(undefined, -2);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }
    if (self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
}

function Promise(executor) {
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    if (executor !== INTERNAL) {
        check(this, executor);
        this._resolveFromExecutor(executor);
    }
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("expecting an object but got " +
                    "A catch statement predicate " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.4.5";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (!true) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype._unshiftOne = function(value) {
    var capacity = this._capacity;
    this._checkCapacity(this.length() + 1);
    var front = this._front;
    var i = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = value;
    this._front = i;
    this._length = this.length() + 1;
};

Queue.prototype.unshift = function(fn, receiver, arg) {
    this._unshiftOne(arg);
    this._unshiftOne(receiver);
    this._unshiftOne(fn);
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
                toggleScheduled = true;
                div2.classList.toggle("foo");
            };

            return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string";
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

function env(key, def) {
    return isNode ? process.env[key] : def;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":30}],23:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],24:[function(require,module,exports){
var exports = module.exports = function (doc) {
    if (!doc) doc = {};
    if (typeof doc === 'string') doc = { cookie: doc };
    if (doc.cookie === undefined) doc.cookie = '';
    
    var self = {};
    self.get = function (key) {
        var splat = doc.cookie.split(/;\s*/);
        for (var i = 0; i < splat.length; i++) {
            var ps = splat[i].split('=');
            var k = unescape(ps[0]);
            if (k === key) return unescape(ps[1]);
        }
        return undefined;
    };
    
    self.set = function (key, value, opts) {
        if (!opts) opts = {};
        var s = escape(key) + '=' + escape(value);
        if (opts.expires) s += '; expires=' + opts.expires;
        if (opts.path) s += '; path=' + escape(opts.path);
        if (opts.domain) s += '; domain=' + escape(opts.domain);
        if (opts.secure) s += '; secure';
        doc.cookie = s;
        return s;
    };
    return self;
};

if (typeof document !== 'undefined') {
    var cookie = exports(document);
    exports.get = cookie.get;
    exports.set = cookie.set;
}

},{}],25:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],26:[function(require,module,exports){

module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}

},{}],27:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],28:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with seven arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = mergeWith;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],29:[function(require,module,exports){
// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.3.6 2017-04-05*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo 3DS",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Puffin": "Puffin",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UC Browser": "UC Browser[VER]",
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = userAgent || '';
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.3.6 2017-04-05';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (typeof define === 'function' && define.amd) {
        return define;
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());
},{}],30:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],31:[function(require,module,exports){
// From https://gist.github.com/epeli/11209665

var Promise = require("bluebird");

// So you can `var request = require("superagent-bluebird-promise")`
var superagent = module.exports = require("superagent");
var Request = superagent.Request;

try {
  Promise.config({
    // Enable cancellation.
    cancellation: true
  });
} catch (e) {
  console.warn([
    'Enabling bluebird cancellation failed.',
    'If you are using bluebird elsewhere in your application,',
    'be sure to enable cancellation there as well.',
    'Promise.config({cancellation: true});'].join(' ')
  );
  console.warn(e.stack);
}
// Create custom error type.
// Create a new object, that prototypally inherits from the Error constructor.
var SuperagentPromiseError = function(message, originalError) {
  var stack;
  this.message = message;
  this.name = 'SuperagentPromiseError';
  this.originalError = originalError;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
    stack = this.stack;
  }
  else {
    stack = (new Error(message)).stack;
  }

  if (Object.defineProperty) {
    Object.defineProperty(this, 'stack', {
      get: function() {
        if (this.originalError) {
          return stack + '\nCaused by:  ' + this.originalError.stack;
        }

        return stack;
      }
    });
  }
};

SuperagentPromiseError.prototype = new Error();
SuperagentPromiseError.prototype.constructor = SuperagentPromiseError;
superagent.SuperagentPromiseError = SuperagentPromiseError;

/**
 * @namespace utils
 * @class Superagent
 */

/**
 *
 * Add promise support for superagent/supertest
 *
 * Call .promise() to return promise for the request
 *
 * @method then
 * @return {Bluebird.Promise}
 */
Request.prototype.promise = function() {
  var req = this;
  var error;

  return new Promise(function(resolve, reject, onCancel) {
      req.end(function(err, res) {
        if (typeof res !== "undefined" && res !== null && res.status >= 400) {
          var msg = 'cannot ' + req.method + ' ' + req.url + ' (' + res.status + ')';
          error = new SuperagentPromiseError(msg);
          error.status = res.status;
          error.body = res.body;
          error.res = res;
          reject(error);
        } else if (err) {
          reject(new SuperagentPromiseError('Bad request', err));
        } else {
          resolve(res);
        }
      });

      if (typeof onCancel === 'function') {
        onCancel(function() {
          req.abort();
        });
      }
    });
};

/**
 *
 * Make superagent requests Promises ES6 conformant
 *
 * Call .then([onFulfilled], [onRejected]) to register callbacks
 *
 * @method then
 * @param {function} [onFulfilled]
 * @param {function} [onRejected]
 * @return {Bluebird.Promise}
 */
Request.prototype.then = function() {
  var promise = this.promise();
  return promise.then.apply(promise, arguments);
};

/**
 *
 * Make superagent requests Promises ES6 conformant
 *
 * Call .catch([onRejected]) to register callback
 *
 * @method catch
 * @param {function} [onRejected]
 * @return {Bluebird.Promise}
 */
Request.prototype.catch = function() {
  var promise = this.promise();
  return promise.catch.apply(promise, arguments);
};

},{"bluebird":22,"superagent":32}],32:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('component-emitter');
var RequestBase = require('./request-base');
var isObject = require('./is-object');
var isFunction = require('./is-function');
var ResponseBase = require('./response-base');
var shouldRetry = require('./should-retry');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
      status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if(this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
    options = pass;
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    }
  }

  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
      
    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
    break;  
  }
  return this;
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  // console.log(this._retries, this._maxRetries)
  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if (isFunction(this._sort)) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._appendQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn){
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./is-function":33,"./is-object":34,"./request-base":35,"./response-base":36,"./should-retry":37,"component-emitter":23}],33:[function(require,module,exports){
/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = require('./is-object');

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;

},{"./is-object":34}],34:[function(require,module,exports){
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],35:[function(require,module,exports){
/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, read, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  return this;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
}

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on){
  // This is browser-only functionality. Node side is no-op.
  if(on==undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};


/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};


/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
}

},{"./is-object":34}],36:[function(require,module,exports){

/**
 * Module dependencies.
 */

var utils = require('./utils');

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field){
    return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};

},{"./utils":38}],37:[function(require,module,exports){
var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
module.exports = function shouldRetry(err, res) {
  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
  if (res && res.status && res.status >= 500) return true;
  // Superagent timeout
  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
  if (err && 'crossDomain' in err) return true;
  return false;
};

},{}],38:[function(require,module,exports){

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, shouldStripCookie){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  if (shouldStripCookie) {
    delete header['cookie'];
  }
  return header;
};
},{}],39:[function(require,module,exports){
module.exports={"zones":{"America/New_York":["z",{"wallclock":-94694400000,"format":"E%sT","abbrev":"EST","offset":-18000000,"posix":-94676400000,"save":0,"rules":"US"},{"wallclock":-757382400000,"format":"E%sT","abbrev":"EST","offset":-18000000,"posix":-757364400000,"save":0,"rules":"NYC"},{"wallclock":-883612800000,"format":"E%sT","abbrev":"EST","offset":-18000000,"posix":-883594800000,"save":0,"rules":"US"},{"wallclock":-1577923200000,"format":"E%sT","abbrev":"EST","offset":-18000000,"posix":-1577905200000,"save":0,"rules":"NYC"},{"wallclock":-2717668562000,"format":"E%sT","abbrev":"EST","offset":-18000000,"posix":-2717650800000,"save":0,"rules":"US"},{"wallclock":-1.7976931348623157e+308,"format":"LMT","abbrev":"LMT","offset":-17762000,"posix":-1.7976931348623157e+308,"save":0}]},"rules":{"US":[{"from":2007,"to":1.7976931348623157e+308,"month":10,"day":[0,1],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":2007,"to":1.7976931348623157e+308,"month":2,"day":[0,8],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1987,"to":2006,"month":3,"day":[0,1],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1967,"to":2006,"month":9,"day":[0,-31],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":1976,"to":1986,"month":3,"day":[0,-30],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1975,"to":1975,"month":1,"day":[7,23],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1974,"to":1974,"month":0,"day":[7,6],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1967,"to":1973,"month":3,"day":[0,-30],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1945,"to":1945,"month":8,"day":[0,-30],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":1945,"to":1945,"month":7,"day":[7,14],"time":1380,"clock":"posix","save":60,"letter":"P","saved":3600000},{"from":1942,"to":1942,"month":1,"day":[7,9],"time":120,"clock":"wallclock","save":60,"letter":"W","saved":0},{"from":1918,"to":1919,"month":9,"day":[0,-31],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":1918,"to":1919,"month":2,"day":[0,-31],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0}],"NYC":[{"from":1921,"to":1966,"month":3,"day":[0,-30],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1955,"to":1966,"month":9,"day":[0,-31],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":1921,"to":1954,"month":8,"day":[0,-30],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000},{"from":1920,"to":1920,"month":2,"day":[0,-31],"time":120,"clock":"wallclock","save":60,"letter":"D","saved":0},{"from":1920,"to":1920,"month":9,"day":[0,-31],"time":120,"clock":"wallclock","save":0,"letter":"S","saved":3600000}]}}
},{}],40:[function(require,module,exports){
!function (definition) {
  if (typeof module == "object" && module.exports) module.exports = definition();
  else if (typeof define == "function") define(definition);
  else this.tz = definition();
} (function () {
/*
  function die () {
    console.log.apply(console, __slice.call(arguments, 0));
    return process.exit(1);
  }

  function say () { return console.log.apply(console, __slice.call(arguments, 0)) }
*/
  function actualize (entry, rule, year) {
    var actualized, date = rule.day[1];

    do {
      actualized = new Date(Date.UTC(year, rule.month, Math.abs(date++)));
    } while (rule.day[0] < 7 && actualized.getUTCDay() != rule.day[0])

    actualized = {
      clock: rule.clock,
      sort: actualized.getTime(),
      rule: rule,
      save: rule.save * 6e4,
      offset: entry.offset
    };

    actualized[actualized.clock] = actualized.sort + rule.time * 6e4;

    if (actualized.posix) {
      actualized.wallclock = actualized[actualized.clock] + (entry.offset + rule.saved);
    } else {
      actualized.posix = actualized[actualized.clock] - (entry.offset + rule.saved);
    }

    return actualized;
  }

  function find (request, clock, time) {
    var i, I, entry, found, zone = request[request.zone], actualized = [], abbrev, rules
      , j, year = new Date(time).getUTCFullYear(), off = 1;
    for (i = 1, I = zone.length; i < I; i++) if (zone[i][clock] <= time) break;
    entry = zone[i];
    if (entry.rules) {
      rules = request[entry.rules];
      for (j = year + 1; j >= year - off; --j)
        for (i = 0, I = rules.length; i < I; i++)
          if (rules[i].from <= j && j <= rules[i].to) actualized.push(actualize(entry, rules[i], j));
          else if (rules[i].to < j && off == 1) off = j - rules[i].to;
      actualized.sort(function (a, b) { return a.sort - b.sort });
      for (i = 0, I = actualized.length; i < I; i++) {
        if (time >= actualized[i][clock] && actualized[i][actualized[i].clock] > entry[actualized[i].clock]) found = actualized[i];
      }
    }
    if (found) {
      if (abbrev = /^(.*)\/(.*)$/.exec(entry.format)) {
        found.abbrev = abbrev[found.save ? 2 : 1];
      } else {
        found.abbrev = entry.format.replace(/%s/, found.rule.letter);
      }
    }
    return found || entry;
  }

  function convertToWallclock (request, posix) {
    if (request.zone == "UTC") return posix;
    request.entry = find(request, "posix", posix);
    return posix + request.entry.offset + request.entry.save;
  }

  function convertToPOSIX (request, wallclock) {
    if (request.zone == "UTC") return wallclock;

    var entry, diff;
    request.entry = entry = find(request, "wallclock", wallclock);
    diff = wallclock - entry.wallclock;

    return 0 < diff && diff < entry.save ? null : wallclock - entry.offset - entry.save;
  }

  function adjust (request, posix, match) {
    var increment = +(match[1] + 1) // conversion necessary for week day addition
      , offset = match[2] * increment
      , index = UNITS.indexOf(match[3].toLowerCase())
      , date
      ;
    if (index > 9) {
      posix += offset * TIME[index - 10];
    } else {
      date = new Date(convertToWallclock(request, posix));
      if (index < 7) {
        while (offset) {
          date.setUTCDate(date.getUTCDate() + increment);
          if (date.getUTCDay() == index) offset -= increment;
        }
      } else if (index == 7) {
        date.setUTCFullYear(date.getUTCFullYear() + offset);
      } else if (index == 8) {
        date.setUTCMonth(date.getUTCMonth() + offset);
      } else {
        date.setUTCDate(date.getUTCDate() + offset);
      }
      if ((posix = convertToPOSIX(request, date.getTime())) == null) {
        posix = convertToPOSIX(request, date.getTime() + 864e5 * increment) - 864e5 * increment;
      }
    }
    return posix;
  }

  function convert (vargs) {
    if (!vargs.length) return "1.0.6";

    var request = Object.create(this)
      , adjustments = []
      , i, I, $, argument, date
      ;

    for (i = 0; i < vargs.length; i++) { // leave the for loop alone, it works.
      argument = vargs[i];
      // https://twitter.com/bigeasy/status/215112186572439552
      if (Array.isArray(argument)) {
        if (!i && !isNaN(argument[1])) {
          date = argument;
        } else {
          argument.splice.apply(vargs, [ i--, 1 ].concat(argument));
        }
      } else if (isNaN(argument)) {
        $ = typeof argument;
        if ($ == "string") {
          if (~argument.indexOf("%")) {
            request.format = argument;
          } else if (!i && argument == "*") {
            date = argument;
          } else if (!i && ($ = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?(Z|(([+-])(\d{2}(:\d{2}){0,2})))?)?$/.exec(argument))) {
            date = [];
            date.push.apply(date, $.slice(1, 8));
            if ($[9]) {
              date.push($[10] + 1);
              date.push.apply(date, $[11].split(/:/));
            } else if ($[8]) {
              date.push(1);
            }
          } else if (/^\w{2,3}_\w{2}$/.test(argument)) {
            request.locale = argument;
          } else if ($ = UNIT_RE.exec(argument)) {
            adjustments.push($);
          } else {
            request.zone = argument;
          }
        } else if ($ == "function") {
          if ($ = argument.call(request)) return $;
        } else if (/^\w{2,3}_\w{2}$/.test(argument.name)) {
          request[argument.name] = argument;
        } else if (argument.zones) {
          for ($ in argument.zones) request[$] = argument.zones[$];
          for ($ in argument.rules) request[$] = argument.rules[$];
        }
      } else if (!i) {
        date = argument;
      }
    }

    if (!request[request.locale]) delete request.locale;
    if (!request[request.zone]) delete request.zone;

    if (date != null) {
      if (date == "*") {
        date = request.clock();
      } else if (Array.isArray(date)) {
        I = !date[7];
        for (i = 0; i < 11; i++) date[i] = +(date[i] || 0); // conversion necessary for decrement
        --date[1]; // Grr..
        date = Date.UTC.apply(Date.UTC, date.slice(0, 8)) +
          -date[7] * (date[8] * 36e5 + date[9] * 6e4 + date[10] * 1e3);
      } else {
        date = Math.floor(date);
      }
      if (!isNaN(date)) {
        if (I) date = convertToPOSIX(request, date);

        if (date == null) return date;

        for (i = 0, I = adjustments.length; i < I; i++) {
          date = adjust(request, date, adjustments[i]);
        }

        if (!request.format) return date;

        $ = new Date(convertToWallclock(request, date));
        return request.format.replace(/%([-0_^]?)(:{0,3})(\d*)(.)/g,
        function (value, flag, colons, padding, specifier) {
          var f, fill = "0", pad;
          if (f = request[specifier]) {
            value = String(f.call(request, $, date, flag, colons.length));
            if ((flag || f.style) == "_") fill = " ";
            pad = flag == "-" ? 0 : f.pad || 0;
            while (value.length < pad) value = fill + value;
            pad = flag == "-" ? 0 : padding || f.pad;
            while (value.length < pad) value = fill + value;
            if (specifier == "N" && pad < value.length) value = value.slice(0, pad);
            if (flag == "^") value = value.toUpperCase();
          }
          return value;
        });
      }
    }

    return function () { return request.convert(arguments) };
  }

  var context =
    { clock: function () { return +(new Date()) }
    , zone: "UTC"
    , entry: { abbrev: "UTC", offset: 0, save: 0 }
    , UTC: 1
    , z: function(date, posix, flag, delimiters) {
        var offset = this.entry.offset + this.entry.save
          , seconds = Math.abs(offset / 1000), parts = [], part = 3600, i, z;
        for (i = 0; i < 3; i++) {
          parts.push(("0" + Math.floor(seconds / part)).slice(-2));
          seconds %= part;
          part /= 60;
        }
        if (flag == "^" && !offset) return "Z";
        if (flag == "^") delimiters = 3;
        if (delimiters == 3) {
          z = parts.join(":");
          z = z.replace(/:00$/, "");
          if (flag != "^") z = z.replace(/:00$/, "");
        } else if (delimiters) {
          z = parts.slice(0, delimiters + 1).join(":");
          if (flag == "^") z = z.replace(/:00$/, "");
        } else {
          z = parts.slice(0, 2).join("");
        }
        z = (offset < 0 ? "-" : "+") + z;
        z = z.replace(/([-+])(0)/, { "_": " $1", "-": "$1" }[flag] || "$1$2");
        return z;
      }
    , "%": function(date) { return "%" }
    , n: function (date) { return "\n" }
    , t: function (date) { return "\t" }
    , U: function (date) { return weekOfYear(date, 0) }
    , W: function (date) { return weekOfYear(date, 1) }
    , V: function (date) { return isoWeek(date)[0] }
    , G: function (date) { return isoWeek(date)[1] }
    , g: function (date) { return isoWeek(date)[1] % 100 }
    , j: function (date) { return Math.floor((date.getTime() - Date.UTC(date.getUTCFullYear(), 0)) / 864e5) + 1 }
    , s: function (date) { return Math.floor(date.getTime() / 1000) }
    , C: function (date) { return Math.floor(date.getUTCFullYear() / 100) }
    , N: function (date) { return date.getTime() % 1000 * 1000000 }
    , m: function (date) { return date.getUTCMonth() + 1 }
    , Y: function (date) { return date.getUTCFullYear() }
    , y: function (date) { return date.getUTCFullYear() % 100 }
    , H: function (date) { return date.getUTCHours() }
    , M: function (date) { return date.getUTCMinutes() }
    , S: function (date) { return date.getUTCSeconds() }
    , e: function (date) { return date.getUTCDate() }
    , d: function (date) { return date.getUTCDate() }
    , u: function (date) { return date.getUTCDay() || 7 }
    , w: function (date) { return date.getUTCDay() }
    , l: function (date) { return date.getUTCHours() % 12 || 12 }
    , I: function (date) { return date.getUTCHours() % 12 || 12 }
    , k: function (date) { return date.getUTCHours() }
    , Z: function (date) { return this.entry.abbrev }
    , a: function (date) { return this[this.locale].day.abbrev[date.getUTCDay()] }
    , A: function (date) { return this[this.locale].day.full[date.getUTCDay()] }
    , h: function (date) { return this[this.locale].month.abbrev[date.getUTCMonth()] }
    , b: function (date) { return this[this.locale].month.abbrev[date.getUTCMonth()] }
    , B: function (date) { return this[this.locale].month.full[date.getUTCMonth()] }
    , P: function (date) { return this[this.locale].meridiem[Math.floor(date.getUTCHours() / 12)].toLowerCase() }
    , p: function (date) { return this[this.locale].meridiem[Math.floor(date.getUTCHours() / 12)] }
    , R: function (date, posix) { return this.convert([ posix, "%H:%M" ]) }
    , T: function (date, posix) { return this.convert([ posix, "%H:%M:%S" ]) }
    , D: function (date, posix) { return this.convert([ posix, "%m/%d/%y" ]) }
    , F: function (date, posix) { return this.convert([ posix, "%Y-%m-%d" ]) }
    , x: function (date, posix) { return this.convert([ posix, this[this.locale].date ]) }
    , r: function (date, posix) { return this.convert([ posix, this[this.locale].time12 || '%I:%M:%S' ]) }
    , X: function (date, posix) { return this.convert([ posix, this[this.locale].time24 ]) }
    , c: function (date, posix) { return this.convert([ posix, this[this.locale].dateTime ]) }
    , convert: convert
    , locale: "en_US"
    , en_US: {
        date: "%m/%d/%Y",
        time24: "%I:%M:%S %p",
        time12: "%I:%M:%S %p",
        dateTime: "%a %d %b %Y %I:%M:%S %p %Z",
        meridiem: [ "AM", "PM" ],
        month: {
          abbrev: "Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec".split("|"),
          full: "January|February|March|April|May|June|July|August|September|October|November|December".split("|")
        },
        day: {
          abbrev: "Sun|Mon|Tue|Wed|Thu|Fri|Sat".split("|"),
          full: "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday".split("|")
        }
      }
    };
  var UNITS = "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|year|month|day|hour|minute|second|millisecond"
    , UNIT_RE = new RegExp("^\\s*([+-])(\\d+)\\s+(" + UNITS + ")s?\\s*$", "i")
    , TIME = [ 36e5, 6e4, 1e3, 1 ]
    ;
  UNITS = UNITS.toLowerCase().split("|");

  "delmHMSUWVgCIky".replace(/./g, function (e) { context[e].pad = 2 });

  context.N.pad = 9;
  context.j.pad = 3;

  context.k.style = "_";
  context.l.style = "_";
  context.e.style = "_";

  function weekOfYear (date, startOfWeek) {
    var diff, nyd, weekStart;
    nyd = new Date(Date.UTC(date.getUTCFullYear(), 0));
    diff = Math.floor((date.getTime() - nyd.getTime()) / 864e5);
    if (nyd.getUTCDay() == startOfWeek) {
      weekStart = 0;
    } else {
      weekStart = 7 - nyd.getUTCDay() + startOfWeek;
      if (weekStart == 8) {
        weekStart = 1;
      }
    }
    return diff >= weekStart ? Math.floor((diff - weekStart) / 7) + 1 : 0;
  }

  function isoWeek (date) {
    var nyd, nyy, week;
    nyy = date.getUTCFullYear();
    nyd = new Date(Date.UTC(nyy, 0)).getUTCDay();
    week = weekOfYear(date, 1) + (nyd > 1 && nyd <= 4 ? 1 : 0);
    if (!week) {
      nyy = date.getUTCFullYear() - 1;
      nyd = new Date(Date.UTC(nyy, 0)).getUTCDay();
      week = nyd == 4 || (nyd == 3 && new Date(nyy, 1, 29).getDate() == 29) ? 53 : 52;
      return [week, date.getUTCFullYear() - 1];
    } else if (week == 53 && !(nyd == 4 || (nyd == 3 && new Date(nyy, 1, 29).getDate() == 29))) {
      return [1, date.getUTCFullYear() + 1];
    } else {
      return [week, date.getUTCFullYear()];
    }
  }

  return function () { return context.convert(arguments) };
});

},{}],41:[function(require,module,exports){
'use strict';

var _superagentBluebirdPromise = require('superagent-bluebird-promise');

var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Storage = require('./Storage');

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAN_PRODUCT_PROD_HOST = '//fan.api.espn.com';
var FAN_CORE_PROD_HOST = '//fan.core.api.espn.com';
var DEFAULT_SOURCE_HEADER = 'espn-video-player'; // watchespn-web // ESPN.com - FAM
var FAN_API_CACHE_MINUTES = 10;
var SWID_RE = /^\{[\w\-]+\}/;

var DEFAULT_CONFIGURATION = {
    sourceHeader: DEFAULT_SOURCE_HEADER,
    cacheDuration: FAN_API_CACHE_MINUTES
};

var _sourceHeader = void 0;
var _cacheDuration = void 0;
var _storage = void 0;

function getFan(id, resolve, reject) {
    var url = FAN_PRODUCT_PROD_HOST + '/apis/v2/fans/' + id;
    _superagentBluebirdPromise2.default.get(url).withCredentials().set('X-Personalization-Source', _sourceHeader).end(function (err, res) {
        if (err || !res.ok) {
            reject(err);
        } else {
            var fan = res && res.body;
            _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
            resolve(fan);
        }
    });
}

function getFanForId(id) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    return new _bluebird2.default(function (resolve, reject) {
        _storage.getFan().then(function (cache) {
            var fan = cache && cache.item;
            var cacheExpired = Date.now() - cache.timestamp > _cacheDuration * 60 * 1000;
            if (fan === null || fan.id !== id || cacheExpired) {
                getFan(id, resolve, reject);
            } else {
                resolve(fan);
            }
        }).catch(function () {
            getFan(id, resolve, reject);
        });
    });
}

function updateSettingsForFanId(id, postData) {
    if (!SWID_RE.test(id)) {
        return _bluebird2.default.reject(new Error('Invalid SWID'));
    }

    var url = FAN_CORE_PROD_HOST + '/apis/v2/fans/' + id + '/profile/';
    return _superagentBluebirdPromise2.default.post(url).withCredentials().set('X-Personalization-Source', _sourceHeader).send(postData).promise();
}

function FanAPI() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIGURATION,
        _ref$sourceHeader = _ref.sourceHeader,
        sourceHeader = _ref$sourceHeader === undefined ? DEFAULT_CONFIGURATION.sourceHeader : _ref$sourceHeader,
        _ref$cacheDuration = _ref.cacheDuration,
        cacheDuration = _ref$cacheDuration === undefined ? DEFAULT_CONFIGURATION.cacheDuration : _ref$cacheDuration;

    if (!(this instanceof FanAPI)) {
        return new FanAPI({ sourceHeader: sourceHeader, cacheDuration: cacheDuration });
    }
    _sourceHeader = sourceHeader;
    _cacheDuration = cacheDuration;
    _storage = new _Storage2.default(_cacheDuration);
    return this;
}

FanAPI.prototype.getFanForId = function (id, callback) {
    return getFanForId(id).tap(function (fan) {
        if (typeof callback === 'function') callback(fan);
    });
};

FanAPI.prototype.getAutoStartForFanId = function (id, callback) {
    return getFanForId(id).then(function (fan) {
        var profile = fan && fan.profile;
        var settings = profile && profile.settings;
        var videoAutoStartValue = settings && settings.videoAutoStart && settings.videoAutoStart.value;
        return videoAutoStartValue !== '2';
    }).catch(function () {
        return true;
    }).tap(function (videoAutoStart) {
        if (typeof callback === 'function') {
            callback(videoAutoStart);
        }
    });
};

FanAPI.prototype.updateAutoStartForFanId = function (id, autoStart, callback) {
    var videoAutoStartValue = (!!autoStart ? '1' : '2').toString();

    var postData = {
        settings: {
            videoAutoStart: {
                value: videoAutoStartValue,
                lastUpdateSource: _sourceHeader,
                lastUpdateDate: Date.now()
            }
        }
    };

    return updateSettingsForFanId(id, postData).tap(function (err, res) {
        if (typeof callback === 'function') {
            callback(err, res);
        }
    }).catch(function () {
        return true;
    }).finally(function () {
        FanAPI.prototype.updateAutoStartCache(postData.settings);
    });
};

FanAPI.prototype.updateAutoStartCache = function (settings) {
    var videoAutoStart = settings.videoAutoStart;
    _storage.getFan().then(function (cache) {
        var fan = cache && cache.item;
        // const cacheExpired = (Date.now() - cache.timestamp > _cacheDuration * 60 * 1000);
        var key = void 0;
        for (key in videoAutoStart) {
            if (videoAutoStart.hasOwnProperty(key)) {
                fan.profile.settings.videoAutoStart[key] = videoAutoStart[key];
            }
        }
        _storage.setFan({ item: fan, id: fan.id, timestamp: Date.now() });
    }).catch(function () {});
};

FanAPI.prototype.getUidsForFanId = function (id, callback) {
    function hasUid(preference) {
        return preference.metaData.team || preference.metaData.sport;
    }

    function collectUids(preference) {
        if (preference.metaData.team) {
            return preference.metaData.team.uid;
        } else if (preference.metaData.sport) {
            return preference.metaData.sport.uid;
        }
        return null;
    }

    return getFanForId(id).then(function (fan) {
        var preferences = fan && fan.preferences;
        return preferences.filter(hasUid).map(collectUids);
    }).catch(function () {
        return [];
    }).tap(function (uids) {
        if (typeof callback === 'function') {
            callback(uids);
        }
    });
};

module.exports = FanAPI;
},{"./Storage":42,"bluebird":22,"superagent-bluebird-promise":31}],42:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global espn window */


var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// this is the key .com uses for local storage of fanapi data
var ESPN_FAN_STORAGE_KEY = 'fanapi_fan';
var StorageType = {
    ESPN: 'ESPN',
    LOCAL_STORAGE: 'LOCAL_STORAGE'
};

var ls = {
    getItem: function getItem(key) {
        return _bluebird2.default.resolve(JSON.parse(localStorage.getItem(key)));
    },
    setItem: function setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
};

/**
 * @class {Storage} - This class uses ESPN storage if available, and local storage if not
 */

var Storage = function () {
    /**
     * @constructor
     * @param {int} expiration - expiration of storage in minutes
     */
    function Storage() {
        var expiration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

        _classCallCheck(this, Storage);

        this.expiration = expiration;
        // default to localstorage.  we will infer storage type at the time [get/set]Fan is called
        this.storageType = StorageType.LOCAL_STORAGE;
    }

    /**
     * This function sets appropriate properties if ESPN storage is available.  Does not set it twice if already determined.
     */


    _createClass(Storage, [{
        key: 'inferStorageType',
        value: function inferStorageType() {
            if (this.storageType !== StorageType.ESPN && window && window.espn && window.espn.storageFactory) {
                this.storageType = StorageType.ESPN;
                this.espnStorage = espn.storageFactory.getMostPermanent();
            }
        }
    }, {
        key: 'getFan',
        value: function getFan() {
            var _this = this;

            this.inferStorageType();
            if (this.storageType === StorageType.ESPN) {
                return new _bluebird2.default(function (resolve, reject) {
                    var cache = _this.espnStorage.getItem(ESPN_FAN_STORAGE_KEY);
                    var fan = cache && cache.item;
                    if (fan) {
                        // keep local storage in sync with espn storage
                        ls.setItem(ESPN_FAN_STORAGE_KEY, {
                            item: fan,
                            id: fan.id,
                            timestamp: Date.now()
                        });
                        resolve(cache);
                    } else {
                        reject(new Error('No item for key'));
                    }
                });
            }
            return ls.getItem(ESPN_FAN_STORAGE_KEY);
        }

        /**
         * @param {object} fan - The fan to replace the current cache
         */

    }, {
        key: 'setFan',
        value: function setFan(fan) {
            this.inferStorageType();
            // always set local storage cache
            ls.setItem(ESPN_FAN_STORAGE_KEY, {
                item: fan.item,
                id: fan.id,
                timestamp: Date.now()
            });

            // only set espn storage if present
            if (this.storageType === StorageType.ESPN) {
                this.espnStorage.setItem(ESPN_FAN_STORAGE_KEY, {
                    item: fan.item,
                    id: fan && fan.id,
                    expiresAt: new Date().getTime() + this.expiration * 60000
                });
            }
        }
    }]);

    return Storage;
}();

exports.default = Storage;
},{"bluebird":22}],43:[function(require,module,exports){
'use strict';

var _FanAPI = require('./FanAPI');

var _FanAPI2 = _interopRequireDefault(_FanAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _FanAPI2.default;
},{"./FanAPI":41}],44:[function(require,module,exports){
'use strict';

/* globals videojs */

(function () {
  'use strict';

  function fireTrackingBeacon(beaconURL, airingID, adID) {
    var img, imgID;

    if (!beaconURL) return;

    // Using an img tag to avoid CORS issues
    imgID = 'passThroughTracking';
    img = document.getElementById(imgID);
    if (!img) {
      img = new Image();
      img.id = imgID;
      document.body.appendChild(img);
    }
    img.src = beaconURL + '&caid=' + airingID + '&pvrn=' + Date.now() + '&resp=ad;adid=' + encodeURIComponent(adID) + '&airing=' + airingID + ';ptgt=a&slau=midroll';
    return;
  }

  function init() {
    var plugin;

    plugin = function plugin() {
      var player, lastID;

      player = this;

      if (typeof player.id3 === 'function') {
        player.id3();
      }

      player.on('espn.id3cuechange', function (event, cue) {
        var adID, payload;

        if (cue.owner === 'com.espn.authnet.transition') {
          // console.debug('APT: '+cue.text);
          payload = JSON.parse(cue.text);

          if (payload.to.type === 'COMMERCIAL') {
            adID = payload.to.id;
            if (adID) {
              if (adID !== lastID) {
                lastID = adID;
                fireTrackingBeacon(player.mediainfo.passThroughBeaconURL, player.mediainfo.simulcastAiringId, adID);
              } else {
                console.warn('APT: Skipping duplicate adID: ' + adID);
              }
            } else {
              console.warn('APT: No valid Ad ID available to send.');
            }
          } else {
            lastID = null;
          }
        }
      });
    };

    videojs.plugin('adPassThrough', plugin);
  }

  module.exports = {
    init: init
  };
}).call(undefined);

},{}],45:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  /* global videojs */

  var formatTime, init;

  formatTime = function formatTime(seconds, guide) {
    var gh, gm, h, m, s;
    if (guide == null) {
      guide = seconds;
    }
    seconds = seconds < 0 ? 0 : seconds;
    s = Math.floor(seconds % 60);
    m = Math.floor(seconds / 60 % 60);
    h = Math.floor(seconds / 3600);
    gm = Math.floor(guide / 60 % 60);
    gh = Math.floor(guide / 3600);
    if (isNaN(seconds) || seconds === Infinity) {
      h = m = s = '-';
    }
    h = h > 0 || gh > 0 ? h + ':' : '';
    m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
    s = s < 10 ? '0' + s : s;
    return h + m + s;
  };

  init = function init() {
    var Component, ControlBar, ESPNAdRemainingTimeDisplay, RemainingTimeDisplay, currentTimeDisplayIndex;
    Component = videojs.getComponent('Component');
    ControlBar = videojs.getComponent('ControlBar');
    RemainingTimeDisplay = videojs.getComponent('RemainingTimeDisplay');
    ESPNAdRemainingTimeDisplay = videojs.extend(RemainingTimeDisplay, {
      constructor: function constructor(player, options) {
        return RemainingTimeDisplay.call(this, player, options);
      },
      createEl: function createEl() {
        var el;
        el = Component.prototype.createEl.call(this, 'div', {
          className: 'vjs-ad-remaining-time vjs-time-control vjs-control'
        });
        this.contentEl_ = document.createElement('div');
        this.contentEl_.classList.add('vjs-ad-remaining-time-display');
        this.contentEl_.innerHTML = "<span class=\"vjs-control\">" + this.localize('Ad') + "</span> (0:00)";
        this.contentEl_.setAttribute('aria-live', 'off');
        el.appendChild(this.contentEl_);
        return el;
      },
      updateContent: function updateContent() {
        var formattedTime, localizedText;
        if (this.player_.duration()) {
          localizedText = this.localize('Ad');
          formattedTime = formatTime(this.player_.remainingTime());
          if (formattedTime !== this.formattedTime_) {
            this.formattedTime_ = formattedTime;
            this.contentEl_.innerHTML = "<span class=\"vjs-control\">" + localizedText + "</span> (" + formattedTime + ")";
          }
        }
      }
    });
    Component.registerComponent('AdRemainingTimeDisplay', ESPNAdRemainingTimeDisplay);
    if (ControlBar.prototype.options_.children.indexOf('adRemainingTimeDisplay') === -1) {
      currentTimeDisplayIndex = ControlBar.prototype.options_.children.indexOf('currentTimeDisplay');
      ControlBar.prototype.options_.children.splice(currentTimeDisplayIndex, 0, 'adRemainingTimeDisplay');
    }
  };

  module.exports = {
    init: init
  };
}).call(undefined);

},{}],46:[function(require,module,exports){
/* globals videojs */
'use strict';

function init() {
  var plugin;

  /*
    Set up bandwidth persistence in sessionStorage.
   */
  plugin = function plugin(opts) {
    var dispose, getTech, hlsTech, player, resetBandwidth, restoreBandwidth, storeBandwidth;

    player = this;

    var options = opts || {};
    var storageNamespace = options.namespace || 'espn';
    var bandwidthStorageKey = storageNamespace + '-' + 'bandwidth';
    var initialBandwidth = options.initialBandwidth || 1500000; //2097152

    getTech = function getTech() {
      hlsTech = player.tech({
        IWillNotUseThisInPlugins: true
      }).hls;
    };

    restoreBandwidth = function restoreBandwidth() {
      getTech();
      if (hlsTech) {
        var persistedBandwidth = sessionStorage.getItem(bandwidthStorageKey);
        if (persistedBandwidth != null) {
          persistedBandwidth = Number(persistedBandwidth);
        } else {
          persistedBandwidth = initialBandwidth;
        }
        if (!Number.isNaN(persistedBandwidth)) {
          console.log('Setting bandwidth: ' + persistedBandwidth);
          hlsTech.bandwidth = persistedBandwidth;
        }
      }
      player.on('loadstart', getTech);
    };

    storeBandwidth = function storeBandwidth() {
      if (hlsTech) {
        var bandwidth = hlsTech.bandwidth;
        if (bandwidth > 1) {
          sessionStorage.setItem(bandwidthStorageKey, bandwidth);
        }
      }
    };

    resetBandwidth = function resetBandwidth() {
      sessionStorage.setItem(bandwidthStorageKey, null);
      if (hlsTech) {
        hlsTech.bandwidth = 1;
      }
    };

    dispose = function dispose() {
      player.off('error', resetBandwidth);
      player.off('loadstart', getTech);
      player.off('mediachange', storeBandwidth);
    };

    player.one('dispose', dispose);
    player.one('loadstart', restoreBandwidth);
    player.on('error', resetBandwidth);
    player.on('mediachange', storeBandwidth);
  };

  videojs.plugin('persistBandwidth', plugin);
}

module.exports = {
  init: init
};

},{}],47:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  /* global videojs */

  var init;

  init = function init() {
    var CaptionsToggleButton, Component, ESPNCaptionSettingsMenuItem, TextTrackMenuItem;
    Component = videojs.getComponent('Component');
    TextTrackMenuItem = videojs.getComponent('TextTrackMenuItem');
    CaptionsToggleButton = videojs.getComponent('CaptionsToggleButton');
    ESPNCaptionSettingsMenuItem = videojs.extend(TextTrackMenuItem, {
      constructor: function constructor(player, options) {
        var changeHandler;
        options.track = {
          kind: options.kind,
          player: player,
          label: "<span>" + player.localize(options.label || 'Caption Settings') + "</span>",
          selectable: false,
          "default": false,
          mode: 'disabled'
        };
        options.selectable = false;

        TextTrackMenuItem.call(this, player, options);
        this.addClass('vjs-texttrack-settings');

        this.hide();

        changeHandler = this.handleTracksChange.bind(this);
        player.on('texttrackchange', changeHandler);
        player.on('espn.captionchange', changeHandler);
        this.on('dispose', function () {
          player.off('texttrackchange', changeHandler);
          player.off('espn.captionchange', changeHandler);
        });
      },
      handleClick: function handleClick() {
        var textTrackSettings, videoWasPlaying;
        textTrackSettings = this.player_.$('.bcc-caption-settings');
        textTrackSettings.classList.remove('vjs-hidden');
        videoWasPlaying = !this.player_.paused();
        this.player_.addClass('vjs-caption-settings-active');
        this.player_.pause();

        this.player_.$('.vjs-done-button', textTrackSettings).addEventListener('click', function () {
          this.player_.removeClass('vjs-caption-settings-active');
          if (videoWasPlaying) {
            this.player_.play();
          }
        }.bind(this));

        return textTrackSettings.focus();
      },
      handleTracksChange: function handleTracksChange() {
        if (this.hasValidTracks()) {
          this.show();
        } else {
          this.hide();
        }
      },
      hasValidTracks: CaptionsToggleButton.prototype.hasValidTracks
    });
    return Component.registerComponent('CaptionSettingsMenuItem', ESPNCaptionSettingsMenuItem);
  };

  module.exports = {
    init: init
  };
}).call(undefined);

},{}],48:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  /* global videojs */

  var init, initialized, plugin, videoJsPlugin, LS_SAVED_LANGUAGE;

  initialized = false;

  LS_SAVED_LANGUAGE = 'bgs-saved-language';

  init = function init() {
    var Button, Component, ESPNCaptionsToggleButton;
    Component = videojs.getComponent('Component');
    Button = videojs.getComponent('Button');
    ESPNCaptionsToggleButton = videojs.extend(Button, {
      constructor: function constructor(player, options) {
        var changeHandler;
        Button.call(this, player, options);
        this.controlText(options && options.controlText || this.localize('Closed Captions'));

        this.hide();

        changeHandler = this.handleTracksChange.bind(this);
        player.on('texttrackchange', changeHandler);
        player.on('espn.captionchange', changeHandler);
        this.on('dispose', function () {
          player.off('texttrackchange', changeHandler);
          player.off('espn.captionchange', changeHandler);
        });
      },
      buildCSSClass: function buildCSSClass() {
        return "evp-toggle-cc-button vjs-captions-button cc-disabled " + Button.prototype.buildCSSClass.call(this);
      },
      handleClick: function handleClick(event) {
        this.toggleTracks();
        return Button.prototype.handleClick.call(this, event);
      },
      createEl: function createEl(tag, props, attributes) {
        return Button.prototype.createEl.call(this, tag, props, attributes);
      },
      handleTracksChange: function handleTracksChange() {
        if (this.hasValidTracks()) {
          this.show();
        } else {
          this.hide();
        }

        if (this.tracksEnabled()) {
          this.el_.classList.remove('cc-disabled');
        } else {
          this.el_.classList.add('cc-disabled');
        }
      },
      toggleTracks: function toggleTracks() {
        var i, len, tracks;
        tracks = this.player_.textTracks();

        for (i = 0, len = tracks.length; i < len; i++) {
          if (tracks[i].kind !== 'captions') {
            continue;
          }

          if (tracks[i].mode === 'disabled') {
            tracks[i].mode = 'showing';
            continue;
          }
          if (tracks[i].mode === 'showing') {
            tracks[i].mode = 'hidden';
            window.localStorage.setItem(LS_SAVED_LANGUAGE, 'off');
          } else {
            tracks[i].mode = 'showing';
            window.localStorage.setItem(LS_SAVED_LANGUAGE, tracks[i].language + '-' + tracks[i].label);
          }
        }
        this.player_.trigger('espn.captionchange');
      },
      tracksEnabled: function tracksEnabled() {
        var i, isEnabled, len, storedLanguage, tracks;
        tracks = this.player().textTracks();
        isEnabled = false;
        storedLanguage = window.localStorage.getItem(LS_SAVED_LANGUAGE);
        for (i = 0, len = tracks.length; i < len; i++) {
          if (tracks[i].kind !== 'captions') {
            continue;
          }

          if (storedLanguage === tracks[i].language + '-' + tracks[i].label) {
            if (tracks[i].mode === 'disabled') {
              // Wait a tick to set the mode.
              // Not entirely sure why this works, but setting the mode
              // directly doesn't work.
              setTimeout(function () {
                this.mode = 'showing';
              }.bind(tracks[i]), 0);
            }
            isEnabled = true;
            continue;
          }

          if (tracks[i].mode === 'disabled') {
            // Chrome won't fire `cuechange` events on tracks that have not had a mode of `showing`.
            // Doing this janky dance seems to fix that issue.
            tracks[i].mode = 'showing';
            tracks[i].mode = 'hidden';
            continue;
          }
          if (tracks[i].mode === 'showing') {
            isEnabled = true;
            continue;
          }
        }

        if (window.videojs.IS_ANY_SAFARI) {
          this.player().el().querySelector('video').webkitClosedCaptionsVisible = isEnabled;
        }

        return isEnabled;
      },
      kind_: 'captions',
      hasValidTracks: function hasValidTracks() {
        var _changeHandler, handleTracksChange, hasCues, i, len, tracks;
        tracks = this.player().textTracks() || [];
        handleTracksChange = this.handleTracksChange.bind(this);
        _changeHandler = function changeHandler() {
          this.removeEventListener('cuechange', _changeHandler);
          handleTracksChange();
        };

        for (i = 0, len = tracks.length; i < len; i++) {
          if (tracks[i].kind !== 'captions') continue;

          hasCues = tracks[i].cues && tracks[i].cues.length > 0;

          if (!hasCues) {
            tracks[i].addEventListener('cuechange', _changeHandler);
            return false;
          }

          if (hasCues || tracks[i].label || tracks[i].language) {
            return true;
          }
        }

        return false;
      }
    });
    Component.registerComponent('CaptionsToggleButton', ESPNCaptionsToggleButton);
    videojs.plugin('captionsToggleButton', videoJsPlugin);
    initialized = true;
  };

  videoJsPlugin = function videoJsPlugin() {
    var player;
    player = this;
    return player.ready(function () {
      var settingsMenuButtonIndex;
      settingsMenuButtonIndex = player.controlBar.children().map(function (c) {
        return c.name().toUpperCase();
      }).indexOf('SettingsMenuButton'.toUpperCase());

      if (player.controlBar.captionsToggleButton) {
        player.controlBar.removeChild(player.controlBar.captionsToggleButton);
        delete player.controlBar.captionsToggleButton;
      }
      if (player.controlBar.captionsButton) {
        player.controlBar.removeChild(player.controlBar.captionsButton);
      }
      player.controlBar.captionsToggleButton = player.controlBar.addChild('captionsToggleButton', {}, settingsMenuButtonIndex - 1);
    });
  };

  plugin = function plugin(player) {
    if (!initialized) {
      init();
    }
    player.captionsToggleButton();
  };

  module.exports = {
    init: init,
    plugin: plugin
  };
}).call(undefined);

},{}],49:[function(require,module,exports){
'use strict';

/* globals videojs */

(function () {
  'use strict';

  /*
    Some tag data is binary, but an error may be thrown if the data is
    not a Uint8Array, so catch it and just pass it along as a string.
   */

  function textFromFrame(frame) {
    if (typeof frame.data === 'string') {
      return frame.data;
    }
    if (frame.data instanceof ArrayBuffer) {
      frame.data = new Uint8Array(frame.data);
    }
    try {
      return String.fromCharCode.apply(null, frame.data);
    } catch (error) {
      console.warn(error);
      return frame.data;
    }
  }

  function init() {
    var plugin;

    /*
      Set up logging to expose raw ID3 data.
       An aside on ID3 tags:
       BC will expose ID3 frames of type TXXX, WXXX, and PRIV. The latter being
      most relevent to ESPN, as the XML ad markers are in PRIV frames.
       TXXX is a user-defined text tag, and WXXX is a user-defined URL tag.
      See http://id3.org/id3v2.3.0#User_defined_text_information_frame
     */
    plugin = function plugin() {
      var _findMetadata, player;

      player = this;

      _findMetadata = function findMetadata() {
        var allTextTracks, track, trackIndex;

        /*
          Detach this event handler, we'll re-attach it if we don't find metadata.
         */
        player.off('texttrackchange', _findMetadata);
        allTextTracks = player.textTracks();
        trackIndex = allTextTracks.length - 1;

        /*
          Find the latest track, and determine if it is a metadata track,
          re-attaching this event handler and returning if it is not.
         */
        if (trackIndex < 0) {
          player.on('texttrackchange', _findMetadata);
          return;
        }
        track = allTextTracks[trackIndex];
        if (track.kind !== 'metadata') {
          player.on('texttrackchange', _findMetadata);
          return;
        }

        // Chrome/Safari won't fire `cuechange` events on tracks that have a mode of `disabled`.
        // This seems to fix that issue.
        track.mode = 'hidden';

        /*
          We haven't returned, so we have a metadata track. Attach a 'cuechange'
          handler that will expose the ID3 tag data.
         */
        track.addEventListener('cuechange', function () {
          if (track.activeCues.length > 0) {
            for (var i = 0; i < track.activeCues.length; i++) {
              if (track.activeCues[i].value) {
                track.activeCues[i].text = textFromFrame(track.activeCues[i].value);

                // Safari puts the owner in info...
                if (track.activeCues[i].value.owner) {
                  track.activeCues[i].owner = track.activeCues[i].value.owner;
                } else {
                  track.activeCues[i].owner = track.activeCues[i].value.info;
                }

                player.trigger('espn.id3cuechange', track.activeCues[i]);
              }
            }
          }
        });
      };

      this.on('texttrackchange', _findMetadata);
    };

    videojs.plugin('id3', plugin);
  }

  module.exports = {
    init: init
  };
}).call(undefined);

},{}],50:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

function init() {
    var Component = videojs.getComponent('Component');
    var LoadingSpinner = videojs.getComponent('LoadingSpinner');

    var ESPNLoadingSpinner = videojs.extend(LoadingSpinner, {
        constructor: function constructor(player, options) {
            LoadingSpinner.call(this, player, options);
        },
        createEl: function createEl() {
            return Component.prototype.createEl.call(this, 'div', {
                className: 'vjs-loader active',
                dir: 'ltr',
                innerHTML: '<div class="spinner-layer">' + '<div class="circle-clipper left"><div class="circle"></div></div>' + '<div class="gap-patch"><div class="circle"></div></div>' + '<div class="circle-clipper right"><div class="circle"></div>' + '</div></div>'
            });
        }
    });
    Component.registerComponent('LoadingSpinner', ESPNLoadingSpinner);
}

module.exports = {
    init: init
};

},{}],51:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  /* global videojs */

  var init;

  init = function init() {
    var Component, ESPNPlayToggle, PlayToggle;
    Component = videojs.getComponent('Component');
    PlayToggle = videojs.getComponent('PlayToggle');
    ESPNPlayToggle = videojs.extend(PlayToggle, {
      constructor: function constructor(player, options) {
        PlayToggle.call(this, player, options);
        this.on(player, 'durationchange', this.handleDurationChange);
        this.on(player, 'ended', this.handleEnded);
      },
      pauseText: 'Pause',
      playText: 'Play',
      handleDurationChange: function handleDurationChange() {
        if (this.player_.duration() === Infinity) {
          // change the button text to "Stop"
          this.pauseText = 'Stop';
          if (!this.player_.paused()) {
            // the player is currently playing, so we need to manually set the button text
            this.controlText(this.pauseText);
          }
        }
      },
      handleEnded: function handleEnded() {
        this.controlText('Replay');
      },
      handlePlay: function handlePlay() {
        this.removeClass('vjs-paused');
        this.addClass('vjs-playing');
        // change the button text to "Pause"
        this.controlText(this.pauseText);
      },
      handlePause: function handlePause() {
        this.removeClass('vjs-playing');
        this.addClass('vjs-paused');
        // change the button text to "Play"
        this.controlText(this.playText);
      }
    });
    return Component.registerComponent('PlayToggle', ESPNPlayToggle);
  };

  module.exports = {
    init: init
  };
}).call(undefined);

},{}],52:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */
function init() {
    var Component = videojs.getComponent('Component');
    var SeekBar = videojs.getComponent('SeekBar');
    var ESPNSeekBar = videojs.extend(SeekBar, {
        constructor: function constructor(player, options) {
            SeekBar.call(this, player, options);
        },
        createEl: function createEl() {
            var el = SeekBar.prototype.createEl.call(this);
            if (!el.querySelector('.evp-progress-holder-wrapper')) {
                var wrapper = document.createElement('div');
                wrapper.className = 'evp-progress-holder-wrapper';
                el.appendChild(wrapper);
            }
            return el;
        },
        handleMouseDown: function handleMouseDown(event) {
            SeekBar.prototype.handleMouseDown.call(this, event);
            this.scrubbingTime = this.calculateDistance(event);
            this.update();
        },
        handleMouseMove: function handleMouseMove(event) {
            this.scrubbingTime = this.calculateDistance(event);
            this.update();
        },
        handleMouseUp: function handleMouseUp(event) {
            var newTime = this.calculateDistance(event) * this.player_.duration();

            // Don't let video end while scrubbing.
            if (newTime === this.player_.duration()) {
                newTime = newTime - 0.1;
            }

            // Set new time (tell player to seek to new time)
            this.player_.currentTime(newTime);

            return SeekBar.prototype.handleMouseUp.call(this, event);
        },
        getPercent: function getPercent() {
            var percent = SeekBar.prototype.getPercent.call(this);
            if (this.player_.scrubbing()) {
                percent = this.scrubbingTime || percent;
            }
            return percent >= 1 ? 1 : percent;
        }
    });
    Component.registerComponent('SeekBar', ESPNSeekBar);
}

module.exports = {
    init: init
};

},{}],53:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */
var FanPreferences = require('../../fan');
var IS_SAFARI = /^((?!Chrome|Android).)*Safari/i.test(window.navigator && window.navigator.userAgent);

function init() {
    var Component = videojs.getComponent('Component');
    var MenuItem = videojs.getComponent('MenuItem');
    var MenuButton = videojs.getComponent('MenuButton');
    var CaptionSettingsMenuItem = videojs.getComponent('CaptionSettingsMenuItem');
    var CaptionsToggleButton = videojs.getComponent('CaptionsToggleButton');

    var AutoplayMenuItem = videojs.extend(MenuItem, {
        contentElType: 'checkbox',
        constructor: function constructor(player, options) {
            this.isSelected = false;
            options.label = '<span>' + player.localize('Autoplay') + '</span>';
            options.selectable = true;

            MenuItem.call(this, player, options);

            FanPreferences.getAutoStart(function (autoStart) {
                if (this.el_ && (autoStart === true || autoStart === false)) {
                    this.isSelected = autoStart;
                    this.selected(autoStart);
                    this.el_.querySelector('input').checked = this.isSelected;
                }
            }.bind(this));
        }
    });

    AutoplayMenuItem.prototype.handleClick = function () {
        this.isSelected = !this.isSelected;
        this.selected(this.isSelected);
        this.el_.querySelector('input').checked = this.isSelected;
        FanPreferences.setAutoStart(this.isSelected);
        this.player().player_.trigger('espn.autoplaytoggled', { autoplay: this.isSelected });
    };

    AutoplayMenuItem.prototype.createEl = function (type) {
        return MenuItem.prototype.createEl.call(this, type, {
            innerHTML: this.localize(this.options_.label) + '<div class="toggle-btn sm"><input id="autoplay_toggle" class="toggle-input round" type="checkbox"><label for="autoplay_toggle"></label></div>'
        });
    };

    var CaptionsMenuItem = videojs.extend(MenuItem, {
        contentElType: 'checkbox',
        constructor: function constructor(player, options) {
            var changeHandler;
            this.isSelected = true;
            options.label = '<span>' + player.localize('Closed Caption') + '</span>';
            options.selectable = true;
            MenuItem.call(this, player, options);

            this.hide();

            changeHandler = this.handleTracksChange.bind(this);
            player.on('texttrackchange', changeHandler);
            player.on('espn.captionchange', changeHandler);
            this.on('dispose', function () {
                player.off('texttrackchange', changeHandler);
                player.off('espn.captionchange', changeHandler);
            });
        },
        toggleTracks: CaptionsToggleButton.prototype.toggleTracks,
        handleTracksChange: function handleTracksChange() {
            if (this.hasValidTracks()) {
                this.show();
            } else {
                this.hide();
            }

            var tracksEnabled = CaptionsToggleButton.prototype.tracksEnabled.call(this);
            this.isSelected = tracksEnabled;
            this.selected(this.isSelected);
            this.el_.querySelector('input').checked = this.isSelected;
        },
        hasValidTracks: CaptionsToggleButton.prototype.hasValidTracks
    });

    CaptionsMenuItem.prototype.handleClick = function () {
        this.toggleTracks();
        this.handleTracksChange();
    };

    CaptionsMenuItem.prototype.createEl = function (type) {
        return MenuItem.prototype.createEl.call(this, type, {
            innerHTML: this.localize(this.options_.label) + '<div class="toggle-btn sm"><input id="captions_toggle" class="toggle-input round" type="checkbox"' + (this.isSelected ? 'checked ' : '') + '><label for="captions_toggle"></label></div>'
        });
    };

    var SettingsMenuButton = videojs.extend(MenuButton, {
        constructor: function constructor(player, options) {
            MenuButton.call(this, player, options);
            player.on('mouseup', function (e) {
                if (this.buttonPressed_ && !this.el().contains(e.target)) {
                    this.unpressButton(true);
                }
            }.bind(this));
        },
        handleClick: function handleClick() {
            if (this.buttonPressed_) {
                this.unpressButton();
            } else {
                this.pressButton();
            }
        }
    });

    SettingsMenuButton.prototype.createEl = function () {
        return Component.prototype.createEl.call(this, 'div', {
            className: 'vjs-settings-control-button vjs-menu-button vjs-menu-button-popup vjs-control vjs-button',
            innerHTML: '<div class="vjs-control-text">' + this.localize('Settings') + '</div>',
            tabIndex: 0
        }, {
            role: 'menuitem'
        });
    };

    SettingsMenuButton.prototype.pressButton = function () {
        this.player().addClass('vjs-settings-active');
        return MenuButton.prototype.pressButton.call(this);
    };

    SettingsMenuButton.prototype.unpressButton = function (shouldNotFocus) {
        this.player().removeClass('vjs-settings-active');
        if (this.enabled_) {
            this.buttonPressed_ = false;
            this.menu.unlockShowing();
            this.el_.setAttribute('aria-expanded', 'false');
            if (!shouldNotFocus) this.el_.focus();
        }
    };

    SettingsMenuButton.prototype.createItems = function () {
        var autoplayMenuItem, items;

        items = [];
        autoplayMenuItem = new AutoplayMenuItem(this, {});
        autoplayMenuItem.on('click', function () {
            // console.log('toggle autoplay');
        });

        items.push(autoplayMenuItem);
        items.push(new CaptionsMenuItem(this.player_, {}));

        if (!IS_SAFARI) {
            items.push(new CaptionSettingsMenuItem(this.player_, { 'kind': 'captions' }));
        }

        return items;
    };

    videojs.registerComponent('SettingsMenuButton', SettingsMenuButton);
    videojs.plugin('settingsMenu', videoJsPlugin);
}

function videoJsPlugin() {
    var player = this;

    player.ready(function () {
        var fullscreenToggleIndex = player.controlBar.children().map(function (c) {
            return c.name().toUpperCase();
        }).indexOf('FullscreenToggle'.toUpperCase());

        if (player.controlBar.settingsMenuButton) {
            player.controlBar.removeChild(player.controlBar.settingsMenuButton);
            delete player.controlBar.settingsMenuButton;
        }

        player.controlBar.settingsMenuButton = player.controlBar.addChild('settingsMenuButton', {}, fullscreenToggleIndex - 1);
    });
}

function plugin(player) {
    player.settingsMenu();
}

module.exports = {
    init: init,
    plugin: plugin
};

},{"../../fan":17}],54:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

function SocialESPN(options) {
  var SocialButtonESPN = require('./ESPNSocialButton'),
      SocialOverlayESPN = require('./ESPNSocialOverlay');

  var player = this;
  var defaults = {
    title: '',
    description: '',
    url: '',
    offset: '00:00:00',
    services: {
      facebook: true,
      twitter: true,
      google: false,
      tumblr: false,
      pinterest: false,
      linkedin: false,
      email: true
    },
    accountId: 3948005062001
  },

  // Initialize the plugin
  init = function init(options) {
    var settings = videojs.mergeOptions(defaults, options);

    // Make sure that at least one social service is specified
    //  If not, then do not add the social button
    if (!(settings && settings.services && (settings.services.facebook || settings.services.twitter || settings.services.google || settings.services.tumblr || settings.services.pinterest || settings.services.linkedin || settings.services.email))) {
      throw new Error('videojs-social requires at least one service to be enabled');
    }

    // If we are being re-initialized then remove the old stuff
    if (player.controlBar.socialButtonESPN) {
      player.controlBar.removeChild(player.controlBar.socialButtonESPN);
      delete player.controlBar.socialButtonESPN;

      if (player.socialOverlayESPN) {
        player.removeChild(player.socialOverlayESPN);
        delete player.socialOverlayESPN;
      }
    }

    // add the social button to the control bar, and the overlay to the player
    var socialIndex = player.controlBar.children().map(function (c) {
      return c.name().toUpperCase();
    }).indexOf('CustomControlSpacer'.toUpperCase()) + 1;
    player.controlBar.socialButtonESPN = player.controlBar.addChild('socialButtonESPN', settings, socialIndex);
    player.socialOverlayESPN = player.addChild('socialOverlayESPN', settings);

    player.controlBar.socialButtonESPN.el().setAttribute('tabindex', 0);
  };

  videojs.registerComponent('SocialButtonESPN', SocialButtonESPN);
  videojs.registerComponent('SocialOverlayESPN', SocialOverlayESPN);

  init(options);
}

module.exports = SocialESPN;

},{"./ESPNSocialButton":55,"./ESPNSocialOverlay":56}],55:[function(require,module,exports){
"use strict";

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

var SocialButtonESPN = videojs.extend(videojs.Button, {
  constructor: function constructor(player, options) {
    // If we are being recreated, then remove our old self
    if (player.socialButtonESPN) {
      player.controlBar.removeChild(player.socialButtonESPN);
    }

    videojs.Button.call(this, player, options);

    this.on('touchstart', function (e) {
      e.preventDefault();
      player.socialOverlayESPN.show();
      player.addClass("vjs-share-open").removeClass("vjs-controls-disabled");
    });

    // Bind click event for desktop browsers
    this.on('click', function () {
      player.socialOverlayESPN.show();
      player.addClass("vjs-share-open").removeClass("vjs-controls-disabled");
    });
  },

  createEl: function createEl() {
    return videojs.Button.prototype.createEl.call(this, 'button', {
      className: 'vjs-share-control vjs-control vjs-icon-share vjs-button',
      innerHTML: '<div class="vjs-control-content"><span class="vjs-control-text">' + this.player().localize('Share') + '</span></div>'
    }, {
      'aria-live': 'polite'
    });
  }
});

module.exports = SocialButtonESPN;

},{}],56:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

var SocialOverlayESPN = videojs.extend(videojs.Component, {
  constructor: function constructor(player, options) {
    // If we are being recreated, then remove our old self
    if (player.socialOverlayESPN) {
      player.removeChild(player.socialOverlayESPN);
    }

    if (typeof options.pauseOnOpen === 'undefined') {
      options.pauseOnOpen = true;
    }
    if (typeof options.showOffset === 'undefined') {
      options.showOffset = true;
    }

    // Don't show the "Start at" option for live content
    if (player.mediainfo.live) {
      options.showOffset = false;
    }

    videojs.Component.call(this, player, options);

    // Bind service buttons using options
    this._bindServiceButtons(options.services);

    // Grab all the interesting elements
    this.directLinkTextBox = this.el().querySelector('#direct-link-textbox');
    this.directLinkCopy = this.el().querySelector('#direct-link-copy');
    this.directLinkCopyIcon = this.el().querySelector('#directLink');

    this.offsetContainer = this.el().querySelector('#start-offset-container');
    this.offsetTextBox = this.el().querySelector('#start-offset-textbox');
    this.offsetCheckBox = this.el().querySelector('#start-offset-checkbox');

    this.embedCodeTextBox = this.el().querySelector('#embed-code-textbox');
    this.embedCodeCopy = this.el().querySelector('#embed-code-copy');
    this.embedCodeCopyIcon = this.el().querySelector('#embedLink');

    this.socialLinksInputContainer = this.el().querySelector('.vjs-social-links-input-container');
    this.socialLinksInputLabel = this.el().querySelector('#social-links-input-label');
    this.socialLinksTextBox = this.el().querySelector('#social-links-textbox');

    // If the browser doesn't support copy (Looking at you Safari) remove the option
    if (document.queryCommandSupported('copy') === false) {
      Array.prototype.forEach.call(this.el().querySelectorAll('.social-copy-link'), function (el) {
        el.parentNode.removeChild(el);
      });
    }

    /**
      Let events bubble up to parent and handle them here
    */

    // It's cleaner to specifically handle svg clicks because of the html structure
    var _this = this;
    Array.prototype.forEach.call(this.el().querySelectorAll('svg'), function (el) {
      el.addEventListener('click', function (e) {
        var targetEl = e.target;
        if (targetEl.getAttribute('data-behavior') === 'copy-svg') {
          _this._handleCopy(targetEl);
        }
      });
    });

    this.on('keydown', function (event) {
      // Catch escape key and hide dialog when pressed
      if (player.socialOverlayESPN.el().display !== 'none' && event.keyCode === 27) {
        // Hide the overlay, return focus to social button
        player.socialOverlayESPN.hide();
        player.removeClass("vjs-share-open");
      }
    });

    this.on('change', function (event) {
      var targetEl = event.target;
      if (targetEl === this.offsetTextBox) {
        this.offsetTextBox.value = this._cleanupTimeString(this.offsetTextBox.value);

        this.directLinkTextBox.value = this._getDirectLinkWithTime(this.offsetCheckBox.value === "1");
        this._resetDirectLinkState();
      }
    });

    this.on('click', function (event) {
      var targetEl = event.target;
      var behavior = event.target.getAttribute('data-behavior');

      var targetClassName = targetEl.className && typeof targetEl.className === 'string' ? targetEl.className : '';
      if (targetClassName.indexOf('vjs-social-cancel') !== -1) {
        // cancel button
        player.socialOverlayESPN.hide();
        player.removeClass("vjs-share-open");
      } else if (behavior === 'copy') {
        // copy link hit
        event.preventDefault();
        this._handleCopy(targetEl);
      } else if (targetEl === this.offsetCheckBox) {
        // checkbox toggled
        targetEl.value = targetEl.value === "0" ? "1" : "0";
        this.updateState();
        this._resetDirectLinkState();
      } else if (behavior === 'default') {
        this._resetEmbedCodeState();
        this._resetDirectLinkState();
        this.socialLinksInputContainer.className = this.socialLinksInputContainer.className.replace('social-input-container-shown', '');
      }
    });
  },

  createEl: function createEl() {
    var player = this.player(),
        options = this.options_;

    return videojs.Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-social-overlay vjs-modal-dialog vjs-hidden',
      'tabindex': -1,
      innerHTML: '<div class="vjs-social-container" tabindex="0">' + '<button class="vjs-close-button vjs-control vjs-icon-cancel vjs-button vjs-social-cancel">' + '<span class="vjs-control-text" aria-label="' + player.localize('Close button') + '">' + player.localize('Close') + '</span>' + '</button>' + '<div class="vjs-modal-dialog-content" role="document">' + '<form class="social-form">' + '<div class="vjs-social-share-links">' + this._addSocialButtons(options.services) + '<div class="vjs-social-links-input-container">' + '<label id="social-links-input-label" class="vjs-social-label-text" for="social-links-textbox">' + player.localize('URL') + '</label>' + '<input id="social-links-textbox" class="social-links-textbox" type="text" tabindex="10" readonly="true" value="">' + '</div>' + '</div>' + '<div class="vjs-social-direct-link-container vjs-social-direct-link" aria-label="Read Only: Direct Link To Content">' + '<div class="direct-link-header-container">' + '<label class="vjs-social-label-text" for="direct-link-textbox">' + player.localize('URL') + '</label>' + '<span id="start-offset-container">' + '<input type="checkbox" id="start-offset-checkbox" value="0"><label for="start-offset-checkbox">' + player.localize('Start at') + '</label>' + '<input id="start-offset-textbox" class="start-offset-textbox" type="text" title="The offset must be specified using the following pattern: hh:mm:ss" placeholder="hh:mm:ss" maxlength="10" value="00:00:00">' + '</span>' + '<a data-behavior="copy" href="#" id="direct-link-copy" class="social-copy-link">' + player.localize('Copy') + '</a>' + '</div>' + '<input id="direct-link-textbox" class="direct-link-textbox has-link-icon" type="text" tabindex="8" readonly="true" value="">' + '</div>' + '<div class="vjs-social-embed-container vjs-social-embed-code" aria-label="Read Only: Embed Code" style="' + (options.syndicatable ? '' : 'display: none;') + '">' + '<div class="direct-link-header-container">' + '<label for="embed-code-textbox" class="vjs-social-label vjs-social-label-text">' + player.localize('Embed Code') + '</label>' + '<a data-behavior="copy" href="#" id="embed-code-copy" class="social-copy-link">' + player.localize('Copy') + '</a>' + '</div>' + '<input id="embed-code-textbox" class="embed-code-textbox has-link-icon" type="text" tabindex="10" readonly="true" value="">' + '</div>' + '</form>' + '</div>' + '</div>'
    }, {
      'aria-role': 'dialog',
      'aria-label': player.localize('Sharing Dialog')
    });
  },

  clearState: function clearState() {
    this.offsetCheckBox.value = "0";
    this.offsetCheckBox.checked = false;

    this._resetEmbedCodeState();
    this._resetDirectLinkState();

    this.directLinkTextBox.value = this._getDirectLinkWithTime(false);
  },

  updateState: function updateState() {
    var player = this.player(),
        options = this.options_;

    if (!options.showOffset) {
      this.offsetContainer.style.display = 'none';
    }

    var includeTime = this.offsetCheckBox.value === "1" ? true : false;
    if (includeTime) {
      this.offsetTextBox.className += ' offset-active';
    } else {
      this.offsetTextBox.className = this.offsetTextBox.className.replace(/ offset-active/, '');
    }
    var currentPlayerTime = player.ads && player.ads.state !== 'ad-playback' ? this._formatSeconds(player.currentTime()) : '00:00';

    this.offsetTextBox.value = currentPlayerTime;

    if (options.syndicatable) {
      this.embedCodeTextBox.value = this._getEmbedCode();
    }
    this.directLinkTextBox.value = this._getDirectLinkWithTime(includeTime);

    // rebind buttons
    this._bindServiceButtons(options.services);
  },

  hide: function hide() {
    videojs.Component.prototype.hide.call(this);
    var player = this.player();
    player.trigger('socialclosed');

    player.controls(true);
    this.clearState();

    if (this.previouslyPlaying) {
      // #TODO: Figure out why the hell we need to do this
      setTimeout(function () {
        player.play();
      }.bind(this), 0);
    }

    // Set focus back to the social button for accessibility
    player.controlBar.socialButtonESPN.el().focus();
  },

  show: function show() {
    videojs.Component.prototype.show.call(this);
    var player = this.player();
    player.trigger('socialopened');

    this.updateState();

    player.controls(false);
    if (this.options_.pauseOnOpen) {
      if (!player.paused()) {
        this.previouslyPlaying = true;
        player.pause();
      } else {
        this.previouslyPlaying = false;
      }
    }
    // Set focus to first social service link
    this.el().querySelector('.vjs-social-share-links a:first-child').focus();
  }
});

SocialOverlayESPN.prototype._getMailToLink = function () {
  var options = this.options_,
      mailToLink = options.mailToLink;

  var directLink = this._getDirectLinkWithTime(false);
  var bodyPrefix = this.player().localize('Check out this video on ESPN');

  mailToLink = mailToLink.replace('{{subject}}', encodeURIComponent(options.title)).replace('{{body}}', bodyPrefix + ': ' + encodeURIComponent(directLink));

  return mailToLink;
};

SocialOverlayESPN.prototype._resetEmbedCodeState = function () {
  var player = this.player();
  this.embedCodeCopy.className = this.embedCodeCopy.className.replace(/ copied/, '');
  if (this.embedCodeCopyIcon) {
    this.embedCodeCopyIcon.parentNode.className = this.embedCodeCopyIcon.parentNode.className.replace(/ copied/, '');
  }
  this.embedCodeCopy.textContent = player.localize('Copy');
};

SocialOverlayESPN.prototype._resetDirectLinkState = function () {
  var player = this.player();
  this.directLinkCopy.className = this.directLinkCopy.className.replace(/ copied/, '');
  if (this.directLinkCopyIcon) {
    this.directLinkCopyIcon.parentNode.className = this.directLinkCopyIcon.parentNode.className.replace(/ copied/, '');
  }
  this.directLinkCopy.textContent = player.localize('Copy');
};

SocialOverlayESPN.prototype._setSocialLinksInput = function (value) {
  this.socialLinksTextBox.value = value;
  this.socialLinksInputContainer.className += ' social-input-container-shown';
  this.socialLinksTextBox.select();
};

SocialOverlayESPN.prototype._handleCopy = function (targetEl) {
  var isEmbedIcon = targetEl === this.embedCodeCopyIcon,
      isEmbedLink = targetEl === this.embedCodeCopy,
      isDirectLinkIcon = targetEl === this.directLinkCopyIcon,
      isDirectLink = targetEl === this.directLinkCopy;
  var player = this.player();

  // Reset state of copyable elements
  this._resetEmbedCodeState();
  this._resetDirectLinkState();
  this.socialLinksInputContainer.className = this.socialLinksInputContainer.className.replace('social-input-container-hidden', '');
  this.socialLinksInputContainer.className = this.socialLinksInputContainer.className.replace('social-input-container-shown', '');

  // Select the appropriate input box
  if (isDirectLink) {
    this.directLinkTextBox.select();
  } else if (isEmbedLink) {
    this.embedCodeTextBox.select();
  }

  if (isDirectLinkIcon || isDirectLink) {
    this._setSocialLinksInput(this.directLinkTextBox.value);
  } else if (isEmbedIcon || isEmbedLink) {
    this._setSocialLinksInput(this.embedCodeTextBox.value);
  }

  this.socialLinksInputLabel.textContent = isEmbedIcon || isEmbedLink ? this.player().localize('Embed Code') : this.player().localize('URL');

  try {
    // copy to clipboard
    if (document.execCommand('copy')) {
      if (isEmbedLink || isEmbedIcon) {
        this.embedCodeCopy.className += ' copied';
        this.embedCodeCopy.textContent = this.embedCodeCopy.className.indexOf('copied') !== -1 ? player.localize("Copied") : player.localize("Copy");
        if (this.embedCodeCopyIcon) {
          this.embedCodeCopyIcon.parentNode.className += ' copied';
        }
      } else if (isDirectLink || isDirectLinkIcon) {
        this.directLinkCopy.className += ' copied';
        this.directLinkCopy.textContent = this.directLinkCopy.className.indexOf('copied') !== -1 ? player.localize("Copied") : player.localize("Copy");
        if (this.directLinkCopyIcon) {
          this.directLinkCopyIcon.parentNode.className += ' copied';
        }
      }
    }
  } catch (err) {
    console.error('Oops, unable to copy', err);
  }
};

/*
* Iterates through the list of selected social services and binds the href to the anchor
*/
SocialOverlayESPN.prototype._bindServiceButtons = function (serviceButtons) {
  var options = this.options_,
      service,
      encodedUrl,
      encodedTitle,
      encodedDescription,
      encodedPoster,
      posterUrl = this.player().poster();

  // Encode share url properties
  encodedUrl = encodeURIComponent(this._getUrl());
  encodedTitle = encodeURIComponent(this._getTitle());
  encodedDescription = encodeURIComponent(options.description);

  // if there is a poster image, encode the url
  if (posterUrl) {
    encodedPoster = encodeURIComponent(posterUrl);
  }

  // Iterate through supported services and bind buttons
  for (service in serviceButtons) {
    if (serviceButtons[service] === true) {
      this._bindServiceButton(service, encodedUrl, encodedTitle, encodedDescription, encodedPoster);
    }
  }
};

/*
*  Binds the correct href url to the matching service button
*/
SocialOverlayESPN.prototype._bindServiceButton = function (service, encodedUrl, encodedTitle, encodedDescription, encodedPoster) {
  // Switch on the requested service
  switch (service) {
    // Facebook
    case 'facebook':
      // Bind Facebook button
      this._attachServiceButtonHandler('.vjs-icon-facebook', 'https://www.facebook.com/sharer/sharer.php?u={URL}&title={TITLE}'.replace('{URL}', encodedUrl).replace('{TITLE}', encodedTitle));
      break;

    // Google+
    case 'google':
      // Bind Google+ button
      this._attachServiceButtonHandler('.vjs-icon-gplus', 'https://plus.google.com/share?url={URL}'.replace('{URL}', encodedUrl));
      break;

    // Twitter
    case 'twitter':
      // Bind Twitter button
      this._attachServiceButtonHandler('.vjs-icon-twitter', 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fabout.twitter.com%2Fresources%2Fbuttons&text={TITLE}&tw_p=tweetbutton&url={URL}'.replace('{URL}', encodedUrl).replace('{TITLE}', encodedTitle));
      break;

    // Tumblr
    case 'tumblr':
      // Bind Tumblr button
      this._attachServiceButtonHandler('.vjs-icon-tumblr', 'http://www.tumblr.com/share?v=3&u={URL}&t={TITLE}'.replace('{URL}', encodedUrl).replace('{TITLE}', encodedTitle));
      break;

    // Pinterest
    case 'pinterest':
      // Bind Pinterest button if there is a poster image available otherwise the link will not work
      this._attachServiceButtonHandler('.vjs-icon-pinterest', 'https://pinterest.com/pin/create/button/?url={URL}{POSTER}&description={TITLE}&is_video=true'.replace('{URL}', encodedUrl).replace('{TITLE}', encodedTitle).replace('{POSTER}', encodedPoster ? '&media=' + encodedPoster : ''));
      break;

    // LinkedIn
    case 'linkedin':
      // Bind LinkedIn button
      this._attachServiceButtonHandler('.vjs-icon-linkedin', 'https://www.linkedin.com/shareArticle?mini=true&url={URL}&title={TITLE}&summary={DESCRIPTION}&source=Classic'.replace('{URL}', encodedUrl).replace('{TITLE}', encodedTitle).replace('{DESCRIPTION}', encodedDescription));
      break;

    // Email
    case 'email':
      // Bind Email button
      this._attachServiceButtonHandler('.vjs-icon-email', this._getMailToLink());
      break;

    // Direct link (for small sizes)
    case 'directlink':
      // Bind Direct Link button
      this._attachServiceButtonHandler('.vjs-icon-directlink');
      break;

    // Embed (for small sizes)
    case 'embed':
      // Embed Link button
      this._attachServiceButtonHandler('.vjs-icon-embed');
      break;

    default:
      throw new Error('An unsupported social service was specified.');
  }
};

SocialOverlayESPN.prototype._handleServiceButtonClick = function (e) {
  var behavior = e.target.getAttribute('data-behavior');
  if (behavior !== 'show-email') {
    e.preventDefault();
  }
  if (behavior === 'default' || behavior === 'twitter' && typeof window.twttr === 'undefined') {
    window.open(e.target.href, '_blank', 'width=600, height=400, top=100, left=100, titlebar=yes, modal=yes, resizable=yes, toolbar=no, status=1, location=no, menubar=no, centerscreen=yes');
  }
};

/*
 * Computes the new embed code
 */
SocialOverlayESPN.prototype._getEmbedCode = function () {
  var embedCode = this.options_.embedCode;
  return embedCode;
};

/*
 * Determines the URL to be dispayed in the share dialog
 */
SocialOverlayESPN.prototype._getUrl = function () {
  var url,
      options = this.options_;

  // Determine the custom base url
  // In IE8, window.parent doesn't === window, but it does == equal it.
  // jshint -W116
  if (options.url) {
    url = options.url;
  } else if (window.parent != window) {
    url = document.referrer;
  } else {
    url = window.location.href;
  }
  // jshint +W116

  return url;
};

SocialOverlayESPN.prototype._getDirectLinkWithTime = function (includeTime) {
  var player = this.player(),
      url = this._getUrl(),
      offset;

  // Get the start offset textbox (Only include offset if deeplinking is enabled)
  if (includeTime) {
    offset = this.offsetTextBox.value;
  }

  // Append the offset if available
  if (offset) {
    if (this._deFormatSeconds(offset) >= player.duration()) {
      this.offsetTextBox.value = offset = this._formatSeconds(player.currentTime()) || '00:00';
    }

    var offsetArr = offset.split(':');
    var param = '';
    var unit = '';
    for (var i = 0, len = offsetArr.length; i < len; i++) {
      switch (i) {
        case 0:
          unit = 's';
          break;
        case 1:
          unit = 'm';
          break;
        case 2:
          unit = 'h';
          break;
        default:
      }
      param = offsetArr.pop() + unit + param;
    }

    var sep = url.indexOf('?') !== -1 ? '&' : '?';
    url = url + sep + 't=' + param;
  }

  return url;
};

/*
 * Updates the title based on the media date or the custom options setting
 */
SocialOverlayESPN.prototype._getTitle = function () {
  var playerOptions,
      options = this.options_,
      title = options.title;

  // If there's no title try and find one in the options
  if (!title) {
    // Get player options
    playerOptions = this.player().options_;

    // Search the player options data media for a title
    if (playerOptions['data-media'] && playerOptions['data-media'].title) {
      title = playerOptions['data-media'].title;
    }
  }

  return title || '';
};
/*
 * Unobtrusively attaches events to a button
 */
SocialOverlayESPN.prototype._attachServiceButtonHandler = function (elementSelector, url) {
  var el = this.el().querySelector(elementSelector);

  // If element found then bind events, if not found, it isn't a supported service
  if (el) {
    el.player = this;
    el.href = url || '#';

    // re-add event listeners
    el.removeEventListener('touchend', this._handleServiceButtonClick, false);
    el.addEventListener('touchend', this._handleServiceButtonClick, false);

    el.removeEventListener('click', this._handleServiceButtonClick, false);
    el.addEventListener('click', this._handleServiceButtonClick, false);
  }
};

/*
 * Iterates through the list of selected social services and creates their html
 */
SocialOverlayESPN.prototype._addSocialButtons = function (services) {
  var servicesHtml, service;

  // Iterate through supported services and construct html
  servicesHtml = '';
  for (service in services) {
    if (services[service] === true) {
      servicesHtml += this._addServiceButton(service);
    }
  }

  // return html
  return servicesHtml;
};

/*
 * addServiceButton - Creates a link that appears as a social sharing button.
 */
SocialOverlayESPN.prototype._addServiceButton = function (service) {
  var player = this.player();
  var link = '';

  // Switch on the requested service
  switch (service) {
    // Facebook
    case 'facebook':
      link = '<a data-behavior="default" class="vjs-social-share-link vjs-icon-facebook" aria-role="link" aria-label="Share on Facebook" tabindex="1" title="Facebook" target="_blank"><span class="vjs-control-text">Facebook</span></a>';
      break;

    // Google+
    case 'google':
      link = '<a data-behavior="default" class="vjs-social-share-link vjs-icon-gplus" aria-role="link" aria-label="Share on Google Plus" tabindex="2" title="Google+" target="_blank"><span class="vjs-control-text">Google+</span></a>';
      break;

    // Twitter
    case 'twitter':
      link = '<a data-behavior="twitter" class="vjs-social-share-link vjs-icon-twitter" aria-role="link" aria-label="Share on Twitter" tabindex="3" title="Twitter" target="_blank"><span class="vjs-control-text">Twitter</span></a>';
      break;

    // Tumblr
    case 'tumblr':
      link = '<a data-behavior="default" class="vjs-social-share-link vjs-icon-tumblr" aria-role="link" aria-label="Share on Tumblr" tabindex="4" title="Tumblr" target="_blank"><span class="vjs-control-text">tumblr</span></a>';
      break;

    // Pinterest
    case 'pinterest':
      link = '<a data-behavior="default" class="vjs-social-share-link vjs-icon-pinterest" aria-role="link" aria-label="Share on Pinterest" tabindex="5" title="Pinterest" target="_blank"><span class="vjs-control-text">Pinterest</span></a>';
      break;

    // LinkedIn
    case 'linkedin':
      link = '<a data-behavior="default" class="vjs-social-share-link vjs-icon-linkedin" aria-role="link" aria-label="Share on LinkedIn" tabindex="6" title="LinkedIn" target="_blank"><span class="vjs-control-text">LinkedIn</span></a>';
      break;

    // Email
    case 'email':
      link = '<a data-behavior="show-email" class="vjs-social-share-link vjs-icon-email" aria-role="link" aria-label="Share via Email" tabindex="7" title="Email"><span class="vjs-control-text">' + player.localize('Email') + '</span></a>';
      break;

    // Direct Link
    case 'directlink':
      link = '<a class="vjs-social-share-link vjs-icon-directlink" aria-role="link" aria-label="Direct link" tabindex="8" title="Direct Link"><svg data-behavior="copy-svg" id="directLink" x="0px" y="0px" viewBox="119.1 223.8 356.4 359.4" enable-background="new 119.1 223.8 356.4 359.4" xml:space="preserve"><path fill="#FFFFFF" d="M290.9,310.1c-10.4,10.4-14.9,22.3-14.9,35.7c0,13.4,4.5,26.8,13.4,37.2l17.9-17.9 c-4.5-6-7.4-11.9-7.4-19.3c0-7.4,3-13.4,7.4-19.3l69.9-69.9c6-6,11.9-7.4,19.3-7.4s14.9,3,19.3,7.4l26.8,26.8 c6,6,7.4,11.9,7.4,19.3c0,7.4-3,14.9-7.4,19.3l-69.9,69.9c-6,6-11.9,7.4-19.3,7.4c-7.4,0-13.4-3-19.3-7.4l-16.4,19.3 c10.4,8.9,22.3,13.4,37.2,13.4c13.4,0,26.8-6,35.7-14.9l69.9-69.9c10.4-10.4,14.9-22.3,14.9-37.2c0-14.9-6-26.8-14.9-37.2 l-26.8-26.8c-10.4-10.4-22.3-14.9-37.2-14.9c-14.9,0-26.8,4.5-37.2,14.9L290.9,310.1z"/><path fill="#FFFFFF" d="M243.3,440.3c-4.5,4.5-6,11.9,0,17.9c4.5,4.5,13.4,4.5,17.9,0l91.5-91.5c4.5-4.5,4.5-13.4,0-17.9 c-6-6-13.4-4.5-17.9,0L243.3,440.3z"/><path fill="#FFFFFF" d="M133.9,467.1c-10.4,10.4-14.9,22.3-14.9,37.2s4.5,26.8,14.9,37.2l26.8,26.8 c10.4,10.4,22.3,14.9,37.2,14.9s26.8-6,37.2-14.9l69.9-69.9c10.4-10.4,14.9-22.3,14.9-35.7s-4.5-26.8-13.4-37.2l-19.3,16.4 c6,6,7.4,11.9,7.4,19.3c0,7.4-3,13.4-7.4,19.3l-69.9,69.9c-6,6-11.9,7.4-19.3,7.4c-7.4,0-14.9-3-19.3-7.4l-26.8-26.8 c-6-4.5-7.4-11.9-7.4-19.3c0-7.4,3-14.9,7.4-19.3l69.9-69.9c6-6,11.9-7.4,19.3-7.4c7.4,0,13.4,3,19.3,7.4l17.9-17.9 c-10.4-10.4-22.3-14.9-37.2-13.4c-13.4,0-26.8,6-35.7,14.9L133.9,467.1z"/></svg><span class="vjs-control-text">Copy Link</span></a>';
      break;

    // Embed
    case 'embed':
      link = '<a class="vjs-social-share-link vjs-icon-embed" aria-role="link" aria-label="Embed link" tabindex="9" title="Embed"><svg data-behavior="copy-svg" id="embedLink" x="0px" y="0px" viewBox="119.1 293 357.2 256" enable-background="new 119.1 293 357.2 256" xml:space="preserve"><path fill="#FFFFFF" d="M476.2,423.2l-81.1,81.1l-9.7-9.7l70.7-71.4l-70.7-70.7l9.7-9.7L476.2,423.2z"/><polygon fill="#FFFFFF" points="261.9,548.9 249.3,546 326.7,293 339.3,295.2  "/><path fill="#FFFFFF" d="M119.1,423.2l81.1-80.4l9.7,9.7l-70.7,70.7l70.7,71.4l-9.7,9.7L119.1,423.2z"/></svg></span><span class="vjs-control-text">Copy Embed Link</span></a>';
      break;

    default:
      throw new Error('An unsupported social service was specified.');
  }

  // Return the constructed link
  return link;
};

SocialOverlayESPN.prototype._zeroPadNumber = function (number) {
  return String(number).length === 1 ? '0' + number : number;
};

SocialOverlayESPN.prototype._cleanupTimeString = function (value) {
  var parts = value.split(":");

  // If there is no colon, we're assuming the user is just inserting seconds
  if (parts.length === 1) {
    return this._formatSeconds(parts[0]);

    // Otherwise, ignore non numerical inputs and replace them with '00'
  } else {
    for (var i = 0, len = parts.length; i < len; i++) {
      parts[i] = isNaN(parseInt(parts[i])) ? '00' : this._zeroPadNumber(parseInt(parts[i]));
    }
  }

  return parts.join(":");
};

SocialOverlayESPN.prototype._formatSeconds = function (seconds) {
  var secs = Number(seconds);

  // Handle for NaN seconds passed in
  if (isNaN(secs)) return "00:00";

  var h = Math.floor(secs / 3600),
      m = Math.floor(secs % 3600 / 60),
      s = Math.floor(secs % 3600 % 60);

  // pad with a leading 0 if less than 10
  h = h > 0 ? (h < 10 ? '0' + h : h) + ':' : '';
  m = (m > 0 ? m < 10 ? '0' + m : m : '00') + ':';
  s = s < 10 ? '0' + s : s;

  return h + m + s;
};

SocialOverlayESPN.prototype._deFormatSeconds = function (value) {
  var parts = value.split(":");

  // If there is no colon, we're assuming the value _is_ seconds
  if (parts.length === 1) {
    if (isNaN(parts[0] * 1)) {
      return 0;
    }

    return parts[0] * 1;
  }

  var s = parts.pop() * 1,
      m = (parts.pop() || 0) * 60,
      h = (parts.pop() || 0) * 3600;

  return h + m + s;
};

module.exports = SocialOverlayESPN;

},{}],57:[function(require,module,exports){
/* globals videojs */
'use strict';

function init() {
  var volume, muted, plugin;
  volume = 1;
  muted = false;

  plugin = function plugin(opts) {
    var adControlBar, _dispose, fwPlugin, options, player, mouseOut, muteStorageKey, onAdsRequest, onFlashAdVolumeChange, onReady, onVolumeChange, persistedMute, persistedVolume, storageNamespace, volumeMenuButton, volumeStorageKey;
    player = this;

    options = opts || {};
    storageNamespace = options.namespace || 'espn';
    volumeStorageKey = storageNamespace + '-' + 'volume';
    muteStorageKey = storageNamespace + '-' + 'mute';

    if (options.value !== null && options.value !== undefined) {
      // Use the specified volume config, if provided
      volume = options.value;
      localStorage.setItem(volumeStorageKey, volume);
    } else {
      // if no config, try to read volume from localStorage
      persistedVolume = localStorage.getItem(volumeStorageKey);
      if (persistedVolume !== null) {
        volume = persistedVolume;
      }
    }

    if (options.muted !== null && options.muted !== undefined) {
      // Use the specified mute config, if provided
      muted = options.muted === true || options.muted === 'true';
      localStorage.setItem(muteStorageKey, muted);
    } else {
      // if no config, try to read muted from localStorage
      persistedMute = localStorage.getItem(muteStorageKey);
      if (persistedMute !== null) {
        muted = 'true' === persistedMute;
      }
    }

    mouseOut = function mouseOut() {
      // Used to hide volume slider on mouseOut
      player.removeClass('evp-volume-menu-active');
      player.addClass('evp-volume-menu-inactive');
    };

    onAdsRequest = function onAdsRequest() {
      // need to wait until there's an an request to grab references to these
      adControlBar = player.childNameIndex_.adControlBar;
      if (adControlBar && adControlBar.volumeMenuButton) {
        adControlBar.volumeMenuButton.on('mouseout', mouseOut);
      }
      fwPlugin = player.FreeWheelPlugin;
      if (fwPlugin.tech === 'Flash') {
        fwPlugin.adPlayer.on('volumechange', onFlashAdVolumeChange);
      }
    };

    onFlashAdVolumeChange = function onFlashAdVolumeChange() {
      // on flash ad volume change, persist
      if (player.ads.state === 'ad-playback') {
        if (!fwPlugin.adPlayer.muted()) {
          // is volume change, persist player volume
          volume = fwPlugin.adPlayer.volume();
          localStorage.setItem(volumeStorageKey, volume);
        }
        // persist player muted
        muted = fwPlugin.adPlayer.muted();
        localStorage.setItem(muteStorageKey, muted);
      }
    };

    onVolumeChange = function onVolumeChange() {
      // on player volume change, persist
      // dont persist volume if muting the player and the volume is 0
      if (!(player.muted() && player.volume() === 0)) {
        volume = player.volume();
        localStorage.setItem(volumeStorageKey, volume);
      }
      muted = player.muted();
      localStorage.setItem(muteStorageKey, muted);
    };

    // uses on ready so it gets called each time the tech is loaded
    onReady = function onReady() {
      player.volume(volume);
      player.muted(muted);
    };

    // uses ready as it only needs to be called once
    player.ready(function () {
      volumeMenuButton = player.controlBar.volumeMenuButton;
      volumeMenuButton.on('mouseout', mouseOut);
    });

    _dispose = function dispose() {
      player.off('dispose', _dispose);
      player.off('ready', onReady);
      player.off('volumechange', onVolumeChange);
      if (volumeMenuButton) {
        volumeMenuButton.off('mouseout', mouseOut);
      }
      if (adControlBar && adControlBar.volumeMenuButton) {
        adControlBar.volumeMenuButton.off('mouseout', mouseOut);
      }
    };

    player.on('dispose', _dispose);
    player.on('ready', onReady);
    player.on('volumechange', onVolumeChange);

    player.one('ads-request', onAdsRequest);
  };

  videojs.plugin('espnVolumeMenuButton', plugin);
}

module.exports = {
  init: init
};

},{}],58:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */
var API = require('../../api/index');

var TIMEOUT_DELAY_SECONDS_DEFAULT = 5;
var INITIAL_OFFSET = '180';

var _initialized = false;
var _first = true;
var _content;
var _country;
var _intervalId;
var _playHistory = [];
var _timeoutDelay = TIMEOUT_DELAY_SECONDS_DEFAULT;

function isHtmlElement(val) {
    return Object.prototype.toString.call(val) === '[object HTMLDivElement]';
}

function createDefaultEndCardElement(player, relatedContent, stopTimeoutHandler, timeoutHandler) {
    var content = relatedContent;
    var element = document.createElement('div');
    element.className = 'evp-endcard';

    if (content) {
        element.innerHTML = '<div class="evp-endcard-wrap"><h2>' + player.localize('Up Next') + '</h2><span class="evp-endcard-next-title">' + content.headline + '</span></div>';
        var thumbnailElement = document.createElement('div');
        thumbnailElement.className = 'evp-endcard-next-thumbnail';

        var circleElementId = 'evp-endcard-timer-circle_' + player.id();
        var timeoutButtonElement = document.createElement('span');
        timeoutButtonElement.className = 'evp-endcard-timeout-button';
        timeoutButtonElement.innerHTML = '<svg width="54" height="54" class="evp-endcard-timer">' + '<circle id="' + circleElementId + '" class="start-timer" r="23.57" cy="27" cx="27" stroke-width="4" stroke="#ffffff" fill="none"/>' + '</svg>';

        timeoutButtonElement.addEventListener('click', function () {
            if (_intervalId) {
                stopTimeoutHandler();
            } else {
                timeoutHandler(true);
            }
        });

        var i = 1;
        var intervalCount = _timeoutDelay;
        _intervalId = setInterval(function () {
            var el = document.getElementById(circleElementId);
            if (el) {
                el.style.strokeDashoffset = INITIAL_OFFSET - i * (INITIAL_OFFSET / _timeoutDelay);
            }

            intervalCount = intervalCount - 1;
            if (intervalCount <= 0) {
                stopInterval();
                timeoutHandler(false);
            }
            i++;
        }, 1000);

        var imgElement = document.createElement('img');
        imgElement.src = content.poster;

        thumbnailElement.appendChild(timeoutButtonElement);
        thumbnailElement.appendChild(imgElement);
        element.appendChild(thumbnailElement);
    }
    return element;
}

function stopInterval() {
    if (_intervalId) {
        clearInterval(_intervalId);
        _intervalId = null;
    }
}

function videoJsPlugin(options) {
    var player = this;
    var endcardElement;
    var playlist = options && options.playlist || [];
    var timeoutHandler = options && options.timeoutHandler || function () {};

    _content = options && options.content;
    _country = options && options.country;
    _timeoutDelay = options && options.timeout || TIMEOUT_DELAY_SECONDS_DEFAULT;

    if (isHtmlElement(_content)) {
        endcardElement = _content;
    }

    var play = function play() {
        player.play();
    };

    var stopTimeout = function stopTimeout() {
        stopInterval();
        player.removeClass('evp-endcard-timeout-active');
        player.addClass('evp-endcard-timeout-stopped');
    };

    var hide = function hide() {
        stopInterval();
        if (endcardElement) player.el().removeChild(endcardElement);
        player.removeClass('evp-endcard-open');
        player.removeClass('evp-endcard-timeout-active');
        player.removeClass('evp-endcard-timeout-stopped');
        endcardElement = null;
    };

    var onVideoPlay = function onVideoPlay() {
        hide();
    };

    var onContentReceived = function onContentReceived(content) {
        // Handle when a user is able to issue a replay before the relatedContent was returned from the server
        if (player.paused()) {
            endcardElement = createDefaultEndCardElement(player, content, stopTimeout, function (wasManual) {
                timeoutHandler(content, wasManual);
            });

            player.el().appendChild(endcardElement);
            player.addClass('evp-endcard-open');
            player.addClass('evp-endcard-timeout-active');
        } else {
            hide();
        }
    };

    function getRelatedContent(content, country, callback) {
        var clipId = content.id;
        var api = new API();

        api.getRelated(clipId, { country: country }, function (err, clips) {
            // if there was an error or not related results, replay to original clip as a last resort.
            if (err || !clips || clips.length === 0) {
                callback(content);
                return;
            }

            playlist = (clips || []).filter(function (clip) {
                return _playHistory.indexOf(clip.id) === -1 && _playHistory.indexOf(clip.mediaId) === -1;
            });
            playlist = playlist.length > 0 ? playlist : clips;

            var relatedContent = playlist.shift();
            callback(relatedContent || []);
        });
    }

    var onVideoEnded = function onVideoEnded() {
        if (!player.ads.state || player.ads.state === 'content-playback') {

            if (!!endcardElement) {
                player.el().appendChild(endcardElement);
                player.addClass('evp-endcard-open');
            } else if (!!_content) {
                _playHistory.push(_content.id);

                if (!!playlist && playlist.length > 0) {
                    var nextClip = playlist.shift();
                    // make sure all the props needed for endcard are present
                    if (nextClip && nextClip.id && nextClip.headline && nextClip.poster) {
                        onContentReceived(nextClip);
                    } else {
                        getRelatedContent(_content, _country, onContentReceived);
                    }
                } else {
                    getRelatedContent(_content, _country, onContentReceived);
                }
            }

            // Addresses an issue where safari does not play the next clip after an endcard.
            player.one('contentupdate', play);

            player.one('play', onVideoPlay);
            player.one('socialopened', stopTimeout);
        }
    };

    var dispose = function dispose() {
        stopInterval();
        player.off('dispose', dispose);
        player.off('switch', dispose);
        player.off('ended', onVideoEnded);
        player.off('play', onVideoPlay);
        player.off('contentupdate', play);
        player.off('socialopened', stopTimeout);
        _playHistory = [];
        _content = null;
        _initialized = false;
        _first = true;
    };

    player.one('dispose', dispose);
    player.one('switch', dispose);

    /*
      We want all ended events to trigger the endcard, but we only want to register once against the events.
      Using on without this logic causes issues on clips played after the endcard.
      Using one doesn't trigger the enndcard on replay.
    */
    if (_first) {
        _first = false;
        player.on('ended', onVideoEnded);
    }
}

function init() {
    videojs.plugin('endcard', videoJsPlugin);
    _initialized = true;
}

module.exports = {
    init: init
};

},{"../../api/index":9}],59:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

var _initialized = false;

function videoJsPlugin() {
    var player = this;
    var stateFeedbackButton = player.addChild('stateFeedbackButton');
    player.stateFeedbackButton = stateFeedbackButton;
    player.on('pause', function () {
        // player.stateFeedbackButton.toggleClass('whatever');
    });

    player.on('play', function () {});
}

function init() {
    var Component = videojs.getComponent('Component');
    var Button = videojs.getComponent('Button');

    var StateFeedbackButton = videojs.extend(Button, {
        constructor: function constructor(player, options) {
            Button.call(this, player, options);
        },
        createEl: function createEl() {
            return Component.prototype.createEl.call(this, 'div', {
                className: 'espn-player-state-feedback-button',
                innerHTML: ''
            });
        }
    });
    Component.registerComponent('StateFeedbackButton', StateFeedbackButton);
    videojs.plugin('stateFeedbackButton', videoJsPlugin);
    _initialized = true;
}

function plugin(player) {
    if (!_initialized) init();
    player.stateFeedbackButton();
}

module.exports = {
    init: init,
    plugin: plugin
};

},{}],60:[function(require,module,exports){
'use strict';

/* jshint strict: false, curly: false, browserify: true */
/* globals videojs */

function videoJsPlugin() {
    var player = this;
    var progressControl = player.controlBar.progressControl;

    var thumbnailHolderElement;
    var childNodes = progressControl.el().childNodes;
    for (var i = 0; i < childNodes.length; ++i) {
        if (childNodes[i].className === 'vjs-thumbnail-holder') {
            thumbnailHolderElement = childNodes[i];
            break;
        }
    }

    if (thumbnailHolderElement) {
        var mouseTimeDisplay = player.controlBar.progressControl.seekBar.mouseTimeDisplay;
        var timeElement = document.createElement('span');
        timeElement.className = 'vjs-thumbnail-time-tooltip';
        thumbnailHolderElement.appendChild(timeElement);

        var moveListener = function moveListener() {
            var currentTime = mouseTimeDisplay.el().getAttribute('data-current-time');
            timeElement.innerHTML = currentTime;
        };

        progressControl.on('mousemove', moveListener);
        progressControl.on('touchmove', moveListener);
        mouseTimeDisplay.addClass('vjs-time-tooltip-hidden');
    }
}

function plugin(player) {
    if (videojs) videojs.plugin('thumbnailTime', videoJsPlugin);
    player.thumbnailTime();
}

module.exports = {
    plugin: plugin
};

},{}],61:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* globals videojs */

(function () {
  'use strict';

  /* jshint -W004, -W040, -W055 */

  var Advertising,
      Analytics,
      BrightcovePlayer,
      CMS,
      ConvivaPlugin,
      errorConfig,
      ESPNAdPassThrough,
      ESPNAdRemainingTimeDisplay,
      ESPNBandwidthPersist,
      ESPNCaptionSettingsMenuItem,
      ESPNCaptionsToggleButton,
      ESPNID3,
      ESPNLoadingSpinner,
      ESPNPlayer,
      ESPNPlayToggle,
      ESPNSeekBar,
      ESPNSettingsMenu,
      ESPNSocial,
      ESPNVolumeMenuButton,
      Endcard,
      FanPreferences,
      Localizations,
      StateFeedbackButton,
      techOptions,
      ThumbnailTime,
      Watermark,
      bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
      debounce,
      extend,
      hasProp,
      lang,
      load;

  hasProp = {}.hasOwnProperty;
  extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  };

  debounce = require('lodash.debounce');

  load = require('load-script');

  ESPNPlayer = require('../espn-player');

  Advertising = require('../../advertising');

  Analytics = require('../../analytics');

  Watermark = require('../../watermark');

  ESPNSocial = require('./ESPNSocial');

  ESPNSettingsMenu = require('./ESPNSettingsMenu');

  ThumbnailTime = require('./ThumbnailTime');

  ESPNSeekBar = require('./ESPNSeekBar');

  ESPNLoadingSpinner = require('./ESPNLoadingSpinner');

  ESPNAdRemainingTimeDisplay = require('./ESPNAdRemainingTimeDisplay');

  ESPNCaptionsToggleButton = require('./ESPNCaptionsToggleButton');

  ESPNCaptionSettingsMenuItem = require('./ESPNCaptionSettingsMenuItem');

  StateFeedbackButton = require('./StateFeedbackButton');

  Endcard = require('./Endcard');

  FanPreferences = require('../../fan');

  ESPNVolumeMenuButton = require('./ESPNVolumeMenuButton');

  ConvivaPlugin = require('../../conviva');

  ESPNID3 = require('./ESPNID3');

  ESPNAdPassThrough = require('./ESPNAdPassThrough');

  CMS = require('../../cms');

  Localizations = require('../../i18n').translations();

  ESPNPlayToggle = require('./ESPNPlayToggle');

  ESPNBandwidthPersist = require('./ESPNBandwidthPersist');

  /*
    ESPN.Player is largely based on the video.js API, so BrightcovePlayer does not
    add much to the base object.
  */

  BrightcovePlayer = function (superClass) {
    extend(BrightcovePlayer, superClass);

    function BrightcovePlayer(originalElement, configs) {
      this.social = bind(this.social, this);
      this.selectPlaylist = bind(this.selectPlaylist, this);
      var player;
      BrightcovePlayer.__super__.constructor.call(this, originalElement);

      this.debouncedSetSizeClass = debounce(this.setSizeClass.bind(this), 250);
      /*
        Parse the configuration object that was passed to the constructor and
        handle automatically loading a source, if applicable.
      */
      configs = configs || {};
      errorConfig = {};

      ESPNSeekBar.init();
      ESPNLoadingSpinner.init();
      ESPNAdRemainingTimeDisplay.init();
      ESPNCaptionsToggleButton.init();
      ESPNCaptionSettingsMenuItem.init();
      ESPNVolumeMenuButton.init();
      ESPNSettingsMenu.init();
      Endcard.init();
      ConvivaPlugin.init();
      ESPNID3.init();
      ESPNAdPassThrough.init();
      ESPNPlayToggle.init();
      ESPNBandwidthPersist.init();

      for (lang in Localizations) {
        videojs.addLanguage(lang, Localizations[lang]);
      }

      if (configs.language && ['en', 'es'].indexOf(configs.language) !== -1) {
        this.element.setAttribute('data-setup', '{ "language": "' + configs.language + '" }');
      }

      // tweak settings for watch
      if (configs.watchId || configs.channelId) {
        // You have to use the Flashls SWF to use Flashls in the Brightcove Player
        // The SWF location can be set in your player configuration like this:
        // curl -u user@example.com -XPATCH -H 'Content-Type: application/json' -d '{ "flash": { "swf": "https://players.brijs-flashls/video-js.swf" } }' 'https://players.api.brightcove.com/v1/accounts/$ACCOUNT/players/$PLAYER/configuration'

        // flashVars will automatically get forwarded to flashls
        videojs.options.flash.flashVars = {
          // see https://github.com/mangui/flashls#configuration for the full list
          // hls_debug: true,
          hls_minbufferlength: 6,
          hls_lowbufferlength: 2,
          hls_capleveltostage: true
        };

        // reduce -2 timeout for watch
        errorConfig.timeout = 15 * 1000;
      } else {
        videojs.options.flash.flashVars = {};
      }

      /*
        Browser specific tech overrides
      */
      var USER_AGENT = window.navigator && window.navigator.userAgent || '';

      // EDGE: use native for vod clips, use flash for live streams
      //       to avoid MSE bitrate switching artifacts in edge 14
      if (videojs.IS_EDGE) {
        var edgeVersionMap = /Edge\/([\d.]+)/i.exec(USER_AGENT);
        var version = parseInt(edgeVersionMap[1], 10);
        if (version && version < 15) {
          if (configs.watchId || configs.channelId) {
            videojs.options.hls = { overrideNative: true };
            // if optimized, prefer flash for watch
            if (techOptions && techOptions.optimizeLive) {
              videojs.options.techOrder = ['flash', 'html5'];
            }
          } else {
            // to force native mode for vod
            videojs.options.hls = { overrideNative: false };
            videojs.options.techOrder = ['html5', 'flash'];
          }
        }

        // SAFARI: Use flash on old versions, to avoid native retry logic
      } else if (videojs.IS_SAFARI) {
        var safariVersionMap = /Version\/([\d.]+)/i.exec(USER_AGENT);
        var _version = parseInt(safariVersionMap[1], 10);
        if (_version < 7) {
          videojs.options.techOrder = ['flash'];
          videojs.options.hls = { overrideNative: true };
        }
      }

      // Add the element to the DOM
      if (this.originalElement.tagName.toLowerCase() !== 'video') {
        this.originalElement.parentNode.replaceChild(this.element, this.originalElement);
      }

      /*
        `bc()` is a Brightcove-specific function that adds some markup and
        performs additional initialization. This step is required for proper
        styling and behavior.
         `bc()` will return an instance of `videojs()`, the player technology that
        underlies BrightcovePlayer.
      */
      player = this.player(window.bc(this.element));
      this.element = player.el();
      ESPNSettingsMenu.plugin(player);
      StateFeedbackButton.plugin(player);
      ESPNCaptionsToggleButton.plugin(player);
      player.ESPNCaptionSettings();
      player.espnVolumeMenuButton(configs.volume);
      player.persistBandwidth();

      player.errors(errorConfig);

      player.load();

      /*
        Adresses looping -2 errors
      */
      var _lastErrorTime;
      player.on('error', function () {
        var interval = 30;
        var error = player.error();
        if (error && error.code === -2) {
          if (_lastErrorTime) {
            // if the error has re-occured within the interval
            if (Date.now() - _lastErrorTime < interval * 1000) {
              // make sure we don't loop
              _lastErrorTime = 0;
              player.reset();
              player.error(error);
            }
          }
          if (_lastErrorTime !== 0) _lastErrorTime = Date.now();
        }
      });

      /*
        Addresses issue where user could not resume a video after leaving
        fullscreen mode on iPhone.
         `usingNativeControls()` is `true` for iPhone, but `false` for iPad,
        so this only affects iPhone. On iPad, controls _are_ visible, so this
        isn't necessary.
      */
      player.on('touchstart', function () {
        if (player.paused() && player.usingNativeControls()) {
          player.play();
        }
      });

      /*
        Addresses an issue where the player remains hidden, if an ad doesn't play.
      */
      player.on('adend', function () {
        player.removeClass('vjs-ad-loading');
      });

      /*
        Addresses an issue where the control bar is not visible in fullscreen
      */
      player.on('contentplayback', function () {
        player.one('mouseover', function () {
          if (player.el().classList.contains('not-hover')) {
            player.el().classList.remove('not-hover');
          }
        });
      });

      if (configs.autoplay === 'userPreference') {
        FanPreferences.getAutoStart(function (autoStart) {
          configs.autoplay = autoStart;
          this.registerConfiguration(configs);
        }.bind(this));
      } else {
        configs.autoplay = configs.autoplay === 'on' || configs.autoplay === true ? true : false;
        this.registerConfiguration(configs);
      }

      this.startType = configs.wasUserInitiated === false ? 'autostart' : 'manual';
      Analytics.configure({ adobeDCR: { ESPN_CUSTOM_METADATA: { startType: this.startType } } });
      Advertising.configure({ startType: this.startType });

      player.on('ended', function () {
        if (!player.ads.state || player.ads.state === 'content-playback') {
          player.trigger('espn.contentended');
        }
      });

      player.on('loadstart', function () {
        var hlsTech;
        hlsTech = player.tech({ IWillNotUseThisInPlugins: true }).hls;

        /*
          Check for the HLS plugin. Safari supports HLS natively, so the plugin doesn't get loaded.
        */
        if (!hlsTech) {
          return;
        }

        /*
          start live playback 4 fragments from the end of the playlist (default 3)
        */
        videojs.Hls.Playlist.UNSAFE_LIVE_SEGMENTS = 4;

        /*
          Send cookies (by setting `withCredentials`) _only_ for `generateKey` and freewheel requests.
        */
        hlsTech.xhr.beforeRequest = function (options) {
          var rex = new RegExp('prod-freewheel.*\.m3u8|generateKey');
          if (rex.test(options.uri)) {
            options.withCredentials = true;
          }
        };
      });

      // The player 'ready' event gets fired on startup and also when we setup new tech so
      // switching between html5 and flash tech need to be captured using the 'ready' event
      player.on('ready', function () {
        this.setTechClass();
      }.bind(this));

      // The player.ready() function gets called once on startup and never again
      player.ready(function () {
        this.setSizeClass();
        window.addEventListener('resize', this.debouncedSetSizeClass);

        /*
          Per product request, disable volume control via scroll
        */
        player.hotkeys({
          enableVolumeScroll: false
        });
      }.bind(this));
    }

    BrightcovePlayer.prototype.mimeType = function () {
      return this.player().currentType();
    };

    BrightcovePlayer.prototype._useAdManager = false;

    BrightcovePlayer.prototype.loadMidroll = function (breakParams) {
      var options, slots;
      slots = [{
        adUnit: "midroll",
        adBreak: breakParams && breakParams.break_number ? breakParams.break_number : void 0,
        timePosition: this.player().currentTime()
      }];
      Advertising.configure({
        assetId: this.advertisingId || this.id,
        live: true,
        mimeType: this.mimeType()
      });
      if (this._useAdManager) {
        options = Advertising.adManager({}, slots);
        console.log(JSON.stringify(options));
        if (typeof this.player().FreeWheelPlugin === 'function') {
          this.player().FreeWheelPlugin(options);
        } else {
          this.player().FreeWheelPlugin.settings = options;
        }
      } else {
        options = {
          serverUrl: Advertising.vast({}, slots),
          requestMode: 'ondemand'
        };

        /*
          This is a dirty patch that fixes an an issue where both pre-roll and
          mid-roll are selected. The FW AdManager seems to alter the `ads`
          property from a function to an object. The IMA3 plugin relies on that
          property being a function, so we need to reset it with the prototype.
           This should only be run once, which is why we check the type of `ima3`.
        */
        if (this.preroll() && typeof this.player().ads !== 'function' && typeof this.player().ima3 === 'function') {
          this.player().ads = Object.getPrototypeOf(this.player()).ads;
        }
        if (typeof this.player().ima3 === 'function') {
          this.player().ima3(options);
        }
        this.player().ima3.adrequest(options.serverUrl);
      }
    };

    BrightcovePlayer.prototype._midroll = false;

    BrightcovePlayer.prototype.midroll = function (value) {
      if (value != null) {
        this._midroll = value;
      }
      return this._midroll;
    };

    BrightcovePlayer.prototype.loadClips = function (clips, autoplay, source) {
      var clip;
      source = source || this.clipSource;
      if ((typeof clips === 'undefined' ? 'undefined' : _typeof(clips)) === 'object') {
        clip = clips.shift ? clips.shift() : [clips];
      } else {
        clip = [{ id: clips }];
      }

      if (clips && clips.length > 0 && this.showEndCard === false && this.loopClip === false) {
        this.player().one('ended', function () {
          this.loadClips(clips, true, source);
        }.bind(this));
      }

      return this.loadShield(clip.id, autoplay, source);
    };

    BrightcovePlayer.prototype.loop = function () {
      this.player().on('ended', function () {
        this.player().play();
      }.bind(this));
    };

    BrightcovePlayer.prototype.error = function (value, content) {
      var err, modal, modalContent, player;

      player = this.player();

      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        err = {
          message: value.message,
          headline: value.headline || value.message
        };
        if (value.code || value.status) {
          err.code = value.code || value.status;
        }
        if (value.type || value.abbreviation) {
          err.type = value.type || value.abbreviation;
        }
      } else {
        err = {
          headline: value,
          message: value
        };
      }

      if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
        window.newrelic.noticeError(new Error(err.type || err.headline || err.message));
      }

      // Errors can sometimes occur before the player is ready...
      player.ready(function () {
        player.error(err);

        // Show custom content
        if (content) {
          modal = player.getChild('errorDisplay');

          // Check if content is HTML
          if (content.nodeName) {
            modalContent = content;
          } else {
            modalContent = document.createElement('div');
            modalContent.innerHTML = content;
          }

          modalContent.className = 'vjs-errors-dialog';
          modalContent.id = 'vjs-errors-dialog';

          modal.fillWith(modalContent);
          if (player.width() <= 600 || player.height() <= 250) {
            modal.addClass('vjs-xs');
          }
        }
      });
    };

    BrightcovePlayer.prototype.thumbnails = function (previews) {
      var missingThumbnailImageUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAA+CAIAAABFt7lbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAuFJREFUeNrsmtGxIUEUhne3PJOATYAIdgPAOzYAJIAAxgaABBAAAkAARgCUAFYCRLBfzV/V1YXaO7eurboP//8wdabn9Dmnvz4940EhSZLj8fjF+rAKcEzT1CA+rm9GYJRGaZSWURqlURqlZZRGaZSWURqlURqlZZRGaZSWURqlURqlZZRGaZSWUX4ClNVq9Uem/1fK90whXbFYfO+sN0VMIv978KnPK1H+zjQcDs/nc85MvzLlLwXn1WolguR6mmW9Xt+NjEaj+Xyep/5qJozHLokHn/q8+IAnSdJqtWazWaPRYNl0KGQZl8EgFDSCgcOfTGocxnu9npyRHIQv7qnb7aYIMV9GdBqwy+Vy7KAO4kqQu+xcyajCGDydTgQPE1UzCr0v5/gohAg5z8c7UFI0JdbrdcrCYOs2mw2D0+l0v9+3223Ww1NGqJ7rz0xM3O12TCmVSlSGD3MZZ5YWINzSZDIhQniN8JRbguNMQOHgNviTaLvdsru48eguOw6aG7Yh3iEeMaIdxf9yuXAb9yMTqZmkivBilICgNyGoJiWN9pyt0xqWy6VwY4T9D1BwYK4aE4c7juh6vfb7/bAe/MGUpikHH1so478wqvtIrZaPsxNZrfe0pwCnZgeWepbCmBUfETLiQGSt8U0V8qMk0+M/MSmiUql0u13WQ/VUxrJZcKCMAaBOp6OTziOWgfN4PF4sFuzHXcA0k9Awl+biliXBlJG4s3SotWd6D9KhITsvUGyMw+Hw2BPgrtVqod0ISyiKp9R4aWqXnB/bvCjv3jXhVmecr4EaCpqsh6c8UsfhxpcBampkbQl1A0i9EGLir5hQZm3YGHQowXGWJ1O45ZUtIupZbAxuiRyyY7Af2HIIBWPoJU4c2ep0YeUNIx+uLGcwGMD3aQ896muz2fS/fv0T3SiN0jJKozRKo7SM0iiN0jJKozRKo7SM0iiN0jJKozRKo7SM0iiN0jJKo/z0+ivAAEPb6BambmykAAAAAElFTkSuQmCC';
      var thumbnailHolder, thumbnails, thumbnailImage;
      if (typeof this.player().thumbnails !== 'function') {
        return;
      }
      thumbnailHolder = this.player().controlBar.progressControl.el().querySelector('.vjs-thumbnail-holder');
      if (!!thumbnailHolder) {
        this.player().controlBar.progressControl.el().removeChild(thumbnailHolder);
      }
      thumbnails = this.player().thumbnails(previews);

      thumbnailHolder = this.player().controlBar.progressControl.el().querySelector('.vjs-thumbnail-holder');
      thumbnailImage = thumbnailHolder.querySelector('img');
      thumbnailImage.addEventListener('error', function () {
        this.src = missingThumbnailImageUrl;
      });

      ThumbnailTime.plugin(this.player());
      return thumbnails;
    };

    BrightcovePlayer.prototype.social = function (options) {
      videojs.plugin('social', ESPNSocial);
      if (typeof this.player().social !== 'function') {
        return;
      }
      this.logConfigs('ESPNSocial', options);
      return this.player().social(options);
    };

    BrightcovePlayer.prototype.watermark = function () {
      return new Watermark(function (_this) {
        return function (overlays) {
          if (!overlays.length) {
            overlays = [overlays];
          }
          return _this.player().overlay({
            overlays: overlays
          });
        };
      }(this));
    };

    BrightcovePlayer.prototype.endcard = function (clip, options) {
      var country = clip._shield && clip._shield.country ? clip._shield.country : null;
      var content = {
        id: clip.mediaId || clip.id,
        headline: clip.headline,
        poster: clip.posterHref
      };

      this.player().endcard({
        playlist: this.playlist,
        content: content,
        country: country,
        timeoutHandler: function (clip, wasManual) {
          this.startType = wasManual ? 'manual:endcard_continuous' : 'endcard_continuous';
          Analytics.configure({ adobeDCR: { ESPN_CUSTOM_METADATA: { startType: this.startType } } });
          Advertising.configure({ startType: this.startType });
          this.loadClip(clip.id, true, clip.source);
        }.bind(this),
        timeout: options && options.timeout || null
      });
    };

    BrightcovePlayer.prototype.watchLoadedCallback = function (error) {
      var player;
      player = this.player();
      BrightcovePlayer.__super__.watchLoadedCallback.apply(this, arguments);

      /*
        Seek to live point on play if the source is live. This prevents DVR-
        like behavior for live streams.
      */

      if (!error && player.mediainfo.live) {
        player.on('play', function () {
          if (player.seekable().length > 0) {
            player.currentTime(player.seekable().end(0));
          }
        });
      }
    };

    BrightcovePlayer.prototype.setTechClass = function () {
      var player, techPrefix, techClass, cl;
      player = this.player();
      techPrefix = 'evp-tech-';
      techClass = techPrefix + player.techName_.toLowerCase();
      cl = player.el().classList;

      // Remove any previous tech classes
      for (var i = 0; i < cl.length; i++) {
        if (cl[i].indexOf(techPrefix) !== -1) {
          player.removeClass(cl[i]);
        }
      }

      player.addClass(techClass);
    };

    BrightcovePlayer.prototype.setSizeClass = function () {
      var player, playerWidth;
      player = this.player();
      playerWidth = player && player.dimension('width') || -1;

      if (playerWidth >= 660) {
        player.addClass('espn-endCard-large');
      } else {
        player.removeClass('espn-endCard-large');
      }

      if (playerWidth >= 375 && playerWidth <= 659) {
        player.addClass('espn-endCard-medium');
      } else {
        player.removeClass('espn-endCard-medium');
      }

      if (playerWidth >= 275 && playerWidth <= 374) {
        player.addClass('espn-endCard-small');
      } else {
        player.removeClass('espn-endCard-small');
      }

      if (playerWidth >= 250 && playerWidth <= 274) {
        player.addClass('espn-endCard-xSmall');
      } else {
        player.removeClass('espn-endCard-xSmall');
      }

      if (playerWidth <= 640) {
        player.addClass('espn-player-medium');
      } else {
        player.removeClass('espn-player-medium');
      }

      if (playerWidth <= 300) {
        player.addClass('espn-player-small');
      } else {
        player.removeClass('espn-player-small');
      }

      if (playerWidth >= 250 && playerWidth <= 480) {
        player.addClass('remove-time');
      } else {
        player.removeClass('remove-time');
      }

      if (playerWidth >= 250 && playerWidth <= 400) {
        player.addClass('remove-duration');
      } else {
        player.removeClass('remove-duration');
      }
    };

    BrightcovePlayer.prototype.dispose = function () {
      window.removeEventListener('resize', this.debouncedSetSizeClass);
      if (this.debouncedSetSizeClass.cancel) {
        this.debouncedSetSizeClass.cancel();
      }
      var player = this.player();
      if (player) {
        try {
          player.dispose();
        } catch (err) {
          console.error(err);
        }
      }
      BrightcovePlayer.__super__.dispose.apply(this, arguments);
    };

    return BrightcovePlayer;
  }(ESPNPlayer);

  BrightcovePlayer.loadTech = function loadBrightcovePlayer() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (window.bc) {
      callback();return;
    }

    options = options || {};
    techOptions = options;

    if (!options.playerId) {
      if (options.optimizeLive) {
        options.playerId = 'r1f1yuGpl_default'; // Flashls
      } else {
        options.playerId = 'rJliAPf6l_default'; // no Flashls
      }
    }
    options.accountId = options.accountId || '3948005062001';

    load('//players.brightcove.net/' + options.accountId + '/' + options.playerId + '/index.min.js', function (err) {
      if (err) {
        load('//secure.espncdn.com/players/web-player-bundle/latest/perform-assets/players/' + options.playerId + '/index.min.js', function (err) {
          if (err) {
            // Uh oh, the backup failed, too.
            return;
          }
          callback();
        });
      } else {
        callback();
      }
    });
  };

  module.exports = BrightcovePlayer;
}).call(undefined);

},{"../../advertising":5,"../../analytics":7,"../../cms":12,"../../conviva":15,"../../fan":17,"../../i18n":20,"../../watermark":72,"../espn-player":62,"./ESPNAdPassThrough":44,"./ESPNAdRemainingTimeDisplay":45,"./ESPNBandwidthPersist":46,"./ESPNCaptionSettingsMenuItem":47,"./ESPNCaptionsToggleButton":48,"./ESPNID3":49,"./ESPNLoadingSpinner":50,"./ESPNPlayToggle":51,"./ESPNSeekBar":52,"./ESPNSettingsMenu":53,"./ESPNSocial":54,"./ESPNVolumeMenuButton":57,"./Endcard":58,"./StateFeedbackButton":59,"./ThumbnailTime":60,"load-script":26,"lodash.debounce":27}],62:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var API, AdProvider, Advertising, Analytics, Authorizer, CMS, ConfigLogger, ESPNAdobeNielsenAdapter, ESPNPlayer, Shield, Social, StreamLimiter, TimelinePreviews, _adobeNielsen, _authorizer, _lastAiringId, _reload, _reloadError, _reloadInitialized, _reloadTime;

  API = require('../../api');

  Shield = require('../../shield');

  TimelinePreviews = require('../../timeline-previews');

  Social = require('../../social');

  Advertising = require('../../advertising');

  Analytics = require('../../analytics');

  Authorizer = require('../../authorizer');

  StreamLimiter = require('../../stream-limiter');

  ConfigLogger = require('../../config-logger');

  AdProvider = require('../../ad-provider');

  CMS = require('../../cms');

  ESPNAdobeNielsenAdapter = require('../../espn-adobe-nielsen-adapter');

  /*
    UA-sniffing code borrowed from VideoJS
    https://github.com/videojs/video.js/blob/3a859f97d0647fc3d1ef6b2f4b755c71da8bef63/src/js/utils/browser.js
  */
  var USER_AGENT = window.navigator && window.navigator.userAgent || '';
  var IS_EDGE = /Edge/i.test(USER_AGENT);
  var IS_CHROME = !IS_EDGE && /Chrome/i.test(USER_AGENT);

  function loadWatch(autoplay) {
    /*jshint validthis:true */
    var _this, args, player;
    if (autoplay != null) {
      this.autoplay(autoplay);
    }
    _this = this;
    args = arguments;
    player = this.player();

    if (typeof player.reloadSourceOnError === 'function' && !_reloadInitialized) {
      player.reloadSourceOnError({
        getSource: function getSource(reload) {
          var error = player.error();
          // avoid restarting for error 0, -1 or http codes 400 and greater
          if (!(error.code === 0 || error.code === -1 || error.code >= 400)) {
            _reload = reload;
            _reloadTime = player.currentTime();
            _reloadError = error;
            loadWatch.apply(_this, args);
          }
        },
        // this value needs to be more than the error timeout value
        errorInterval: 30
      });

      _reloadInitialized = true;

      /*
        if the player gets disposed, but the bundle is still initialized,
        lets make sure we'll initialize this again with a new player.
      */
      player.on('dispose', function () {
        _reloadInitialized = false;
      });
    }

    return this.listings(function (err, listing) {
      if (_authorizer) _authorizer.dispose();
      this.logConfigs.call(this, 'authorizer', Authorizer.configure(), listing.id);
      _authorizer = new Authorizer(player);
      _authorizer.onStatusChange = this.watchLoadedCallback.bind(this);

      if (listing.videoHref.indexOf('startSession') !== -1) {
        return _authorizer.startSession(listing);
      } else {
        return _authorizer.startShieldSession(listing);
      }
    }.bind(this));
  }

  function listenForProgramChange() {
    /*jshint validthis:true */
    var newAiringId,
        player = this.player();

    player.one('espn.id3cuechange', function (event, cue) {
      var payload;

      if (!cue.owner || !cue.owner.match(/heartbeat|transition/g)) {
        listenForProgramChange.call(this);
        return;
      }

      try {
        payload = JSON.parse(cue.text);
      } catch (e) {
        payload = cue.text;
      }

      if (!_lastAiringId) {
        _lastAiringId = payload[0] && payload[0].id || player.mediainfo.simulcastAiringId;
      }

      if (payload.from && payload.from.type === 'PROGRAM' && payload.to.type === 'PROGRAM' || payload[0] && payload[0].type === 'PROGRAM' && payload[0].id !== _lastAiringId) {
        newAiringId = payload.to && payload.to.id || payload[0] && payload[0].id;

        this.listings(function (err, listing) {
          if (err) {
            throw new Error(err);
          }
          if (listing) {
            if (listing.simulcastAiringId !== newAiringId) {
              // The simulcast airing ID of the listing doesn't match the ID in
              // the ID3 tag, so we'll poll `/listings` again on the next tag.
              return listenForProgramChange.call(this);
            }

            _lastAiringId = listing.simulcastAiringId;
            return _authorizer.startSession(listing);
          }
          return;
        }.bind(this));
      } else {
        listenForProgramChange.call(this);
      }
    }.bind(this));
  }

  /*
    The ESPNPlayer object is a base "class" that contains common methods and
    describes the shared interface.
     BrightcovePlayer and PrimetimePlayer both extend this base ESPNPlayer object.
    Where internal functionality differ, they override methods from ESPNPlayer.
     The `player()` method of ESPNPlayer gets (and sets) a reference to the
    underlying player, i.e. video.js for BrightcovePlayer and ActionScript
    methods for PrimetimePlayer. Methods such as `play()` and `pause()` call
    corresponding methods on the underlying player.
     ESPNPlayer also wraps common calls to the ESPN API, enabling both Brightcove
    and Primetime to use exactly the same API logic.
   */

  ESPNPlayer = function () {

    /*
      Initialize an instance of ESPNPlayer.
     */
    function ESPNPlayer(originalElement) {
      if (typeof originalElement === 'string') {
        if (originalElement.indexOf('#') === 0) {
          originalElement = originalElement.slice(1);
        }
        originalElement = document.getElementById(originalElement);
      }
      if (!originalElement || !originalElement.nodeName) {
        throw new TypeError('The element or ID supplied is not valid.');
      }
      this.originalElement = originalElement;
      this.element = originalElement.tagName.toLowerCase() === 'video' ? originalElement : document.createElement('video');
      this.element.controls = true;
      this.element.preload = 'metadata';
      this.element.className = 'evp-player video-js';

      if (!IS_CHROME) {
        this.element.crossOrigin = 'anonymous';
      }
    }

    ESPNPlayer.prototype.registerConfiguration = function (options) {
      if (options == null) {
        return;
      }

      this.options = options;
      this.clipSource = options.clipSource;

      if (options.advertising) {
        Advertising.configure(options.advertising);
        if (options.advertising.assetId) {
          this.advertisingId = options.advertising.assetId;
        }
      }
      if (options.analytics) {
        Analytics.configure(options.analytics);
      }
      if (options.api) {
        API.configure(options.api);
      }
      if (options.auth != null) {
        Authorizer.configure(options.auth);
      }
      if (options.autoplay != null) {
        this.autoplay(options.autoplay);
      }
      if (options.endcard != null) {
        this.showEndCard = !!options.endcard;
      }
      if (options.preroll != null) {
        this.preroll(options.preroll);
      }
      if (options.postroll != null) {
        this.postroll(options.postroll);
      }
      if (options.shield) {
        Shield.configure(options.shield);
      }
      if (options.streamlimiter) {
        StreamLimiter.configure(options.streamlimiter);
      }
      if (options.loop != null) {
        this.loopClip = options.loop;
      }
      if (options.error) {
        var player;
        player = this.player();
        if (player.conviva) {
          this.logConfigs('conviva', Analytics.conviva());
          player.conviva(Analytics.conviva());
        }

        return this.error(options.error);
      }
      switch (false) {
        case !options.adOnly:
          this.advertisingId = options.advertising && options.advertising.assetId;
          return this.adOnly();

        case options.cerebroId == null:
          this.id = options.cerebroId;
          return this.loadShield(this.id, options.autoplay);

        case options.clipId == null:
          this.id = options.clipId;
          return this.loadClip(this.id, options.autoplay, this.clipSource);

        case options.playlist == null:
          this.playlist = options.playlist;
          return this.loadClips(this.playlist, options.autoplay, this.clipSource);

        case options.listings == null:
          if (!options.auth || !options.streamlimiter) {
            return console.error('Missing configuration data');
          }
          if (typeof options.listings !== 'function') {
            return console.error('listings MUST be a function');
          }
          this.listings = options.listings;
          return loadWatch.call(this, options.autoplay);

        case options.watchId == null:
          this.id = options.watchId;
          if (!options.auth || !options.streamlimiter) {
            return console.error('Missing configuration data');
          }
          this.listings = function (callback) {
            new API().getListing(options.watchId, callback);
          };

          return loadWatch.call(this, options.autoplay);

        case options.channelId == null:
          this.id = options.channelId;
          if (!options.auth || !options.streamlimiter) {
            return console.error('Missing configuration data');
          }
          this.listings = function (callback) {
            new API().getChannel(options.channelId, callback);
          };
          return loadWatch.call(this, options.autoplay);

      }
    };

    ESPNPlayer.prototype._player = void 0;

    ESPNPlayer.prototype.player = function (value) {
      if (value != null) {
        this._player = value;
      }
      return this._player;
    };

    ESPNPlayer.prototype.autoplay = function (value) {
      return this.player().autoplay(value);
    };

    ESPNPlayer.prototype.play = function () {
      return this.player().play();
    };

    ESPNPlayer.prototype.pause = function () {
      return this.player().pause();
    };

    ESPNPlayer.prototype.poster = function (value) {
      return this.player().poster(value);
    };

    ESPNPlayer.prototype._preroll = false;

    ESPNPlayer.prototype.preroll = function (value) {
      if (value != null) {
        this._preroll = value;
      }
      return this._preroll;
    };

    ESPNPlayer.prototype._postroll = false;

    ESPNPlayer.prototype.postroll = function (value) {
      if (value != null) {
        this._postroll = value;
      }
      return this._postroll;
    };

    ESPNPlayer.prototype.id = void 0;

    ESPNPlayer.prototype.advertisingId = void 0;

    ESPNPlayer.prototype.metadata = void 0;

    ESPNPlayer.prototype._duration = void 0;

    ESPNPlayer.prototype.duration = function (value) {
      if (value != null) {
        this._duration = value;
      }
      return this._duration;
    };

    ESPNPlayer.prototype.mimeType = function () {

      /*
        Abstract method that must be implemented by sub-classes.
       */
    };

    ESPNPlayer.prototype.load = function () {

      /*
        Abstract method that must be implemented by sub-classes.
       */
    };

    ESPNPlayer.prototype.loopClip = false;

    /*
      `loadClip()` calls the API with the provided ID and parses the response,
      setting the source for the player to the appropriate format.
     */

    ESPNPlayer.prototype.loadClip = function (id, autoplay, source) {
      var endpoint;
      this.clipId = id;
      if (autoplay != null) {
        this.autoplay(autoplay);
      }
      source = source || this.clipSource;
      endpoint = new API({
        cms: source
      });
      return endpoint.getClipThroughShield(id, this.clipLoadedCallback.bind(this));
    };

    /* jshint ignore:start */

    ESPNPlayer.prototype.loadClips = function (ids, autoplay, source) {

      /*
        Abstract method that must be implemented by sub-classes.
       */
    };

    /* jshint ignore:end */

    ESPNPlayer.prototype.loadShield = function (cerebroId, autoplay) {
      var endpoint;
      if (autoplay != null) {
        this.autoplay(autoplay);
      }
      endpoint = new Shield();
      return endpoint.getClip(cerebroId, this.clipLoadedCallback.bind(this));
    };

    ESPNPlayer.prototype.showEndCard = true;

    ESPNPlayer.prototype.adOnly = function () {
      this.duration(1);
      this.preroll(true);
      this.autoplay(true);

      new AdProvider(this.player(), {}, this.options.adProviderOrder, function (adProvider) {

        /*
          base64 encoded version of https://code.espn.com/pocplayer/web-player-poc/blob/master/src/assets/black.mp4
         */
        this.player().src({
          src: 'data:video/mp4;base64,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',
          type: 'video/mp4'
        });
        // Must be after src()
        adProvider.initAds({
          id: this.advertisingId || this.id,
          slots: {
            preroll: true
          },
          duration: this.duration(),
          logger: this.logConfigs.bind(this)
        });
      }.bind(this));
    };

    ESPNPlayer.prototype.clipLoadedCallback = function (error, clip) {
      var cms, player;
      player = this.player();
      if (typeof player.conviva === 'function') {
        this.logConfigs('conviva', Analytics.conviva());
        player.conviva(Analytics.conviva());
      }
      if (error) {
        this.error(error);
        return;
      }
      player.trigger('espn.clipfetched', { player: this, clip: clip });
      this.id = clip.id;
      this.advertisingId = clip.advertisingId;
      this.duration(clip.duration);
      this.clipId = clip.clipId;
      this.clipSource = clip.clipSource;
      cms = new CMS(this.clipSource);

      // Remove remote captions from the previous clip, if any.
      // The check of `player.removeRemoteTextTrack` is probably unnecessary.
      if (this.webVTT && typeof player.removeRemoteTextTrack === 'function') {
        this.webVTT = player.removeRemoteTextTrack(this.webVTT); // removeRemoteTextTrack returns `null`
      }

      new AdProvider(player, clip, this.options.adProviderOrder, function (adProvider) {
        clip.sources = adProvider.sources;

        if (typeof this.mediainfo === 'function') {
          this.mediainfo(clip);
        }

        if (clip.webVTT && typeof player.addRemoteTextTrack === 'function') {
          this.webVTT = player.addRemoteTextTrack({
            kind: 'captions',
            language: '',
            label: 'cc1',
            src: clip.webVTT
          });
        }
        if (clip.posterHref && !this.autoplay()) {
          this.poster(clip.posterHref);
        } else {
          // black poster image
          this.poster('data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=');
        }
        if (typeof this.loop === 'function' && this.loopClip) {
          this.loop();
        } else if (typeof this.endcard === 'function' && this.showEndCard) {
          this.endcard(clip, this.options.endcard);
        }
        if (typeof this.social === 'function') {
          new Social(player.mediainfo, this.social, this.options.social);
        }
        if (typeof this.thumbnails === 'function' && clip.posterHref) {
          new TimelinePreviews(this.id, clip.sources[0].src, this);
        }

        player.trigger('espn.contentloaded', { id: this.id, clipId: this.clipId, mediainfo: player.mediainfo });

        player.src(clip.sources);
        // Must be after src()
        adProvider.initAds({
          // don't set a bad network id, in the case of ad only
          networkId: cms.adNetworkId ? cms.adNetworkId : null,
          id: this.advertisingId || this.id,
          slots: {
            preroll: this.preroll(),
            postroll: this.postroll()
          },
          duration: this.duration(),
          logger: this.logConfigs.bind(this)
        });

        if (typeof this.initAnalytics === 'function') {
          this.initAnalytics();
        }
      }.bind(this));
    };

    ESPNPlayer.prototype.watchLoadedCallback = function (error, listing) {
      var limiter, player;
      player = this.player();
      if (typeof player.conviva === 'function') {
        // If we have reloaded due to an error, add it as a tag
        if (typeof _reload === 'function') {
          Analytics.conviva({
            tags: {
              reloadCause: _reloadError.code + '' || _reloadError.message
            }
          });
        } else {
          Analytics.conviva({
            tags: {
              reloadCause: 'null'
            }
          });
        }

        this.logConfigs('conviva', Analytics.conviva());
        player.conviva(Analytics.conviva());
      }
      if (error) {
        this.error(error);
        return;
      }

      new AdProvider(player, listing, this.options.adProviderOrder, function (adProvider) {
        /*
          If `mediainfo.id` is already set, the program has changed; need to
          reset metadata, don't need to set sources or anything else.
         */
        if (player.mediainfo && player.mediainfo.id && !_reload) {
          this.id = listing.id;
          this.advertisingId = listing.advertisingId || listing.id;
          if (typeof this.mediainfo === 'function') {
            this.mediainfo(listing);
          }

          /*
             The bundle integration _MUST_ implement a handler for this event.
             `data.callback` _MUST_ be called in the handler for this event--
             _after_ any asynchronous API calls for additional program data--in
             order for analytics to be tracked correctly.
           */
          player.trigger('espn.programchange', {
            id: listing.id,
            callback: _adobeNielsen.completeLiveProgram.bind(_adobeNielsen) || function () {}
          });

          listenForProgramChange.call(this);
          return;
        }

        this.id = listing.id;
        this.advertisingId = listing.advertisingId || listing.id;
        if (typeof this.mediainfo === 'function') {
          this.mediainfo(listing);
        }

        this.poster(listing.posterHref);

        listenForProgramChange.call(this);

        if (typeof this.social === 'function') {
          new Social(player.mediainfo, this.social, this.options.social);
        }

        player.trigger('espn.contentloaded', { id: this.id, mediainfo: player.mediainfo });

        if (typeof _reload === 'function') {
          Analytics.configure({ adobeDCR: { ESPN_CUSTOM_METADATA: { startType: 'error - restart' } } });

          if (player.techName_ === 'Flash') {
            player.reset();
          }

          _reload({
            src: listing.videoHref,
            type: 'application/x-mpegURL'
          });
          player.currentTime(_reloadTime);
          _reload = null;
          _reloadTime = null;
        } else {
          player.src({
            src: listing.videoHref,
            type: 'application/x-mpegURL'
          });

          if (listing.seekInSeconds) {
            player.currentTime(listing.seekInSeconds);
          }
        }

        // Must be after src()
        adProvider.initAds({
          id: this.advertisingId || this.id,
          slots: {
            preroll: this.preroll(),
            postroll: this.postroll()
          },
          logger: this.logConfigs.bind(this)
        });

        this.initAnalytics();

        if (typeof player.adPassThrough === 'function') {
          player.adPassThrough();
        }

        this.logConfigs('streamlimiter', StreamLimiter.configure());
        limiter = new StreamLimiter(this);
      }.bind(this));
    };

    ESPNPlayer.prototype.initAnalytics = function () {
      var player;
      player = this.player();

      if (player.comscore) {
        this.logConfigs('comscore', Analytics.comscore());
        player.comscore(Analytics.comscore());
      }
      if (player.chartbeat) {
        this.logConfigs('chartbeat', Analytics.chartbeat());
        player.chartbeat(Analytics.chartbeat());
      }

      if (!_adobeNielsen) {
        _adobeNielsen = new ESPNAdobeNielsenAdapter(player, Analytics.adobeDCR());
      } else {
        _adobeNielsen.loadNewOptions(Analytics.adobeDCR());
      }

      return;
    };

    ESPNPlayer.prototype.logConfigs = function (plugin, configs, id) {
      return ConfigLogger(id || this.id, plugin, configs); // jshint ignore:line
    };

    ESPNPlayer.prototype.dispose = function () {
      if (_authorizer) _authorizer.dispose();
      _adobeNielsen = null;
    };

    /*
      Set the `mediainfo` prop on the player with data from Shield or the clips
      or listings APIs.
    */
    ESPNPlayer.prototype.mediainfo = function (opts) {
      var data;
      if (opts) {
        data = {
          created_at: opts.createDate || '',
          custom_fields: {},
          description: opts.caption || '',
          duration: opts.duration || '',
          id: '' + (opts.clipId || opts.id) || '',
          live: false,
          name: opts.assetName || opts.name || '',
          pageTitle: opts.pageTitle || opts.headline + " - ESPN Video",
          posterHref: opts.posterHref || '',
          publisher: opts.publisher || 'ESPN',
          published_at: opts.publishDate || '',
          reference_id: opts.cerebroId || '',
          showcode: opts.showcode || 'Not Applicable',
          site: opts.site || 'espncom',
          sources: opts.sources || '',
          sport: opts.sport || '',
          tags: opts.keywords || '',
          updated_at: opts.publishDate || ''
        };

        if (this.options.affiliate) {
          data.affiliate = this.options.affiliate;
        }

        /*
          Transform times in responses from invalid, non-ISO form,
          '2016-06-24T10:00:00GMT', to valid form, '2016-06-24T14:00:00.000Z'.
         */
        ['startTime', 'endTime', 'originalAirDate', 'originalPublishDate'].forEach(function (prop) {
          if (opts[prop]) {
            data[prop] = new Date(opts[prop].replace('GMT', 'Z'));
          }
        });

        ['airingId', 'commercialReplacement', 'comscoreC6', 'eventId', 'hasEspnId3Heartbeats', 'hasNielsenWatermarks', 'hasPassThroughAds', 'nielsenCrossId1', 'passThroughBeaconURL', 'program', 'simulcastAiringId', 'sourceId', 'sourceType', 'status', 'webHref'].forEach(function (prop) {
          if (typeof opts[prop] !== 'undefined') {
            data[prop] = opts[prop];
          }
        });

        if (opts._listing) {
          data.duration = 86400;
          data.live = opts.status === 'live';
        }

        // Ensure comscoreC6 is present or '*null'
        data.comscoreC6 = data.comscoreC6 || '*null';

        if (opts._shield && opts._shield.gameId !== -1) {
          data.custom_fields.gameId = opts._shield.gameId;
        }
        if (opts._shield && opts._shield.mediaType) {
          data.custom_fields.mediaType = opts._shield.mediaType;
        }

        data.startType = this.startType;

        this.logConfigs('mediainfo', data);
        this.player().mediainfo = data;
        this.player().trigger('espn.mediainfoloaded', data);
      }
      return this.player().mediainfo;
    };

    return ESPNPlayer;
  }();

  module.exports = ESPNPlayer;
}).call(undefined);

},{"../../ad-provider":3,"../../advertising":5,"../../analytics":7,"../../api":9,"../../authorizer":10,"../../cms":12,"../../config-logger":13,"../../espn-adobe-nielsen-adapter":16,"../../shield":66,"../../social":68,"../../stream-limiter":69,"../../timeline-previews":70}],63:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* jshint esversion: 6, strict: false, curly: false, browserify: true */

var ESPNPlayer = require('../espn-player');
var EventEmitter = require('events').EventEmitter;
var Analytics = require('../../analytics');
var NativeOmniture = require('./native-omniture');
var FanPreferences = require('../../fan');
var MobileDetect = require('mobile-detect');

var VideoElementPlayer = function () {
    function VideoElementPlayer(element) {
        _classCallCheck(this, VideoElementPlayer);

        // ['loadstart', 'progress', 'suspend', 'abort', 'error', 'emptied',
        //     'stalled', 'loadedmetadata', 'loadeddata',
        //     'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking',
        //     'seeked', 'ended', 'durationchange', 'timeupdate', 'play',
        //     'pause', 'ratechange', 'volumechange', 'loadeddata', 'waiting'
        // ].forEach((eventName) => {
        //     element.addEventListener(eventName, (event) => {
        //         console.log(eventName, event);
        //     });
        // });

        this.element = element;
        this.events = new EventEmitter();
    }

    _createClass(VideoElementPlayer, [{
        key: 'autoplay',
        value: function autoplay(value) {
            if (value != null) {
                if (value === true) {
                    this.element.setAttribute('autoplay', 'autoplay');
                } else {
                    this.element.removeAttribute('autoplay');
                }
            }

            return !!this.element.autoplay;
        }
    }, {
        key: 'poster',
        value: function poster(value) {
            this.element.setAttribute('poster', value);
            return this;
        }
    }, {
        key: 'src',
        value: function src(sources) {
            var _this = this;

            if (sources != null) {
                // Remove any existing <source> elements.
                if (!!this.element.currentSrc) {
                    var sourceElements = this.element.getElementsByTagName('source');
                    for (var i = 0; i < sourceElements.length; i++) {
                        this.element.removeChild(sourceElements[i]);
                    }
                }

                if (!sources.length) {
                    sources = [sources];
                }

                sources.map(function (source) {
                    var element = document.createElement('source');
                    element.setAttribute('src', source.src);
                    element.setAttribute('type', source.type);
                    return element;
                }).forEach(function (element) {
                    _this.element.appendChild(element);
                });
                this.element.load();
            }
            return this.element.currentSrc;
        }
    }, {
        key: 'reset',
        value: function reset() {
            return this;
        }
    }, {
        key: 'ready',
        value: function ready() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            callback.call(this);
            return this;
        }
    }, {
        key: 'on',
        value: function on() {
            var _element, _events;

            (_element = this.element).addEventListener.apply(_element, arguments);
            (_events = this.events).on.apply(_events, arguments);
            return this;
        }
    }, {
        key: 'off',
        value: function off() {
            var _element2, _events2;

            (_element2 = this.element).removeEventListener.apply(_element2, arguments);
            (_events2 = this.events).removeListener.apply(_events2, arguments);
            return this;
        }
    }, {
        key: 'trigger',
        value: function trigger() {
            var _events3;

            (_events3 = this.events).emit.apply(_events3, arguments);
            return this;
        }
    }, {
        key: 'play',
        value: function play() {
            this.element.play();
            return this;
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.element.pause();
            return this;
        }
    }, {
        key: 'load',
        value: function load() {
            this.element.load();
            return this;
        }
    }, {
        key: 'duration',
        value: function duration() {
            return this.element.duration;
        }
    }]);

    return VideoElementPlayer;
}();

var Html5Player = function (_ESPNPlayer) {
    _inherits(Html5Player, _ESPNPlayer);

    function Html5Player(element, configs) {
        _classCallCheck(this, Html5Player);

        var player;

        configs.adProviderOrder = {
            desktop: ['brightcove_once'],
            tablet: ['brightcove_once'],
            mobile: ['brightcove_once']
        };

        var _this2 = _possibleConstructorReturn(this, (Html5Player.__proto__ || Object.getPrototypeOf(Html5Player)).call(this, element, configs));

        player = _this2.player(new VideoElementPlayer(_this2.element));

        if (configs.autoplay === 'userPreference') {
            FanPreferences.getAutoStart(function (autoStart) {
                configs.autoplay = autoStart;
                this.registerConfiguration(configs);
            }.bind(_this2));
        } else {
            configs.autoplay = configs.autoplay === 'on' || configs.autoplay === true ? true : false;
            _this2.registerConfiguration(configs);
        }

        player.load();

        if (element.tagName.toLowerCase() !== 'video') {
            element.parentNode.replaceChild(_this2.element, element);
        }
        return _this2;
    }

    _createClass(Html5Player, [{
        key: 'loadClips',
        value: function loadClips(clips, autoplay, source) {
            var clip;
            source = source || this.clipSource;
            if ((typeof clips === 'undefined' ? 'undefined' : _typeof(clips)) === 'object') {
                clip = clips.shift ? clips.shift() : [clips];
            } else {
                clip = [{ id: clips }];
            }

            if (clips && clips.length > 0 && this.loopClip === false) {
                this.player().on('ended', function () {
                    this.loadClips(clips, true, source);
                }.bind(this), { once: true });
            }

            return this.loadShield(clip.id, autoplay, source);
        }
    }, {
        key: 'initAnalytics',
        value: function initAnalytics() {
            var player;
            player = this.player();
            new NativeOmniture(player, Analytics.nativeOmniture({
                playerLocation: 'foo',
                showCode: 'bar',
                site: 'espn'
            }));
            return;
        }
    }, {
        key: 'loop',
        value: function loop() {
            this.player().on('ended', function () {
                this.player().play();
            }.bind(this));
        }
    }, {
        key: 'error',
        value: function error() {
            var _console;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            (_console = console).error.apply(_console, ['Html5Player ERROR: '].concat(args));
        }
    }]);

    return Html5Player;
}(ESPNPlayer);

Html5Player.loadTech = function loadNativePlayer() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var md = new MobileDetect(window.navigator.userAgent);

    if (options.native === true) {
        callback();
    } else if (options.native instanceof Array) {
        var i, len, platform;

        for (i = 0, len = options.native.length; i < len; i++) {
            platform = options.native[i];
            if (md[platform]()) {
                callback();
            }
        }
    }
};

module.exports = Html5Player;

},{"../../analytics":7,"../../fan":17,"../espn-player":62,"./native-omniture":64,"events":25,"mobile-detect":29}],64:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* jshint esversion: 6, strict: false, curly: false, browserify: true */

var NativeOmniture = function () {
  function NativeOmniture(player, options) {
    _classCallCheck(this, NativeOmniture);

    this.player = player;
    this.options = options;

    if (this.options.s_omni && this.options.s_omni.visitor) {
      if (this.options.s_omni.visitor.getAnalyticsVisitorID && typeof this.options.s_omni.visitor.getAnalyticsVisitorID === 'function') {
        this.aid = this.options.s_omni.visitor.getAnalyticsVisitorID();
      }
      if (this.options.s_omni.visitor.getMarketingCloudVisitorID()) {
        this.mid = this.options.s_omni.visitor.getMarketingCloudVisitorID();
      }
    }

    player.on('play', this.onPlay.bind(this));
    player.on('ended', this.onEnded.bind(this));
  }

  _createClass(NativeOmniture, [{
    key: 'fireTrackingBeacon',
    value: function fireTrackingBeacon(eventString) {
      var cmsId, param, params, queryString;

      if (!this.img) {
        this.img = new Image();
        this.img.id = 'html5playerAnalytics';
        document.body.appendChild(this.img);
      }

      cmsId = this.options.cmsId || this.player.mediainfo.name;
      params = {
        pe: 'media',
        c3: cmsId,
        v2: cmsId,
        events: eventString,
        v20: this.options.playerLocation + ':' + this.options.showCode,
        c1: this.options.site
      };

      if (this.aid) {
        params.aid = this.aid;
      }

      if (this.mid) {
        params.mid = this.mid;
      }

      queryString = [];
      for (param in params) {
        queryString.push(param + '=' + encodeURIComponent(params[param]));
      }

      this.img.src = (this.options.secure ? 'https' : 'http') + '://' + this.options.trackingServer + '/b/ss/' + this.options.reportSuites + '/5.4/REDIR/' + Date.now() + '?' + queryString.join('&');
      return;
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      var duration;
      duration = this.player.duration();
      this.fireTrackingBeacon('event1,event14=' + (duration && duration.toFixed(2)));
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      this.fireTrackingBeacon('event11');
    }
  }]);

  return NativeOmniture;
}();

module.exports = NativeOmniture;

},{}],65:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    BASE_URL: 'https://watch.auth.api.espn.com/video/auth',
    API_KEY: '5p8m6dw513q716wt2os04mec3'
  };
}).call(undefined);

},{}],66:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var CMS, SYNDICATIONS, SYNDICATION_KEY_TO_CLIP_SOURCE, Shield, config, merge, request;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  request = require('superagent');

  CMS = require('../cms');

  config = require('./config');

  merge = require('lodash.mergewith');

  SYNDICATIONS = ['cricinfo', 'deportes', 'domestic', 'soccerfc'];

  SYNDICATION_KEY_TO_CLIP_SOURCE = {
    'cricinfo': 'cric',
    'deportes': 'deportes',
    'domestic': 'espn',
    'soccerfc': 'intl'
  };

  Shield = function () {
    function Shield(options) {
      this.baseURL = options && options.BASE_URL || config.BASE_URL;
      this.apiKey = options && options.API_KEY || config.API_KEY;
    }

    Shield.prototype.getClip = function (cerebroId, callback, clipData) {
      var url;
      url = this.baseURL + '/getclip/' + cerebroId;
      clipData = clipData || {};
      return request.get(url).query({ apikey: this.apiKey }).end(function (error, res) {
        var clip, clipId, cms, errorResponse, sources, syndicationDetails, syndicationKey, video;
        if (error) {
          if (error.status === 403) {
            // Handle shield auth denies
            if (res.body && res.body.message) {
              var messageArr = res.body.message.split(':');
              if (messageArr.length > 0) {
                errorResponse = {
                  code: error.status,
                  message: messageArr[messageArr.length - 1].trim()
                };
                return callback(errorResponse, null);
              }
            }
          }
          //  Handle other errors
          if (res.body && res.body.error) {
            errorResponse = {
              code: error.status,
              message: res.body.error
            };
          } else {
            errorResponse = error;
          }
          return callback(errorResponse, null);
        }

        if (!(res.body && res.body.clip)) {
          errorResponse = res.body && res.body.authenticationStatus && res.body.authenticationStatus.messages.shift();
          console.warn(errorResponse);
          return callback(errorResponse, null);
        }
        video = res.body && res.body.clip;
        syndicationKey = Object.keys(video.syndicationDetails).filter(function (key) {
          return SYNDICATIONS.indexOf(key) !== -1;
        }).shift();
        syndicationDetails = syndicationKey && video.syndicationDetails[syndicationKey];
        clipId = syndicationDetails && syndicationDetails.cms && syndicationDetails.cms.syndicationId;
        cms = new CMS(SYNDICATION_KEY_TO_CLIP_SOURCE[syndicationKey] || syndicationKey);
        sources = [];
        if (video.transcodes && video.transcodes.hls) {
          sources.push({
            src: video.transcodes.hls,
            type: 'application/x-mpegURL'
          });
        }
        if (video.transcodes && video.transcodes.primary_mezzanine) {
          sources.push({
            src: video.transcodes.primary_mezzanine,
            type: 'video/mp4'
          });
        }
        clip = {
          _shield: video,
          advertisingId: cms.adAssetId(clipId),
          assetName: video.assetName,
          caption: video.caption,
          cerebroId: video.id,
          clipId: clipId,
          clipSource: cms.key,
          createDate: new Date(video.createDate).toISOString(),
          duration: video.durationSeconds,
          headline: video.headline,
          id: video.id,
          keywords: video.keywords && video.keywords.split && video.keywords.split(",\n"),
          mediaId: cms.apiMediaId(clipId),
          posterHref: video.transcodes && video.transcodes.thumbnail,
          publishDate: new Date(video.publishDate).toISOString(),
          showcode: video.adTarget && video.adTarget.adBundle && video.adTarget.adBundle[0],
          sport: video.adTarget && video.adTarget.sport,
          syndicatable: video.videoRights && video.videoRights.socialSharing,
          webHref: syndicationDetails && syndicationDetails.cms && syndicationDetails.cms.url,
          webVTT: syndicationDetails && syndicationDetails.threeplay && syndicationDetails.threeplay.url
        };
        clip._shield.device = res.body && res.body.requestedBy && res.body.requestedBy.device;
        clip._shield.country = res.body && res.body.requestedBy && res.body.requestedBy.country;

        merge(clip, clipData);

        // Ensure that Shield playback URLs are set
        clip.onceHref = syndicationDetails && syndicationDetails.brightcove && syndicationDetails.brightcove.url;
        clip.sources = sources;

        return callback(null, clip);
      });
    };

    return Shield;
  }();

  Shield.configure = function (options) {
    merge(config, options, mergeCustomizer);
    return config;
  };

  module.exports = Shield;
}).call(undefined);

},{"../cms":12,"./config":65,"lodash.mergewith":28,"superagent":32}],67:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    mailToLink: 'mailto:?subject={{subject}}&body={{body}}',
    sendMailUrl: 'http://proxy.espn.com/videohub/player/sendMail?id={{id}}&clipName={{clipName}}&youremail={{youremail}}&friendemail={{friendemail}}&message={{message}}&videoImage={{videoImage}}',
    embedCode: '<iframe width="640" height="360" src="http://www.espn.com/core/video/iframe?id={{ID}}&endcard=false" allowfullscreen frameborder="0"></iframe>',
    embedUrlTemplate: '//players.brightcove.net/{{account_id}}/{{player_id}}_{{embed_id}}/index.html{{video_id}}{{offset}}',
    deeplinking: true,
    services: {
      facebook: true,
      google: false,
      twitter: true,
      tumblr: false,
      pinterest: false,
      linkedin: false,
      email: true,
      directlink: true,
      embed: true
    }
  };
}).call(undefined);

},{}],68:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Social, config, merge;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  merge = require('lodash.mergewith');

  config = require('./config');

  Social = function () {
    function Social(mediainfo, callback, options) {
      var opts = merge({}, config, mergeCustomizer);
      if (options) {
        merge(opts, options, mergeCustomizer);
      }

      opts.id = opts.id || (mediainfo.site ? mediainfo.site + ':' + mediainfo.advertisingId : mediainfo.id);
      opts.title = mediainfo.headline || mediainfo.name;
      opts.description = mediainfo.caption;
      opts.url = opts.url && opts.url.replace(/{{ID}}/g, mediainfo.id) || opts.url || mediainfo.web;
      opts.poster = mediainfo.poster;
      opts.syndicatable = !!mediainfo.syndicatable;
      opts.embedCode = opts.embedCode && opts.embedCode.replace(/{{ID}}/g, mediainfo.id);
      opts.pauseOnOpen = true;
      opts.showOffset = true;
      if (opts.services && opts.services.embed) {
        opts.services.embed = opts.syndicatable;
      }

      if (mediainfo.type === 'live') {
        opts.pauseOnOpen = false;
        opts.showOffset = false;
      }

      callback(opts);
    }

    return Social;
  }();

  module.exports = Social;
}).call(undefined);

},{"./config":67,"lodash.mergewith":28}],69:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var API, StreamLimiter, config, merge, request;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  request = require('superagent');

  API = require('../api');

  config = {
    baseURL: 'https://streams.adobeprimetime.com/v1/'
  };

  merge = require('lodash.mergewith');

  StreamLimiter = function () {
    function StreamLimiter(player, options) {
      var endpoint;
      merge(config, options, mergeCustomizer);
      this.accountId = config.accountId;
      this.baseURL = config.baseURL;
      this.player = player;
      endpoint = new API();
      endpoint.getProvidersByClient('watchespn-flash', function (_this) {
        return function (error, providers) {
          _this.mvpd = providers.filter(function (provider) {
            return provider.abbreviation === config.mvpd;
          })[0];
          if (_this.accountId && _this.mvpd && _this.mvpd.streamLimiting && _this.mvpd.abbreviation) {
            _this.heartbeat = _this.mvpd.streamLimiting.heartbeat;
            _this.statusCheck = _this.mvpd.streamLimiting.statusCheck;
            _this.streamLimit = _this.mvpd.streamLimiting.streamLimit || 3;
            _this.statusCheck.url = "" + _this.baseURL + _this.mvpd.streamLimiting.context + "/" + _this.mvpd.abbreviation + "/accounts/" + _this.accountId + "/streams";
            return request.post(_this.statusCheck.url).query({
              initiator: 'ESPN',
              programmer: 'ESPN'
            }).set('Accept', 'application/json').end(function (error, res) {
              _this.streamId = res.body.streamId;
              _this.streamStart = res.body.streamStart;
              _this.heartbeat.url = res.body._links && res.body._links.heartbeat && res.body._links.heartbeat.href;
              if (_this.heartbeat.url) {
                _this.heartbeat.timeout = setTimeout(_this.sendHeartbeat.bind(_this), _this.heartbeat.initialDelay * 1000);
                _this.statusCheck.timeout = setTimeout(_this.sendStatusCheck.bind(_this), _this.statusCheck.initialDelay * 1000);
                return;
              }
            });
          }
        };
      }(this));

      this.player.player().on('error', function () {
        var error = this.player.player().error();

        // Terminate the StreamLimiter session unless the error is a StreamLimiter error
        if (this.heartbeat.url && ['STREAM_LIMITED', 'STREAM_LIMIT_ERROR'].indexOf(error.message) === -1) {
          this.terminate();
        }
      }.bind(this));

      this.player.player().one('dispose', function () {
        if (this.heartbeat.url) {
          this.terminate();
        }
      }.bind(this));
    }

    StreamLimiter.prototype.accountId = void 0;

    StreamLimiter.prototype.mvpd = {};

    StreamLimiter.prototype.heartbeat = {};

    StreamLimiter.prototype.statusCheck = {};

    StreamLimiter.prototype.streamLimit = 3;

    StreamLimiter.prototype.streamId = null;

    StreamLimiter.prototype.streamStart = null;

    StreamLimiter.prototype.sendHeartbeat = function () {
      clearTimeout(this.heartbeat.timeout);
      this.heartbeat.timeout = setTimeout(function (_this) {
        return function () {
          return request.post(_this.heartbeat.url.replace('{event}', 'alive')).end(function (error) {
            if (error) {
              _this.handleError();
            }
            return _this.sendHeartbeat();
          });
        };
      }(this), this.heartbeat.interval * 1000);
      return;
    };

    StreamLimiter.prototype.sendStatusCheck = function () {
      clearTimeout(this.statusCheck.timeout);
      this.statusCheck.timeout = setTimeout(function (_this) {
        return function () {
          return request.get(_this.statusCheck.url).query({
            programmer: 'ESPN',
            status: 'active'
          }).set('Accept', 'application/json').end(function (error, res) {
            var rank;
            if (error) {
              _this.handleError();
            }
            rank = _this.rankStreams(res.body._embedded && res.body._embedded.streams);
            if (rank > _this.streamLimit) {
              _this.onLimitReached(_this.accountId);
              return _this.terminate();
            }
            return _this.sendStatusCheck();
          });
        };
      }(this), this.statusCheck.interval * 1000);
      return;
    };

    StreamLimiter.prototype.rankStreams = function (streams) {
      return streams.reduce(function (_this) {
        return function (previous, current) {
          if (current.streamStart > _this.streamStart) {
            return previous + 1;
          }
          return previous;
        };
      }(this), 1);
    };

    StreamLimiter.prototype.errorCount = 0;

    StreamLimiter.prototype.handleError = function () {
      this.errorCount++;
      if (this.errorCount >= 3) {
        this.onError(this.accountId);
        return this.terminate();
      }
    };

    StreamLimiter.prototype.onLimitReached = function (accountId) {
      console.warn('Stream limit reached: accountId: ' + accountId);
      this.player.error('STREAM_LIMITED');
      this.player.player().trigger('espn.streamlimiter.limitreached', { accountId: accountId });
    };

    StreamLimiter.prototype.onError = function (accountId) {
      console.warn('Stream limit error: accountId: ' + accountId);
      this.player.error('STREAM_LIMIT_ERROR');
      this.player.player().trigger('espn.streamlimiter.error', { accountId: accountId });
    };

    StreamLimiter.prototype.terminate = function () {
      clearTimeout(this.heartbeat.timeout);
      clearTimeout(this.statusCheck.timeout);
      request.post(this.heartbeat.url.replace('{event}', 'stop')).end();
      this.errorCount = 0;
      this.heartbeat = {};
      this.statusCheck = {};
      this.streamId = null;
      this.streamStart = null;
    };

    return StreamLimiter;
  }();

  StreamLimiter.configure = function (options) {
    merge(config, options, mergeCustomizer);
    return config;
  };

  module.exports = StreamLimiter;
}).call(undefined);

},{"../api":9,"lodash.mergewith":28,"superagent":32}],70:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  /*
    I have been unable to locate an actual API endpoint for timeline preview
    thumbnails, but I did determine that the thumbnail URLs are _very_ similar
    to the video URL, so we'll use that derive the preview thumbnails.
     If the video URL looks like:
       http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_president_obama_bracket/dm_150318_ncb_feature_president_obama_bracket.m3u8
     Then our thumbnail URLs should look like:
       http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_president_obama_bracket/chaptertn/dm_150318_ncb_feature_president_obama_bracket_{N}.jpg
     Chapter thumbnails appear every 10 seconds, beginning at 0:00.
     Builds an object like this:
       {
        "0": {
          "src": "http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_pres…bama_bracket/chaptertn/dm_150318_ncb_feature_president_obama_bracket_1.jpg"
        },
        "10": {
          "src": "http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_pres…bama_bracket/chaptertn/dm_150318_ncb_feature_president_obama_bracket_2.jpg"
        },
        "20": {
          "src": "http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_pres…bama_bracket/chaptertn/dm_150318_ncb_feature_president_obama_bracket_3.jpg"
        },
        "30": {
          "src": "http://media.video-cdn.espn.com/motion/2015/0318/dm_150318_ncb_feature_pres…bama_bracket/chaptertn/dm_150318_ncb_feature_president_obama_bracket_4.jpg"
        },
      }
     This is the format required by the Brightcove thumbnail plugin.
   */

  var TimelinePreviews;

  TimelinePreviews = function () {
    function TimelinePreviews(id, videoURL, player) {
      var extension, i, image, numPreviews, path, previews, ref;
      if (!videoURL) {
        return;
      }
      previews = {};
      numPreviews = Math.floor(player.duration() / 10);
      i = 0;
      image = videoURL.split('/').pop();
      path = videoURL.replace(image, 'chaptertn');
      ref = image.split('.');
      image = ref[0];
      extension = 'jpg';
      while (i <= numPreviews) {
        previews["" + i * 10] = {
          src: path + "/" + image + "_" + ++i + "." + extension,
          width: '150px'
        };
      }
      player.thumbnails(previews);
    }

    return TimelinePreviews;
  }();

  module.exports = TimelinePreviews;
}).call(undefined);

},{}],71:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  module.exports = {
    asset: 'http://a.espncdn.com/broadband/video/images/espn-watermark.png',
    url: 'http://www.espn.com',
    position: 'bottom-left',
    start: 'play',
    end: 'end'
  };
}).call(undefined);

},{}],72:[function(require,module,exports){
'use strict';

(function () {
  'use strict';

  var Watermark, config, merge;

  function mergeCustomizer(objValue, srcValue) {
    if (srcValue === null) {
      return objValue;
    }
  }

  merge = require('lodash.mergewith');

  config = require('./config');

  Watermark = function () {
    function Watermark(callback, options) {
      var content;
      if (options) {
        merge(config, options, mergeCustomizer);
      }
      content = "<a href=\"" + config.url + "\" target=\"_blank\" class=\"espn-watermark\"> <img src=\"" + config.asset + "\" /> </a>";
      callback({
        content: content,
        align: config.position,
        start: config.start,
        end: config.end
      });
    }

    return Watermark;
  }();

  module.exports = Watermark;
}).call(undefined);

},{"./config":71,"lodash.mergewith":28}]},{},[1])(1)
});


//////////////////
// WEBPACK FOOTER
// ./~/espn-web-player-bundle/dist/espn-web-player-bundle.js
// module id = 464
// module chunks = 0